
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired5a1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired5a1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l6ag6", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f5c21db16393767e$export$ffb0004e005737fa, (v) => $f5c21db16393767e$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $f5c21db16393767e$export$34b9dba7ce09269b, (v) => $f5c21db16393767e$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $f5c21db16393767e$export$25062201e9e25d76, (v) => $f5c21db16393767e$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f5c21db16393767e$export$ffb0004e005737fa;
var $f5c21db16393767e$export$34b9dba7ce09269b;
var $f5c21db16393767e$export$25062201e9e25d76;
"use strict";
var $f5c21db16393767e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f5c21db16393767e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $f5c21db16393767e$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $f5c21db16393767e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$f5c21db16393767e$export$ffb0004e005737fa = $f5c21db16393767e$var$REACT_FRAGMENT_TYPE;
$f5c21db16393767e$export$34b9dba7ce09269b = $f5c21db16393767e$var$jsxProd;
$f5c21db16393767e$export$25062201e9e25d76 = $f5c21db16393767e$var$jsxProd;

});

parcelRegister("bsBsX", function(module, exports) {

$parcel$export(module.exports, "Children", () => $857f5f39d554efd5$export$dca3b0875bd9a954, (v) => $857f5f39d554efd5$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $857f5f39d554efd5$export$16fa2f45be04daa8, (v) => $857f5f39d554efd5$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $857f5f39d554efd5$export$ffb0004e005737fa, (v) => $857f5f39d554efd5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $857f5f39d554efd5$export$e2c29f18771995cb, (v) => $857f5f39d554efd5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $857f5f39d554efd5$export$221d75b3f55bb0bd, (v) => $857f5f39d554efd5$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $857f5f39d554efd5$export$5f8d39834fd61797, (v) => $857f5f39d554efd5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $857f5f39d554efd5$export$74bf444e3cd11ea5, (v) => $857f5f39d554efd5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $857f5f39d554efd5$export$1ced07cd6b1985ce, (v) => $857f5f39d554efd5$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $857f5f39d554efd5$export$3ba232387fd5d6dd, (v) => $857f5f39d554efd5$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $857f5f39d554efd5$export$69a3209f1a06c04d, (v) => $857f5f39d554efd5$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $857f5f39d554efd5$export$e530037191fcd5d7, (v) => $857f5f39d554efd5$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $857f5f39d554efd5$export$fd42f52fd3ae1109, (v) => $857f5f39d554efd5$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $857f5f39d554efd5$export$c8a8987d4410bf2d, (v) => $857f5f39d554efd5$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $857f5f39d554efd5$export$7d1e3a5e95ceca43, (v) => $857f5f39d554efd5$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $857f5f39d554efd5$export$257a8862b851cb5b, (v) => $857f5f39d554efd5$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $857f5f39d554efd5$export$a8257692ac88316c, (v) => $857f5f39d554efd5$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $857f5f39d554efd5$export$488013bae63b21da, (v) => $857f5f39d554efd5$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $857f5f39d554efd5$export$7c73462e0d25e514, (v) => $857f5f39d554efd5$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $857f5f39d554efd5$export$7568632d0d33d16d, (v) => $857f5f39d554efd5$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $857f5f39d554efd5$export$f93f40ac0ca7e3a8, (v) => $857f5f39d554efd5$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $857f5f39d554efd5$export$1f96ae73734a86cc, (v) => $857f5f39d554efd5$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $857f5f39d554efd5$export$9a47ced3238df325, (v) => $857f5f39d554efd5$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $857f5f39d554efd5$export$35808ee640e87ca7, (v) => $857f5f39d554efd5$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $857f5f39d554efd5$export$fae74005e78b1a27, (v) => $857f5f39d554efd5$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $857f5f39d554efd5$export$dc8fbce3eb94dc1e, (v) => $857f5f39d554efd5$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $857f5f39d554efd5$export$6a7bc4e911dc01cf, (v) => $857f5f39d554efd5$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $857f5f39d554efd5$export$6d9c69b0de29b591, (v) => $857f5f39d554efd5$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $857f5f39d554efd5$export$f680877a34711e37, (v) => $857f5f39d554efd5$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $857f5f39d554efd5$export$d5a552a76deda3c2, (v) => $857f5f39d554efd5$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $857f5f39d554efd5$export$aaabe4eda9ed9969, (v) => $857f5f39d554efd5$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $857f5f39d554efd5$export$e5c5a5f917a5871c, (v) => $857f5f39d554efd5$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $857f5f39d554efd5$export$1538c33de8887b59, (v) => $857f5f39d554efd5$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $857f5f39d554efd5$export$fca7f784ae7a249a, (v) => $857f5f39d554efd5$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $857f5f39d554efd5$export$13e3392192263954, (v) => $857f5f39d554efd5$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $857f5f39d554efd5$export$b8f5890fc79d6aca, (v) => $857f5f39d554efd5$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $857f5f39d554efd5$export$60241385465d0a34, (v) => $857f5f39d554efd5$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $857f5f39d554efd5$export$306c0aa65ff9ec16, (v) => $857f5f39d554efd5$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $857f5f39d554efd5$export$7b286972b8d8ccbf, (v) => $857f5f39d554efd5$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $857f5f39d554efd5$export$83d89fbfd8236492, (v) => $857f5f39d554efd5$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $857f5f39d554efd5$export$dca3b0875bd9a954;
var $857f5f39d554efd5$export$16fa2f45be04daa8;
var $857f5f39d554efd5$export$ffb0004e005737fa;
var $857f5f39d554efd5$export$e2c29f18771995cb;
var $857f5f39d554efd5$export$221d75b3f55bb0bd;
var $857f5f39d554efd5$export$5f8d39834fd61797;
var $857f5f39d554efd5$export$74bf444e3cd11ea5;
var $857f5f39d554efd5$export$1ced07cd6b1985ce;
var $857f5f39d554efd5$export$3ba232387fd5d6dd;
var $857f5f39d554efd5$export$69a3209f1a06c04d;
var $857f5f39d554efd5$export$e530037191fcd5d7;
var $857f5f39d554efd5$export$fd42f52fd3ae1109;
var $857f5f39d554efd5$export$c8a8987d4410bf2d;
var $857f5f39d554efd5$export$7d1e3a5e95ceca43;
var $857f5f39d554efd5$export$257a8862b851cb5b;
var $857f5f39d554efd5$export$a8257692ac88316c;
var $857f5f39d554efd5$export$488013bae63b21da;
var $857f5f39d554efd5$export$7c73462e0d25e514;
var $857f5f39d554efd5$export$7568632d0d33d16d;
var $857f5f39d554efd5$export$f93f40ac0ca7e3a8;
var $857f5f39d554efd5$export$1f96ae73734a86cc;
var $857f5f39d554efd5$export$9a47ced3238df325;
var $857f5f39d554efd5$export$35808ee640e87ca7;
var $857f5f39d554efd5$export$fae74005e78b1a27;
var $857f5f39d554efd5$export$dc8fbce3eb94dc1e;
var $857f5f39d554efd5$export$6a7bc4e911dc01cf;
var $857f5f39d554efd5$export$6d9c69b0de29b591;
var $857f5f39d554efd5$export$f680877a34711e37;
var $857f5f39d554efd5$export$d5a552a76deda3c2;
var $857f5f39d554efd5$export$aaabe4eda9ed9969;
var $857f5f39d554efd5$export$e5c5a5f917a5871c;
var $857f5f39d554efd5$export$1538c33de8887b59;
var $857f5f39d554efd5$export$fca7f784ae7a249a;
var $857f5f39d554efd5$export$13e3392192263954;
var $857f5f39d554efd5$export$b8f5890fc79d6aca;
var $857f5f39d554efd5$export$60241385465d0a34;
var $857f5f39d554efd5$export$306c0aa65ff9ec16;
var $857f5f39d554efd5$export$7b286972b8d8ccbf;
var $857f5f39d554efd5$export$83d89fbfd8236492;

var $7G10b = parcelRequire("7G10b");
"use strict";
var $857f5f39d554efd5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $857f5f39d554efd5$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $857f5f39d554efd5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $857f5f39d554efd5$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $857f5f39d554efd5$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $857f5f39d554efd5$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $857f5f39d554efd5$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $857f5f39d554efd5$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $857f5f39d554efd5$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $857f5f39d554efd5$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $857f5f39d554efd5$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $857f5f39d554efd5$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $857f5f39d554efd5$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $857f5f39d554efd5$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$857f5f39d554efd5$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $857f5f39d554efd5$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $857f5f39d554efd5$var$assign = Object.assign, $857f5f39d554efd5$var$emptyObject = {};
function $857f5f39d554efd5$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $857f5f39d554efd5$var$emptyObject;
    this.updater = updater || $857f5f39d554efd5$var$ReactNoopUpdateQueue;
}
$857f5f39d554efd5$var$Component.prototype.isReactComponent = {};
$857f5f39d554efd5$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$857f5f39d554efd5$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $857f5f39d554efd5$var$ComponentDummy() {}
$857f5f39d554efd5$var$ComponentDummy.prototype = $857f5f39d554efd5$var$Component.prototype;
function $857f5f39d554efd5$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $857f5f39d554efd5$var$emptyObject;
    this.updater = updater || $857f5f39d554efd5$var$ReactNoopUpdateQueue;
}
var $857f5f39d554efd5$var$pureComponentPrototype = $857f5f39d554efd5$var$PureComponent.prototype = new $857f5f39d554efd5$var$ComponentDummy();
$857f5f39d554efd5$var$pureComponentPrototype.constructor = $857f5f39d554efd5$var$PureComponent;
$857f5f39d554efd5$var$assign($857f5f39d554efd5$var$pureComponentPrototype, $857f5f39d554efd5$var$Component.prototype);
$857f5f39d554efd5$var$pureComponentPrototype.isPureReactComponent = !0;
var $857f5f39d554efd5$var$isArrayImpl = Array.isArray, $857f5f39d554efd5$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $857f5f39d554efd5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $857f5f39d554efd5$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $857f5f39d554efd5$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $857f5f39d554efd5$var$cloneAndReplaceKey(oldElement, newKey) {
    return $857f5f39d554efd5$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $857f5f39d554efd5$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $857f5f39d554efd5$var$REACT_ELEMENT_TYPE;
}
function $857f5f39d554efd5$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $857f5f39d554efd5$var$userProvidedKeyEscapeRegex = /\/+/g;
function $857f5f39d554efd5$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $857f5f39d554efd5$var$escape("" + element.key) : index.toString(36);
}
function $857f5f39d554efd5$var$noop$1() {}
function $857f5f39d554efd5$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($857f5f39d554efd5$var$noop$1, $857f5f39d554efd5$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $857f5f39d554efd5$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $857f5f39d554efd5$var$REACT_ELEMENT_TYPE:
                case $857f5f39d554efd5$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $857f5f39d554efd5$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $857f5f39d554efd5$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $857f5f39d554efd5$var$getElementKey(children, 0) : nameSoFar, $857f5f39d554efd5$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($857f5f39d554efd5$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $857f5f39d554efd5$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($857f5f39d554efd5$var$isValidElement(callback) && (callback = $857f5f39d554efd5$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($857f5f39d554efd5$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($857f5f39d554efd5$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $857f5f39d554efd5$var$getElementKey(nameSoFar, i), invokeCallback += $857f5f39d554efd5$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $857f5f39d554efd5$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $857f5f39d554efd5$var$getElementKey(nameSoFar, i++), invokeCallback += $857f5f39d554efd5$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $857f5f39d554efd5$var$mapIntoArray($857f5f39d554efd5$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $857f5f39d554efd5$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $857f5f39d554efd5$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $857f5f39d554efd5$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $857f5f39d554efd5$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $7G10b && "function" === typeof $7G10b.emit) {
        $7G10b.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $857f5f39d554efd5$var$noop() {}
$857f5f39d554efd5$export$dca3b0875bd9a954 = {
    map: $857f5f39d554efd5$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $857f5f39d554efd5$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $857f5f39d554efd5$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $857f5f39d554efd5$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$857f5f39d554efd5$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$857f5f39d554efd5$export$16fa2f45be04daa8 = $857f5f39d554efd5$var$Component;
$857f5f39d554efd5$export$ffb0004e005737fa = $857f5f39d554efd5$var$REACT_FRAGMENT_TYPE;
$857f5f39d554efd5$export$e2c29f18771995cb = $857f5f39d554efd5$var$REACT_PROFILER_TYPE;
$857f5f39d554efd5$export$221d75b3f55bb0bd = $857f5f39d554efd5$var$PureComponent;
$857f5f39d554efd5$export$5f8d39834fd61797 = $857f5f39d554efd5$var$REACT_STRICT_MODE_TYPE;
$857f5f39d554efd5$export$74bf444e3cd11ea5 = $857f5f39d554efd5$var$REACT_SUSPENSE_TYPE;
$857f5f39d554efd5$export$1ced07cd6b1985ce = $857f5f39d554efd5$var$ReactSharedInternals;
$857f5f39d554efd5$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$857f5f39d554efd5$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$857f5f39d554efd5$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $857f5f39d554efd5$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$857f5f39d554efd5$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $857f5f39d554efd5$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$857f5f39d554efd5$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $857f5f39d554efd5$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $857f5f39d554efd5$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$857f5f39d554efd5$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$857f5f39d554efd5$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $857f5f39d554efd5$var$ReactElement(type, key, void 0, void 0, null, props);
};
$857f5f39d554efd5$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$857f5f39d554efd5$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $857f5f39d554efd5$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$857f5f39d554efd5$export$a8257692ac88316c = $857f5f39d554efd5$var$isValidElement;
$857f5f39d554efd5$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $857f5f39d554efd5$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $857f5f39d554efd5$var$lazyInitializer
    };
};
$857f5f39d554efd5$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $857f5f39d554efd5$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$857f5f39d554efd5$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $857f5f39d554efd5$var$ReactSharedInternals.T, currentTransition = {};
    $857f5f39d554efd5$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $857f5f39d554efd5$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($857f5f39d554efd5$var$noop, $857f5f39d554efd5$var$reportGlobalError);
    } catch (error) {
        $857f5f39d554efd5$var$reportGlobalError(error);
    } finally{
        $857f5f39d554efd5$var$ReactSharedInternals.T = prevTransition;
    }
};
$857f5f39d554efd5$export$f93f40ac0ca7e3a8 = function() {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useCacheRefresh();
};
$857f5f39d554efd5$export$1f96ae73734a86cc = function(usable) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.use(usable);
};
$857f5f39d554efd5$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$857f5f39d554efd5$export$35808ee640e87ca7 = function(callback, deps) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$857f5f39d554efd5$export$fae74005e78b1a27 = function(Context) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useContext(Context);
};
$857f5f39d554efd5$export$dc8fbce3eb94dc1e = function() {};
$857f5f39d554efd5$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$857f5f39d554efd5$export$6d9c69b0de29b591 = function(create, deps) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useEffect(create, deps);
};
$857f5f39d554efd5$export$f680877a34711e37 = function() {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useId();
};
$857f5f39d554efd5$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$857f5f39d554efd5$export$aaabe4eda9ed9969 = function(create, deps) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$857f5f39d554efd5$export$e5c5a5f917a5871c = function(create, deps) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$857f5f39d554efd5$export$1538c33de8887b59 = function(create, deps) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useMemo(create, deps);
};
$857f5f39d554efd5$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$857f5f39d554efd5$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$857f5f39d554efd5$export$b8f5890fc79d6aca = function(initialValue) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useRef(initialValue);
};
$857f5f39d554efd5$export$60241385465d0a34 = function(initialState) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useState(initialState);
};
$857f5f39d554efd5$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$857f5f39d554efd5$export$7b286972b8d8ccbf = function() {
    return $857f5f39d554efd5$var$ReactSharedInternals.H.useTransition();
};
$857f5f39d554efd5$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("7G10b", function(module, exports) {
// shim for using process in browser
var $596d3ba2bc149891$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $596d3ba2bc149891$var$cachedSetTimeout;
var $596d3ba2bc149891$var$cachedClearTimeout;
function $596d3ba2bc149891$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $596d3ba2bc149891$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $596d3ba2bc149891$var$cachedSetTimeout = setTimeout;
        else $596d3ba2bc149891$var$cachedSetTimeout = $596d3ba2bc149891$var$defaultSetTimout;
    } catch (e) {
        $596d3ba2bc149891$var$cachedSetTimeout = $596d3ba2bc149891$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $596d3ba2bc149891$var$cachedClearTimeout = clearTimeout;
        else $596d3ba2bc149891$var$cachedClearTimeout = $596d3ba2bc149891$var$defaultClearTimeout;
    } catch (e) {
        $596d3ba2bc149891$var$cachedClearTimeout = $596d3ba2bc149891$var$defaultClearTimeout;
    }
})();
function $596d3ba2bc149891$var$runTimeout(fun) {
    if ($596d3ba2bc149891$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($596d3ba2bc149891$var$cachedSetTimeout === $596d3ba2bc149891$var$defaultSetTimout || !$596d3ba2bc149891$var$cachedSetTimeout) && setTimeout) {
        $596d3ba2bc149891$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $596d3ba2bc149891$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $596d3ba2bc149891$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $596d3ba2bc149891$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $596d3ba2bc149891$var$runClearTimeout(marker) {
    if ($596d3ba2bc149891$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($596d3ba2bc149891$var$cachedClearTimeout === $596d3ba2bc149891$var$defaultClearTimeout || !$596d3ba2bc149891$var$cachedClearTimeout) && clearTimeout) {
        $596d3ba2bc149891$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $596d3ba2bc149891$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $596d3ba2bc149891$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $596d3ba2bc149891$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $596d3ba2bc149891$var$queue = [];
var $596d3ba2bc149891$var$draining = false;
var $596d3ba2bc149891$var$currentQueue;
var $596d3ba2bc149891$var$queueIndex = -1;
function $596d3ba2bc149891$var$cleanUpNextTick() {
    if (!$596d3ba2bc149891$var$draining || !$596d3ba2bc149891$var$currentQueue) return;
    $596d3ba2bc149891$var$draining = false;
    if ($596d3ba2bc149891$var$currentQueue.length) $596d3ba2bc149891$var$queue = $596d3ba2bc149891$var$currentQueue.concat($596d3ba2bc149891$var$queue);
    else $596d3ba2bc149891$var$queueIndex = -1;
    if ($596d3ba2bc149891$var$queue.length) $596d3ba2bc149891$var$drainQueue();
}
function $596d3ba2bc149891$var$drainQueue() {
    if ($596d3ba2bc149891$var$draining) return;
    var timeout = $596d3ba2bc149891$var$runTimeout($596d3ba2bc149891$var$cleanUpNextTick);
    $596d3ba2bc149891$var$draining = true;
    var len = $596d3ba2bc149891$var$queue.length;
    while(len){
        $596d3ba2bc149891$var$currentQueue = $596d3ba2bc149891$var$queue;
        $596d3ba2bc149891$var$queue = [];
        while(++$596d3ba2bc149891$var$queueIndex < len)if ($596d3ba2bc149891$var$currentQueue) $596d3ba2bc149891$var$currentQueue[$596d3ba2bc149891$var$queueIndex].run();
        $596d3ba2bc149891$var$queueIndex = -1;
        len = $596d3ba2bc149891$var$queue.length;
    }
    $596d3ba2bc149891$var$currentQueue = null;
    $596d3ba2bc149891$var$draining = false;
    $596d3ba2bc149891$var$runClearTimeout(timeout);
}
$596d3ba2bc149891$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $596d3ba2bc149891$var$queue.push(new $596d3ba2bc149891$var$Item(fun, args));
    if ($596d3ba2bc149891$var$queue.length === 1 && !$596d3ba2bc149891$var$draining) $596d3ba2bc149891$var$runTimeout($596d3ba2bc149891$var$drainQueue);
};
// v8 likes predictible objects
function $596d3ba2bc149891$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$596d3ba2bc149891$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$596d3ba2bc149891$var$process.title = "browser";
$596d3ba2bc149891$var$process.browser = true;
$596d3ba2bc149891$var$process.env = {};
$596d3ba2bc149891$var$process.argv = [];
$596d3ba2bc149891$var$process.version = ""; // empty string to avoid regexp issues
$596d3ba2bc149891$var$process.versions = {};
function $596d3ba2bc149891$var$noop() {}
$596d3ba2bc149891$var$process.on = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.addListener = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.once = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.off = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.removeListener = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.removeAllListeners = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.emit = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.prependListener = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.prependOnceListener = $596d3ba2bc149891$var$noop;
$596d3ba2bc149891$var$process.listeners = function(name) {
    return [];
};
$596d3ba2bc149891$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$596d3ba2bc149891$var$process.cwd = function() {
    return "/";
};
$596d3ba2bc149891$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$596d3ba2bc149891$var$process.umask = function() {
    return 0;
};

});


parcelRegister("cacyt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $8db028646a03dbcf$export$882461b6382ed46c, (v) => $8db028646a03dbcf$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $8db028646a03dbcf$export$757ceba2d55c277e, (v) => $8db028646a03dbcf$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $8db028646a03dbcf$export$83d89fbfd8236492, (v) => $8db028646a03dbcf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8db028646a03dbcf$export$882461b6382ed46c;
var $8db028646a03dbcf$export$757ceba2d55c277e;
var $8db028646a03dbcf$export$83d89fbfd8236492;

var $7G10b = parcelRequire("7G10b");
"use strict";

var $lugMi = parcelRequire("lugMi");

var $iBfRJ = parcelRequire("iBfRJ");

var $4mG4E = parcelRequire("4mG4E");
function $8db028646a03dbcf$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8db028646a03dbcf$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $8db028646a03dbcf$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $8db028646a03dbcf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8db028646a03dbcf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8db028646a03dbcf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8db028646a03dbcf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8db028646a03dbcf$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $8db028646a03dbcf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8db028646a03dbcf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8db028646a03dbcf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8db028646a03dbcf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8db028646a03dbcf$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $8db028646a03dbcf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8db028646a03dbcf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8db028646a03dbcf$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $8db028646a03dbcf$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $8db028646a03dbcf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8db028646a03dbcf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8db028646a03dbcf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8db028646a03dbcf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8db028646a03dbcf$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $8db028646a03dbcf$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $8db028646a03dbcf$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $8db028646a03dbcf$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $8db028646a03dbcf$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $8db028646a03dbcf$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $8db028646a03dbcf$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $8db028646a03dbcf$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $8db028646a03dbcf$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $8db028646a03dbcf$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $8db028646a03dbcf$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $8db028646a03dbcf$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $8db028646a03dbcf$var$getComponentNameFromType(type.type) || "Memo";
        case $8db028646a03dbcf$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $8db028646a03dbcf$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $8db028646a03dbcf$var$ReactSharedInternals = $iBfRJ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8db028646a03dbcf$var$assign = Object.assign, $8db028646a03dbcf$var$prefix, $8db028646a03dbcf$var$suffix;
function $8db028646a03dbcf$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $8db028646a03dbcf$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $8db028646a03dbcf$var$prefix = match && match[1] || "";
        $8db028646a03dbcf$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $8db028646a03dbcf$var$prefix + name + $8db028646a03dbcf$var$suffix;
}
var $8db028646a03dbcf$var$reentry = !1;
function $8db028646a03dbcf$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $8db028646a03dbcf$var$reentry) return "";
    $8db028646a03dbcf$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $8db028646a03dbcf$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $8db028646a03dbcf$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $8db028646a03dbcf$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $8db028646a03dbcf$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $8db028646a03dbcf$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $8db028646a03dbcf$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $8db028646a03dbcf$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $8db028646a03dbcf$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $8db028646a03dbcf$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $8db028646a03dbcf$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $8db028646a03dbcf$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $8db028646a03dbcf$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $8db028646a03dbcf$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $8db028646a03dbcf$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $8db028646a03dbcf$var$assertIsMounted(fiber) {
    if ($8db028646a03dbcf$var$getNearestMountedFiber(fiber) !== fiber) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(188));
}
function $8db028646a03dbcf$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $8db028646a03dbcf$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $8db028646a03dbcf$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $8db028646a03dbcf$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $8db028646a03dbcf$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $8db028646a03dbcf$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $8db028646a03dbcf$var$isArrayImpl = Array.isArray, $8db028646a03dbcf$var$ReactDOMSharedInternals = $4mG4E.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8db028646a03dbcf$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $8db028646a03dbcf$var$valueStack = [], $8db028646a03dbcf$var$index = -1;
function $8db028646a03dbcf$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $8db028646a03dbcf$var$pop(cursor) {
    0 > $8db028646a03dbcf$var$index || (cursor.current = $8db028646a03dbcf$var$valueStack[$8db028646a03dbcf$var$index], $8db028646a03dbcf$var$valueStack[$8db028646a03dbcf$var$index] = null, $8db028646a03dbcf$var$index--);
}
function $8db028646a03dbcf$var$push(cursor, value) {
    $8db028646a03dbcf$var$index++;
    $8db028646a03dbcf$var$valueStack[$8db028646a03dbcf$var$index] = cursor.current;
    cursor.current = value;
}
var $8db028646a03dbcf$var$contextStackCursor = $8db028646a03dbcf$var$createCursor(null), $8db028646a03dbcf$var$contextFiberStackCursor = $8db028646a03dbcf$var$createCursor(null), $8db028646a03dbcf$var$rootInstanceStackCursor = $8db028646a03dbcf$var$createCursor(null), $8db028646a03dbcf$var$hostTransitionProviderCursor = $8db028646a03dbcf$var$createCursor(null);
function $8db028646a03dbcf$var$pushHostContainer(fiber, nextRootInstance) {
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$rootInstanceStackCursor, nextRootInstance);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$contextFiberStackCursor, fiber);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $8db028646a03dbcf$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $8db028646a03dbcf$var$getOwnHostContext(fiber), nextRootInstance = $8db028646a03dbcf$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$contextStackCursor);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$contextStackCursor, nextRootInstance);
}
function $8db028646a03dbcf$var$popHostContainer() {
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$contextStackCursor);
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$contextFiberStackCursor);
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$rootInstanceStackCursor);
}
function $8db028646a03dbcf$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $8db028646a03dbcf$var$push($8db028646a03dbcf$var$hostTransitionProviderCursor, fiber);
    var context = $8db028646a03dbcf$var$contextStackCursor.current;
    var JSCompiler_inline_result = $8db028646a03dbcf$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($8db028646a03dbcf$var$push($8db028646a03dbcf$var$contextFiberStackCursor, fiber), $8db028646a03dbcf$var$push($8db028646a03dbcf$var$contextStackCursor, JSCompiler_inline_result));
}
function $8db028646a03dbcf$var$popHostContext(fiber) {
    $8db028646a03dbcf$var$contextFiberStackCursor.current === fiber && ($8db028646a03dbcf$var$pop($8db028646a03dbcf$var$contextStackCursor), $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$contextFiberStackCursor));
    $8db028646a03dbcf$var$hostTransitionProviderCursor.current === fiber && ($8db028646a03dbcf$var$pop($8db028646a03dbcf$var$hostTransitionProviderCursor), $8db028646a03dbcf$var$HostTransitionContext._currentValue = $8db028646a03dbcf$var$sharedNotPendingObject);
}
var $8db028646a03dbcf$var$hasOwnProperty = Object.prototype.hasOwnProperty, $8db028646a03dbcf$var$scheduleCallback$3 = $lugMi.unstable_scheduleCallback, $8db028646a03dbcf$var$cancelCallback$1 = $lugMi.unstable_cancelCallback, $8db028646a03dbcf$var$shouldYield = $lugMi.unstable_shouldYield, $8db028646a03dbcf$var$requestPaint = $lugMi.unstable_requestPaint, $8db028646a03dbcf$var$now = $lugMi.unstable_now, $8db028646a03dbcf$var$getCurrentPriorityLevel = $lugMi.unstable_getCurrentPriorityLevel, $8db028646a03dbcf$var$ImmediatePriority = $lugMi.unstable_ImmediatePriority, $8db028646a03dbcf$var$UserBlockingPriority = $lugMi.unstable_UserBlockingPriority, $8db028646a03dbcf$var$NormalPriority$1 = $lugMi.unstable_NormalPriority, $8db028646a03dbcf$var$LowPriority = $lugMi.unstable_LowPriority, $8db028646a03dbcf$var$IdlePriority = $lugMi.unstable_IdlePriority, $8db028646a03dbcf$var$log$1 = $lugMi.log, $8db028646a03dbcf$var$unstable_setDisableYieldValue = $lugMi.unstable_setDisableYieldValue, $8db028646a03dbcf$var$rendererID = null, $8db028646a03dbcf$var$injectedHook = null;
function $8db028646a03dbcf$var$onCommitRoot(root) {
    if ($8db028646a03dbcf$var$injectedHook && "function" === typeof $8db028646a03dbcf$var$injectedHook.onCommitFiberRoot) try {
        $8db028646a03dbcf$var$injectedHook.onCommitFiberRoot($8db028646a03dbcf$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $8db028646a03dbcf$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $8db028646a03dbcf$var$log$1 && $8db028646a03dbcf$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($8db028646a03dbcf$var$injectedHook && "function" === typeof $8db028646a03dbcf$var$injectedHook.setStrictMode) try {
        $8db028646a03dbcf$var$injectedHook.setStrictMode($8db028646a03dbcf$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $8db028646a03dbcf$var$clz32 = Math.clz32 ? Math.clz32 : $8db028646a03dbcf$var$clz32Fallback, $8db028646a03dbcf$var$log = Math.log, $8db028646a03dbcf$var$LN2 = Math.LN2;
function $8db028646a03dbcf$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($8db028646a03dbcf$var$log(x) / $8db028646a03dbcf$var$LN2 | 0) | 0;
}
var $8db028646a03dbcf$var$nextTransitionLane = 128, $8db028646a03dbcf$var$nextRetryLane = 4194304;
function $8db028646a03dbcf$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $8db028646a03dbcf$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $8db028646a03dbcf$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $8db028646a03dbcf$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $8db028646a03dbcf$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $8db028646a03dbcf$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $8db028646a03dbcf$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $8db028646a03dbcf$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $8db028646a03dbcf$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $8db028646a03dbcf$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8db028646a03dbcf$var$claimNextTransitionLane() {
    var lane = $8db028646a03dbcf$var$nextTransitionLane;
    $8db028646a03dbcf$var$nextTransitionLane <<= 1;
    0 === ($8db028646a03dbcf$var$nextTransitionLane & 4194176) && ($8db028646a03dbcf$var$nextTransitionLane = 128);
    return lane;
}
function $8db028646a03dbcf$var$claimNextRetryLane() {
    var lane = $8db028646a03dbcf$var$nextRetryLane;
    $8db028646a03dbcf$var$nextRetryLane <<= 1;
    0 === ($8db028646a03dbcf$var$nextRetryLane & 62914560) && ($8db028646a03dbcf$var$nextRetryLane = 4194304);
    return lane;
}
function $8db028646a03dbcf$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $8db028646a03dbcf$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $8db028646a03dbcf$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $8db028646a03dbcf$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $8db028646a03dbcf$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $8db028646a03dbcf$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $8db028646a03dbcf$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $8db028646a03dbcf$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $8db028646a03dbcf$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $8db028646a03dbcf$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $8db028646a03dbcf$var$resolveUpdatePriority() {
    var updatePriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $8db028646a03dbcf$var$getEventPriority(updatePriority.type);
}
function $8db028646a03dbcf$var$runWithPriority(priority, fn) {
    var previousPriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
    try {
        return $8db028646a03dbcf$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $8db028646a03dbcf$var$randomKey = Math.random().toString(36).slice(2), $8db028646a03dbcf$var$internalInstanceKey = "__reactFiber$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalPropsKey = "__reactProps$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalContainerInstanceKey = "__reactContainer$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalEventHandlersKey = "__reactEvents$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalEventHandlerListenersKey = "__reactListeners$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalEventHandlesSetKey = "__reactHandles$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalRootNodeResourcesKey = "__reactResources$" + $8db028646a03dbcf$var$randomKey, $8db028646a03dbcf$var$internalHoistableMarker = "__reactMarker$" + $8db028646a03dbcf$var$randomKey;
function $8db028646a03dbcf$var$detachDeletedInstance(node) {
    delete node[$8db028646a03dbcf$var$internalInstanceKey];
    delete node[$8db028646a03dbcf$var$internalPropsKey];
    delete node[$8db028646a03dbcf$var$internalEventHandlersKey];
    delete node[$8db028646a03dbcf$var$internalEventHandlerListenersKey];
    delete node[$8db028646a03dbcf$var$internalEventHandlesSetKey];
}
function $8db028646a03dbcf$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$8db028646a03dbcf$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$8db028646a03dbcf$var$internalContainerInstanceKey] || parentNode[$8db028646a03dbcf$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $8db028646a03dbcf$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$8db028646a03dbcf$var$internalInstanceKey]) return parentNode;
                targetNode = $8db028646a03dbcf$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $8db028646a03dbcf$var$getInstanceFromNode(node) {
    if (node = node[$8db028646a03dbcf$var$internalInstanceKey] || node[$8db028646a03dbcf$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $8db028646a03dbcf$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(33));
}
function $8db028646a03dbcf$var$getResourcesFromRoot(root) {
    var resources = root[$8db028646a03dbcf$var$internalRootNodeResourcesKey];
    resources || (resources = root[$8db028646a03dbcf$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $8db028646a03dbcf$var$markNodeAsHoistable(node) {
    node[$8db028646a03dbcf$var$internalHoistableMarker] = !0;
}
var $8db028646a03dbcf$var$allNativeEvents = new Set(), $8db028646a03dbcf$var$registrationNameDependencies = {};
function $8db028646a03dbcf$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $8db028646a03dbcf$var$registerDirectEvent(registrationName, dependencies);
    $8db028646a03dbcf$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $8db028646a03dbcf$var$registerDirectEvent(registrationName, dependencies) {
    $8db028646a03dbcf$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$8db028646a03dbcf$var$allNativeEvents.add(dependencies[registrationName]);
}
var $8db028646a03dbcf$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8db028646a03dbcf$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $8db028646a03dbcf$var$illegalAttributeNameCache = {}, $8db028646a03dbcf$var$validatedAttributeNameCache = {};
function $8db028646a03dbcf$var$isAttributeNameSafe(attributeName) {
    if ($8db028646a03dbcf$var$hasOwnProperty.call($8db028646a03dbcf$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($8db028646a03dbcf$var$hasOwnProperty.call($8db028646a03dbcf$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($8db028646a03dbcf$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $8db028646a03dbcf$var$validatedAttributeNameCache[attributeName] = !0;
    $8db028646a03dbcf$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $8db028646a03dbcf$var$setValueForAttribute(node, name, value) {
    if ($8db028646a03dbcf$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $8db028646a03dbcf$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $8db028646a03dbcf$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $8db028646a03dbcf$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $8db028646a03dbcf$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $8db028646a03dbcf$var$trackValueOnNode(node) {
    var valueField = $8db028646a03dbcf$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $8db028646a03dbcf$var$track(node) {
    node._valueTracker || (node._valueTracker = $8db028646a03dbcf$var$trackValueOnNode(node));
}
function $8db028646a03dbcf$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $8db028646a03dbcf$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $8db028646a03dbcf$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $8db028646a03dbcf$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $8db028646a03dbcf$var$getToStringValue(value);
        } else element.value !== "" + $8db028646a03dbcf$var$getToStringValue(value) && (element.value = "" + $8db028646a03dbcf$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $8db028646a03dbcf$var$setDefaultValue(element, type, $8db028646a03dbcf$var$getToStringValue(value)) : null != defaultValue ? $8db028646a03dbcf$var$setDefaultValue(element, type, $8db028646a03dbcf$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $8db028646a03dbcf$var$getToStringValue(name) : element.removeAttribute("name");
}
function $8db028646a03dbcf$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $8db028646a03dbcf$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $8db028646a03dbcf$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $8db028646a03dbcf$var$setDefaultValue(node, type, value) {
    "number" === type && $8db028646a03dbcf$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $8db028646a03dbcf$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $8db028646a03dbcf$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $8db028646a03dbcf$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $8db028646a03dbcf$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $8db028646a03dbcf$var$getToStringValue(defaultValue) : "";
}
function $8db028646a03dbcf$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(92));
            if ($8db028646a03dbcf$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $8db028646a03dbcf$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $8db028646a03dbcf$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $8db028646a03dbcf$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $8db028646a03dbcf$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $8db028646a03dbcf$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $8db028646a03dbcf$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $8db028646a03dbcf$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $8db028646a03dbcf$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $8db028646a03dbcf$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8db028646a03dbcf$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $8db028646a03dbcf$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $8db028646a03dbcf$var$sanitizeURL(url) {
    return $8db028646a03dbcf$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $8db028646a03dbcf$var$currentReplayingEvent = null;
function $8db028646a03dbcf$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $8db028646a03dbcf$var$restoreTarget = null, $8db028646a03dbcf$var$restoreQueue = null;
function $8db028646a03dbcf$var$restoreStateOfTarget(target) {
    var internalInstance = $8db028646a03dbcf$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$8db028646a03dbcf$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $8db028646a03dbcf$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$8db028646a03dbcf$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(90));
                            $8db028646a03dbcf$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $8db028646a03dbcf$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $8db028646a03dbcf$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $8db028646a03dbcf$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $8db028646a03dbcf$var$isInsideEventHandler = !1;
function $8db028646a03dbcf$var$batchedUpdates$1(fn, a, b) {
    if ($8db028646a03dbcf$var$isInsideEventHandler) return fn(a, b);
    $8db028646a03dbcf$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($8db028646a03dbcf$var$isInsideEventHandler = !1, null !== $8db028646a03dbcf$var$restoreTarget || null !== $8db028646a03dbcf$var$restoreQueue) {
            if ($8db028646a03dbcf$var$flushSyncWork$1(), $8db028646a03dbcf$var$restoreTarget && (a = $8db028646a03dbcf$var$restoreTarget, fn = $8db028646a03dbcf$var$restoreQueue, $8db028646a03dbcf$var$restoreQueue = $8db028646a03dbcf$var$restoreTarget = null, $8db028646a03dbcf$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$8db028646a03dbcf$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $8db028646a03dbcf$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$8db028646a03dbcf$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $8db028646a03dbcf$var$passiveBrowserEventsSupported = !1;
if ($8db028646a03dbcf$var$canUseDOM) try {
    var $8db028646a03dbcf$var$options = {};
    Object.defineProperty($8db028646a03dbcf$var$options, "passive", {
        get: function() {
            $8db028646a03dbcf$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $8db028646a03dbcf$var$options, $8db028646a03dbcf$var$options);
    window.removeEventListener("test", $8db028646a03dbcf$var$options, $8db028646a03dbcf$var$options);
} catch (e) {
    $8db028646a03dbcf$var$passiveBrowserEventsSupported = !1;
}
var $8db028646a03dbcf$var$root = null, $8db028646a03dbcf$var$startText = null, $8db028646a03dbcf$var$fallbackText = null;
function $8db028646a03dbcf$var$getData() {
    if ($8db028646a03dbcf$var$fallbackText) return $8db028646a03dbcf$var$fallbackText;
    var start, startValue = $8db028646a03dbcf$var$startText, startLength = startValue.length, end, endValue = "value" in $8db028646a03dbcf$var$root ? $8db028646a03dbcf$var$root.value : $8db028646a03dbcf$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $8db028646a03dbcf$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $8db028646a03dbcf$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $8db028646a03dbcf$var$functionThatReturnsTrue() {
    return !0;
}
function $8db028646a03dbcf$var$functionThatReturnsFalse() {
    return !1;
}
function $8db028646a03dbcf$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $8db028646a03dbcf$var$functionThatReturnsTrue : $8db028646a03dbcf$var$functionThatReturnsFalse;
        this.isPropagationStopped = $8db028646a03dbcf$var$functionThatReturnsFalse;
        return this;
    }
    $8db028646a03dbcf$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $8db028646a03dbcf$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $8db028646a03dbcf$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $8db028646a03dbcf$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $8db028646a03dbcf$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8db028646a03dbcf$var$SyntheticEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$EventInterface), $8db028646a03dbcf$var$UIEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$EventInterface, {
    view: 0,
    detail: 0
}), $8db028646a03dbcf$var$SyntheticUIEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$UIEventInterface), $8db028646a03dbcf$var$lastMovementX, $8db028646a03dbcf$var$lastMovementY, $8db028646a03dbcf$var$lastMouseEvent, $8db028646a03dbcf$var$MouseEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8db028646a03dbcf$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $8db028646a03dbcf$var$lastMouseEvent && ($8db028646a03dbcf$var$lastMouseEvent && "mousemove" === event.type ? ($8db028646a03dbcf$var$lastMovementX = event.screenX - $8db028646a03dbcf$var$lastMouseEvent.screenX, $8db028646a03dbcf$var$lastMovementY = event.screenY - $8db028646a03dbcf$var$lastMouseEvent.screenY) : $8db028646a03dbcf$var$lastMovementY = $8db028646a03dbcf$var$lastMovementX = 0, $8db028646a03dbcf$var$lastMouseEvent = event);
        return $8db028646a03dbcf$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $8db028646a03dbcf$var$lastMovementY;
    }
}), $8db028646a03dbcf$var$SyntheticMouseEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$MouseEventInterface), $8db028646a03dbcf$var$DragEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$MouseEventInterface, {
    dataTransfer: 0
}), $8db028646a03dbcf$var$SyntheticDragEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$DragEventInterface), $8db028646a03dbcf$var$FocusEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$UIEventInterface, {
    relatedTarget: 0
}), $8db028646a03dbcf$var$SyntheticFocusEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$FocusEventInterface), $8db028646a03dbcf$var$AnimationEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8db028646a03dbcf$var$SyntheticAnimationEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$AnimationEventInterface), $8db028646a03dbcf$var$ClipboardEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $8db028646a03dbcf$var$SyntheticClipboardEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$ClipboardEventInterface), $8db028646a03dbcf$var$CompositionEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$EventInterface, {
    data: 0
}), $8db028646a03dbcf$var$SyntheticCompositionEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$CompositionEventInterface), $8db028646a03dbcf$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8db028646a03dbcf$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8db028646a03dbcf$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8db028646a03dbcf$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $8db028646a03dbcf$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $8db028646a03dbcf$var$getEventModifierState() {
    return $8db028646a03dbcf$var$modifierStateGetter;
}
var $8db028646a03dbcf$var$KeyboardEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $8db028646a03dbcf$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $8db028646a03dbcf$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $8db028646a03dbcf$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8db028646a03dbcf$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $8db028646a03dbcf$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $8db028646a03dbcf$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $8db028646a03dbcf$var$SyntheticKeyboardEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$KeyboardEventInterface), $8db028646a03dbcf$var$PointerEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8db028646a03dbcf$var$SyntheticPointerEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$PointerEventInterface), $8db028646a03dbcf$var$TouchEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8db028646a03dbcf$var$getEventModifierState
}), $8db028646a03dbcf$var$SyntheticTouchEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$TouchEventInterface), $8db028646a03dbcf$var$TransitionEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8db028646a03dbcf$var$SyntheticTransitionEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$TransitionEventInterface), $8db028646a03dbcf$var$WheelEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8db028646a03dbcf$var$SyntheticWheelEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$WheelEventInterface), $8db028646a03dbcf$var$ToggleEventInterface = $8db028646a03dbcf$var$assign({}, $8db028646a03dbcf$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $8db028646a03dbcf$var$SyntheticToggleEvent = $8db028646a03dbcf$var$createSyntheticEvent($8db028646a03dbcf$var$ToggleEventInterface), $8db028646a03dbcf$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $8db028646a03dbcf$var$canUseCompositionEvent = $8db028646a03dbcf$var$canUseDOM && "CompositionEvent" in window, $8db028646a03dbcf$var$documentMode = null;
$8db028646a03dbcf$var$canUseDOM && "documentMode" in document && ($8db028646a03dbcf$var$documentMode = document.documentMode);
var $8db028646a03dbcf$var$canUseTextInputEvent = $8db028646a03dbcf$var$canUseDOM && "TextEvent" in window && !$8db028646a03dbcf$var$documentMode, $8db028646a03dbcf$var$useFallbackCompositionData = $8db028646a03dbcf$var$canUseDOM && (!$8db028646a03dbcf$var$canUseCompositionEvent || $8db028646a03dbcf$var$documentMode && 8 < $8db028646a03dbcf$var$documentMode && 11 >= $8db028646a03dbcf$var$documentMode), $8db028646a03dbcf$var$SPACEBAR_CHAR = String.fromCharCode(32), $8db028646a03dbcf$var$hasSpaceKeypress = !1;
function $8db028646a03dbcf$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $8db028646a03dbcf$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8db028646a03dbcf$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $8db028646a03dbcf$var$isComposing = !1;
function $8db028646a03dbcf$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $8db028646a03dbcf$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $8db028646a03dbcf$var$hasSpaceKeypress = !0;
            return $8db028646a03dbcf$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $8db028646a03dbcf$var$SPACEBAR_CHAR && $8db028646a03dbcf$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $8db028646a03dbcf$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($8db028646a03dbcf$var$isComposing) return "compositionend" === domEventName || !$8db028646a03dbcf$var$canUseCompositionEvent && $8db028646a03dbcf$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $8db028646a03dbcf$var$getData(), $8db028646a03dbcf$var$fallbackText = $8db028646a03dbcf$var$startText = $8db028646a03dbcf$var$root = null, $8db028646a03dbcf$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $8db028646a03dbcf$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $8db028646a03dbcf$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8db028646a03dbcf$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$8db028646a03dbcf$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $8db028646a03dbcf$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $8db028646a03dbcf$var$restoreTarget ? $8db028646a03dbcf$var$restoreQueue ? $8db028646a03dbcf$var$restoreQueue.push(target) : $8db028646a03dbcf$var$restoreQueue = [
        target
    ] : $8db028646a03dbcf$var$restoreTarget = target;
    inst = $8db028646a03dbcf$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $8db028646a03dbcf$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $8db028646a03dbcf$var$activeElement$1 = null, $8db028646a03dbcf$var$activeElementInst$1 = null;
function $8db028646a03dbcf$var$runEventInBatch(dispatchQueue) {
    $8db028646a03dbcf$var$processDispatchQueue(dispatchQueue, 0);
}
function $8db028646a03dbcf$var$getInstIfValueChanged(targetInst) {
    var targetNode = $8db028646a03dbcf$var$getNodeFromInstance(targetInst);
    if ($8db028646a03dbcf$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $8db028646a03dbcf$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $8db028646a03dbcf$var$isInputEventSupported = !1;
if ($8db028646a03dbcf$var$canUseDOM) {
    var $8db028646a03dbcf$var$JSCompiler_inline_result$jscomp$283;
    if ($8db028646a03dbcf$var$canUseDOM) {
        var $8db028646a03dbcf$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$8db028646a03dbcf$var$isSupported$jscomp$inline_418) {
            var $8db028646a03dbcf$var$element$jscomp$inline_419 = document.createElement("div");
            $8db028646a03dbcf$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $8db028646a03dbcf$var$isSupported$jscomp$inline_418 = "function" === typeof $8db028646a03dbcf$var$element$jscomp$inline_419.oninput;
        }
        $8db028646a03dbcf$var$JSCompiler_inline_result$jscomp$283 = $8db028646a03dbcf$var$isSupported$jscomp$inline_418;
    } else $8db028646a03dbcf$var$JSCompiler_inline_result$jscomp$283 = !1;
    $8db028646a03dbcf$var$isInputEventSupported = $8db028646a03dbcf$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $8db028646a03dbcf$var$stopWatchingForValueChange() {
    $8db028646a03dbcf$var$activeElement$1 && ($8db028646a03dbcf$var$activeElement$1.detachEvent("onpropertychange", $8db028646a03dbcf$var$handlePropertyChange), $8db028646a03dbcf$var$activeElementInst$1 = $8db028646a03dbcf$var$activeElement$1 = null);
}
function $8db028646a03dbcf$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $8db028646a03dbcf$var$getInstIfValueChanged($8db028646a03dbcf$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $8db028646a03dbcf$var$createAndAccumulateChangeEvent(dispatchQueue, $8db028646a03dbcf$var$activeElementInst$1, nativeEvent, $8db028646a03dbcf$var$getEventTarget(nativeEvent));
        $8db028646a03dbcf$var$batchedUpdates$1($8db028646a03dbcf$var$runEventInBatch, dispatchQueue);
    }
}
function $8db028646a03dbcf$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($8db028646a03dbcf$var$stopWatchingForValueChange(), $8db028646a03dbcf$var$activeElement$1 = target, $8db028646a03dbcf$var$activeElementInst$1 = targetInst, $8db028646a03dbcf$var$activeElement$1.attachEvent("onpropertychange", $8db028646a03dbcf$var$handlePropertyChange)) : "focusout" === domEventName && $8db028646a03dbcf$var$stopWatchingForValueChange();
}
function $8db028646a03dbcf$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $8db028646a03dbcf$var$getInstIfValueChanged($8db028646a03dbcf$var$activeElementInst$1);
}
function $8db028646a03dbcf$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $8db028646a03dbcf$var$getInstIfValueChanged(targetInst);
}
function $8db028646a03dbcf$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $8db028646a03dbcf$var$getInstIfValueChanged(targetInst);
}
function $8db028646a03dbcf$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8db028646a03dbcf$var$objectIs = "function" === typeof Object.is ? Object.is : $8db028646a03dbcf$var$is;
function $8db028646a03dbcf$var$shallowEqual(objA, objB) {
    if ($8db028646a03dbcf$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$8db028646a03dbcf$var$hasOwnProperty.call(objB, currentKey) || !$8db028646a03dbcf$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $8db028646a03dbcf$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $8db028646a03dbcf$var$getNodeForCharacterOffset(root, offset) {
    var node = $8db028646a03dbcf$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $8db028646a03dbcf$var$getLeafNode(node);
    }
}
function $8db028646a03dbcf$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $8db028646a03dbcf$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $8db028646a03dbcf$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $8db028646a03dbcf$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $8db028646a03dbcf$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $8db028646a03dbcf$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $8db028646a03dbcf$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $8db028646a03dbcf$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $8db028646a03dbcf$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $8db028646a03dbcf$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $8db028646a03dbcf$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $8db028646a03dbcf$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $8db028646a03dbcf$var$skipSelectionChangeEvent = $8db028646a03dbcf$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $8db028646a03dbcf$var$activeElement = null, $8db028646a03dbcf$var$activeElementInst = null, $8db028646a03dbcf$var$lastSelection = null, $8db028646a03dbcf$var$mouseDown = !1;
function $8db028646a03dbcf$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $8db028646a03dbcf$var$mouseDown || null == $8db028646a03dbcf$var$activeElement || $8db028646a03dbcf$var$activeElement !== $8db028646a03dbcf$var$getActiveElement(doc) || (doc = $8db028646a03dbcf$var$activeElement, "selectionStart" in doc && $8db028646a03dbcf$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $8db028646a03dbcf$var$lastSelection && $8db028646a03dbcf$var$shallowEqual($8db028646a03dbcf$var$lastSelection, doc) || ($8db028646a03dbcf$var$lastSelection = doc, doc = $8db028646a03dbcf$var$accumulateTwoPhaseListeners($8db028646a03dbcf$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $8db028646a03dbcf$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $8db028646a03dbcf$var$activeElement)));
}
function $8db028646a03dbcf$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $8db028646a03dbcf$var$vendorPrefixes = {
    animationend: $8db028646a03dbcf$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $8db028646a03dbcf$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $8db028646a03dbcf$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $8db028646a03dbcf$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $8db028646a03dbcf$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $8db028646a03dbcf$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $8db028646a03dbcf$var$makePrefixMap("Transition", "TransitionEnd")
}, $8db028646a03dbcf$var$prefixedEventNames = {}, $8db028646a03dbcf$var$style = {};
$8db028646a03dbcf$var$canUseDOM && ($8db028646a03dbcf$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $8db028646a03dbcf$var$vendorPrefixes.animationend.animation, delete $8db028646a03dbcf$var$vendorPrefixes.animationiteration.animation, delete $8db028646a03dbcf$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $8db028646a03dbcf$var$vendorPrefixes.transitionend.transition);
function $8db028646a03dbcf$var$getVendorPrefixedEventName(eventName) {
    if ($8db028646a03dbcf$var$prefixedEventNames[eventName]) return $8db028646a03dbcf$var$prefixedEventNames[eventName];
    if (!$8db028646a03dbcf$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $8db028646a03dbcf$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $8db028646a03dbcf$var$style) return $8db028646a03dbcf$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $8db028646a03dbcf$var$ANIMATION_END = $8db028646a03dbcf$var$getVendorPrefixedEventName("animationend"), $8db028646a03dbcf$var$ANIMATION_ITERATION = $8db028646a03dbcf$var$getVendorPrefixedEventName("animationiteration"), $8db028646a03dbcf$var$ANIMATION_START = $8db028646a03dbcf$var$getVendorPrefixedEventName("animationstart"), $8db028646a03dbcf$var$TRANSITION_RUN = $8db028646a03dbcf$var$getVendorPrefixedEventName("transitionrun"), $8db028646a03dbcf$var$TRANSITION_START = $8db028646a03dbcf$var$getVendorPrefixedEventName("transitionstart"), $8db028646a03dbcf$var$TRANSITION_CANCEL = $8db028646a03dbcf$var$getVendorPrefixedEventName("transitioncancel"), $8db028646a03dbcf$var$TRANSITION_END = $8db028646a03dbcf$var$getVendorPrefixedEventName("transitionend"), $8db028646a03dbcf$var$topLevelEventsToReactNames = new Map(), $8db028646a03dbcf$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $8db028646a03dbcf$var$registerSimpleEvent(domEventName, reactName) {
    $8db028646a03dbcf$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $8db028646a03dbcf$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $8db028646a03dbcf$var$concurrentQueues = [], $8db028646a03dbcf$var$concurrentQueuesIndex = 0, $8db028646a03dbcf$var$concurrentlyUpdatedLanes = 0;
function $8db028646a03dbcf$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $8db028646a03dbcf$var$concurrentQueuesIndex, i = $8db028646a03dbcf$var$concurrentlyUpdatedLanes = $8db028646a03dbcf$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $8db028646a03dbcf$var$concurrentQueues[i];
        $8db028646a03dbcf$var$concurrentQueues[i++] = null;
        var queue = $8db028646a03dbcf$var$concurrentQueues[i];
        $8db028646a03dbcf$var$concurrentQueues[i++] = null;
        var update = $8db028646a03dbcf$var$concurrentQueues[i];
        $8db028646a03dbcf$var$concurrentQueues[i++] = null;
        var lane = $8db028646a03dbcf$var$concurrentQueues[i];
        $8db028646a03dbcf$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $8db028646a03dbcf$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $8db028646a03dbcf$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $8db028646a03dbcf$var$concurrentQueues[$8db028646a03dbcf$var$concurrentQueuesIndex++] = fiber;
    $8db028646a03dbcf$var$concurrentQueues[$8db028646a03dbcf$var$concurrentQueuesIndex++] = queue;
    $8db028646a03dbcf$var$concurrentQueues[$8db028646a03dbcf$var$concurrentQueuesIndex++] = update;
    $8db028646a03dbcf$var$concurrentQueues[$8db028646a03dbcf$var$concurrentQueuesIndex++] = lane;
    $8db028646a03dbcf$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $8db028646a03dbcf$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $8db028646a03dbcf$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $8db028646a03dbcf$var$getRootForUpdatedFiber(fiber);
}
function $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $8db028646a03dbcf$var$enqueueUpdate$1(fiber, null, null, lane);
    return $8db028646a03dbcf$var$getRootForUpdatedFiber(fiber);
}
function $8db028646a03dbcf$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $8db028646a03dbcf$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $8db028646a03dbcf$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $8db028646a03dbcf$var$nestedUpdateCount) throw $8db028646a03dbcf$var$nestedUpdateCount = 0, $8db028646a03dbcf$var$rootWithNestedUpdates = null, Error($8db028646a03dbcf$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $8db028646a03dbcf$var$emptyContextObject = {}, $8db028646a03dbcf$var$CapturedStacks = new WeakMap();
function $8db028646a03dbcf$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $8db028646a03dbcf$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $8db028646a03dbcf$var$getStackByFiberInDevAndProd(source)
        };
        $8db028646a03dbcf$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $8db028646a03dbcf$var$getStackByFiberInDevAndProd(source)
    };
}
var $8db028646a03dbcf$var$forkStack = [], $8db028646a03dbcf$var$forkStackIndex = 0, $8db028646a03dbcf$var$treeForkProvider = null, $8db028646a03dbcf$var$treeForkCount = 0, $8db028646a03dbcf$var$idStack = [], $8db028646a03dbcf$var$idStackIndex = 0, $8db028646a03dbcf$var$treeContextProvider = null, $8db028646a03dbcf$var$treeContextId = 1, $8db028646a03dbcf$var$treeContextOverflow = "";
function $8db028646a03dbcf$var$pushTreeFork(workInProgress, totalChildren) {
    $8db028646a03dbcf$var$forkStack[$8db028646a03dbcf$var$forkStackIndex++] = $8db028646a03dbcf$var$treeForkCount;
    $8db028646a03dbcf$var$forkStack[$8db028646a03dbcf$var$forkStackIndex++] = $8db028646a03dbcf$var$treeForkProvider;
    $8db028646a03dbcf$var$treeForkProvider = workInProgress;
    $8db028646a03dbcf$var$treeForkCount = totalChildren;
}
function $8db028646a03dbcf$var$pushTreeId(workInProgress, totalChildren, index) {
    $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex++] = $8db028646a03dbcf$var$treeContextId;
    $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex++] = $8db028646a03dbcf$var$treeContextOverflow;
    $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex++] = $8db028646a03dbcf$var$treeContextProvider;
    $8db028646a03dbcf$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $8db028646a03dbcf$var$treeContextId;
    workInProgress = $8db028646a03dbcf$var$treeContextOverflow;
    var baseLength = 32 - $8db028646a03dbcf$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $8db028646a03dbcf$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $8db028646a03dbcf$var$treeContextId = 1 << 32 - $8db028646a03dbcf$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $8db028646a03dbcf$var$treeContextOverflow = length + workInProgress;
    } else $8db028646a03dbcf$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $8db028646a03dbcf$var$treeContextOverflow = workInProgress;
}
function $8db028646a03dbcf$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($8db028646a03dbcf$var$pushTreeFork(workInProgress, 1), $8db028646a03dbcf$var$pushTreeId(workInProgress, 1, 0));
}
function $8db028646a03dbcf$var$popTreeContext(workInProgress) {
    for(; workInProgress === $8db028646a03dbcf$var$treeForkProvider;)$8db028646a03dbcf$var$treeForkProvider = $8db028646a03dbcf$var$forkStack[--$8db028646a03dbcf$var$forkStackIndex], $8db028646a03dbcf$var$forkStack[$8db028646a03dbcf$var$forkStackIndex] = null, $8db028646a03dbcf$var$treeForkCount = $8db028646a03dbcf$var$forkStack[--$8db028646a03dbcf$var$forkStackIndex], $8db028646a03dbcf$var$forkStack[$8db028646a03dbcf$var$forkStackIndex] = null;
    for(; workInProgress === $8db028646a03dbcf$var$treeContextProvider;)$8db028646a03dbcf$var$treeContextProvider = $8db028646a03dbcf$var$idStack[--$8db028646a03dbcf$var$idStackIndex], $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex] = null, $8db028646a03dbcf$var$treeContextOverflow = $8db028646a03dbcf$var$idStack[--$8db028646a03dbcf$var$idStackIndex], $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex] = null, $8db028646a03dbcf$var$treeContextId = $8db028646a03dbcf$var$idStack[--$8db028646a03dbcf$var$idStackIndex], $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex] = null;
}
var $8db028646a03dbcf$var$hydrationParentFiber = null, $8db028646a03dbcf$var$nextHydratableInstance = null, $8db028646a03dbcf$var$isHydrating = !1, $8db028646a03dbcf$var$hydrationErrors = null, $8db028646a03dbcf$var$rootOrSingletonContext = !1, $8db028646a03dbcf$var$HydrationMismatchException = Error($8db028646a03dbcf$var$formatProdErrorMessage(519));
function $8db028646a03dbcf$var$throwOnHydrationMismatch(fiber) {
    var error = Error($8db028646a03dbcf$var$formatProdErrorMessage(418, ""));
    $8db028646a03dbcf$var$queueHydrationError($8db028646a03dbcf$var$createCapturedValueAtFiber(error, fiber));
    throw $8db028646a03dbcf$var$HydrationMismatchException;
}
function $8db028646a03dbcf$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$8db028646a03dbcf$var$internalInstanceKey] = fiber;
    instance[$8db028646a03dbcf$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("cancel", instance);
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $8db028646a03dbcf$var$mediaEventTypes.length; type++)$8db028646a03dbcf$var$listenToNonDelegatedEvent($8db028646a03dbcf$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("error", instance);
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("invalid", instance);
            $8db028646a03dbcf$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $8db028646a03dbcf$var$track(instance);
            break;
        case "select":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("invalid", instance), $8db028646a03dbcf$var$initTextarea(instance, props.value, props.defaultValue, props.children), $8db028646a03dbcf$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $8db028646a03dbcf$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($8db028646a03dbcf$var$listenToNonDelegatedEvent("beforetoggle", instance), $8db028646a03dbcf$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $8db028646a03dbcf$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $8db028646a03dbcf$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $8db028646a03dbcf$var$noop$1), instance = !0) : instance = !1;
    instance || $8db028646a03dbcf$var$throwOnHydrationMismatch(fiber);
}
function $8db028646a03dbcf$var$popToNextHostParent(fiber) {
    for($8db028646a03dbcf$var$hydrationParentFiber = fiber.return; $8db028646a03dbcf$var$hydrationParentFiber;)switch($8db028646a03dbcf$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $8db028646a03dbcf$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $8db028646a03dbcf$var$rootOrSingletonContext = !1;
            return;
        default:
            $8db028646a03dbcf$var$hydrationParentFiber = $8db028646a03dbcf$var$hydrationParentFiber.return;
    }
}
function $8db028646a03dbcf$var$popHydrationState(fiber) {
    if (fiber !== $8db028646a03dbcf$var$hydrationParentFiber) return !1;
    if (!$8db028646a03dbcf$var$isHydrating) return $8db028646a03dbcf$var$popToNextHostParent(fiber), $8db028646a03dbcf$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $8db028646a03dbcf$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $8db028646a03dbcf$var$nextHydratableInstance && $8db028646a03dbcf$var$throwOnHydrationMismatch(fiber);
    $8db028646a03dbcf$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $8db028646a03dbcf$var$nextHydratableInstance = null;
        }
    } else $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$hydrationParentFiber ? $8db028646a03dbcf$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $8db028646a03dbcf$var$resetHydrationState() {
    $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$hydrationParentFiber = null;
    $8db028646a03dbcf$var$isHydrating = !1;
}
function $8db028646a03dbcf$var$queueHydrationError(error) {
    null === $8db028646a03dbcf$var$hydrationErrors ? $8db028646a03dbcf$var$hydrationErrors = [
        error
    ] : $8db028646a03dbcf$var$hydrationErrors.push(error);
}
var $8db028646a03dbcf$var$SuspenseException = Error($8db028646a03dbcf$var$formatProdErrorMessage(460)), $8db028646a03dbcf$var$SuspenseyCommitException = Error($8db028646a03dbcf$var$formatProdErrorMessage(474)), $8db028646a03dbcf$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $8db028646a03dbcf$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $8db028646a03dbcf$var$noop$3() {}
function $8db028646a03dbcf$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($8db028646a03dbcf$var$noop$3, $8db028646a03dbcf$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $8db028646a03dbcf$var$SuspenseException) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($8db028646a03dbcf$var$noop$3, $8db028646a03dbcf$var$noop$3);
            else {
                thenableState = $8db028646a03dbcf$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $8db028646a03dbcf$var$SuspenseException) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $8db028646a03dbcf$var$suspendedThenable = thenable;
            throw $8db028646a03dbcf$var$SuspenseException;
    }
}
var $8db028646a03dbcf$var$suspendedThenable = null;
function $8db028646a03dbcf$var$getSuspendedThenable() {
    if (null === $8db028646a03dbcf$var$suspendedThenable) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(459));
    var thenable = $8db028646a03dbcf$var$suspendedThenable;
    $8db028646a03dbcf$var$suspendedThenable = null;
    return thenable;
}
var $8db028646a03dbcf$var$thenableState$1 = null, $8db028646a03dbcf$var$thenableIndexCounter$1 = 0;
function $8db028646a03dbcf$var$unwrapThenable(thenable) {
    var index = $8db028646a03dbcf$var$thenableIndexCounter$1;
    $8db028646a03dbcf$var$thenableIndexCounter$1 += 1;
    null === $8db028646a03dbcf$var$thenableState$1 && ($8db028646a03dbcf$var$thenableState$1 = []);
    return $8db028646a03dbcf$var$trackUsedThenable($8db028646a03dbcf$var$thenableState$1, thenable, index);
}
function $8db028646a03dbcf$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $8db028646a03dbcf$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $8db028646a03dbcf$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $8db028646a03dbcf$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $8db028646a03dbcf$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $8db028646a03dbcf$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $8db028646a03dbcf$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $8db028646a03dbcf$var$REACT_LAZY_TYPE && $8db028646a03dbcf$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $8db028646a03dbcf$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $8db028646a03dbcf$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $8db028646a03dbcf$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $8db028646a03dbcf$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $8db028646a03dbcf$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $8db028646a03dbcf$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8db028646a03dbcf$var$REACT_ELEMENT_TYPE:
                    return lanes = $8db028646a03dbcf$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8db028646a03dbcf$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $8db028646a03dbcf$var$REACT_PORTAL_TYPE:
                    return newChild = $8db028646a03dbcf$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $8db028646a03dbcf$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($8db028646a03dbcf$var$isArrayImpl(newChild) || $8db028646a03dbcf$var$getIteratorFn(newChild)) return newChild = $8db028646a03dbcf$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $8db028646a03dbcf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8db028646a03dbcf$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $8db028646a03dbcf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8db028646a03dbcf$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8db028646a03dbcf$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $8db028646a03dbcf$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $8db028646a03dbcf$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($8db028646a03dbcf$var$isArrayImpl(newChild) || $8db028646a03dbcf$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $8db028646a03dbcf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8db028646a03dbcf$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $8db028646a03dbcf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8db028646a03dbcf$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8db028646a03dbcf$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $8db028646a03dbcf$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $8db028646a03dbcf$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($8db028646a03dbcf$var$isArrayImpl(newChild) || $8db028646a03dbcf$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $8db028646a03dbcf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8db028646a03dbcf$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $8db028646a03dbcf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8db028646a03dbcf$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $8db028646a03dbcf$var$isHydrating && $8db028646a03dbcf$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $8db028646a03dbcf$var$isHydrating && $8db028646a03dbcf$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8db028646a03dbcf$var$isHydrating && $8db028646a03dbcf$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $8db028646a03dbcf$var$isHydrating && $8db028646a03dbcf$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $8db028646a03dbcf$var$isHydrating && $8db028646a03dbcf$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8db028646a03dbcf$var$isHydrating && $8db028646a03dbcf$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8db028646a03dbcf$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $8db028646a03dbcf$var$REACT_LAZY_TYPE && $8db028646a03dbcf$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $8db028646a03dbcf$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE ? (lanes = $8db028646a03dbcf$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $8db028646a03dbcf$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8db028646a03dbcf$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $8db028646a03dbcf$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $8db028646a03dbcf$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $8db028646a03dbcf$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($8db028646a03dbcf$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($8db028646a03dbcf$var$getIteratorFn(newChild)) {
                key = $8db028646a03dbcf$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8db028646a03dbcf$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8db028646a03dbcf$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8db028646a03dbcf$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8db028646a03dbcf$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $8db028646a03dbcf$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $8db028646a03dbcf$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $8db028646a03dbcf$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $8db028646a03dbcf$var$SuspenseException) throw x;
            var fiber = $8db028646a03dbcf$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $8db028646a03dbcf$var$reconcileChildFibers = $8db028646a03dbcf$var$createChildReconciler(!0), $8db028646a03dbcf$var$mountChildFibers = $8db028646a03dbcf$var$createChildReconciler(!1), $8db028646a03dbcf$var$currentTreeHiddenStackCursor = $8db028646a03dbcf$var$createCursor(null), $8db028646a03dbcf$var$prevEntangledRenderLanesCursor = $8db028646a03dbcf$var$createCursor(0);
function $8db028646a03dbcf$var$pushHiddenContext(fiber, context) {
    fiber = $8db028646a03dbcf$var$entangledRenderLanes;
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$prevEntangledRenderLanesCursor, fiber);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$currentTreeHiddenStackCursor, context);
    $8db028646a03dbcf$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $8db028646a03dbcf$var$reuseHiddenContextOnStack() {
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$prevEntangledRenderLanesCursor, $8db028646a03dbcf$var$entangledRenderLanes);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$currentTreeHiddenStackCursor, $8db028646a03dbcf$var$currentTreeHiddenStackCursor.current);
}
function $8db028646a03dbcf$var$popHiddenContext() {
    $8db028646a03dbcf$var$entangledRenderLanes = $8db028646a03dbcf$var$prevEntangledRenderLanesCursor.current;
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$currentTreeHiddenStackCursor);
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$prevEntangledRenderLanesCursor);
}
var $8db028646a03dbcf$var$suspenseHandlerStackCursor = $8db028646a03dbcf$var$createCursor(null), $8db028646a03dbcf$var$shellBoundary = null;
function $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, $8db028646a03dbcf$var$suspenseStackCursor.current & 1);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseHandlerStackCursor, handler);
    null === $8db028646a03dbcf$var$shellBoundary && (null === current || null !== $8db028646a03dbcf$var$currentTreeHiddenStackCursor.current ? $8db028646a03dbcf$var$shellBoundary = handler : null !== current.memoizedState && ($8db028646a03dbcf$var$shellBoundary = handler));
}
function $8db028646a03dbcf$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, $8db028646a03dbcf$var$suspenseStackCursor.current), $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseHandlerStackCursor, fiber), null === $8db028646a03dbcf$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($8db028646a03dbcf$var$shellBoundary = fiber);
        }
    } else $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(fiber);
}
function $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack() {
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, $8db028646a03dbcf$var$suspenseStackCursor.current);
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseHandlerStackCursor, $8db028646a03dbcf$var$suspenseHandlerStackCursor.current);
}
function $8db028646a03dbcf$var$popSuspenseHandler(fiber) {
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$suspenseHandlerStackCursor);
    $8db028646a03dbcf$var$shellBoundary === fiber && ($8db028646a03dbcf$var$shellBoundary = null);
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$suspenseStackCursor);
}
var $8db028646a03dbcf$var$suspenseStackCursor = $8db028646a03dbcf$var$createCursor(0);
function $8db028646a03dbcf$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $8db028646a03dbcf$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $8db028646a03dbcf$var$scheduleCallback$2 = $lugMi.unstable_scheduleCallback, $8db028646a03dbcf$var$NormalPriority = $lugMi.unstable_NormalPriority, $8db028646a03dbcf$var$CacheContext = {
    $$typeof: $8db028646a03dbcf$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $8db028646a03dbcf$var$createCache() {
    return {
        controller: new $8db028646a03dbcf$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $8db028646a03dbcf$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $8db028646a03dbcf$var$scheduleCallback$2($8db028646a03dbcf$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $8db028646a03dbcf$var$currentEntangledListeners = null, $8db028646a03dbcf$var$currentEntangledPendingCount = 0, $8db028646a03dbcf$var$currentEntangledLane = 0, $8db028646a03dbcf$var$currentEntangledActionThenable = null;
function $8db028646a03dbcf$var$entangleAsyncAction(transition, thenable) {
    if (null === $8db028646a03dbcf$var$currentEntangledListeners) {
        var entangledListeners = $8db028646a03dbcf$var$currentEntangledListeners = [];
        $8db028646a03dbcf$var$currentEntangledPendingCount = 0;
        $8db028646a03dbcf$var$currentEntangledLane = $8db028646a03dbcf$var$requestTransitionLane();
        $8db028646a03dbcf$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $8db028646a03dbcf$var$currentEntangledPendingCount++;
    thenable.then($8db028646a03dbcf$var$pingEngtangledActionScope, $8db028646a03dbcf$var$pingEngtangledActionScope);
    return thenable;
}
function $8db028646a03dbcf$var$pingEngtangledActionScope() {
    if (0 === --$8db028646a03dbcf$var$currentEntangledPendingCount && null !== $8db028646a03dbcf$var$currentEntangledListeners) {
        null !== $8db028646a03dbcf$var$currentEntangledActionThenable && ($8db028646a03dbcf$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $8db028646a03dbcf$var$currentEntangledListeners;
        $8db028646a03dbcf$var$currentEntangledListeners = null;
        $8db028646a03dbcf$var$currentEntangledLane = 0;
        $8db028646a03dbcf$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $8db028646a03dbcf$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $8db028646a03dbcf$var$prevOnStartTransitionFinish = $8db028646a03dbcf$var$ReactSharedInternals.S;
$8db028646a03dbcf$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $8db028646a03dbcf$var$entangleAsyncAction(transition, returnValue);
    null !== $8db028646a03dbcf$var$prevOnStartTransitionFinish && $8db028646a03dbcf$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $8db028646a03dbcf$var$resumedCache = $8db028646a03dbcf$var$createCursor(null);
function $8db028646a03dbcf$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $8db028646a03dbcf$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $8db028646a03dbcf$var$workInProgressRoot.pooledCache;
}
function $8db028646a03dbcf$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $8db028646a03dbcf$var$push($8db028646a03dbcf$var$resumedCache, $8db028646a03dbcf$var$resumedCache.current) : $8db028646a03dbcf$var$push($8db028646a03dbcf$var$resumedCache, prevCachePool.pool);
}
function $8db028646a03dbcf$var$getSuspendedCache() {
    var cacheFromPool = $8db028646a03dbcf$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $8db028646a03dbcf$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $8db028646a03dbcf$var$renderLanes = 0, $8db028646a03dbcf$var$currentlyRenderingFiber$1 = null, $8db028646a03dbcf$var$currentHook = null, $8db028646a03dbcf$var$workInProgressHook = null, $8db028646a03dbcf$var$didScheduleRenderPhaseUpdate = !1, $8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $8db028646a03dbcf$var$localIdCounter = 0, $8db028646a03dbcf$var$thenableIndexCounter = 0, $8db028646a03dbcf$var$thenableState = null, $8db028646a03dbcf$var$globalClientIdCounter = 0;
function $8db028646a03dbcf$var$throwInvalidHookError() {
    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(321));
}
function $8db028646a03dbcf$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$8db028646a03dbcf$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $8db028646a03dbcf$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $8db028646a03dbcf$var$renderLanes = nextRenderLanes;
    $8db028646a03dbcf$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $8db028646a03dbcf$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $8db028646a03dbcf$var$HooksDispatcherOnMount : $8db028646a03dbcf$var$HooksDispatcherOnUpdate;
    $8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $8db028646a03dbcf$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $8db028646a03dbcf$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $8db028646a03dbcf$var$finishRenderingHooks(current) {
    $8db028646a03dbcf$var$ReactSharedInternals.H = $8db028646a03dbcf$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $8db028646a03dbcf$var$currentHook && null !== $8db028646a03dbcf$var$currentHook.next;
    $8db028646a03dbcf$var$renderLanes = 0;
    $8db028646a03dbcf$var$workInProgressHook = $8db028646a03dbcf$var$currentHook = $8db028646a03dbcf$var$currentlyRenderingFiber$1 = null;
    $8db028646a03dbcf$var$didScheduleRenderPhaseUpdate = !1;
    $8db028646a03dbcf$var$thenableIndexCounter = 0;
    $8db028646a03dbcf$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(300));
    null === current || $8db028646a03dbcf$var$didReceiveUpdate || (current = current.dependencies, null !== current && $8db028646a03dbcf$var$checkIfContextChanged(current) && ($8db028646a03dbcf$var$didReceiveUpdate = !0));
}
function $8db028646a03dbcf$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $8db028646a03dbcf$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass && ($8db028646a03dbcf$var$thenableState = null);
        $8db028646a03dbcf$var$thenableIndexCounter = 0;
        $8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $8db028646a03dbcf$var$workInProgressHook = $8db028646a03dbcf$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $8db028646a03dbcf$var$ReactSharedInternals.H = $8db028646a03dbcf$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $8db028646a03dbcf$var$TransitionAwareHostComponent() {
    var dispatcher = $8db028646a03dbcf$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $8db028646a03dbcf$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $8db028646a03dbcf$var$currentHook ? $8db028646a03dbcf$var$currentHook.memoizedState : null) !== dispatcher && ($8db028646a03dbcf$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $8db028646a03dbcf$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $8db028646a03dbcf$var$localIdCounter;
    $8db028646a03dbcf$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $8db028646a03dbcf$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $8db028646a03dbcf$var$resetHooksOnUnwind(workInProgress) {
    if ($8db028646a03dbcf$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $8db028646a03dbcf$var$didScheduleRenderPhaseUpdate = !1;
    }
    $8db028646a03dbcf$var$renderLanes = 0;
    $8db028646a03dbcf$var$workInProgressHook = $8db028646a03dbcf$var$currentHook = $8db028646a03dbcf$var$currentlyRenderingFiber$1 = null;
    $8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $8db028646a03dbcf$var$thenableIndexCounter = $8db028646a03dbcf$var$localIdCounter = 0;
    $8db028646a03dbcf$var$thenableState = null;
}
function $8db028646a03dbcf$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8db028646a03dbcf$var$workInProgressHook ? $8db028646a03dbcf$var$currentlyRenderingFiber$1.memoizedState = $8db028646a03dbcf$var$workInProgressHook = hook : $8db028646a03dbcf$var$workInProgressHook = $8db028646a03dbcf$var$workInProgressHook.next = hook;
    return $8db028646a03dbcf$var$workInProgressHook;
}
function $8db028646a03dbcf$var$updateWorkInProgressHook() {
    if (null === $8db028646a03dbcf$var$currentHook) {
        var nextCurrentHook = $8db028646a03dbcf$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $8db028646a03dbcf$var$currentHook.next;
    var nextWorkInProgressHook = null === $8db028646a03dbcf$var$workInProgressHook ? $8db028646a03dbcf$var$currentlyRenderingFiber$1.memoizedState : $8db028646a03dbcf$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $8db028646a03dbcf$var$workInProgressHook = nextWorkInProgressHook, $8db028646a03dbcf$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $8db028646a03dbcf$var$currentlyRenderingFiber$1.alternate) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(467));
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(310));
        }
        $8db028646a03dbcf$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $8db028646a03dbcf$var$currentHook.memoizedState,
            baseState: $8db028646a03dbcf$var$currentHook.baseState,
            baseQueue: $8db028646a03dbcf$var$currentHook.baseQueue,
            queue: $8db028646a03dbcf$var$currentHook.queue,
            next: null
        };
        null === $8db028646a03dbcf$var$workInProgressHook ? $8db028646a03dbcf$var$currentlyRenderingFiber$1.memoizedState = $8db028646a03dbcf$var$workInProgressHook = nextCurrentHook : $8db028646a03dbcf$var$workInProgressHook = $8db028646a03dbcf$var$workInProgressHook.next = nextCurrentHook;
    }
    return $8db028646a03dbcf$var$workInProgressHook;
}
var $8db028646a03dbcf$var$createFunctionComponentUpdateQueue;
$8db028646a03dbcf$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $8db028646a03dbcf$var$useThenable(thenable) {
    var index = $8db028646a03dbcf$var$thenableIndexCounter;
    $8db028646a03dbcf$var$thenableIndexCounter += 1;
    null === $8db028646a03dbcf$var$thenableState && ($8db028646a03dbcf$var$thenableState = []);
    thenable = $8db028646a03dbcf$var$trackUsedThenable($8db028646a03dbcf$var$thenableState, thenable, index);
    index = $8db028646a03dbcf$var$currentlyRenderingFiber$1;
    null === (null === $8db028646a03dbcf$var$workInProgressHook ? index.memoizedState : $8db028646a03dbcf$var$workInProgressHook.next) && (index = index.alternate, $8db028646a03dbcf$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $8db028646a03dbcf$var$HooksDispatcherOnMount : $8db028646a03dbcf$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $8db028646a03dbcf$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $8db028646a03dbcf$var$useThenable(usable);
        if (usable.$$typeof === $8db028646a03dbcf$var$REACT_CONTEXT_TYPE) return $8db028646a03dbcf$var$readContext(usable);
    }
    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(438, String(usable)));
}
function $8db028646a03dbcf$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $8db028646a03dbcf$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $8db028646a03dbcf$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $8db028646a03dbcf$var$createFunctionComponentUpdateQueue(), $8db028646a03dbcf$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $8db028646a03dbcf$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $8db028646a03dbcf$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $8db028646a03dbcf$var$updateReducer(reducer) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    return $8db028646a03dbcf$var$updateReducerImpl(hook, $8db028646a03dbcf$var$currentHook, reducer);
}
function $8db028646a03dbcf$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($8db028646a03dbcf$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($8db028646a03dbcf$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $8db028646a03dbcf$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($8db028646a03dbcf$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $8db028646a03dbcf$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $8db028646a03dbcf$var$currentlyRenderingFiber$1.lanes |= revertLane, $8db028646a03dbcf$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $8db028646a03dbcf$var$currentlyRenderingFiber$1.lanes |= updateLane, $8db028646a03dbcf$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$8db028646a03dbcf$var$objectIs(pendingQueue, hook.memoizedState) && ($8db028646a03dbcf$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $8db028646a03dbcf$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $8db028646a03dbcf$var$rerenderReducer(reducer) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $8db028646a03dbcf$var$objectIs(newState, hook.memoizedState) || ($8db028646a03dbcf$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $8db028646a03dbcf$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $8db028646a03dbcf$var$currentlyRenderingFiber$1, hook = $8db028646a03dbcf$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $8db028646a03dbcf$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$8db028646a03dbcf$var$objectIs(($8db028646a03dbcf$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $8db028646a03dbcf$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $8db028646a03dbcf$var$updateEffect($8db028646a03dbcf$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $8db028646a03dbcf$var$workInProgressHook && $8db028646a03dbcf$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $8db028646a03dbcf$var$pushEffect(9, $8db028646a03dbcf$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $8db028646a03dbcf$var$workInProgressRoot) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($8db028646a03dbcf$var$renderLanes & 60) || $8db028646a03dbcf$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $8db028646a03dbcf$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $8db028646a03dbcf$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $8db028646a03dbcf$var$createFunctionComponentUpdateQueue(), $8db028646a03dbcf$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $8db028646a03dbcf$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $8db028646a03dbcf$var$checkIfSnapshotChanged(inst) && $8db028646a03dbcf$var$forceStoreRerender(fiber);
}
function $8db028646a03dbcf$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $8db028646a03dbcf$var$checkIfSnapshotChanged(inst) && $8db028646a03dbcf$var$forceStoreRerender(fiber);
    });
}
function $8db028646a03dbcf$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$8db028646a03dbcf$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $8db028646a03dbcf$var$forceStoreRerender(fiber) {
    var root = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $8db028646a03dbcf$var$mountStateImpl(initialState) {
    var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8db028646a03dbcf$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $8db028646a03dbcf$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8db028646a03dbcf$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $8db028646a03dbcf$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $8db028646a03dbcf$var$updateReducerImpl(hook, $8db028646a03dbcf$var$currentHook, "function" === typeof reducer ? reducer : $8db028646a03dbcf$var$basicStateReducer);
}
function $8db028646a03dbcf$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($8db028646a03dbcf$var$isRenderPhaseUpdate(fiber)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $8db028646a03dbcf$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $8db028646a03dbcf$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $8db028646a03dbcf$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $8db028646a03dbcf$var$ReactSharedInternals.T, currentTransition = {};
        $8db028646a03dbcf$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $8db028646a03dbcf$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $8db028646a03dbcf$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $8db028646a03dbcf$var$onActionError(actionQueue, node, error);
        } finally{
            $8db028646a03dbcf$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $8db028646a03dbcf$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $8db028646a03dbcf$var$onActionError(actionQueue, node, error$60);
    }
}
function $8db028646a03dbcf$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $8db028646a03dbcf$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $8db028646a03dbcf$var$onActionError(actionQueue, node, error);
    }) : $8db028646a03dbcf$var$onActionSuccess(actionQueue, node, returnValue);
}
function $8db028646a03dbcf$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $8db028646a03dbcf$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $8db028646a03dbcf$var$runActionStateAction(actionQueue, nextState)));
}
function $8db028646a03dbcf$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $8db028646a03dbcf$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $8db028646a03dbcf$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $8db028646a03dbcf$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $8db028646a03dbcf$var$mountActionState(action, initialStateProp) {
    if ($8db028646a03dbcf$var$isHydrating) {
        var ssrFormState = $8db028646a03dbcf$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $8db028646a03dbcf$var$currentlyRenderingFiber$1;
                if ($8db028646a03dbcf$var$isHydrating) {
                    if ($8db028646a03dbcf$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $8db028646a03dbcf$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $8db028646a03dbcf$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $8db028646a03dbcf$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $8db028646a03dbcf$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $8db028646a03dbcf$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8db028646a03dbcf$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $8db028646a03dbcf$var$dispatchSetState.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $8db028646a03dbcf$var$mountStateImpl(!1);
    inRootOrSingleton = $8db028646a03dbcf$var$dispatchOptimisticSetState.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $8db028646a03dbcf$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $8db028646a03dbcf$var$dispatchActionState.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $8db028646a03dbcf$var$updateActionState(action) {
    var stateHook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    return $8db028646a03dbcf$var$updateActionStateImpl(stateHook, $8db028646a03dbcf$var$currentHook, action);
}
function $8db028646a03dbcf$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $8db028646a03dbcf$var$updateReducerImpl(stateHook, currentStateHook, $8db028646a03dbcf$var$actionStateReducer)[0];
    stateHook = $8db028646a03dbcf$var$updateReducer($8db028646a03dbcf$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $8db028646a03dbcf$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $8db028646a03dbcf$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($8db028646a03dbcf$var$currentlyRenderingFiber$1.flags |= 2048, $8db028646a03dbcf$var$pushEffect(9, $8db028646a03dbcf$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $8db028646a03dbcf$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $8db028646a03dbcf$var$rerenderActionState(action) {
    var stateHook = $8db028646a03dbcf$var$updateWorkInProgressHook(), currentStateHook = $8db028646a03dbcf$var$currentHook;
    if (null !== currentStateHook) return $8db028646a03dbcf$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $8db028646a03dbcf$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $8db028646a03dbcf$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $8db028646a03dbcf$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $8db028646a03dbcf$var$createFunctionComponentUpdateQueue(), $8db028646a03dbcf$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $8db028646a03dbcf$var$updateRef() {
    return $8db028646a03dbcf$var$updateWorkInProgressHook().memoizedState;
}
function $8db028646a03dbcf$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
    $8db028646a03dbcf$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $8db028646a03dbcf$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $8db028646a03dbcf$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $8db028646a03dbcf$var$currentHook && null !== deps && $8db028646a03dbcf$var$areHookInputsEqual(deps, $8db028646a03dbcf$var$currentHook.memoizedState.deps) ? hook.memoizedState = $8db028646a03dbcf$var$pushEffect(hookFlags, create, inst, deps) : ($8db028646a03dbcf$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $8db028646a03dbcf$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $8db028646a03dbcf$var$mountEffect(create, deps) {
    $8db028646a03dbcf$var$mountEffectImpl(8390656, 8, create, deps);
}
function $8db028646a03dbcf$var$updateEffect(create, deps) {
    $8db028646a03dbcf$var$updateEffectImpl(2048, 8, create, deps);
}
function $8db028646a03dbcf$var$updateInsertionEffect(create, deps) {
    return $8db028646a03dbcf$var$updateEffectImpl(4, 2, create, deps);
}
function $8db028646a03dbcf$var$updateLayoutEffect(create, deps) {
    return $8db028646a03dbcf$var$updateEffectImpl(4, 4, create, deps);
}
function $8db028646a03dbcf$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $8db028646a03dbcf$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $8db028646a03dbcf$var$updateEffectImpl(4, 4, $8db028646a03dbcf$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $8db028646a03dbcf$var$mountDebugValue() {}
function $8db028646a03dbcf$var$updateCallback(callback, deps) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8db028646a03dbcf$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $8db028646a03dbcf$var$updateMemo(nextCreate, deps) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8db028646a03dbcf$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $8db028646a03dbcf$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $8db028646a03dbcf$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $8db028646a03dbcf$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($8db028646a03dbcf$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $8db028646a03dbcf$var$requestDeferredLane();
    $8db028646a03dbcf$var$currentlyRenderingFiber$1.lanes |= hook;
    $8db028646a03dbcf$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $8db028646a03dbcf$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($8db028646a03dbcf$var$objectIs(value, prevValue)) return value;
    if (null !== $8db028646a03dbcf$var$currentTreeHiddenStackCursor.current) return hook = $8db028646a03dbcf$var$mountDeferredValueImpl(hook, value, initialValue), $8db028646a03dbcf$var$objectIs(hook, prevValue) || ($8db028646a03dbcf$var$didReceiveUpdate = !0), hook;
    if (0 === ($8db028646a03dbcf$var$renderLanes & 42)) return $8db028646a03dbcf$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $8db028646a03dbcf$var$requestDeferredLane();
    $8db028646a03dbcf$var$currentlyRenderingFiber$1.lanes |= hook;
    $8db028646a03dbcf$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $8db028646a03dbcf$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
    $8db028646a03dbcf$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $8db028646a03dbcf$var$ReactSharedInternals.T, currentTransition = {};
    $8db028646a03dbcf$var$ReactSharedInternals.T = currentTransition;
    $8db028646a03dbcf$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $8db028646a03dbcf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $8db028646a03dbcf$var$chainThenableValue(returnValue, finishedState);
            $8db028646a03dbcf$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $8db028646a03dbcf$var$requestUpdateLane(fiber));
        } else $8db028646a03dbcf$var$dispatchSetStateInternal(fiber, queue, finishedState, $8db028646a03dbcf$var$requestUpdateLane(fiber));
    } catch (error) {
        $8db028646a03dbcf$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $8db028646a03dbcf$var$requestUpdateLane());
    } finally{
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = previousPriority, $8db028646a03dbcf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8db028646a03dbcf$var$noop$2() {}
function $8db028646a03dbcf$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(476));
    var queue = $8db028646a03dbcf$var$ensureFormComponentIsStateful(formFiber).queue;
    $8db028646a03dbcf$var$startTransition(formFiber, queue, pendingState, $8db028646a03dbcf$var$sharedNotPendingObject, null === action ? $8db028646a03dbcf$var$noop$2 : function() {
        $8db028646a03dbcf$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $8db028646a03dbcf$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $8db028646a03dbcf$var$sharedNotPendingObject,
        baseState: $8db028646a03dbcf$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8db028646a03dbcf$var$basicStateReducer,
            lastRenderedState: $8db028646a03dbcf$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8db028646a03dbcf$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $8db028646a03dbcf$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $8db028646a03dbcf$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $8db028646a03dbcf$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $8db028646a03dbcf$var$requestUpdateLane());
}
function $8db028646a03dbcf$var$useHostTransitionStatus() {
    return $8db028646a03dbcf$var$readContext($8db028646a03dbcf$var$HostTransitionContext);
}
function $8db028646a03dbcf$var$updateId() {
    return $8db028646a03dbcf$var$updateWorkInProgressHook().memoizedState;
}
function $8db028646a03dbcf$var$updateRefresh() {
    return $8db028646a03dbcf$var$updateWorkInProgressHook().memoizedState;
}
function $8db028646a03dbcf$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $8db028646a03dbcf$var$requestUpdateLane();
                fiber = $8db028646a03dbcf$var$createUpdate(lane);
                var root$63 = $8db028646a03dbcf$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($8db028646a03dbcf$var$scheduleUpdateOnFiber(root$63, provider, lane), $8db028646a03dbcf$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $8db028646a03dbcf$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $8db028646a03dbcf$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $8db028646a03dbcf$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $8db028646a03dbcf$var$isRenderPhaseUpdate(fiber) ? $8db028646a03dbcf$var$enqueueRenderPhaseUpdate(queue, action) : (action = $8db028646a03dbcf$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($8db028646a03dbcf$var$scheduleUpdateOnFiber(action, fiber, lane), $8db028646a03dbcf$var$entangleTransitionUpdate(action, queue, lane)));
}
function $8db028646a03dbcf$var$dispatchSetState(fiber, queue, action) {
    var lane = $8db028646a03dbcf$var$requestUpdateLane();
    $8db028646a03dbcf$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $8db028646a03dbcf$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8db028646a03dbcf$var$isRenderPhaseUpdate(fiber)) $8db028646a03dbcf$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($8db028646a03dbcf$var$objectIs(eagerState, currentState)) return $8db028646a03dbcf$var$enqueueUpdate$1(fiber, queue, update, 0), null === $8db028646a03dbcf$var$workInProgressRoot && $8db028646a03dbcf$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $8db028646a03dbcf$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $8db028646a03dbcf$var$scheduleUpdateOnFiber(action, fiber, lane), $8db028646a03dbcf$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $8db028646a03dbcf$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $8db028646a03dbcf$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8db028646a03dbcf$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $8db028646a03dbcf$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $8db028646a03dbcf$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $8db028646a03dbcf$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $8db028646a03dbcf$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $8db028646a03dbcf$var$currentlyRenderingFiber$1;
}
function $8db028646a03dbcf$var$enqueueRenderPhaseUpdate(queue, update) {
    $8db028646a03dbcf$var$didScheduleRenderPhaseUpdateDuringThisPass = $8db028646a03dbcf$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $8db028646a03dbcf$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $8db028646a03dbcf$var$markRootEntangled(root, lane);
    }
}
var $8db028646a03dbcf$var$ContextOnlyDispatcher = {
    readContext: $8db028646a03dbcf$var$readContext,
    use: $8db028646a03dbcf$var$use,
    useCallback: $8db028646a03dbcf$var$throwInvalidHookError,
    useContext: $8db028646a03dbcf$var$throwInvalidHookError,
    useEffect: $8db028646a03dbcf$var$throwInvalidHookError,
    useImperativeHandle: $8db028646a03dbcf$var$throwInvalidHookError,
    useLayoutEffect: $8db028646a03dbcf$var$throwInvalidHookError,
    useInsertionEffect: $8db028646a03dbcf$var$throwInvalidHookError,
    useMemo: $8db028646a03dbcf$var$throwInvalidHookError,
    useReducer: $8db028646a03dbcf$var$throwInvalidHookError,
    useRef: $8db028646a03dbcf$var$throwInvalidHookError,
    useState: $8db028646a03dbcf$var$throwInvalidHookError,
    useDebugValue: $8db028646a03dbcf$var$throwInvalidHookError,
    useDeferredValue: $8db028646a03dbcf$var$throwInvalidHookError,
    useTransition: $8db028646a03dbcf$var$throwInvalidHookError,
    useSyncExternalStore: $8db028646a03dbcf$var$throwInvalidHookError,
    useId: $8db028646a03dbcf$var$throwInvalidHookError
};
$8db028646a03dbcf$var$ContextOnlyDispatcher.useCacheRefresh = $8db028646a03dbcf$var$throwInvalidHookError;
$8db028646a03dbcf$var$ContextOnlyDispatcher.useMemoCache = $8db028646a03dbcf$var$throwInvalidHookError;
$8db028646a03dbcf$var$ContextOnlyDispatcher.useHostTransitionStatus = $8db028646a03dbcf$var$throwInvalidHookError;
$8db028646a03dbcf$var$ContextOnlyDispatcher.useFormState = $8db028646a03dbcf$var$throwInvalidHookError;
$8db028646a03dbcf$var$ContextOnlyDispatcher.useActionState = $8db028646a03dbcf$var$throwInvalidHookError;
$8db028646a03dbcf$var$ContextOnlyDispatcher.useOptimistic = $8db028646a03dbcf$var$throwInvalidHookError;
var $8db028646a03dbcf$var$HooksDispatcherOnMount = {
    readContext: $8db028646a03dbcf$var$readContext,
    use: $8db028646a03dbcf$var$use,
    useCallback: function(callback, deps) {
        $8db028646a03dbcf$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $8db028646a03dbcf$var$readContext,
    useEffect: $8db028646a03dbcf$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $8db028646a03dbcf$var$mountEffectImpl(4194308, 4, $8db028646a03dbcf$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $8db028646a03dbcf$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $8db028646a03dbcf$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8db028646a03dbcf$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $8db028646a03dbcf$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($8db028646a03dbcf$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $8db028646a03dbcf$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $8db028646a03dbcf$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $8db028646a03dbcf$var$dispatchReducerAction.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $8db028646a03dbcf$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $8db028646a03dbcf$var$dispatchSetState.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $8db028646a03dbcf$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
        return $8db028646a03dbcf$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $8db028646a03dbcf$var$mountStateImpl(!1);
        stateHook = $8db028646a03dbcf$var$startTransition.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $8db028646a03dbcf$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $8db028646a03dbcf$var$currentlyRenderingFiber$1, hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
        if ($8db028646a03dbcf$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $8db028646a03dbcf$var$workInProgressRoot) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(349));
            0 !== ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 60) || $8db028646a03dbcf$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $8db028646a03dbcf$var$mountEffect($8db028646a03dbcf$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $8db028646a03dbcf$var$pushEffect(9, $8db028646a03dbcf$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $8db028646a03dbcf$var$mountWorkInProgressHook(), identifierPrefix = $8db028646a03dbcf$var$workInProgressRoot.identifierPrefix;
        if ($8db028646a03dbcf$var$isHydrating) {
            var JSCompiler_inline_result = $8db028646a03dbcf$var$treeContextOverflow;
            var idWithLeadingBit = $8db028646a03dbcf$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $8db028646a03dbcf$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $8db028646a03dbcf$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $8db028646a03dbcf$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $8db028646a03dbcf$var$mountWorkInProgressHook().memoizedState = $8db028646a03dbcf$var$refreshCache.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1);
    }
};
$8db028646a03dbcf$var$HooksDispatcherOnMount.useMemoCache = $8db028646a03dbcf$var$useMemoCache;
$8db028646a03dbcf$var$HooksDispatcherOnMount.useHostTransitionStatus = $8db028646a03dbcf$var$useHostTransitionStatus;
$8db028646a03dbcf$var$HooksDispatcherOnMount.useFormState = $8db028646a03dbcf$var$mountActionState;
$8db028646a03dbcf$var$HooksDispatcherOnMount.useActionState = $8db028646a03dbcf$var$mountActionState;
$8db028646a03dbcf$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $8db028646a03dbcf$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $8db028646a03dbcf$var$dispatchOptimisticSetState.bind(null, $8db028646a03dbcf$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $8db028646a03dbcf$var$HooksDispatcherOnUpdate = {
    readContext: $8db028646a03dbcf$var$readContext,
    use: $8db028646a03dbcf$var$use,
    useCallback: $8db028646a03dbcf$var$updateCallback,
    useContext: $8db028646a03dbcf$var$readContext,
    useEffect: $8db028646a03dbcf$var$updateEffect,
    useImperativeHandle: $8db028646a03dbcf$var$updateImperativeHandle,
    useInsertionEffect: $8db028646a03dbcf$var$updateInsertionEffect,
    useLayoutEffect: $8db028646a03dbcf$var$updateLayoutEffect,
    useMemo: $8db028646a03dbcf$var$updateMemo,
    useReducer: $8db028646a03dbcf$var$updateReducer,
    useRef: $8db028646a03dbcf$var$updateRef,
    useState: function() {
        return $8db028646a03dbcf$var$updateReducer($8db028646a03dbcf$var$basicStateReducer);
    },
    useDebugValue: $8db028646a03dbcf$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
        return $8db028646a03dbcf$var$updateDeferredValueImpl(hook, $8db028646a03dbcf$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8db028646a03dbcf$var$updateReducer($8db028646a03dbcf$var$basicStateReducer)[0], start = $8db028646a03dbcf$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8db028646a03dbcf$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8db028646a03dbcf$var$updateSyncExternalStore,
    useId: $8db028646a03dbcf$var$updateId
};
$8db028646a03dbcf$var$HooksDispatcherOnUpdate.useCacheRefresh = $8db028646a03dbcf$var$updateRefresh;
$8db028646a03dbcf$var$HooksDispatcherOnUpdate.useMemoCache = $8db028646a03dbcf$var$useMemoCache;
$8db028646a03dbcf$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $8db028646a03dbcf$var$useHostTransitionStatus;
$8db028646a03dbcf$var$HooksDispatcherOnUpdate.useFormState = $8db028646a03dbcf$var$updateActionState;
$8db028646a03dbcf$var$HooksDispatcherOnUpdate.useActionState = $8db028646a03dbcf$var$updateActionState;
$8db028646a03dbcf$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    return $8db028646a03dbcf$var$updateOptimisticImpl(hook, $8db028646a03dbcf$var$currentHook, passthrough, reducer);
};
var $8db028646a03dbcf$var$HooksDispatcherOnRerender = {
    readContext: $8db028646a03dbcf$var$readContext,
    use: $8db028646a03dbcf$var$use,
    useCallback: $8db028646a03dbcf$var$updateCallback,
    useContext: $8db028646a03dbcf$var$readContext,
    useEffect: $8db028646a03dbcf$var$updateEffect,
    useImperativeHandle: $8db028646a03dbcf$var$updateImperativeHandle,
    useInsertionEffect: $8db028646a03dbcf$var$updateInsertionEffect,
    useLayoutEffect: $8db028646a03dbcf$var$updateLayoutEffect,
    useMemo: $8db028646a03dbcf$var$updateMemo,
    useReducer: $8db028646a03dbcf$var$rerenderReducer,
    useRef: $8db028646a03dbcf$var$updateRef,
    useState: function() {
        return $8db028646a03dbcf$var$rerenderReducer($8db028646a03dbcf$var$basicStateReducer);
    },
    useDebugValue: $8db028646a03dbcf$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
        return null === $8db028646a03dbcf$var$currentHook ? $8db028646a03dbcf$var$mountDeferredValueImpl(hook, value, initialValue) : $8db028646a03dbcf$var$updateDeferredValueImpl(hook, $8db028646a03dbcf$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8db028646a03dbcf$var$rerenderReducer($8db028646a03dbcf$var$basicStateReducer)[0], start = $8db028646a03dbcf$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8db028646a03dbcf$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8db028646a03dbcf$var$updateSyncExternalStore,
    useId: $8db028646a03dbcf$var$updateId
};
$8db028646a03dbcf$var$HooksDispatcherOnRerender.useCacheRefresh = $8db028646a03dbcf$var$updateRefresh;
$8db028646a03dbcf$var$HooksDispatcherOnRerender.useMemoCache = $8db028646a03dbcf$var$useMemoCache;
$8db028646a03dbcf$var$HooksDispatcherOnRerender.useHostTransitionStatus = $8db028646a03dbcf$var$useHostTransitionStatus;
$8db028646a03dbcf$var$HooksDispatcherOnRerender.useFormState = $8db028646a03dbcf$var$rerenderActionState;
$8db028646a03dbcf$var$HooksDispatcherOnRerender.useActionState = $8db028646a03dbcf$var$rerenderActionState;
$8db028646a03dbcf$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $8db028646a03dbcf$var$updateWorkInProgressHook();
    if (null !== $8db028646a03dbcf$var$currentHook) return $8db028646a03dbcf$var$updateOptimisticImpl(hook, $8db028646a03dbcf$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $8db028646a03dbcf$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $8db028646a03dbcf$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $8db028646a03dbcf$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $8db028646a03dbcf$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8db028646a03dbcf$var$requestUpdateLane(), update = $8db028646a03dbcf$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8db028646a03dbcf$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8db028646a03dbcf$var$scheduleUpdateOnFiber(payload, inst, lane), $8db028646a03dbcf$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8db028646a03dbcf$var$requestUpdateLane(), update = $8db028646a03dbcf$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8db028646a03dbcf$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8db028646a03dbcf$var$scheduleUpdateOnFiber(payload, inst, lane), $8db028646a03dbcf$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $8db028646a03dbcf$var$requestUpdateLane(), update = $8db028646a03dbcf$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $8db028646a03dbcf$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($8db028646a03dbcf$var$scheduleUpdateOnFiber(callback, inst, lane), $8db028646a03dbcf$var$entangleTransitions(callback, inst, lane));
    }
};
function $8db028646a03dbcf$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$8db028646a03dbcf$var$shallowEqual(oldProps, newProps) || !$8db028646a03dbcf$var$shallowEqual(oldState, newState) : !0;
}
function $8db028646a03dbcf$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $8db028646a03dbcf$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $8db028646a03dbcf$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $8db028646a03dbcf$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $8db028646a03dbcf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $7G10b && "function" === typeof $7G10b.emit) {
        $7G10b.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $8db028646a03dbcf$var$defaultOnUncaughtError(error) {
    $8db028646a03dbcf$var$reportGlobalError(error);
}
function $8db028646a03dbcf$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $8db028646a03dbcf$var$defaultOnRecoverableError(error) {
    $8db028646a03dbcf$var$reportGlobalError(error);
}
function $8db028646a03dbcf$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $8db028646a03dbcf$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $8db028646a03dbcf$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $8db028646a03dbcf$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $8db028646a03dbcf$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $8db028646a03dbcf$var$createClassErrorUpdate(lane) {
    lane = $8db028646a03dbcf$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $8db028646a03dbcf$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $8db028646a03dbcf$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $8db028646a03dbcf$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed ? $8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $8db028646a03dbcf$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $8db028646a03dbcf$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $8db028646a03dbcf$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $8db028646a03dbcf$var$shellBoundary ? $8db028646a03dbcf$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $8db028646a03dbcf$var$workInProgressRootExitStatus && ($8db028646a03dbcf$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $8db028646a03dbcf$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $8db028646a03dbcf$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $8db028646a03dbcf$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $8db028646a03dbcf$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $8db028646a03dbcf$var$attachPingListener(root, value, rootRenderLanes);
        $8db028646a03dbcf$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($8db028646a03dbcf$var$isHydrating) return returnFiber = $8db028646a03dbcf$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $8db028646a03dbcf$var$HydrationMismatchException && (root = Error($8db028646a03dbcf$var$formatProdErrorMessage(422), {
        cause: value
    }), $8db028646a03dbcf$var$queueHydrationError($8db028646a03dbcf$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $8db028646a03dbcf$var$HydrationMismatchException && (returnFiber = Error($8db028646a03dbcf$var$formatProdErrorMessage(423), {
        cause: value
    }), $8db028646a03dbcf$var$queueHydrationError($8db028646a03dbcf$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $8db028646a03dbcf$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $8db028646a03dbcf$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $8db028646a03dbcf$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $8db028646a03dbcf$var$workInProgressRootExitStatus && ($8db028646a03dbcf$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($8db028646a03dbcf$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $8db028646a03dbcf$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $8db028646a03dbcf$var$workInProgressRootConcurrentErrors ? $8db028646a03dbcf$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $8db028646a03dbcf$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $8db028646a03dbcf$var$workInProgressRootExitStatus && ($8db028646a03dbcf$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $8db028646a03dbcf$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $8db028646a03dbcf$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $8db028646a03dbcf$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed || !$8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $8db028646a03dbcf$var$createClassErrorUpdate(rootRenderLanes), $8db028646a03dbcf$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $8db028646a03dbcf$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $8db028646a03dbcf$var$SelectiveHydrationException = Error($8db028646a03dbcf$var$formatProdErrorMessage(461)), $8db028646a03dbcf$var$didReceiveUpdate = !1;
function $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $8db028646a03dbcf$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $8db028646a03dbcf$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $8db028646a03dbcf$var$prepareToReadContext(workInProgress);
    nextProps = $8db028646a03dbcf$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $8db028646a03dbcf$var$checkDidRenderIdHook();
    if (null !== current && !$8db028646a03dbcf$var$didReceiveUpdate) return $8db028646a03dbcf$var$bailoutHooks(current, workInProgress, renderLanes), $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8db028646a03dbcf$var$isHydrating && key && $8db028646a03dbcf$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8db028646a03dbcf$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$8db028646a03dbcf$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $8db028646a03dbcf$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $8db028646a03dbcf$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$8db028646a03dbcf$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $8db028646a03dbcf$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $8db028646a03dbcf$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $8db028646a03dbcf$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($8db028646a03dbcf$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($8db028646a03dbcf$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $8db028646a03dbcf$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($8db028646a03dbcf$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $8db028646a03dbcf$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $8db028646a03dbcf$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $8db028646a03dbcf$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $8db028646a03dbcf$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $8db028646a03dbcf$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $8db028646a03dbcf$var$pushHiddenContext(workInProgress, prevState) : $8db028646a03dbcf$var$reuseHiddenContextOnStack(), $8db028646a03dbcf$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $8db028646a03dbcf$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($8db028646a03dbcf$var$pushTransition(workInProgress, prevState.cachePool), $8db028646a03dbcf$var$pushHiddenContext(workInProgress, prevState), $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $8db028646a03dbcf$var$pushTransition(workInProgress, null), $8db028646a03dbcf$var$reuseHiddenContextOnStack(), $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress));
    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $8db028646a03dbcf$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $8db028646a03dbcf$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $8db028646a03dbcf$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $8db028646a03dbcf$var$pushTransition(workInProgress, null);
    $8db028646a03dbcf$var$reuseHiddenContextOnStack();
    $8db028646a03dbcf$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $8db028646a03dbcf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $8db028646a03dbcf$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $8db028646a03dbcf$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8db028646a03dbcf$var$prepareToReadContext(workInProgress);
    Component = $8db028646a03dbcf$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $8db028646a03dbcf$var$checkDidRenderIdHook();
    if (null !== current && !$8db028646a03dbcf$var$didReceiveUpdate) return $8db028646a03dbcf$var$bailoutHooks(current, workInProgress, renderLanes), $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8db028646a03dbcf$var$isHydrating && nextProps && $8db028646a03dbcf$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $8db028646a03dbcf$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $8db028646a03dbcf$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $8db028646a03dbcf$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $8db028646a03dbcf$var$finishRenderingHooks(current);
    Component = $8db028646a03dbcf$var$checkDidRenderIdHook();
    if (null !== current && !$8db028646a03dbcf$var$didReceiveUpdate) return $8db028646a03dbcf$var$bailoutHooks(current, workInProgress, renderLanes), $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8db028646a03dbcf$var$isHydrating && Component && $8db028646a03dbcf$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8db028646a03dbcf$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8db028646a03dbcf$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $8db028646a03dbcf$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $8db028646a03dbcf$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $8db028646a03dbcf$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $8db028646a03dbcf$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $8db028646a03dbcf$var$readContext(contextType) : $8db028646a03dbcf$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($8db028646a03dbcf$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $8db028646a03dbcf$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $8db028646a03dbcf$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $8db028646a03dbcf$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $8db028646a03dbcf$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $8db028646a03dbcf$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $8db028646a03dbcf$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $8db028646a03dbcf$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $8db028646a03dbcf$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8db028646a03dbcf$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8db028646a03dbcf$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $8db028646a03dbcf$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($8db028646a03dbcf$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $8db028646a03dbcf$var$hasForceUpdate || $8db028646a03dbcf$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $8db028646a03dbcf$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $8db028646a03dbcf$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $8db028646a03dbcf$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $8db028646a03dbcf$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $8db028646a03dbcf$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $8db028646a03dbcf$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8db028646a03dbcf$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8db028646a03dbcf$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $8db028646a03dbcf$var$hasForceUpdate || null !== current && null !== current.dependencies && $8db028646a03dbcf$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($8db028646a03dbcf$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $8db028646a03dbcf$var$hasForceUpdate || $8db028646a03dbcf$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $8db028646a03dbcf$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $8db028646a03dbcf$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $8db028646a03dbcf$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $8db028646a03dbcf$var$resetHydrationState();
    workInProgress.flags |= 256;
    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $8db028646a03dbcf$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8db028646a03dbcf$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $8db028646a03dbcf$var$getSuspendedCache()
    };
}
function $8db028646a03dbcf$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $8db028646a03dbcf$var$workInProgressDeferredLane);
    return current;
}
function $8db028646a03dbcf$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($8db028646a03dbcf$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($8db028646a03dbcf$var$isHydrating) {
            showFallback ? $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($8db028646a03dbcf$var$isHydrating) {
                var nextInstance = $8db028646a03dbcf$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $8db028646a03dbcf$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $8db028646a03dbcf$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $8db028646a03dbcf$var$treeContextProvider ? {
                            id: $8db028646a03dbcf$var$treeContextId,
                            overflow: $8db028646a03dbcf$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $8db028646a03dbcf$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $8db028646a03dbcf$var$hydrationParentFiber = workInProgress, $8db028646a03dbcf$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $8db028646a03dbcf$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $8db028646a03dbcf$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $8db028646a03dbcf$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $8db028646a03dbcf$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $8db028646a03dbcf$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $8db028646a03dbcf$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8db028646a03dbcf$var$SUSPENDED_MARKER, nextProps;
        $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $8db028646a03dbcf$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $8db028646a03dbcf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $8db028646a03dbcf$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $8db028646a03dbcf$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $8db028646a03dbcf$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8db028646a03dbcf$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8db028646a03dbcf$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($8db028646a03dbcf$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $8db028646a03dbcf$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $8db028646a03dbcf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($8db028646a03dbcf$var$didReceiveUpdate || $8db028646a03dbcf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $8db028646a03dbcf$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $8db028646a03dbcf$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(current, nextProps), $8db028646a03dbcf$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $8db028646a03dbcf$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $8db028646a03dbcf$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8db028646a03dbcf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $8db028646a03dbcf$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$getNextHydratable(nextInstance.nextSibling), $8db028646a03dbcf$var$hydrationParentFiber = workInProgress, $8db028646a03dbcf$var$isHydrating = !0, $8db028646a03dbcf$var$hydrationErrors = null, $8db028646a03dbcf$var$rootOrSingletonContext = !1, null !== current && ($8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex++] = $8db028646a03dbcf$var$treeContextId, $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex++] = $8db028646a03dbcf$var$treeContextOverflow, $8db028646a03dbcf$var$idStack[$8db028646a03dbcf$var$idStackIndex++] = $8db028646a03dbcf$var$treeContextProvider, $8db028646a03dbcf$var$treeContextId = current.id, $8db028646a03dbcf$var$treeContextOverflow = current.overflow, $8db028646a03dbcf$var$treeContextProvider = workInProgress), workInProgress = $8db028646a03dbcf$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $8db028646a03dbcf$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $8db028646a03dbcf$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $8db028646a03dbcf$var$createWorkInProgress(digest, showFallback) : (showFallback = $8db028646a03dbcf$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $8db028646a03dbcf$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $8db028646a03dbcf$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $8db028646a03dbcf$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $8db028646a03dbcf$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8db028646a03dbcf$var$SUSPENDED_MARKER, nextProps;
    $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $8db028646a03dbcf$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $8db028646a03dbcf$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $8db028646a03dbcf$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $8db028646a03dbcf$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $8db028646a03dbcf$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $8db028646a03dbcf$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8db028646a03dbcf$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $8db028646a03dbcf$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $8db028646a03dbcf$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $8db028646a03dbcf$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $8db028646a03dbcf$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $8db028646a03dbcf$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $8db028646a03dbcf$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $8db028646a03dbcf$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $8db028646a03dbcf$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $8db028646a03dbcf$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $8db028646a03dbcf$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $8db028646a03dbcf$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $8db028646a03dbcf$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $8db028646a03dbcf$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($8db028646a03dbcf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $8db028646a03dbcf$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $8db028646a03dbcf$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $8db028646a03dbcf$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $8db028646a03dbcf$var$checkIfContextChanged(current) ? !0 : !1;
}
function $8db028646a03dbcf$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $8db028646a03dbcf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $8db028646a03dbcf$var$pushProvider(workInProgress, $8db028646a03dbcf$var$CacheContext, current.memoizedState.cache);
            $8db028646a03dbcf$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $8db028646a03dbcf$var$pushHostContext(workInProgress);
            break;
        case 4:
            $8db028646a03dbcf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $8db028646a03dbcf$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $8db028646a03dbcf$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $8db028646a03dbcf$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($8db028646a03dbcf$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $8db028646a03dbcf$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, $8db028646a03dbcf$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $8db028646a03dbcf$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $8db028646a03dbcf$var$pushProvider(workInProgress, $8db028646a03dbcf$var$CacheContext, current.memoizedState.cache);
    }
    return $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $8db028646a03dbcf$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $8db028646a03dbcf$var$didReceiveUpdate = !0;
        else {
            if (!$8db028646a03dbcf$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $8db028646a03dbcf$var$didReceiveUpdate = !1, $8db028646a03dbcf$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $8db028646a03dbcf$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $8db028646a03dbcf$var$didReceiveUpdate = !1, $8db028646a03dbcf$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $8db028646a03dbcf$var$pushTreeId(workInProgress, $8db028646a03dbcf$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $8db028646a03dbcf$var$shouldConstruct(lazyComponent) ? (current = $8db028646a03dbcf$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $8db028646a03dbcf$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $8db028646a03dbcf$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $8db028646a03dbcf$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $8db028646a03dbcf$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $8db028646a03dbcf$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $8db028646a03dbcf$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $8db028646a03dbcf$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $8db028646a03dbcf$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $8db028646a03dbcf$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $8db028646a03dbcf$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $8db028646a03dbcf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $8db028646a03dbcf$var$cloneUpdateQueue(current, workInProgress);
                $8db028646a03dbcf$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $8db028646a03dbcf$var$pushProvider(workInProgress, $8db028646a03dbcf$var$CacheContext, nextProps);
                nextProps !== init.cache && $8db028646a03dbcf$var$propagateContextChanges(workInProgress, [
                    $8db028646a03dbcf$var$CacheContext
                ], renderLanes, !0);
                $8db028646a03dbcf$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $8db028646a03dbcf$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $8db028646a03dbcf$var$createCapturedValueAtFiber(Error($8db028646a03dbcf$var$formatProdErrorMessage(424)), workInProgress);
                        $8db028646a03dbcf$var$queueHydrationError(lazyComponent);
                        workInProgress = $8db028646a03dbcf$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $8db028646a03dbcf$var$hydrationParentFiber = workInProgress, $8db028646a03dbcf$var$isHydrating = !0, $8db028646a03dbcf$var$hydrationErrors = null, $8db028646a03dbcf$var$rootOrSingletonContext = !0, renderLanes = $8db028646a03dbcf$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $8db028646a03dbcf$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $8db028646a03dbcf$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $8db028646a03dbcf$var$markRef(current, workInProgress), null === current ? (renderLanes = $8db028646a03dbcf$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $8db028646a03dbcf$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $8db028646a03dbcf$var$getOwnerDocumentFromRootContainer($8db028646a03dbcf$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$8db028646a03dbcf$var$internalInstanceKey] = workInProgress, lazyComponent[$8db028646a03dbcf$var$internalPropsKey] = current, $8db028646a03dbcf$var$setInitialProperties(lazyComponent, renderLanes, current), $8db028646a03dbcf$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $8db028646a03dbcf$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $8db028646a03dbcf$var$pushHostContext(workInProgress), null === current && $8db028646a03dbcf$var$isHydrating && (lazyComponent = workInProgress.stateNode = $8db028646a03dbcf$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $8db028646a03dbcf$var$rootInstanceStackCursor.current), $8db028646a03dbcf$var$hydrationParentFiber = workInProgress, $8db028646a03dbcf$var$rootOrSingletonContext = !0, $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $8db028646a03dbcf$var$isHydrating ? $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $8db028646a03dbcf$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $8db028646a03dbcf$var$isHydrating) {
                if (init = lazyComponent = $8db028646a03dbcf$var$nextHydratableInstance) lazyComponent = $8db028646a03dbcf$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $8db028646a03dbcf$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $8db028646a03dbcf$var$hydrationParentFiber = workInProgress, $8db028646a03dbcf$var$nextHydratableInstance = $8db028646a03dbcf$var$getNextHydratable(lazyComponent.firstChild), $8db028646a03dbcf$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $8db028646a03dbcf$var$throwOnHydrationMismatch(workInProgress);
            }
            $8db028646a03dbcf$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $8db028646a03dbcf$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $8db028646a03dbcf$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $8db028646a03dbcf$var$renderWithHooks(current, workInProgress, $8db028646a03dbcf$var$TransitionAwareHostComponent, null, null, renderLanes), $8db028646a03dbcf$var$HostTransitionContext._currentValue = init);
            $8db028646a03dbcf$var$markRef(current, workInProgress);
            $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $8db028646a03dbcf$var$isHydrating) {
                if (current = renderLanes = $8db028646a03dbcf$var$nextHydratableInstance) renderLanes = $8db028646a03dbcf$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $8db028646a03dbcf$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $8db028646a03dbcf$var$hydrationParentFiber = workInProgress, $8db028646a03dbcf$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $8db028646a03dbcf$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $8db028646a03dbcf$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $8db028646a03dbcf$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $8db028646a03dbcf$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $8db028646a03dbcf$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $8db028646a03dbcf$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $8db028646a03dbcf$var$prepareToReadContext(workInProgress), init = $8db028646a03dbcf$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $8db028646a03dbcf$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $8db028646a03dbcf$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $8db028646a03dbcf$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $8db028646a03dbcf$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $8db028646a03dbcf$var$prepareToReadContext(workInProgress), lazyComponent = $8db028646a03dbcf$var$readContext($8db028646a03dbcf$var$CacheContext), null === current ? (init = $8db028646a03dbcf$var$peekCacheFromPool(), null === init && (init = $8db028646a03dbcf$var$workInProgressRoot, nextProps = $8db028646a03dbcf$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $8db028646a03dbcf$var$initializeUpdateQueue(workInProgress), $8db028646a03dbcf$var$pushProvider(workInProgress, $8db028646a03dbcf$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($8db028646a03dbcf$var$cloneUpdateQueue(current, workInProgress), $8db028646a03dbcf$var$processUpdateQueue(workInProgress, null, null, renderLanes), $8db028646a03dbcf$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $8db028646a03dbcf$var$pushProvider(workInProgress, $8db028646a03dbcf$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $8db028646a03dbcf$var$pushProvider(workInProgress, $8db028646a03dbcf$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $8db028646a03dbcf$var$propagateContextChanges(workInProgress, [
                $8db028646a03dbcf$var$CacheContext
            ], renderLanes, !0))), $8db028646a03dbcf$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $8db028646a03dbcf$var$valueCursor = $8db028646a03dbcf$var$createCursor(null), $8db028646a03dbcf$var$currentlyRenderingFiber = null, $8db028646a03dbcf$var$lastContextDependency = null;
function $8db028646a03dbcf$var$pushProvider(providerFiber, context, nextValue) {
    $8db028646a03dbcf$var$push($8db028646a03dbcf$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $8db028646a03dbcf$var$popProvider(context) {
    context._currentValue = $8db028646a03dbcf$var$valueCursor.current;
    $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$valueCursor);
}
function $8db028646a03dbcf$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $8db028646a03dbcf$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $8db028646a03dbcf$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $8db028646a03dbcf$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $8db028646a03dbcf$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $8db028646a03dbcf$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $8db028646a03dbcf$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($8db028646a03dbcf$var$HostTransitionContext) : current = [
                $8db028646a03dbcf$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $8db028646a03dbcf$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $8db028646a03dbcf$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$8db028646a03dbcf$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $8db028646a03dbcf$var$prepareToReadContext(workInProgress) {
    $8db028646a03dbcf$var$currentlyRenderingFiber = workInProgress;
    $8db028646a03dbcf$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $8db028646a03dbcf$var$readContext(context) {
    return $8db028646a03dbcf$var$readContextForConsumer($8db028646a03dbcf$var$currentlyRenderingFiber, context);
}
function $8db028646a03dbcf$var$readContextDuringReconciliation(consumer, context) {
    null === $8db028646a03dbcf$var$currentlyRenderingFiber && $8db028646a03dbcf$var$prepareToReadContext(consumer);
    return $8db028646a03dbcf$var$readContextForConsumer(consumer, context);
}
function $8db028646a03dbcf$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $8db028646a03dbcf$var$lastContextDependency) {
        if (null === consumer) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(308));
        $8db028646a03dbcf$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $8db028646a03dbcf$var$lastContextDependency = $8db028646a03dbcf$var$lastContextDependency.next = context;
    return value;
}
var $8db028646a03dbcf$var$hasForceUpdate = !1;
function $8db028646a03dbcf$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $8db028646a03dbcf$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $8db028646a03dbcf$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8db028646a03dbcf$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($8db028646a03dbcf$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $8db028646a03dbcf$var$getRootForUpdatedFiber(fiber);
        $8db028646a03dbcf$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $8db028646a03dbcf$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $8db028646a03dbcf$var$getRootForUpdatedFiber(fiber);
}
function $8db028646a03dbcf$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $8db028646a03dbcf$var$markRootEntangled(root, lane);
    }
}
function $8db028646a03dbcf$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $8db028646a03dbcf$var$didReadFromEntangledAsyncAction = !1;
function $8db028646a03dbcf$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($8db028646a03dbcf$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $8db028646a03dbcf$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $8db028646a03dbcf$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $8db028646a03dbcf$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $8db028646a03dbcf$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($8db028646a03dbcf$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $8db028646a03dbcf$var$currentEntangledLane && ($8db028646a03dbcf$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $8db028646a03dbcf$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $8db028646a03dbcf$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $8db028646a03dbcf$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $8db028646a03dbcf$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $8db028646a03dbcf$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$8db028646a03dbcf$var$callCallback(callbacks[updateQueue], context);
}
function $8db028646a03dbcf$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8db028646a03dbcf$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $8db028646a03dbcf$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8db028646a03dbcf$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $8db028646a03dbcf$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8db028646a03dbcf$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $8db028646a03dbcf$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8db028646a03dbcf$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8db028646a03dbcf$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $8db028646a03dbcf$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $8db028646a03dbcf$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $8db028646a03dbcf$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8db028646a03dbcf$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $8db028646a03dbcf$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$8db028646a03dbcf$var$internalPropsKey] = newProps;
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8db028646a03dbcf$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $8db028646a03dbcf$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $8db028646a03dbcf$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $8db028646a03dbcf$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $8db028646a03dbcf$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($8db028646a03dbcf$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$8db028646a03dbcf$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $8db028646a03dbcf$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($8db028646a03dbcf$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$8db028646a03dbcf$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $8db028646a03dbcf$var$offscreenSubtreeIsHidden = !1, $8db028646a03dbcf$var$offscreenSubtreeWasHidden = !1, $8db028646a03dbcf$var$needsFormReset = !1, $8db028646a03dbcf$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $8db028646a03dbcf$var$nextEffect = null, $8db028646a03dbcf$var$shouldFireAfterActiveInstanceBlur = !1;
function $8db028646a03dbcf$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $8db028646a03dbcf$var$eventsEnabled = $8db028646a03dbcf$var$_enabled;
    root = $8db028646a03dbcf$var$getActiveElementDeep(root);
    if ($8db028646a03dbcf$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $8db028646a03dbcf$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $8db028646a03dbcf$var$_enabled = !1;
    for($8db028646a03dbcf$var$nextEffect = firstChild; null !== $8db028646a03dbcf$var$nextEffect;)if (firstChild = $8db028646a03dbcf$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $8db028646a03dbcf$var$nextEffect = root;
    else for(; null !== $8db028646a03dbcf$var$nextEffect;){
        firstChild = $8db028646a03dbcf$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $8db028646a03dbcf$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $8db028646a03dbcf$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $8db028646a03dbcf$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $8db028646a03dbcf$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $8db028646a03dbcf$var$nextEffect = root;
            break;
        }
        $8db028646a03dbcf$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $8db028646a03dbcf$var$shouldFireAfterActiveInstanceBlur;
    $8db028646a03dbcf$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $8db028646a03dbcf$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8db028646a03dbcf$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $8db028646a03dbcf$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $8db028646a03dbcf$var$commitClassCallbacks(finishedWork);
            flags & 512 && $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $8db028646a03dbcf$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $8db028646a03dbcf$var$commitHostMount(finishedWork);
            flags & 512 && $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8db028646a03dbcf$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $8db028646a03dbcf$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $8db028646a03dbcf$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $8db028646a03dbcf$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $8db028646a03dbcf$var$offscreenSubtreeWasHidden;
                $8db028646a03dbcf$var$offscreenSubtreeIsHidden = prevProps;
                ($8db028646a03dbcf$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $8db028646a03dbcf$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $8db028646a03dbcf$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return) : $8db028646a03dbcf$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $8db028646a03dbcf$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $8db028646a03dbcf$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $8db028646a03dbcf$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $8db028646a03dbcf$var$hostParent = null, $8db028646a03dbcf$var$hostParentIsContainer = !1;
function $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$8db028646a03dbcf$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $8db028646a03dbcf$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($8db028646a03dbcf$var$injectedHook && "function" === typeof $8db028646a03dbcf$var$injectedHook.onCommitFiberUnmount) try {
        $8db028646a03dbcf$var$injectedHook.onCommitFiberUnmount($8db028646a03dbcf$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || $8db028646a03dbcf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || $8db028646a03dbcf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $8db028646a03dbcf$var$hostParent, prevHostParentIsContainer = $8db028646a03dbcf$var$hostParentIsContainer;
            $8db028646a03dbcf$var$hostParent = deletedFiber.stateNode;
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $8db028646a03dbcf$var$detachDeletedInstance(deletedFiber);
            $8db028646a03dbcf$var$hostParent = prevHostParent;
            $8db028646a03dbcf$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || $8db028646a03dbcf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $8db028646a03dbcf$var$hostParent;
            var prevHostParentIsContainer$119 = $8db028646a03dbcf$var$hostParentIsContainer;
            $8db028646a03dbcf$var$hostParent = null;
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8db028646a03dbcf$var$hostParent = prevHostParentIsContainer;
            $8db028646a03dbcf$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $8db028646a03dbcf$var$hostParent) {
                if ($8db028646a03dbcf$var$hostParentIsContainer) try {
                    finishedRoot = $8db028646a03dbcf$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $8db028646a03dbcf$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $8db028646a03dbcf$var$hostParent && ($8db028646a03dbcf$var$hostParentIsContainer ? (nearestMountedAncestor = $8db028646a03dbcf$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $8db028646a03dbcf$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $8db028646a03dbcf$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $8db028646a03dbcf$var$retryIfBlockedOn(nearestMountedAncestor)) : $8db028646a03dbcf$var$clearSuspenseBoundary($8db028646a03dbcf$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $8db028646a03dbcf$var$hostParent;
            prevHostParentIsContainer = $8db028646a03dbcf$var$hostParentIsContainer;
            $8db028646a03dbcf$var$hostParent = deletedFiber.stateNode.containerInfo;
            $8db028646a03dbcf$var$hostParentIsContainer = !0;
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8db028646a03dbcf$var$hostParent = prevHostParent;
            $8db028646a03dbcf$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || $8db028646a03dbcf$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || $8db028646a03dbcf$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || ($8db028646a03dbcf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $8db028646a03dbcf$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden || $8db028646a03dbcf$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden = (prevHostParent = $8db028646a03dbcf$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $8db028646a03dbcf$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $8db028646a03dbcf$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $8db028646a03dbcf$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8db028646a03dbcf$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $8db028646a03dbcf$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $8db028646a03dbcf$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $8db028646a03dbcf$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $8db028646a03dbcf$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $8db028646a03dbcf$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $8db028646a03dbcf$var$hostParent = parent.stateNode;
                    $8db028646a03dbcf$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $8db028646a03dbcf$var$hostParent = parent.stateNode.containerInfo;
                    $8db028646a03dbcf$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $8db028646a03dbcf$var$hostParent = parent.stateNode.containerInfo;
                    $8db028646a03dbcf$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $8db028646a03dbcf$var$hostParent) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(160));
        $8db028646a03dbcf$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $8db028646a03dbcf$var$hostParent = null;
        $8db028646a03dbcf$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$8db028646a03dbcf$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $8db028646a03dbcf$var$currentHoistableRoot = null;
function $8db028646a03dbcf$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($8db028646a03dbcf$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $8db028646a03dbcf$var$commitHookEffectListMount(3, finishedWork), $8db028646a03dbcf$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8db028646a03dbcf$var$offscreenSubtreeWasHidden || null === current || $8db028646a03dbcf$var$safelyDetachRef(current, current.return));
            flags & 64 && $8db028646a03dbcf$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $8db028646a03dbcf$var$currentHoistableRoot;
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8db028646a03dbcf$var$offscreenSubtreeWasHidden || null === current || $8db028646a03dbcf$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$8db028646a03dbcf$var$internalHoistableMarker] || currentResource[$8db028646a03dbcf$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $8db028646a03dbcf$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$8db028646a03dbcf$var$internalInstanceKey] = finishedWork;
                                        $8db028646a03dbcf$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $8db028646a03dbcf$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8db028646a03dbcf$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $8db028646a03dbcf$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8db028646a03dbcf$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($8db028646a03dbcf$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$8db028646a03dbcf$var$internalInstanceKey] = finishedWork;
                                $8db028646a03dbcf$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $8db028646a03dbcf$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $8db028646a03dbcf$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $8db028646a03dbcf$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $8db028646a03dbcf$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $8db028646a03dbcf$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$8db028646a03dbcf$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $8db028646a03dbcf$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$8db028646a03dbcf$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$8db028646a03dbcf$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8db028646a03dbcf$var$offscreenSubtreeWasHidden || null === current || $8db028646a03dbcf$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $8db028646a03dbcf$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $8db028646a03dbcf$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($8db028646a03dbcf$var$needsFormReset = !0);
            break;
        case 6:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $8db028646a03dbcf$var$tagCaches = null;
            hoistableRoot = $8db028646a03dbcf$var$currentHoistableRoot;
            $8db028646a03dbcf$var$currentHoistableRoot = $8db028646a03dbcf$var$getHoistableRoot(root.containerInfo);
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$currentHoistableRoot = hoistableRoot;
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $8db028646a03dbcf$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $8db028646a03dbcf$var$needsFormReset && ($8db028646a03dbcf$var$needsFormReset = !1, $8db028646a03dbcf$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $8db028646a03dbcf$var$currentHoistableRoot;
            $8db028646a03dbcf$var$currentHoistableRoot = $8db028646a03dbcf$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            $8db028646a03dbcf$var$currentHoistableRoot = flags;
            break;
        case 12:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($8db028646a03dbcf$var$globalMostRecentFallbackTime = $8db028646a03dbcf$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8db028646a03dbcf$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($8db028646a03dbcf$var$offscreenSubtreeWasHidden || null === current || $8db028646a03dbcf$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $8db028646a03dbcf$var$offscreenSubtreeIsHidden;
            type = $8db028646a03dbcf$var$offscreenSubtreeWasHidden;
            $8db028646a03dbcf$var$offscreenSubtreeIsHidden = nodeName || node;
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden = type || nextNode;
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$offscreenSubtreeWasHidden = type;
            $8db028646a03dbcf$var$offscreenSubtreeIsHidden = nodeName;
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $8db028646a03dbcf$var$offscreenSubtreeIsHidden || $8db028646a03dbcf$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $8db028646a03dbcf$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $8db028646a03dbcf$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $8db028646a03dbcf$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8db028646a03dbcf$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $8db028646a03dbcf$var$recursivelyTraverseMutationEffects(root, finishedWork), $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork);
    }
}
function $8db028646a03dbcf$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($8db028646a03dbcf$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $8db028646a03dbcf$var$getHostSibling(finishedWork);
                        $8db028646a03dbcf$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($8db028646a03dbcf$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $8db028646a03dbcf$var$getHostSibling(finishedWork);
                        $8db028646a03dbcf$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $8db028646a03dbcf$var$getHostSibling(finishedWork);
                        $8db028646a03dbcf$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($8db028646a03dbcf$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $8db028646a03dbcf$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $8db028646a03dbcf$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $8db028646a03dbcf$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$8db028646a03dbcf$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $8db028646a03dbcf$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $8db028646a03dbcf$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $8db028646a03dbcf$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $8db028646a03dbcf$var$safelyDetachRef(finishedWork, finishedWork.return);
                $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $8db028646a03dbcf$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $8db028646a03dbcf$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8db028646a03dbcf$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$8db028646a03dbcf$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $8db028646a03dbcf$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $8db028646a03dbcf$var$commitClassCallbacks(finishedWork);
                $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $8db028646a03dbcf$var$commitHostMount(finishedWork);
                $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8db028646a03dbcf$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8db028646a03dbcf$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $8db028646a03dbcf$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8db028646a03dbcf$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $8db028646a03dbcf$var$releaseCache(previousCache));
}
function $8db028646a03dbcf$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $8db028646a03dbcf$var$releaseCache(current));
}
function $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8db028646a03dbcf$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $8db028646a03dbcf$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8db028646a03dbcf$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $8db028646a03dbcf$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $8db028646a03dbcf$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $8db028646a03dbcf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $8db028646a03dbcf$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8db028646a03dbcf$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $8db028646a03dbcf$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $8db028646a03dbcf$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $8db028646a03dbcf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $8db028646a03dbcf$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $8db028646a03dbcf$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8db028646a03dbcf$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8db028646a03dbcf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $8db028646a03dbcf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8db028646a03dbcf$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8db028646a03dbcf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8db028646a03dbcf$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8db028646a03dbcf$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $8db028646a03dbcf$var$suspenseyCommitFlag = 8192;
function $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $8db028646a03dbcf$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$8db028646a03dbcf$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $8db028646a03dbcf$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $8db028646a03dbcf$var$suspenseyCommitFlag && null !== fiber.memoizedState && $8db028646a03dbcf$var$suspendResource($8db028646a03dbcf$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $8db028646a03dbcf$var$currentHoistableRoot;
            $8db028646a03dbcf$var$currentHoistableRoot = $8db028646a03dbcf$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $8db028646a03dbcf$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $8db028646a03dbcf$var$suspenseyCommitFlag, $8db028646a03dbcf$var$suspenseyCommitFlag = 16777216, $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(fiber), $8db028646a03dbcf$var$suspenseyCommitFlag = previousHoistableRoot) : $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $8db028646a03dbcf$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $8db028646a03dbcf$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $8db028646a03dbcf$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8db028646a03dbcf$var$nextEffect = childToDelete;
            $8db028646a03dbcf$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8db028646a03dbcf$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8db028646a03dbcf$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $8db028646a03dbcf$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8db028646a03dbcf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $8db028646a03dbcf$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $8db028646a03dbcf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $8db028646a03dbcf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $8db028646a03dbcf$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $8db028646a03dbcf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $8db028646a03dbcf$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $8db028646a03dbcf$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8db028646a03dbcf$var$nextEffect = childToDelete;
            $8db028646a03dbcf$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8db028646a03dbcf$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $8db028646a03dbcf$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $8db028646a03dbcf$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $8db028646a03dbcf$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $8db028646a03dbcf$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8db028646a03dbcf$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $8db028646a03dbcf$var$nextEffect;){
        var fiber = $8db028646a03dbcf$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $8db028646a03dbcf$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $8db028646a03dbcf$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $8db028646a03dbcf$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $8db028646a03dbcf$var$nextEffect;){
            cache = $8db028646a03dbcf$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $8db028646a03dbcf$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $8db028646a03dbcf$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $8db028646a03dbcf$var$nextEffect = sibling;
                break a;
            }
            $8db028646a03dbcf$var$nextEffect = returnFiber;
        }
    }
}
function $8db028646a03dbcf$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8db028646a03dbcf$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $8db028646a03dbcf$var$FiberNode(tag, pendingProps, key, mode);
}
function $8db028646a03dbcf$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $8db028646a03dbcf$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $8db028646a03dbcf$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $8db028646a03dbcf$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $8db028646a03dbcf$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $8db028646a03dbcf$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $8db028646a03dbcf$var$isHostHoistableType(type, pendingProps, $8db028646a03dbcf$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $8db028646a03dbcf$var$REACT_FRAGMENT_TYPE:
            return $8db028646a03dbcf$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $8db028646a03dbcf$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $8db028646a03dbcf$var$REACT_PROFILER_TYPE:
            return type = $8db028646a03dbcf$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $8db028646a03dbcf$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $8db028646a03dbcf$var$REACT_SUSPENSE_TYPE:
            return type = $8db028646a03dbcf$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $8db028646a03dbcf$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $8db028646a03dbcf$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $8db028646a03dbcf$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $8db028646a03dbcf$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $8db028646a03dbcf$var$REACT_OFFSCREEN_TYPE:
            return $8db028646a03dbcf$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $8db028646a03dbcf$var$REACT_PROVIDER_TYPE:
                case $8db028646a03dbcf$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $8db028646a03dbcf$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $8db028646a03dbcf$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $8db028646a03dbcf$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $8db028646a03dbcf$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($8db028646a03dbcf$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $8db028646a03dbcf$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $8db028646a03dbcf$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $8db028646a03dbcf$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $8db028646a03dbcf$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $8db028646a03dbcf$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $8db028646a03dbcf$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $8db028646a03dbcf$var$createFiberFromText(content, mode, lanes) {
    content = $8db028646a03dbcf$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $8db028646a03dbcf$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $8db028646a03dbcf$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $8db028646a03dbcf$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $8db028646a03dbcf$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$8db028646a03dbcf$var$preloadResource(resource)) {
        resource = $8db028646a03dbcf$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($8db028646a03dbcf$var$workInProgressRootRenderLanes & 4194176) === $8db028646a03dbcf$var$workInProgressRootRenderLanes ? null !== $8db028646a03dbcf$var$shellBoundary : ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 62914560) !== $8db028646a03dbcf$var$workInProgressRootRenderLanes && 0 === ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 536870912) || resource !== $8db028646a03dbcf$var$shellBoundary)) throw $8db028646a03dbcf$var$suspendedThenable = $8db028646a03dbcf$var$noopSuspenseyCommitThenable, $8db028646a03dbcf$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $8db028646a03dbcf$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $8db028646a03dbcf$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $8db028646a03dbcf$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $8db028646a03dbcf$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$8db028646a03dbcf$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $8db028646a03dbcf$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $8db028646a03dbcf$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $8db028646a03dbcf$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
        case 1:
            return $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $8db028646a03dbcf$var$popProvider($8db028646a03dbcf$var$CacheContext);
            $8db028646a03dbcf$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $8db028646a03dbcf$var$popHydrationState(workInProgress) ? $8db028646a03dbcf$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $8db028646a03dbcf$var$hydrationErrors && ($8db028646a03dbcf$var$queueRecoverableErrors($8db028646a03dbcf$var$hydrationErrors), $8db028646a03dbcf$var$hydrationErrors = null));
            $8db028646a03dbcf$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($8db028646a03dbcf$var$markUpdate(workInProgress), null !== renderLanes ? ($8db028646a03dbcf$var$bubbleProperties(workInProgress), $8db028646a03dbcf$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($8db028646a03dbcf$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($8db028646a03dbcf$var$markUpdate(workInProgress), $8db028646a03dbcf$var$bubbleProperties(workInProgress), $8db028646a03dbcf$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($8db028646a03dbcf$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $8db028646a03dbcf$var$markUpdate(workInProgress), $8db028646a03dbcf$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $8db028646a03dbcf$var$popHostContext(workInProgress);
            renderLanes = $8db028646a03dbcf$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8db028646a03dbcf$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(166));
                    $8db028646a03dbcf$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $8db028646a03dbcf$var$contextStackCursor.current;
                $8db028646a03dbcf$var$popHydrationState(workInProgress) ? $8db028646a03dbcf$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $8db028646a03dbcf$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $8db028646a03dbcf$var$markUpdate(workInProgress));
            }
            $8db028646a03dbcf$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $8db028646a03dbcf$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8db028646a03dbcf$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(166));
                    $8db028646a03dbcf$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $8db028646a03dbcf$var$contextStackCursor.current;
                if ($8db028646a03dbcf$var$popHydrationState(workInProgress)) $8db028646a03dbcf$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $8db028646a03dbcf$var$getOwnerDocumentFromRootContainer($8db028646a03dbcf$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script></script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$8db028646a03dbcf$var$internalInstanceKey] = workInProgress;
                    current[$8db028646a03dbcf$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($8db028646a03dbcf$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $8db028646a03dbcf$var$markUpdate(workInProgress);
                }
            }
            $8db028646a03dbcf$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8db028646a03dbcf$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(166));
                current = $8db028646a03dbcf$var$rootInstanceStackCursor.current;
                if ($8db028646a03dbcf$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $8db028646a03dbcf$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$8db028646a03dbcf$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $8db028646a03dbcf$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $8db028646a03dbcf$var$throwOnHydrationMismatch(workInProgress);
                } else current = $8db028646a03dbcf$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$8db028646a03dbcf$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $8db028646a03dbcf$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $8db028646a03dbcf$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(317));
                        type[$8db028646a03dbcf$var$internalInstanceKey] = workInProgress;
                    } else $8db028646a03dbcf$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8db028646a03dbcf$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $8db028646a03dbcf$var$hydrationErrors && ($8db028646a03dbcf$var$queueRecoverableErrors($8db028646a03dbcf$var$hydrationErrors), $8db028646a03dbcf$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $8db028646a03dbcf$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8db028646a03dbcf$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $8db028646a03dbcf$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $8db028646a03dbcf$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $8db028646a03dbcf$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $8db028646a03dbcf$var$popHostContainer(), null === current && $8db028646a03dbcf$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
        case 10:
            return $8db028646a03dbcf$var$popProvider(workInProgress.type), $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
        case 19:
            $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $8db028646a03dbcf$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $8db028646a03dbcf$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $8db028646a03dbcf$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $8db028646a03dbcf$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $8db028646a03dbcf$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$8db028646a03dbcf$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, $8db028646a03dbcf$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $8db028646a03dbcf$var$now() > $8db028646a03dbcf$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $8db028646a03dbcf$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $8db028646a03dbcf$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $8db028646a03dbcf$var$scheduleRetryEffect(workInProgress, current), $8db028646a03dbcf$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$8db028646a03dbcf$var$isHydrating) return $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
                    } else 2 * $8db028646a03dbcf$var$now() - type.renderingStartTime > $8db028646a03dbcf$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $8db028646a03dbcf$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $8db028646a03dbcf$var$now(), workInProgress.sibling = null, current = $8db028646a03dbcf$var$suspenseStackCursor.current, $8db028646a03dbcf$var$push($8db028646a03dbcf$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $8db028646a03dbcf$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $8db028646a03dbcf$var$popSuspenseHandler(workInProgress), $8db028646a03dbcf$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($8db028646a03dbcf$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $8db028646a03dbcf$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $8db028646a03dbcf$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $8db028646a03dbcf$var$popProvider($8db028646a03dbcf$var$CacheContext), $8db028646a03dbcf$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8db028646a03dbcf$var$unwindWork(current, workInProgress) {
    $8db028646a03dbcf$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $8db028646a03dbcf$var$popProvider($8db028646a03dbcf$var$CacheContext), $8db028646a03dbcf$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $8db028646a03dbcf$var$popHostContext(workInProgress), null;
        case 13:
            $8db028646a03dbcf$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(340));
                $8db028646a03dbcf$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$suspenseStackCursor), null;
        case 4:
            return $8db028646a03dbcf$var$popHostContainer(), null;
        case 10:
            return $8db028646a03dbcf$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $8db028646a03dbcf$var$popSuspenseHandler(workInProgress), $8db028646a03dbcf$var$popHiddenContext(), null !== current && $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $8db028646a03dbcf$var$popProvider($8db028646a03dbcf$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $8db028646a03dbcf$var$unwindInterruptedWork(current, interruptedWork) {
    $8db028646a03dbcf$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $8db028646a03dbcf$var$popProvider($8db028646a03dbcf$var$CacheContext);
            $8db028646a03dbcf$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $8db028646a03dbcf$var$popHostContext(interruptedWork);
            break;
        case 4:
            $8db028646a03dbcf$var$popHostContainer();
            break;
        case 13:
            $8db028646a03dbcf$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$suspenseStackCursor);
            break;
        case 10:
            $8db028646a03dbcf$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $8db028646a03dbcf$var$popSuspenseHandler(interruptedWork);
            $8db028646a03dbcf$var$popHiddenContext();
            null !== current && $8db028646a03dbcf$var$pop($8db028646a03dbcf$var$resumedCache);
            break;
        case 24:
            $8db028646a03dbcf$var$popProvider($8db028646a03dbcf$var$CacheContext);
    }
}
var $8db028646a03dbcf$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $8db028646a03dbcf$var$readContext($8db028646a03dbcf$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $8db028646a03dbcf$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $8db028646a03dbcf$var$executionContext = 0, $8db028646a03dbcf$var$workInProgressRoot = null, $8db028646a03dbcf$var$workInProgress = null, $8db028646a03dbcf$var$workInProgressRootRenderLanes = 0, $8db028646a03dbcf$var$workInProgressSuspendedReason = 0, $8db028646a03dbcf$var$workInProgressThrownValue = null, $8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings = !1, $8db028646a03dbcf$var$workInProgressRootIsPrerendering = !1, $8db028646a03dbcf$var$workInProgressRootDidAttachPingListener = !1, $8db028646a03dbcf$var$entangledRenderLanes = 0, $8db028646a03dbcf$var$workInProgressRootExitStatus = 0, $8db028646a03dbcf$var$workInProgressRootSkippedLanes = 0, $8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes = 0, $8db028646a03dbcf$var$workInProgressRootPingedLanes = 0, $8db028646a03dbcf$var$workInProgressDeferredLane = 0, $8db028646a03dbcf$var$workInProgressSuspendedRetryLanes = 0, $8db028646a03dbcf$var$workInProgressRootConcurrentErrors = null, $8db028646a03dbcf$var$workInProgressRootRecoverableErrors = null, $8db028646a03dbcf$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $8db028646a03dbcf$var$globalMostRecentFallbackTime = 0, $8db028646a03dbcf$var$workInProgressRootRenderTargetTime = Infinity, $8db028646a03dbcf$var$workInProgressTransitions = null, $8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed = null, $8db028646a03dbcf$var$rootDoesHavePassiveEffects = !1, $8db028646a03dbcf$var$rootWithPendingPassiveEffects = null, $8db028646a03dbcf$var$pendingPassiveEffectsLanes = 0, $8db028646a03dbcf$var$pendingPassiveEffectsRemainingLanes = 0, $8db028646a03dbcf$var$pendingPassiveTransitions = null, $8db028646a03dbcf$var$nestedUpdateCount = 0, $8db028646a03dbcf$var$rootWithNestedUpdates = null;
function $8db028646a03dbcf$var$requestUpdateLane() {
    if (0 !== ($8db028646a03dbcf$var$executionContext & 2) && 0 !== $8db028646a03dbcf$var$workInProgressRootRenderLanes) return $8db028646a03dbcf$var$workInProgressRootRenderLanes & -$8db028646a03dbcf$var$workInProgressRootRenderLanes;
    if (null !== $8db028646a03dbcf$var$ReactSharedInternals.T) {
        var actionScopeLane = $8db028646a03dbcf$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $8db028646a03dbcf$var$requestTransitionLane();
    }
    return $8db028646a03dbcf$var$resolveUpdatePriority();
}
function $8db028646a03dbcf$var$requestDeferredLane() {
    0 === $8db028646a03dbcf$var$workInProgressDeferredLane && ($8db028646a03dbcf$var$workInProgressDeferredLane = 0 === ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 536870912) || $8db028646a03dbcf$var$isHydrating ? $8db028646a03dbcf$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $8db028646a03dbcf$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $8db028646a03dbcf$var$workInProgressDeferredLane;
}
function $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $8db028646a03dbcf$var$workInProgressRoot && 2 === $8db028646a03dbcf$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $8db028646a03dbcf$var$prepareFreshStack(root, 0), $8db028646a03dbcf$var$markRootSuspended(root, $8db028646a03dbcf$var$workInProgressRootRenderLanes, $8db028646a03dbcf$var$workInProgressDeferredLane, !1);
    $8db028646a03dbcf$var$markRootUpdated$1(root, lane);
    if (0 === ($8db028646a03dbcf$var$executionContext & 2) || root !== $8db028646a03dbcf$var$workInProgressRoot) root === $8db028646a03dbcf$var$workInProgressRoot && (0 === ($8db028646a03dbcf$var$executionContext & 2) && ($8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $8db028646a03dbcf$var$workInProgressRootExitStatus && $8db028646a03dbcf$var$markRootSuspended(root, $8db028646a03dbcf$var$workInProgressRootRenderLanes, $8db028646a03dbcf$var$workInProgressDeferredLane, !1)), $8db028646a03dbcf$var$ensureRootIsScheduled(root);
}
function $8db028646a03dbcf$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($8db028646a03dbcf$var$executionContext & 6)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $8db028646a03dbcf$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $8db028646a03dbcf$var$renderRootConcurrent(root$jscomp$0, lanes) : $8db028646a03dbcf$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $8db028646a03dbcf$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $8db028646a03dbcf$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $8db028646a03dbcf$var$markRootSuspended(root$jscomp$0, lanes, 0, !$8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$8db028646a03dbcf$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $8db028646a03dbcf$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $8db028646a03dbcf$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($8db028646a03dbcf$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $8db028646a03dbcf$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($8db028646a03dbcf$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $8db028646a03dbcf$var$workInProgressRootRecoverableErrors;
                            $8db028646a03dbcf$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $8db028646a03dbcf$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $8db028646a03dbcf$var$prepareFreshStack(root$jscomp$0, 0);
                $8db028646a03dbcf$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($8db028646a03dbcf$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $8db028646a03dbcf$var$markRootSuspended(shouldTimeSlice, lanes, $8db028646a03dbcf$var$workInProgressDeferredLane, !$8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $8db028646a03dbcf$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($8db028646a03dbcf$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $8db028646a03dbcf$var$globalMostRecentFallbackTime + 300 - $8db028646a03dbcf$var$now(), 10 < renderWasConcurrent)) {
                    $8db028646a03dbcf$var$markRootSuspended(shouldTimeSlice, lanes, $8db028646a03dbcf$var$workInProgressDeferredLane, !$8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $8db028646a03dbcf$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $8db028646a03dbcf$var$scheduleTimeout($8db028646a03dbcf$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $8db028646a03dbcf$var$workInProgressRootRecoverableErrors, $8db028646a03dbcf$var$workInProgressTransitions, $8db028646a03dbcf$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8db028646a03dbcf$var$workInProgressDeferredLane, $8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes, $8db028646a03dbcf$var$workInProgressSuspendedRetryLanes, $8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $8db028646a03dbcf$var$commitRootWhenReady(shouldTimeSlice, forceSync, $8db028646a03dbcf$var$workInProgressRootRecoverableErrors, $8db028646a03dbcf$var$workInProgressTransitions, $8db028646a03dbcf$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8db028646a03dbcf$var$workInProgressDeferredLane, $8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes, $8db028646a03dbcf$var$workInProgressSuspendedRetryLanes, $8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $8db028646a03dbcf$var$ensureRootIsScheduled(root$jscomp$0);
}
function $8db028646a03dbcf$var$queueRecoverableErrors(errors) {
    null === $8db028646a03dbcf$var$workInProgressRootRecoverableErrors ? $8db028646a03dbcf$var$workInProgressRootRecoverableErrors = errors : $8db028646a03dbcf$var$workInProgressRootRecoverableErrors.push.apply($8db028646a03dbcf$var$workInProgressRootRecoverableErrors, errors);
}
function $8db028646a03dbcf$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($8db028646a03dbcf$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $8db028646a03dbcf$var$noop
        }, $8db028646a03dbcf$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $8db028646a03dbcf$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($8db028646a03dbcf$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $8db028646a03dbcf$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $8db028646a03dbcf$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $8db028646a03dbcf$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$8db028646a03dbcf$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $8db028646a03dbcf$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$8db028646a03dbcf$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $8db028646a03dbcf$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $8db028646a03dbcf$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $8db028646a03dbcf$var$flushSyncWork$1() {
    return 0 === ($8db028646a03dbcf$var$executionContext & 6) ? ($8db028646a03dbcf$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $8db028646a03dbcf$var$resetWorkInProgressStack() {
    if (null !== $8db028646a03dbcf$var$workInProgress) {
        if (0 === $8db028646a03dbcf$var$workInProgressSuspendedReason) var interruptedWork = $8db028646a03dbcf$var$workInProgress.return;
        else interruptedWork = $8db028646a03dbcf$var$workInProgress, $8db028646a03dbcf$var$lastContextDependency = $8db028646a03dbcf$var$currentlyRenderingFiber = null, $8db028646a03dbcf$var$resetHooksOnUnwind(interruptedWork), $8db028646a03dbcf$var$thenableState$1 = null, $8db028646a03dbcf$var$thenableIndexCounter$1 = 0, interruptedWork = $8db028646a03dbcf$var$workInProgress;
        for(; null !== interruptedWork;)$8db028646a03dbcf$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $8db028646a03dbcf$var$workInProgress = null;
    }
}
function $8db028646a03dbcf$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $8db028646a03dbcf$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $8db028646a03dbcf$var$resetWorkInProgressStack();
    $8db028646a03dbcf$var$workInProgressRoot = root;
    $8db028646a03dbcf$var$workInProgress = timeoutHandle = $8db028646a03dbcf$var$createWorkInProgress(root.current, null);
    $8db028646a03dbcf$var$workInProgressRootRenderLanes = lanes;
    $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
    $8db028646a03dbcf$var$workInProgressThrownValue = null;
    $8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $8db028646a03dbcf$var$workInProgressRootIsPrerendering = $8db028646a03dbcf$var$checkIfRootIsPrerendering(root, lanes);
    $8db028646a03dbcf$var$workInProgressRootDidAttachPingListener = !1;
    $8db028646a03dbcf$var$workInProgressSuspendedRetryLanes = $8db028646a03dbcf$var$workInProgressDeferredLane = $8db028646a03dbcf$var$workInProgressRootPingedLanes = $8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes = $8db028646a03dbcf$var$workInProgressRootSkippedLanes = $8db028646a03dbcf$var$workInProgressRootExitStatus = 0;
    $8db028646a03dbcf$var$workInProgressRootRecoverableErrors = $8db028646a03dbcf$var$workInProgressRootConcurrentErrors = null;
    $8db028646a03dbcf$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $8db028646a03dbcf$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $8db028646a03dbcf$var$entangledRenderLanes = lanes;
    $8db028646a03dbcf$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $8db028646a03dbcf$var$handleThrow(root, thrownValue) {
    $8db028646a03dbcf$var$currentlyRenderingFiber$1 = null;
    $8db028646a03dbcf$var$ReactSharedInternals.H = $8db028646a03dbcf$var$ContextOnlyDispatcher;
    thrownValue === $8db028646a03dbcf$var$SuspenseException ? (thrownValue = $8db028646a03dbcf$var$getSuspendedThenable(), $8db028646a03dbcf$var$workInProgressSuspendedReason = 3) : thrownValue === $8db028646a03dbcf$var$SuspenseyCommitException ? (thrownValue = $8db028646a03dbcf$var$getSuspendedThenable(), $8db028646a03dbcf$var$workInProgressSuspendedReason = 4) : $8db028646a03dbcf$var$workInProgressSuspendedReason = thrownValue === $8db028646a03dbcf$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $8db028646a03dbcf$var$workInProgressThrownValue = thrownValue;
    null === $8db028646a03dbcf$var$workInProgress && ($8db028646a03dbcf$var$workInProgressRootExitStatus = 1, $8db028646a03dbcf$var$logUncaughtError(root, $8db028646a03dbcf$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $8db028646a03dbcf$var$pushDispatcher() {
    var prevDispatcher = $8db028646a03dbcf$var$ReactSharedInternals.H;
    $8db028646a03dbcf$var$ReactSharedInternals.H = $8db028646a03dbcf$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $8db028646a03dbcf$var$ContextOnlyDispatcher : prevDispatcher;
}
function $8db028646a03dbcf$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $8db028646a03dbcf$var$ReactSharedInternals.A;
    $8db028646a03dbcf$var$ReactSharedInternals.A = $8db028646a03dbcf$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $8db028646a03dbcf$var$renderDidSuspendDelayIfPossible() {
    $8db028646a03dbcf$var$workInProgressRootExitStatus = 4;
    $8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings || ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 4194176) !== $8db028646a03dbcf$var$workInProgressRootRenderLanes && null !== $8db028646a03dbcf$var$suspenseHandlerStackCursor.current || ($8db028646a03dbcf$var$workInProgressRootIsPrerendering = !0);
    0 === ($8db028646a03dbcf$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($8db028646a03dbcf$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $8db028646a03dbcf$var$workInProgressRoot || $8db028646a03dbcf$var$markRootSuspended($8db028646a03dbcf$var$workInProgressRoot, $8db028646a03dbcf$var$workInProgressRootRenderLanes, $8db028646a03dbcf$var$workInProgressDeferredLane, !1);
}
function $8db028646a03dbcf$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $8db028646a03dbcf$var$executionContext;
    $8db028646a03dbcf$var$executionContext |= 2;
    var prevDispatcher = $8db028646a03dbcf$var$pushDispatcher(), prevAsyncDispatcher = $8db028646a03dbcf$var$pushAsyncDispatcher();
    if ($8db028646a03dbcf$var$workInProgressRoot !== root || $8db028646a03dbcf$var$workInProgressRootRenderLanes !== lanes) $8db028646a03dbcf$var$workInProgressTransitions = null, $8db028646a03dbcf$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $8db028646a03dbcf$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $8db028646a03dbcf$var$workInProgressSuspendedReason && null !== $8db028646a03dbcf$var$workInProgress) {
            var unitOfWork = $8db028646a03dbcf$var$workInProgress, thrownValue = $8db028646a03dbcf$var$workInProgressThrownValue;
            switch($8db028646a03dbcf$var$workInProgressSuspendedReason){
                case 8:
                    $8db028646a03dbcf$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $8db028646a03dbcf$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $8db028646a03dbcf$var$workInProgressSuspendedReason;
                    $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
                    $8db028646a03dbcf$var$workInProgressThrownValue = null;
                    $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $8db028646a03dbcf$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $8db028646a03dbcf$var$workInProgressSuspendedReason, $8db028646a03dbcf$var$workInProgressSuspendedReason = 0, $8db028646a03dbcf$var$workInProgressThrownValue = null, $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $8db028646a03dbcf$var$workLoopSync();
        exitStatus = $8db028646a03dbcf$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $8db028646a03dbcf$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $8db028646a03dbcf$var$lastContextDependency = $8db028646a03dbcf$var$currentlyRenderingFiber = null;
    $8db028646a03dbcf$var$executionContext = prevExecutionContext;
    $8db028646a03dbcf$var$ReactSharedInternals.H = prevDispatcher;
    $8db028646a03dbcf$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $8db028646a03dbcf$var$workInProgress && ($8db028646a03dbcf$var$workInProgressRoot = null, $8db028646a03dbcf$var$workInProgressRootRenderLanes = 0, $8db028646a03dbcf$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $8db028646a03dbcf$var$workLoopSync() {
    for(; null !== $8db028646a03dbcf$var$workInProgress;)$8db028646a03dbcf$var$performUnitOfWork($8db028646a03dbcf$var$workInProgress);
}
function $8db028646a03dbcf$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $8db028646a03dbcf$var$executionContext;
    $8db028646a03dbcf$var$executionContext |= 2;
    var prevDispatcher = $8db028646a03dbcf$var$pushDispatcher(), prevAsyncDispatcher = $8db028646a03dbcf$var$pushAsyncDispatcher();
    $8db028646a03dbcf$var$workInProgressRoot !== root || $8db028646a03dbcf$var$workInProgressRootRenderLanes !== lanes ? ($8db028646a03dbcf$var$workInProgressTransitions = null, $8db028646a03dbcf$var$workInProgressRootRenderTargetTime = $8db028646a03dbcf$var$now() + 500, $8db028646a03dbcf$var$prepareFreshStack(root, lanes)) : $8db028646a03dbcf$var$workInProgressRootIsPrerendering = $8db028646a03dbcf$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $8db028646a03dbcf$var$workInProgressSuspendedReason && null !== $8db028646a03dbcf$var$workInProgress) {
            lanes = $8db028646a03dbcf$var$workInProgress;
            var thrownValue = $8db028646a03dbcf$var$workInProgressThrownValue;
            b: switch($8db028646a03dbcf$var$workInProgressSuspendedReason){
                case 1:
                    $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
                    $8db028646a03dbcf$var$workInProgressThrownValue = null;
                    $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($8db028646a03dbcf$var$isThenableResolved(thrownValue)) {
                        $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
                        $8db028646a03dbcf$var$workInProgressThrownValue = null;
                        $8db028646a03dbcf$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $8db028646a03dbcf$var$workInProgressSuspendedReason && $8db028646a03dbcf$var$workInProgressRoot === root && ($8db028646a03dbcf$var$workInProgressSuspendedReason = 7);
                        $8db028646a03dbcf$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $8db028646a03dbcf$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $8db028646a03dbcf$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $8db028646a03dbcf$var$isThenableResolved(thrownValue) ? ($8db028646a03dbcf$var$workInProgressSuspendedReason = 0, $8db028646a03dbcf$var$workInProgressThrownValue = null, $8db028646a03dbcf$var$replaySuspendedUnitOfWork(lanes)) : ($8db028646a03dbcf$var$workInProgressSuspendedReason = 0, $8db028646a03dbcf$var$workInProgressThrownValue = null, $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($8db028646a03dbcf$var$workInProgress.tag){
                        case 26:
                            resource = $8db028646a03dbcf$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $8db028646a03dbcf$var$workInProgress;
                            if (resource ? $8db028646a03dbcf$var$preloadResource(resource) : 1) {
                                $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
                                $8db028646a03dbcf$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $8db028646a03dbcf$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($8db028646a03dbcf$var$workInProgress = returnFiber, $8db028646a03dbcf$var$completeUnitOfWork(returnFiber)) : $8db028646a03dbcf$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
                    $8db028646a03dbcf$var$workInProgressThrownValue = null;
                    $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $8db028646a03dbcf$var$workInProgressSuspendedReason = 0;
                    $8db028646a03dbcf$var$workInProgressThrownValue = null;
                    $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $8db028646a03dbcf$var$resetWorkInProgressStack();
                    $8db028646a03dbcf$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(462));
            }
        }
        $8db028646a03dbcf$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $8db028646a03dbcf$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $8db028646a03dbcf$var$lastContextDependency = $8db028646a03dbcf$var$currentlyRenderingFiber = null;
    $8db028646a03dbcf$var$ReactSharedInternals.H = prevDispatcher;
    $8db028646a03dbcf$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $8db028646a03dbcf$var$executionContext = prevExecutionContext;
    if (null !== $8db028646a03dbcf$var$workInProgress) return 0;
    $8db028646a03dbcf$var$workInProgressRoot = null;
    $8db028646a03dbcf$var$workInProgressRootRenderLanes = 0;
    $8db028646a03dbcf$var$finishQueueingConcurrentUpdates();
    return $8db028646a03dbcf$var$workInProgressRootExitStatus;
}
function $8db028646a03dbcf$var$workLoopConcurrent() {
    for(; null !== $8db028646a03dbcf$var$workInProgress && !$8db028646a03dbcf$var$shouldYield();)$8db028646a03dbcf$var$performUnitOfWork($8db028646a03dbcf$var$workInProgress);
}
function $8db028646a03dbcf$var$performUnitOfWork(unitOfWork) {
    var next = $8db028646a03dbcf$var$beginWork(unitOfWork.alternate, unitOfWork, $8db028646a03dbcf$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8db028646a03dbcf$var$completeUnitOfWork(unitOfWork) : $8db028646a03dbcf$var$workInProgress = next;
}
function $8db028646a03dbcf$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $8db028646a03dbcf$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $8db028646a03dbcf$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $8db028646a03dbcf$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $8db028646a03dbcf$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $8db028646a03dbcf$var$resetHooksOnUnwind(next);
        default:
            $8db028646a03dbcf$var$unwindInterruptedWork(current, next), next = $8db028646a03dbcf$var$workInProgress = $8db028646a03dbcf$var$resetWorkInProgress(next, $8db028646a03dbcf$var$entangledRenderLanes), next = $8db028646a03dbcf$var$beginWork(current, next, $8db028646a03dbcf$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8db028646a03dbcf$var$completeUnitOfWork(unitOfWork) : $8db028646a03dbcf$var$workInProgress = next;
}
function $8db028646a03dbcf$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $8db028646a03dbcf$var$lastContextDependency = $8db028646a03dbcf$var$currentlyRenderingFiber = null;
    $8db028646a03dbcf$var$resetHooksOnUnwind(unitOfWork);
    $8db028646a03dbcf$var$thenableState$1 = null;
    $8db028646a03dbcf$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($8db028646a03dbcf$var$throwException(root, returnFiber, unitOfWork, thrownValue, $8db028646a03dbcf$var$workInProgressRootRenderLanes)) {
            $8db028646a03dbcf$var$workInProgressRootExitStatus = 1;
            $8db028646a03dbcf$var$logUncaughtError(root, $8db028646a03dbcf$var$createCapturedValueAtFiber(thrownValue, root.current));
            $8db028646a03dbcf$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $8db028646a03dbcf$var$workInProgress = returnFiber, error;
        $8db028646a03dbcf$var$workInProgressRootExitStatus = 1;
        $8db028646a03dbcf$var$logUncaughtError(root, $8db028646a03dbcf$var$createCapturedValueAtFiber(thrownValue, root.current));
        $8db028646a03dbcf$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($8db028646a03dbcf$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($8db028646a03dbcf$var$workInProgressRootIsPrerendering || 0 !== ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $8db028646a03dbcf$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $8db028646a03dbcf$var$unwindUnitOfWork(unitOfWork, root);
    } else $8db028646a03dbcf$var$completeUnitOfWork(unitOfWork);
}
function $8db028646a03dbcf$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $8db028646a03dbcf$var$unwindUnitOfWork(completedWork, $8db028646a03dbcf$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $8db028646a03dbcf$var$completeWork(completedWork.alternate, completedWork, $8db028646a03dbcf$var$entangledRenderLanes);
        if (null !== next) {
            $8db028646a03dbcf$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $8db028646a03dbcf$var$workInProgress = completedWork;
            return;
        }
        $8db028646a03dbcf$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $8db028646a03dbcf$var$workInProgressRootExitStatus && ($8db028646a03dbcf$var$workInProgressRootExitStatus = 5);
}
function $8db028646a03dbcf$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $8db028646a03dbcf$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $8db028646a03dbcf$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $8db028646a03dbcf$var$workInProgress = unitOfWork;
            return;
        }
        $8db028646a03dbcf$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $8db028646a03dbcf$var$workInProgressRootExitStatus = 6;
    $8db028646a03dbcf$var$workInProgress = null;
}
function $8db028646a03dbcf$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $8db028646a03dbcf$var$ReactSharedInternals.T, previousUpdateLanePriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
    try {
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = 2, $8db028646a03dbcf$var$ReactSharedInternals.T = null, $8db028646a03dbcf$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $8db028646a03dbcf$var$ReactSharedInternals.T = prevTransition, $8db028646a03dbcf$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $8db028646a03dbcf$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $8db028646a03dbcf$var$flushPassiveEffects();
    while (null !== $8db028646a03dbcf$var$rootWithPendingPassiveEffects);
    if (0 !== ($8db028646a03dbcf$var$executionContext & 6)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $8db028646a03dbcf$var$concurrentlyUpdatedLanes;
    $8db028646a03dbcf$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $8db028646a03dbcf$var$workInProgressRoot && ($8db028646a03dbcf$var$workInProgress = $8db028646a03dbcf$var$workInProgressRoot = null, $8db028646a03dbcf$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $8db028646a03dbcf$var$rootDoesHavePassiveEffects || ($8db028646a03dbcf$var$rootDoesHavePassiveEffects = !0, $8db028646a03dbcf$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $8db028646a03dbcf$var$pendingPassiveTransitions = transitions, $8db028646a03dbcf$var$scheduleCallback$1($8db028646a03dbcf$var$NormalPriority$1, function() {
        $8db028646a03dbcf$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $8db028646a03dbcf$var$ReactSharedInternals.T, $8db028646a03dbcf$var$ReactSharedInternals.T = null, spawnedLane = $8db028646a03dbcf$var$ReactDOMSharedInternals.p, $8db028646a03dbcf$var$ReactDOMSharedInternals.p = 2, updatedLanes = $8db028646a03dbcf$var$executionContext, $8db028646a03dbcf$var$executionContext |= 4, $8db028646a03dbcf$var$commitBeforeMutationEffects(root, finishedWork), $8db028646a03dbcf$var$commitMutationEffectsOnFiber(finishedWork, root), $8db028646a03dbcf$var$restoreSelection($8db028646a03dbcf$var$selectionInformation, root.containerInfo), $8db028646a03dbcf$var$_enabled = !!$8db028646a03dbcf$var$eventsEnabled, $8db028646a03dbcf$var$selectionInformation = $8db028646a03dbcf$var$eventsEnabled = null, root.current = finishedWork, $8db028646a03dbcf$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $8db028646a03dbcf$var$requestPaint(), $8db028646a03dbcf$var$executionContext = updatedLanes, $8db028646a03dbcf$var$ReactDOMSharedInternals.p = spawnedLane, $8db028646a03dbcf$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $8db028646a03dbcf$var$rootDoesHavePassiveEffects ? ($8db028646a03dbcf$var$rootDoesHavePassiveEffects = !1, $8db028646a03dbcf$var$rootWithPendingPassiveEffects = root, $8db028646a03dbcf$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $8db028646a03dbcf$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $8db028646a03dbcf$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $8db028646a03dbcf$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($8db028646a03dbcf$var$pendingPassiveEffectsLanes & 3) && $8db028646a03dbcf$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $8db028646a03dbcf$var$rootWithNestedUpdates ? $8db028646a03dbcf$var$nestedUpdateCount++ : ($8db028646a03dbcf$var$nestedUpdateCount = 0, $8db028646a03dbcf$var$rootWithNestedUpdates = root) : $8db028646a03dbcf$var$nestedUpdateCount = 0;
    $8db028646a03dbcf$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $8db028646a03dbcf$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $8db028646a03dbcf$var$releaseCache(remainingLanes)));
}
function $8db028646a03dbcf$var$flushPassiveEffects() {
    if (null !== $8db028646a03dbcf$var$rootWithPendingPassiveEffects) {
        var root$170 = $8db028646a03dbcf$var$rootWithPendingPassiveEffects, remainingLanes = $8db028646a03dbcf$var$pendingPassiveEffectsRemainingLanes;
        $8db028646a03dbcf$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $8db028646a03dbcf$var$lanesToEventPriority($8db028646a03dbcf$var$pendingPassiveEffectsLanes), prevTransition = $8db028646a03dbcf$var$ReactSharedInternals.T, previousPriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
        try {
            $8db028646a03dbcf$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $8db028646a03dbcf$var$ReactSharedInternals.T = null;
            if (null === $8db028646a03dbcf$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $8db028646a03dbcf$var$pendingPassiveTransitions;
                $8db028646a03dbcf$var$pendingPassiveTransitions = null;
                var root = $8db028646a03dbcf$var$rootWithPendingPassiveEffects, lanes = $8db028646a03dbcf$var$pendingPassiveEffectsLanes;
                $8db028646a03dbcf$var$rootWithPendingPassiveEffects = null;
                $8db028646a03dbcf$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($8db028646a03dbcf$var$executionContext & 6)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(331));
                var prevExecutionContext = $8db028646a03dbcf$var$executionContext;
                $8db028646a03dbcf$var$executionContext |= 4;
                $8db028646a03dbcf$var$commitPassiveUnmountOnFiber(root.current);
                $8db028646a03dbcf$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $8db028646a03dbcf$var$executionContext = prevExecutionContext;
                $8db028646a03dbcf$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($8db028646a03dbcf$var$injectedHook && "function" === typeof $8db028646a03dbcf$var$injectedHook.onPostCommitFiberRoot) try {
                    $8db028646a03dbcf$var$injectedHook.onPostCommitFiberRoot($8db028646a03dbcf$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $8db028646a03dbcf$var$ReactDOMSharedInternals.p = previousPriority, $8db028646a03dbcf$var$ReactSharedInternals.T = prevTransition, $8db028646a03dbcf$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $8db028646a03dbcf$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $8db028646a03dbcf$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $8db028646a03dbcf$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $8db028646a03dbcf$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($8db028646a03dbcf$var$markRootUpdated$1(rootFiber, 2), $8db028646a03dbcf$var$ensureRootIsScheduled(rootFiber));
}
function $8db028646a03dbcf$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $8db028646a03dbcf$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $8db028646a03dbcf$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed || !$8db028646a03dbcf$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $8db028646a03dbcf$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $8db028646a03dbcf$var$createClassErrorUpdate(2);
                instance = $8db028646a03dbcf$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($8db028646a03dbcf$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $8db028646a03dbcf$var$markRootUpdated$1(instance, 2), $8db028646a03dbcf$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $8db028646a03dbcf$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $8db028646a03dbcf$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($8db028646a03dbcf$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $8db028646a03dbcf$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $8db028646a03dbcf$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $8db028646a03dbcf$var$workInProgressRoot === root && ($8db028646a03dbcf$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $8db028646a03dbcf$var$workInProgressRootExitStatus || 3 === $8db028646a03dbcf$var$workInProgressRootExitStatus && ($8db028646a03dbcf$var$workInProgressRootRenderLanes & 62914560) === $8db028646a03dbcf$var$workInProgressRootRenderLanes && 300 > $8db028646a03dbcf$var$now() - $8db028646a03dbcf$var$globalMostRecentFallbackTime ? 0 === ($8db028646a03dbcf$var$executionContext & 2) && $8db028646a03dbcf$var$prepareFreshStack(root, 0) : $8db028646a03dbcf$var$workInProgressRootPingedLanes |= pingedLanes, $8db028646a03dbcf$var$workInProgressSuspendedRetryLanes === $8db028646a03dbcf$var$workInProgressRootRenderLanes && ($8db028646a03dbcf$var$workInProgressSuspendedRetryLanes = 0));
    $8db028646a03dbcf$var$ensureRootIsScheduled(root);
}
function $8db028646a03dbcf$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $8db028646a03dbcf$var$claimNextRetryLane());
    boundaryFiber = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($8db028646a03dbcf$var$markRootUpdated$1(boundaryFiber, retryLane), $8db028646a03dbcf$var$ensureRootIsScheduled(boundaryFiber));
}
function $8db028646a03dbcf$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $8db028646a03dbcf$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8db028646a03dbcf$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $8db028646a03dbcf$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8db028646a03dbcf$var$scheduleCallback$1(priorityLevel, callback) {
    return $8db028646a03dbcf$var$scheduleCallback$3(priorityLevel, callback);
}
var $8db028646a03dbcf$var$firstScheduledRoot = null, $8db028646a03dbcf$var$lastScheduledRoot = null, $8db028646a03dbcf$var$didScheduleMicrotask = !1, $8db028646a03dbcf$var$mightHavePendingSyncWork = !1, $8db028646a03dbcf$var$isFlushingWork = !1, $8db028646a03dbcf$var$currentEventTransitionLane = 0;
function $8db028646a03dbcf$var$ensureRootIsScheduled(root) {
    root !== $8db028646a03dbcf$var$lastScheduledRoot && null === root.next && (null === $8db028646a03dbcf$var$lastScheduledRoot ? $8db028646a03dbcf$var$firstScheduledRoot = $8db028646a03dbcf$var$lastScheduledRoot = root : $8db028646a03dbcf$var$lastScheduledRoot = $8db028646a03dbcf$var$lastScheduledRoot.next = root);
    $8db028646a03dbcf$var$mightHavePendingSyncWork = !0;
    $8db028646a03dbcf$var$didScheduleMicrotask || ($8db028646a03dbcf$var$didScheduleMicrotask = !0, $8db028646a03dbcf$var$scheduleImmediateTask($8db028646a03dbcf$var$processRootScheduleInMicrotask));
}
function $8db028646a03dbcf$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$8db028646a03dbcf$var$isFlushingWork && $8db028646a03dbcf$var$mightHavePendingSyncWork) {
        $8db028646a03dbcf$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $8db028646a03dbcf$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $8db028646a03dbcf$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $8db028646a03dbcf$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $8db028646a03dbcf$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $8db028646a03dbcf$var$getNextLanes(root$172, root$172 === $8db028646a03dbcf$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $8db028646a03dbcf$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $8db028646a03dbcf$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $8db028646a03dbcf$var$isFlushingWork = !1;
    }
}
function $8db028646a03dbcf$var$processRootScheduleInMicrotask() {
    $8db028646a03dbcf$var$mightHavePendingSyncWork = $8db028646a03dbcf$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $8db028646a03dbcf$var$currentEventTransitionLane && ($8db028646a03dbcf$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $8db028646a03dbcf$var$currentEventTransitionLane), $8db028646a03dbcf$var$currentEventTransitionLane = 0);
    for(var currentTime = $8db028646a03dbcf$var$now(), prev = null, root = $8db028646a03dbcf$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $8db028646a03dbcf$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $8db028646a03dbcf$var$firstScheduledRoot = next : prev.next = next, null === next && ($8db028646a03dbcf$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $8db028646a03dbcf$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $8db028646a03dbcf$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $8db028646a03dbcf$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $8db028646a03dbcf$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $8db028646a03dbcf$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $8db028646a03dbcf$var$workInProgressRoot;
    suspendedLanes = $8db028646a03dbcf$var$workInProgressRootRenderLanes;
    suspendedLanes = $8db028646a03dbcf$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $8db028646a03dbcf$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $8db028646a03dbcf$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $8db028646a03dbcf$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $8db028646a03dbcf$var$cancelCallback$1(pingedLanes);
        switch($8db028646a03dbcf$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $8db028646a03dbcf$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $8db028646a03dbcf$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $8db028646a03dbcf$var$IdlePriority;
                break;
            default:
                suspendedLanes = $8db028646a03dbcf$var$NormalPriority$1;
        }
        pingedLanes = $8db028646a03dbcf$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $8db028646a03dbcf$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $8db028646a03dbcf$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $8db028646a03dbcf$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($8db028646a03dbcf$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $8db028646a03dbcf$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $8db028646a03dbcf$var$getNextLanes(root, root === $8db028646a03dbcf$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $8db028646a03dbcf$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $8db028646a03dbcf$var$scheduleTaskForRootDuringMicrotask(root, $8db028646a03dbcf$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $8db028646a03dbcf$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $8db028646a03dbcf$var$performSyncWorkOnRoot(root, lanes) {
    if ($8db028646a03dbcf$var$flushPassiveEffects()) return null;
    $8db028646a03dbcf$var$performWorkOnRoot(root, lanes, !0);
}
function $8db028646a03dbcf$var$scheduleImmediateTask(cb) {
    $8db028646a03dbcf$var$scheduleMicrotask(function() {
        0 !== ($8db028646a03dbcf$var$executionContext & 6) ? $8db028646a03dbcf$var$scheduleCallback$3($8db028646a03dbcf$var$ImmediatePriority, cb) : cb();
    });
}
function $8db028646a03dbcf$var$requestTransitionLane() {
    0 === $8db028646a03dbcf$var$currentEventTransitionLane && ($8db028646a03dbcf$var$currentEventTransitionLane = $8db028646a03dbcf$var$claimNextTransitionLane());
    return $8db028646a03dbcf$var$currentEventTransitionLane;
}
function $8db028646a03dbcf$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $8db028646a03dbcf$var$sanitizeURL("" + actionProp);
}
function $8db028646a03dbcf$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $8db028646a03dbcf$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $8db028646a03dbcf$var$coerceFormActionProp((nativeEventTarget[$8db028646a03dbcf$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$8db028646a03dbcf$var$internalPropsKey] || null) ? $8db028646a03dbcf$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $8db028646a03dbcf$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $8db028646a03dbcf$var$currentEventTransitionLane) {
                                var formData = submitter ? $8db028646a03dbcf$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $8db028646a03dbcf$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $8db028646a03dbcf$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $8db028646a03dbcf$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $8db028646a03dbcf$var$i$jscomp$inline_1439 = 0; $8db028646a03dbcf$var$i$jscomp$inline_1439 < $8db028646a03dbcf$var$simpleEventPluginEvents.length; $8db028646a03dbcf$var$i$jscomp$inline_1439++){
    var $8db028646a03dbcf$var$eventName$jscomp$inline_1440 = $8db028646a03dbcf$var$simpleEventPluginEvents[$8db028646a03dbcf$var$i$jscomp$inline_1439], $8db028646a03dbcf$var$domEventName$jscomp$inline_1441 = $8db028646a03dbcf$var$eventName$jscomp$inline_1440.toLowerCase(), $8db028646a03dbcf$var$capitalizedEvent$jscomp$inline_1442 = $8db028646a03dbcf$var$eventName$jscomp$inline_1440[0].toUpperCase() + $8db028646a03dbcf$var$eventName$jscomp$inline_1440.slice(1);
    $8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$domEventName$jscomp$inline_1441, "on" + $8db028646a03dbcf$var$capitalizedEvent$jscomp$inline_1442);
}
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$ANIMATION_END, "onAnimationEnd");
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$ANIMATION_ITERATION, "onAnimationIteration");
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$ANIMATION_START, "onAnimationStart");
$8db028646a03dbcf$var$registerSimpleEvent("dblclick", "onDoubleClick");
$8db028646a03dbcf$var$registerSimpleEvent("focusin", "onFocus");
$8db028646a03dbcf$var$registerSimpleEvent("focusout", "onBlur");
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$TRANSITION_RUN, "onTransitionRun");
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$TRANSITION_START, "onTransitionStart");
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$TRANSITION_CANCEL, "onTransitionCancel");
$8db028646a03dbcf$var$registerSimpleEvent($8db028646a03dbcf$var$TRANSITION_END, "onTransitionEnd");
$8db028646a03dbcf$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8db028646a03dbcf$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8db028646a03dbcf$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8db028646a03dbcf$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8db028646a03dbcf$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8db028646a03dbcf$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8db028646a03dbcf$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8db028646a03dbcf$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8db028646a03dbcf$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8db028646a03dbcf$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8db028646a03dbcf$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8db028646a03dbcf$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($8db028646a03dbcf$var$mediaEventTypes));
function $8db028646a03dbcf$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8db028646a03dbcf$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8db028646a03dbcf$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $8db028646a03dbcf$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$8db028646a03dbcf$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$8db028646a03dbcf$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($8db028646a03dbcf$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $8db028646a03dbcf$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $8db028646a03dbcf$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $8db028646a03dbcf$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $8db028646a03dbcf$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$8db028646a03dbcf$var$listeningMarker]) {
        rootContainerElement[$8db028646a03dbcf$var$listeningMarker] = !0;
        $8db028646a03dbcf$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($8db028646a03dbcf$var$nonDelegatedEvents.has(domEventName) || $8db028646a03dbcf$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $8db028646a03dbcf$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$8db028646a03dbcf$var$listeningMarker] || (ownerDocument[$8db028646a03dbcf$var$listeningMarker] = !0, $8db028646a03dbcf$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $8db028646a03dbcf$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($8db028646a03dbcf$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $8db028646a03dbcf$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $8db028646a03dbcf$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $8db028646a03dbcf$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$8db028646a03dbcf$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $8db028646a03dbcf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $8db028646a03dbcf$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $8db028646a03dbcf$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $8db028646a03dbcf$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $8db028646a03dbcf$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $8db028646a03dbcf$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticTouchEvent;
                        break;
                    case $8db028646a03dbcf$var$ANIMATION_END:
                    case $8db028646a03dbcf$var$ANIMATION_ITERATION:
                    case $8db028646a03dbcf$var$ANIMATION_START:
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticAnimationEvent;
                        break;
                    case $8db028646a03dbcf$var$TRANSITION_END:
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $8db028646a03dbcf$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $8db028646a03dbcf$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($8db028646a03dbcf$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $8db028646a03dbcf$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($8db028646a03dbcf$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$8db028646a03dbcf$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $8db028646a03dbcf$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $8db028646a03dbcf$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $8db028646a03dbcf$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $8db028646a03dbcf$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $8db028646a03dbcf$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $8db028646a03dbcf$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $8db028646a03dbcf$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $8db028646a03dbcf$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $8db028646a03dbcf$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $8db028646a03dbcf$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $8db028646a03dbcf$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $8db028646a03dbcf$var$getParent(inCapturePhase);
                                reactEventName = $8db028646a03dbcf$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $8db028646a03dbcf$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $8db028646a03dbcf$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $8db028646a03dbcf$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $8db028646a03dbcf$var$getTargetInstForChangeEvent;
                else if ($8db028646a03dbcf$var$isTextInputElement(reactName)) {
                    if ($8db028646a03dbcf$var$isInputEventSupported) getTargetInstFunc = $8db028646a03dbcf$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $8db028646a03dbcf$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $8db028646a03dbcf$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $8db028646a03dbcf$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $8db028646a03dbcf$var$getTargetInstForChangeEvent) : getTargetInstFunc = $8db028646a03dbcf$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $8db028646a03dbcf$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $8db028646a03dbcf$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $8db028646a03dbcf$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($8db028646a03dbcf$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $8db028646a03dbcf$var$activeElement = handleEventFunc, $8db028646a03dbcf$var$activeElementInst = targetInst, $8db028646a03dbcf$var$lastSelection = null;
                    break;
                case "focusout":
                    $8db028646a03dbcf$var$lastSelection = $8db028646a03dbcf$var$activeElementInst = $8db028646a03dbcf$var$activeElement = null;
                    break;
                case "mousedown":
                    $8db028646a03dbcf$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8db028646a03dbcf$var$mouseDown = !1;
                    $8db028646a03dbcf$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($8db028646a03dbcf$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $8db028646a03dbcf$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($8db028646a03dbcf$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $8db028646a03dbcf$var$isComposing ? $8db028646a03dbcf$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($8db028646a03dbcf$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($8db028646a03dbcf$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $8db028646a03dbcf$var$isComposing && (fallbackData = $8db028646a03dbcf$var$getData()) : ($8db028646a03dbcf$var$root = nativeEventTarget, $8db028646a03dbcf$var$startText = "value" in $8db028646a03dbcf$var$root ? $8db028646a03dbcf$var$root.value : $8db028646a03dbcf$var$root.textContent, $8db028646a03dbcf$var$isComposing = !0)), handleEventFunc = $8db028646a03dbcf$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $8db028646a03dbcf$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $8db028646a03dbcf$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $8db028646a03dbcf$var$canUseTextInputEvent ? $8db028646a03dbcf$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $8db028646a03dbcf$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $8db028646a03dbcf$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $8db028646a03dbcf$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $8db028646a03dbcf$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $8db028646a03dbcf$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $8db028646a03dbcf$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $8db028646a03dbcf$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $8db028646a03dbcf$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($8db028646a03dbcf$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $8db028646a03dbcf$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($8db028646a03dbcf$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $8db028646a03dbcf$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $8db028646a03dbcf$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $8db028646a03dbcf$var$getListener(target, registrationName), null != stateNode && listeners.unshift($8db028646a03dbcf$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $8db028646a03dbcf$var$getListener(target, registrationName), null != stateNode && listeners.push($8db028646a03dbcf$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $8db028646a03dbcf$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $8db028646a03dbcf$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $8db028646a03dbcf$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($8db028646a03dbcf$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($8db028646a03dbcf$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $8db028646a03dbcf$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $8db028646a03dbcf$var$normalizeMarkupForTextOrAttribute(clientText);
    return $8db028646a03dbcf$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $8db028646a03dbcf$var$noop$1() {}
function $8db028646a03dbcf$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $8db028646a03dbcf$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $8db028646a03dbcf$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $8db028646a03dbcf$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $8db028646a03dbcf$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $8db028646a03dbcf$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $8db028646a03dbcf$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $8db028646a03dbcf$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8db028646a03dbcf$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $8db028646a03dbcf$var$setProp(domElement, tag, "name", props.name, props, null), $8db028646a03dbcf$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $8db028646a03dbcf$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $8db028646a03dbcf$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($8db028646a03dbcf$var$setProp(domElement, tag, "encType", props.encType, props, null), $8db028646a03dbcf$var$setProp(domElement, tag, "method", props.method, props, null), $8db028646a03dbcf$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8db028646a03dbcf$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8db028646a03dbcf$var$noop$1);
            break;
        case "onScroll":
            null != value && $8db028646a03dbcf$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8db028646a03dbcf$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $8db028646a03dbcf$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("toggle", domElement);
            $8db028646a03dbcf$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $8db028646a03dbcf$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $8db028646a03dbcf$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $8db028646a03dbcf$var$aliases.get(key) || key, $8db028646a03dbcf$var$setValueForAttribute(domElement, key, value);
    }
}
function $8db028646a03dbcf$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $8db028646a03dbcf$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $8db028646a03dbcf$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $8db028646a03dbcf$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $8db028646a03dbcf$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8db028646a03dbcf$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8db028646a03dbcf$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$8db028646a03dbcf$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$8db028646a03dbcf$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $8db028646a03dbcf$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $8db028646a03dbcf$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("error", domElement);
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($8db028646a03dbcf$var$formatProdErrorMessage(137, tag));
                    default:
                        $8db028646a03dbcf$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $8db028646a03dbcf$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $8db028646a03dbcf$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $8db028646a03dbcf$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $8db028646a03dbcf$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $8db028646a03dbcf$var$track(domElement);
            return;
        case "select":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $8db028646a03dbcf$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $8db028646a03dbcf$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(91));
                    break;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $8db028646a03dbcf$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $8db028646a03dbcf$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("cancel", domElement);
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $8db028646a03dbcf$var$mediaEventTypes.length; hasSrc++)$8db028646a03dbcf$var$listenToNonDelegatedEvent($8db028646a03dbcf$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("error", domElement);
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $8db028646a03dbcf$var$listenToNonDelegatedEvent("error", domElement), $8db028646a03dbcf$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8db028646a03dbcf$var$formatProdErrorMessage(137, tag));
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($8db028646a03dbcf$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $8db028646a03dbcf$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $8db028646a03dbcf$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $8db028646a03dbcf$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $8db028646a03dbcf$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $8db028646a03dbcf$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $8db028646a03dbcf$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $8db028646a03dbcf$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $8db028646a03dbcf$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $8db028646a03dbcf$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $8db028646a03dbcf$var$updateOptions(domElement, !!lastProps, tag, !0) : $8db028646a03dbcf$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $8db028646a03dbcf$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $8db028646a03dbcf$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $8db028646a03dbcf$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $8db028646a03dbcf$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($8db028646a03dbcf$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $8db028646a03dbcf$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $8db028646a03dbcf$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $8db028646a03dbcf$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $8db028646a03dbcf$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $8db028646a03dbcf$var$eventsEnabled = null, $8db028646a03dbcf$var$selectionInformation = null;
function $8db028646a03dbcf$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $8db028646a03dbcf$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $8db028646a03dbcf$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $8db028646a03dbcf$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $8db028646a03dbcf$var$currentPopstateTransitionEvent = null;
function $8db028646a03dbcf$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $8db028646a03dbcf$var$currentPopstateTransitionEvent) return !1;
        $8db028646a03dbcf$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $8db028646a03dbcf$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $8db028646a03dbcf$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $8db028646a03dbcf$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $8db028646a03dbcf$var$localPromise = "function" === typeof Promise ? Promise : void 0, $8db028646a03dbcf$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8db028646a03dbcf$var$localPromise ? function(callback) {
    return $8db028646a03dbcf$var$localPromise.resolve(null).then(callback).catch($8db028646a03dbcf$var$handleErrorInNextTick);
} : $8db028646a03dbcf$var$scheduleTimeout;
function $8db028646a03dbcf$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $8db028646a03dbcf$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $8db028646a03dbcf$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $8db028646a03dbcf$var$retryIfBlockedOn(suspenseInstance);
}
function $8db028646a03dbcf$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $8db028646a03dbcf$var$clearContainerSparingly(node);
                $8db028646a03dbcf$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $8db028646a03dbcf$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$8db028646a03dbcf$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $8db028646a03dbcf$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $8db028646a03dbcf$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8db028646a03dbcf$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8db028646a03dbcf$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $8db028646a03dbcf$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $8db028646a03dbcf$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $8db028646a03dbcf$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(451));
    }
}
var $8db028646a03dbcf$var$preloadPropsMap = new Map(), $8db028646a03dbcf$var$preconnectsSet = new Set();
function $8db028646a03dbcf$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $8db028646a03dbcf$var$previousDispatcher = $8db028646a03dbcf$var$ReactDOMSharedInternals.d;
$8db028646a03dbcf$var$ReactDOMSharedInternals.d = {
    f: $8db028646a03dbcf$var$flushSyncWork,
    r: $8db028646a03dbcf$var$requestFormReset,
    D: $8db028646a03dbcf$var$prefetchDNS,
    C: $8db028646a03dbcf$var$preconnect,
    L: $8db028646a03dbcf$var$preload,
    m: $8db028646a03dbcf$var$preloadModule,
    X: $8db028646a03dbcf$var$preinitScript,
    S: $8db028646a03dbcf$var$preinitStyle,
    M: $8db028646a03dbcf$var$preinitModuleScript
};
function $8db028646a03dbcf$var$flushSyncWork() {
    var previousWasRendering = $8db028646a03dbcf$var$previousDispatcher.f(), wasRendering = $8db028646a03dbcf$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $8db028646a03dbcf$var$requestFormReset(form) {
    var formInst = $8db028646a03dbcf$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $8db028646a03dbcf$var$requestFormReset$1(formInst) : $8db028646a03dbcf$var$previousDispatcher.r(form);
}
var $8db028646a03dbcf$var$globalDocument = "undefined" === typeof document ? null : document;
function $8db028646a03dbcf$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $8db028646a03dbcf$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $8db028646a03dbcf$var$preconnectsSet.has(limitedEscapedHref) || ($8db028646a03dbcf$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $8db028646a03dbcf$var$setInitialProperties(href, "link", rel), $8db028646a03dbcf$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $8db028646a03dbcf$var$prefetchDNS(href) {
    $8db028646a03dbcf$var$previousDispatcher.D(href);
    $8db028646a03dbcf$var$preconnectAs("dns-prefetch", href, null);
}
function $8db028646a03dbcf$var$preconnect(href, crossOrigin) {
    $8db028646a03dbcf$var$previousDispatcher.C(href, crossOrigin);
    $8db028646a03dbcf$var$preconnectAs("preconnect", href, crossOrigin);
}
function $8db028646a03dbcf$var$preload(href, as, options) {
    $8db028646a03dbcf$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $8db028646a03dbcf$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $8db028646a03dbcf$var$getStyleKey(href);
                break;
            case "script":
                key = $8db028646a03dbcf$var$getScriptKey(href);
        }
        $8db028646a03dbcf$var$preloadPropsMap.has(key) || (href = $8db028646a03dbcf$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $8db028646a03dbcf$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($8db028646a03dbcf$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($8db028646a03dbcf$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $8db028646a03dbcf$var$setInitialProperties(as, "link", href), $8db028646a03dbcf$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $8db028646a03dbcf$var$preloadModule(href, options) {
    $8db028646a03dbcf$var$previousDispatcher.m(href, options);
    var ownerDocument = $8db028646a03dbcf$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $8db028646a03dbcf$var$getScriptKey(href);
        }
        if (!$8db028646a03dbcf$var$preloadPropsMap.has(key) && (href = $8db028646a03dbcf$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $8db028646a03dbcf$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($8db028646a03dbcf$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $8db028646a03dbcf$var$setInitialProperties(as, "link", href);
            $8db028646a03dbcf$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $8db028646a03dbcf$var$preinitStyle(href, precedence, options) {
    $8db028646a03dbcf$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $8db028646a03dbcf$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $8db028646a03dbcf$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $8db028646a03dbcf$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($8db028646a03dbcf$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $8db028646a03dbcf$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $8db028646a03dbcf$var$preloadPropsMap.get(key)) && $8db028646a03dbcf$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $8db028646a03dbcf$var$markNodeAsHoistable(link);
                $8db028646a03dbcf$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $8db028646a03dbcf$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $8db028646a03dbcf$var$preinitScript(src, options) {
    $8db028646a03dbcf$var$previousDispatcher.X(src, options);
    var ownerDocument = $8db028646a03dbcf$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8db028646a03dbcf$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8db028646a03dbcf$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8db028646a03dbcf$var$getScriptSelectorFromKey(key)), resource || (src = $8db028646a03dbcf$var$assign({
            src: src,
            async: !0
        }, options), (options = $8db028646a03dbcf$var$preloadPropsMap.get(key)) && $8db028646a03dbcf$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8db028646a03dbcf$var$markNodeAsHoistable(resource), $8db028646a03dbcf$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8db028646a03dbcf$var$preinitModuleScript(src, options) {
    $8db028646a03dbcf$var$previousDispatcher.M(src, options);
    var ownerDocument = $8db028646a03dbcf$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8db028646a03dbcf$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8db028646a03dbcf$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8db028646a03dbcf$var$getScriptSelectorFromKey(key)), resource || (src = $8db028646a03dbcf$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $8db028646a03dbcf$var$preloadPropsMap.get(key)) && $8db028646a03dbcf$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8db028646a03dbcf$var$markNodeAsHoistable(resource), $8db028646a03dbcf$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8db028646a03dbcf$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $8db028646a03dbcf$var$rootInstanceStackCursor.current) ? $8db028646a03dbcf$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $8db028646a03dbcf$var$getStyleKey(pendingProps.href), pendingProps = $8db028646a03dbcf$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $8db028646a03dbcf$var$getStyleKey(pendingProps.href);
                var styles$242 = $8db028646a03dbcf$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($8db028646a03dbcf$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $8db028646a03dbcf$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $8db028646a03dbcf$var$preloadPropsMap.set(type, pendingProps), styles$242 || $8db028646a03dbcf$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $8db028646a03dbcf$var$getScriptKey(pendingProps), pendingProps = $8db028646a03dbcf$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(444, type));
    }
}
function $8db028646a03dbcf$var$getStyleKey(href) {
    return 'href="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $8db028646a03dbcf$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $8db028646a03dbcf$var$stylesheetPropsFromRawProps(rawProps) {
    return $8db028646a03dbcf$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $8db028646a03dbcf$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $8db028646a03dbcf$var$setInitialProperties(key, "link", preloadProps), $8db028646a03dbcf$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $8db028646a03dbcf$var$getScriptKey(src) {
    return '[src="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $8db028646a03dbcf$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $8db028646a03dbcf$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $8db028646a03dbcf$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $8db028646a03dbcf$var$markNodeAsHoistable(instance), instance;
            var styleProps = $8db028646a03dbcf$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $8db028646a03dbcf$var$markNodeAsHoistable(instance);
            $8db028646a03dbcf$var$setInitialProperties(instance, "style", styleProps);
            $8db028646a03dbcf$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $8db028646a03dbcf$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($8db028646a03dbcf$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $8db028646a03dbcf$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $8db028646a03dbcf$var$stylesheetPropsFromRawProps(props);
            (styleProps = $8db028646a03dbcf$var$preloadPropsMap.get(styleProps)) && $8db028646a03dbcf$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $8db028646a03dbcf$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8db028646a03dbcf$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $8db028646a03dbcf$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $8db028646a03dbcf$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($8db028646a03dbcf$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $8db028646a03dbcf$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $8db028646a03dbcf$var$preloadPropsMap.get(instance$248)) instance = $8db028646a03dbcf$var$assign({}, props), $8db028646a03dbcf$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $8db028646a03dbcf$var$markNodeAsHoistable(styleProps);
            $8db028646a03dbcf$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($8db028646a03dbcf$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $8db028646a03dbcf$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $8db028646a03dbcf$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $8db028646a03dbcf$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $8db028646a03dbcf$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $8db028646a03dbcf$var$tagCaches = null;
function $8db028646a03dbcf$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $8db028646a03dbcf$var$tagCaches) {
        var cache = new Map();
        var caches = $8db028646a03dbcf$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $8db028646a03dbcf$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$8db028646a03dbcf$var$internalHoistableMarker] || node[$8db028646a03dbcf$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $8db028646a03dbcf$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $8db028646a03dbcf$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $8db028646a03dbcf$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $8db028646a03dbcf$var$suspendedState = null;
function $8db028646a03dbcf$var$noop() {}
function $8db028646a03dbcf$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $8db028646a03dbcf$var$suspendedState) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(475));
    var state = $8db028646a03dbcf$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $8db028646a03dbcf$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($8db028646a03dbcf$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $8db028646a03dbcf$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $8db028646a03dbcf$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $8db028646a03dbcf$var$stylesheetPropsFromRawProps(props);
            (key = $8db028646a03dbcf$var$preloadPropsMap.get(key)) && $8db028646a03dbcf$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $8db028646a03dbcf$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8db028646a03dbcf$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $8db028646a03dbcf$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $8db028646a03dbcf$var$waitForCommitToBeReady() {
    if (null === $8db028646a03dbcf$var$suspendedState) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(475));
    var state = $8db028646a03dbcf$var$suspendedState;
    state.stylesheets && 0 === state.count && $8db028646a03dbcf$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $8db028646a03dbcf$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $8db028646a03dbcf$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $8db028646a03dbcf$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $8db028646a03dbcf$var$precedencesByRoot = null;
function $8db028646a03dbcf$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $8db028646a03dbcf$var$precedencesByRoot = new Map(), resources.forEach($8db028646a03dbcf$var$insertStylesheetIntoRoot, state), $8db028646a03dbcf$var$precedencesByRoot = null, $8db028646a03dbcf$var$onUnsuspend.call(state));
}
function $8db028646a03dbcf$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $8db028646a03dbcf$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $8db028646a03dbcf$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $8db028646a03dbcf$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $8db028646a03dbcf$var$HostTransitionContext = {
    $$typeof: $8db028646a03dbcf$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $8db028646a03dbcf$var$sharedNotPendingObject,
    _currentValue2: $8db028646a03dbcf$var$sharedNotPendingObject,
    _threadCount: 0
};
function $8db028646a03dbcf$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $8db028646a03dbcf$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8db028646a03dbcf$var$createLaneMap(0);
    this.hiddenUpdates = $8db028646a03dbcf$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $8db028646a03dbcf$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $8db028646a03dbcf$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $8db028646a03dbcf$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $8db028646a03dbcf$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $8db028646a03dbcf$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $8db028646a03dbcf$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $8db028646a03dbcf$var$emptyContextObject;
    parentComponent = $8db028646a03dbcf$var$emptyContextObject;
    return parentComponent;
}
function $8db028646a03dbcf$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $8db028646a03dbcf$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $8db028646a03dbcf$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $8db028646a03dbcf$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($8db028646a03dbcf$var$scheduleUpdateOnFiber(element, rootFiber, lane), $8db028646a03dbcf$var$entangleTransitions(element, rootFiber, lane));
}
function $8db028646a03dbcf$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $8db028646a03dbcf$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $8db028646a03dbcf$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $8db028646a03dbcf$var$markRetryLaneImpl(fiber, retryLane);
}
function $8db028646a03dbcf$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $8db028646a03dbcf$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $8db028646a03dbcf$var$_enabled = !0;
function $8db028646a03dbcf$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8db028646a03dbcf$var$ReactSharedInternals.T;
    $8db028646a03dbcf$var$ReactSharedInternals.T = null;
    var previousPriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
    try {
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = 2, $8db028646a03dbcf$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = previousPriority, $8db028646a03dbcf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8db028646a03dbcf$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8db028646a03dbcf$var$ReactSharedInternals.T;
    $8db028646a03dbcf$var$ReactSharedInternals.T = null;
    var previousPriority = $8db028646a03dbcf$var$ReactDOMSharedInternals.p;
    try {
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = 8, $8db028646a03dbcf$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8db028646a03dbcf$var$ReactDOMSharedInternals.p = previousPriority, $8db028646a03dbcf$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8db028646a03dbcf$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($8db028646a03dbcf$var$_enabled) {
        var blockedOn = $8db028646a03dbcf$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $8db028646a03dbcf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8db028646a03dbcf$var$return_targetInst, targetContainer), $8db028646a03dbcf$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($8db028646a03dbcf$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($8db028646a03dbcf$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $8db028646a03dbcf$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $8db028646a03dbcf$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $8db028646a03dbcf$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $8db028646a03dbcf$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $8db028646a03dbcf$var$ensureRootIsScheduled(fiber);
                                0 === ($8db028646a03dbcf$var$executionContext & 6) && ($8db028646a03dbcf$var$workInProgressRootRenderTargetTime = $8db028646a03dbcf$var$now() + 500, $8db028646a03dbcf$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, fiber, 2), $8db028646a03dbcf$var$flushSyncWork$1(), $8db028646a03dbcf$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $8db028646a03dbcf$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $8db028646a03dbcf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8db028646a03dbcf$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $8db028646a03dbcf$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $8db028646a03dbcf$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $8db028646a03dbcf$var$getEventTarget(nativeEvent);
    return $8db028646a03dbcf$var$findInstanceBlockingTarget(nativeEvent);
}
var $8db028646a03dbcf$var$return_targetInst = null;
function $8db028646a03dbcf$var$findInstanceBlockingTarget(targetNode) {
    $8db028646a03dbcf$var$return_targetInst = null;
    targetNode = $8db028646a03dbcf$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $8db028646a03dbcf$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $8db028646a03dbcf$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $8db028646a03dbcf$var$return_targetInst = targetNode;
    return null;
}
function $8db028646a03dbcf$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($8db028646a03dbcf$var$getCurrentPriorityLevel()){
                case $8db028646a03dbcf$var$ImmediatePriority:
                    return 2;
                case $8db028646a03dbcf$var$UserBlockingPriority:
                    return 8;
                case $8db028646a03dbcf$var$NormalPriority$1:
                case $8db028646a03dbcf$var$LowPriority:
                    return 32;
                case $8db028646a03dbcf$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $8db028646a03dbcf$var$hasScheduledReplayAttempt = !1, $8db028646a03dbcf$var$queuedFocus = null, $8db028646a03dbcf$var$queuedDrag = null, $8db028646a03dbcf$var$queuedMouse = null, $8db028646a03dbcf$var$queuedPointers = new Map(), $8db028646a03dbcf$var$queuedPointerCaptures = new Map(), $8db028646a03dbcf$var$queuedExplicitHydrationTargets = [], $8db028646a03dbcf$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $8db028646a03dbcf$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $8db028646a03dbcf$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $8db028646a03dbcf$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $8db028646a03dbcf$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $8db028646a03dbcf$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8db028646a03dbcf$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $8db028646a03dbcf$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $8db028646a03dbcf$var$getInstanceFromNode(blockedOn), null !== blockedOn && $8db028646a03dbcf$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $8db028646a03dbcf$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $8db028646a03dbcf$var$queuedFocus = $8db028646a03dbcf$var$accumulateOrCreateContinuousQueuedReplayableEvent($8db028646a03dbcf$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $8db028646a03dbcf$var$queuedDrag = $8db028646a03dbcf$var$accumulateOrCreateContinuousQueuedReplayableEvent($8db028646a03dbcf$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $8db028646a03dbcf$var$queuedMouse = $8db028646a03dbcf$var$accumulateOrCreateContinuousQueuedReplayableEvent($8db028646a03dbcf$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $8db028646a03dbcf$var$queuedPointers.set(pointerId, $8db028646a03dbcf$var$accumulateOrCreateContinuousQueuedReplayableEvent($8db028646a03dbcf$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $8db028646a03dbcf$var$queuedPointerCaptures.set(pointerId, $8db028646a03dbcf$var$accumulateOrCreateContinuousQueuedReplayableEvent($8db028646a03dbcf$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $8db028646a03dbcf$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $8db028646a03dbcf$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $8db028646a03dbcf$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $8db028646a03dbcf$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8db028646a03dbcf$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $8db028646a03dbcf$var$requestUpdateLane(), root = $8db028646a03dbcf$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $8db028646a03dbcf$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $8db028646a03dbcf$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $8db028646a03dbcf$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $8db028646a03dbcf$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $8db028646a03dbcf$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $8db028646a03dbcf$var$currentReplayingEvent = null;
        } else return targetContainers = $8db028646a03dbcf$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $8db028646a03dbcf$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $8db028646a03dbcf$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $8db028646a03dbcf$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $8db028646a03dbcf$var$replayUnblockedEvents() {
    $8db028646a03dbcf$var$hasScheduledReplayAttempt = !1;
    null !== $8db028646a03dbcf$var$queuedFocus && $8db028646a03dbcf$var$attemptReplayContinuousQueuedEvent($8db028646a03dbcf$var$queuedFocus) && ($8db028646a03dbcf$var$queuedFocus = null);
    null !== $8db028646a03dbcf$var$queuedDrag && $8db028646a03dbcf$var$attemptReplayContinuousQueuedEvent($8db028646a03dbcf$var$queuedDrag) && ($8db028646a03dbcf$var$queuedDrag = null);
    null !== $8db028646a03dbcf$var$queuedMouse && $8db028646a03dbcf$var$attemptReplayContinuousQueuedEvent($8db028646a03dbcf$var$queuedMouse) && ($8db028646a03dbcf$var$queuedMouse = null);
    $8db028646a03dbcf$var$queuedPointers.forEach($8db028646a03dbcf$var$attemptReplayContinuousQueuedEventInMap);
    $8db028646a03dbcf$var$queuedPointerCaptures.forEach($8db028646a03dbcf$var$attemptReplayContinuousQueuedEventInMap);
}
function $8db028646a03dbcf$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $8db028646a03dbcf$var$hasScheduledReplayAttempt || ($8db028646a03dbcf$var$hasScheduledReplayAttempt = !0, $lugMi.unstable_scheduleCallback($lugMi.unstable_NormalPriority, $8db028646a03dbcf$var$replayUnblockedEvents)));
}
var $8db028646a03dbcf$var$lastScheduledReplayQueue = null;
function $8db028646a03dbcf$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $8db028646a03dbcf$var$lastScheduledReplayQueue !== formReplayingQueue && ($8db028646a03dbcf$var$lastScheduledReplayQueue = formReplayingQueue, $lugMi.unstable_scheduleCallback($lugMi.unstable_NormalPriority, function() {
        $8db028646a03dbcf$var$lastScheduledReplayQueue === formReplayingQueue && ($8db028646a03dbcf$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $8db028646a03dbcf$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $8db028646a03dbcf$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $8db028646a03dbcf$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $8db028646a03dbcf$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $8db028646a03dbcf$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $8db028646a03dbcf$var$queuedFocus && $8db028646a03dbcf$var$scheduleCallbackIfUnblocked($8db028646a03dbcf$var$queuedFocus, unblocked);
    null !== $8db028646a03dbcf$var$queuedDrag && $8db028646a03dbcf$var$scheduleCallbackIfUnblocked($8db028646a03dbcf$var$queuedDrag, unblocked);
    null !== $8db028646a03dbcf$var$queuedMouse && $8db028646a03dbcf$var$scheduleCallbackIfUnblocked($8db028646a03dbcf$var$queuedMouse, unblocked);
    $8db028646a03dbcf$var$queuedPointers.forEach(unblock);
    $8db028646a03dbcf$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $8db028646a03dbcf$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $8db028646a03dbcf$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $8db028646a03dbcf$var$queuedExplicitHydrationTargets.length && (i = $8db028646a03dbcf$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$8db028646a03dbcf$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $8db028646a03dbcf$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$8db028646a03dbcf$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $8db028646a03dbcf$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$8db028646a03dbcf$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $8db028646a03dbcf$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $8db028646a03dbcf$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $8db028646a03dbcf$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8db028646a03dbcf$var$ReactDOMHydrationRoot.prototype.render = $8db028646a03dbcf$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(409));
    var current = root.current, lane = $8db028646a03dbcf$var$requestUpdateLane();
    $8db028646a03dbcf$var$updateContainerImpl(current, lane, children, root, null, null);
};
$8db028646a03dbcf$var$ReactDOMHydrationRoot.prototype.unmount = $8db028646a03dbcf$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $8db028646a03dbcf$var$flushPassiveEffects();
        $8db028646a03dbcf$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $8db028646a03dbcf$var$flushSyncWork$1();
        container[$8db028646a03dbcf$var$internalContainerInstanceKey] = null;
    }
};
function $8db028646a03dbcf$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8db028646a03dbcf$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $8db028646a03dbcf$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $8db028646a03dbcf$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $8db028646a03dbcf$var$queuedExplicitHydrationTargets[i].priority; i++);
        $8db028646a03dbcf$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $8db028646a03dbcf$var$attemptExplicitHydrationTarget(target);
    }
};
var $8db028646a03dbcf$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $iBfRJ.version;
if ("19.0.0" !== $8db028646a03dbcf$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(527, $8db028646a03dbcf$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$8db028646a03dbcf$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($8db028646a03dbcf$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $8db028646a03dbcf$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $8db028646a03dbcf$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $8db028646a03dbcf$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $8db028646a03dbcf$var$ReactSharedInternals,
    findFiberByHostInstance: $8db028646a03dbcf$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8db028646a03dbcf$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8db028646a03dbcf$var$hook$jscomp$inline_2166.isDisabled && $8db028646a03dbcf$var$hook$jscomp$inline_2166.supportsFiber) try {
        $8db028646a03dbcf$var$rendererID = $8db028646a03dbcf$var$hook$jscomp$inline_2166.inject($8db028646a03dbcf$var$internals$jscomp$inline_2165), $8db028646a03dbcf$var$injectedHook = $8db028646a03dbcf$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$8db028646a03dbcf$export$882461b6382ed46c = function(container, options) {
    if (!$8db028646a03dbcf$var$isValidContainer(container)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8db028646a03dbcf$var$defaultOnUncaughtError, onCaughtError = $8db028646a03dbcf$var$defaultOnCaughtError, onRecoverableError = $8db028646a03dbcf$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $8db028646a03dbcf$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$8db028646a03dbcf$var$internalContainerInstanceKey] = options.current;
    $8db028646a03dbcf$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $8db028646a03dbcf$var$ReactDOMRoot(options);
};
$8db028646a03dbcf$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$8db028646a03dbcf$var$isValidContainer(container)) throw Error($8db028646a03dbcf$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8db028646a03dbcf$var$defaultOnUncaughtError, onCaughtError = $8db028646a03dbcf$var$defaultOnCaughtError, onRecoverableError = $8db028646a03dbcf$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $8db028646a03dbcf$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $8db028646a03dbcf$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $8db028646a03dbcf$var$requestUpdateLane();
    identifierPrefix = $8db028646a03dbcf$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $8db028646a03dbcf$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $8db028646a03dbcf$var$markRootUpdated$1(initialChildren, isStrictMode);
    $8db028646a03dbcf$var$ensureRootIsScheduled(initialChildren);
    container[$8db028646a03dbcf$var$internalContainerInstanceKey] = initialChildren.current;
    $8db028646a03dbcf$var$listenToAllSupportedEvents(container);
    return new $8db028646a03dbcf$var$ReactDOMHydrationRoot(initialChildren);
};
$8db028646a03dbcf$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("lugMi", function(module, exports) {
"use strict";

module.exports = (parcelRequire("83g72"));

});
parcelRegister("83g72", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $5dcb1a2c693b29b3$export$c4744153514ff05d, (v) => $5dcb1a2c693b29b3$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $5dcb1a2c693b29b3$export$3e506c1ccc9cc1a7, (v) => $5dcb1a2c693b29b3$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $5dcb1a2c693b29b3$export$e26fe2ed2fa76875, (v) => $5dcb1a2c693b29b3$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $5dcb1a2c693b29b3$export$502329bbf4b505b1, (v) => $5dcb1a2c693b29b3$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $5dcb1a2c693b29b3$export$6e3807111c4874c4, (v) => $5dcb1a2c693b29b3$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $5dcb1a2c693b29b3$export$c27134553091fb3a, (v) => $5dcb1a2c693b29b3$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $5dcb1a2c693b29b3$export$33ee1acdc04fd2a2, (v) => $5dcb1a2c693b29b3$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $5dcb1a2c693b29b3$export$b00a404bbd5edef2, (v) => $5dcb1a2c693b29b3$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $5dcb1a2c693b29b3$export$8352ce38b91d0c62, (v) => $5dcb1a2c693b29b3$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $5dcb1a2c693b29b3$export$d66a1c1c77bd778b, (v) => $5dcb1a2c693b29b3$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $5dcb1a2c693b29b3$export$d3dfb8e4810cb555, (v) => $5dcb1a2c693b29b3$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $5dcb1a2c693b29b3$export$839f9183b0465a69, (v) => $5dcb1a2c693b29b3$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $5dcb1a2c693b29b3$export$72fdf0e06517287b, (v) => $5dcb1a2c693b29b3$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $5dcb1a2c693b29b3$export$4b844e58a3e414b4, (v) => $5dcb1a2c693b29b3$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $5dcb1a2c693b29b3$export$816d2913ae6b83b1, (v) => $5dcb1a2c693b29b3$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $5dcb1a2c693b29b3$export$61bcfe829111a1d0, (v) => $5dcb1a2c693b29b3$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $5dcb1a2c693b29b3$export$7ee8c9beb337bc3f, (v) => $5dcb1a2c693b29b3$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $5dcb1a2c693b29b3$export$b5836b71941fa3ed, (v) => $5dcb1a2c693b29b3$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $5dcb1a2c693b29b3$export$cf845f2c119da08a, (v) => $5dcb1a2c693b29b3$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5dcb1a2c693b29b3$export$c4744153514ff05d;
var $5dcb1a2c693b29b3$export$3e506c1ccc9cc1a7;
var $5dcb1a2c693b29b3$export$e26fe2ed2fa76875;
var $5dcb1a2c693b29b3$export$502329bbf4b505b1;
var $5dcb1a2c693b29b3$export$6e3807111c4874c4;
var $5dcb1a2c693b29b3$export$c27134553091fb3a;
var $5dcb1a2c693b29b3$export$33ee1acdc04fd2a2;
var $5dcb1a2c693b29b3$export$b00a404bbd5edef2;
var $5dcb1a2c693b29b3$export$8352ce38b91d0c62;
var $5dcb1a2c693b29b3$export$d66a1c1c77bd778b;
var $5dcb1a2c693b29b3$export$d3dfb8e4810cb555;
var $5dcb1a2c693b29b3$export$839f9183b0465a69;
var $5dcb1a2c693b29b3$export$72fdf0e06517287b;
var $5dcb1a2c693b29b3$export$4b844e58a3e414b4;
var $5dcb1a2c693b29b3$export$816d2913ae6b83b1;
var $5dcb1a2c693b29b3$export$61bcfe829111a1d0;
var $5dcb1a2c693b29b3$export$7ee8c9beb337bc3f;
var $5dcb1a2c693b29b3$export$b5836b71941fa3ed;
var $5dcb1a2c693b29b3$export$cf845f2c119da08a;
"use strict";
function $5dcb1a2c693b29b3$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $5dcb1a2c693b29b3$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $5dcb1a2c693b29b3$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $5dcb1a2c693b29b3$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $5dcb1a2c693b29b3$var$compare(left, last)) rightIndex < length && 0 > $5dcb1a2c693b29b3$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $5dcb1a2c693b29b3$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $5dcb1a2c693b29b3$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$5dcb1a2c693b29b3$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $5dcb1a2c693b29b3$var$localPerformance = performance;
    $5dcb1a2c693b29b3$export$c4744153514ff05d = function() {
        return $5dcb1a2c693b29b3$var$localPerformance.now();
    };
} else {
    var $5dcb1a2c693b29b3$var$localDate = Date, $5dcb1a2c693b29b3$var$initialTime = $5dcb1a2c693b29b3$var$localDate.now();
    $5dcb1a2c693b29b3$export$c4744153514ff05d = function() {
        return $5dcb1a2c693b29b3$var$localDate.now() - $5dcb1a2c693b29b3$var$initialTime;
    };
}
var $5dcb1a2c693b29b3$var$taskQueue = [], $5dcb1a2c693b29b3$var$timerQueue = [], $5dcb1a2c693b29b3$var$taskIdCounter = 1, $5dcb1a2c693b29b3$var$currentTask = null, $5dcb1a2c693b29b3$var$currentPriorityLevel = 3, $5dcb1a2c693b29b3$var$isPerformingWork = !1, $5dcb1a2c693b29b3$var$isHostCallbackScheduled = !1, $5dcb1a2c693b29b3$var$isHostTimeoutScheduled = !1, $5dcb1a2c693b29b3$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $5dcb1a2c693b29b3$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $5dcb1a2c693b29b3$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $5dcb1a2c693b29b3$var$advanceTimers(currentTime) {
    for(var timer = $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$timerQueue); null !== timer;){
        if (null === timer.callback) $5dcb1a2c693b29b3$var$pop($5dcb1a2c693b29b3$var$timerQueue);
        else if (timer.startTime <= currentTime) $5dcb1a2c693b29b3$var$pop($5dcb1a2c693b29b3$var$timerQueue), timer.sortIndex = timer.expirationTime, $5dcb1a2c693b29b3$var$push($5dcb1a2c693b29b3$var$taskQueue, timer);
        else break;
        timer = $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$timerQueue);
    }
}
function $5dcb1a2c693b29b3$var$handleTimeout(currentTime) {
    $5dcb1a2c693b29b3$var$isHostTimeoutScheduled = !1;
    $5dcb1a2c693b29b3$var$advanceTimers(currentTime);
    if (!$5dcb1a2c693b29b3$var$isHostCallbackScheduled) {
        if (null !== $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$taskQueue)) $5dcb1a2c693b29b3$var$isHostCallbackScheduled = !0, $5dcb1a2c693b29b3$var$requestHostCallback();
        else {
            var firstTimer = $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$timerQueue);
            null !== firstTimer && $5dcb1a2c693b29b3$var$requestHostTimeout($5dcb1a2c693b29b3$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $5dcb1a2c693b29b3$var$isMessageLoopRunning = !1, $5dcb1a2c693b29b3$var$taskTimeoutID = -1, $5dcb1a2c693b29b3$var$frameInterval = 5, $5dcb1a2c693b29b3$var$startTime = -1;
function $5dcb1a2c693b29b3$var$shouldYieldToHost() {
    return $5dcb1a2c693b29b3$export$c4744153514ff05d() - $5dcb1a2c693b29b3$var$startTime < $5dcb1a2c693b29b3$var$frameInterval ? !1 : !0;
}
function $5dcb1a2c693b29b3$var$performWorkUntilDeadline() {
    if ($5dcb1a2c693b29b3$var$isMessageLoopRunning) {
        var currentTime = $5dcb1a2c693b29b3$export$c4744153514ff05d();
        $5dcb1a2c693b29b3$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $5dcb1a2c693b29b3$var$isHostCallbackScheduled = !1;
                $5dcb1a2c693b29b3$var$isHostTimeoutScheduled && ($5dcb1a2c693b29b3$var$isHostTimeoutScheduled = !1, $5dcb1a2c693b29b3$var$localClearTimeout($5dcb1a2c693b29b3$var$taskTimeoutID), $5dcb1a2c693b29b3$var$taskTimeoutID = -1);
                $5dcb1a2c693b29b3$var$isPerformingWork = !0;
                var previousPriorityLevel = $5dcb1a2c693b29b3$var$currentPriorityLevel;
                try {
                    b: {
                        $5dcb1a2c693b29b3$var$advanceTimers(currentTime);
                        for($5dcb1a2c693b29b3$var$currentTask = $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$taskQueue); null !== $5dcb1a2c693b29b3$var$currentTask && !($5dcb1a2c693b29b3$var$currentTask.expirationTime > currentTime && $5dcb1a2c693b29b3$var$shouldYieldToHost());){
                            var callback = $5dcb1a2c693b29b3$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $5dcb1a2c693b29b3$var$currentTask.callback = null;
                                $5dcb1a2c693b29b3$var$currentPriorityLevel = $5dcb1a2c693b29b3$var$currentTask.priorityLevel;
                                var continuationCallback = callback($5dcb1a2c693b29b3$var$currentTask.expirationTime <= currentTime);
                                currentTime = $5dcb1a2c693b29b3$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $5dcb1a2c693b29b3$var$currentTask.callback = continuationCallback;
                                    $5dcb1a2c693b29b3$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $5dcb1a2c693b29b3$var$currentTask === $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$taskQueue) && $5dcb1a2c693b29b3$var$pop($5dcb1a2c693b29b3$var$taskQueue);
                                $5dcb1a2c693b29b3$var$advanceTimers(currentTime);
                            } else $5dcb1a2c693b29b3$var$pop($5dcb1a2c693b29b3$var$taskQueue);
                            $5dcb1a2c693b29b3$var$currentTask = $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$taskQueue);
                        }
                        if (null !== $5dcb1a2c693b29b3$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$timerQueue);
                            null !== firstTimer && $5dcb1a2c693b29b3$var$requestHostTimeout($5dcb1a2c693b29b3$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $5dcb1a2c693b29b3$var$currentTask = null, $5dcb1a2c693b29b3$var$currentPriorityLevel = previousPriorityLevel, $5dcb1a2c693b29b3$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $5dcb1a2c693b29b3$var$schedulePerformWorkUntilDeadline() : $5dcb1a2c693b29b3$var$isMessageLoopRunning = !1;
        }
    }
}
var $5dcb1a2c693b29b3$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $5dcb1a2c693b29b3$var$localSetImmediate) $5dcb1a2c693b29b3$var$schedulePerformWorkUntilDeadline = function() {
    $5dcb1a2c693b29b3$var$localSetImmediate($5dcb1a2c693b29b3$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $5dcb1a2c693b29b3$var$channel = new MessageChannel(), $5dcb1a2c693b29b3$var$port = $5dcb1a2c693b29b3$var$channel.port2;
    $5dcb1a2c693b29b3$var$channel.port1.onmessage = $5dcb1a2c693b29b3$var$performWorkUntilDeadline;
    $5dcb1a2c693b29b3$var$schedulePerformWorkUntilDeadline = function() {
        $5dcb1a2c693b29b3$var$port.postMessage(null);
    };
} else $5dcb1a2c693b29b3$var$schedulePerformWorkUntilDeadline = function() {
    $5dcb1a2c693b29b3$var$localSetTimeout($5dcb1a2c693b29b3$var$performWorkUntilDeadline, 0);
};
function $5dcb1a2c693b29b3$var$requestHostCallback() {
    $5dcb1a2c693b29b3$var$isMessageLoopRunning || ($5dcb1a2c693b29b3$var$isMessageLoopRunning = !0, $5dcb1a2c693b29b3$var$schedulePerformWorkUntilDeadline());
}
function $5dcb1a2c693b29b3$var$requestHostTimeout(callback, ms) {
    $5dcb1a2c693b29b3$var$taskTimeoutID = $5dcb1a2c693b29b3$var$localSetTimeout(function() {
        callback($5dcb1a2c693b29b3$export$c4744153514ff05d());
    }, ms);
}
$5dcb1a2c693b29b3$export$3e506c1ccc9cc1a7 = 5;
$5dcb1a2c693b29b3$export$e26fe2ed2fa76875 = 1;
$5dcb1a2c693b29b3$export$502329bbf4b505b1 = 4;
$5dcb1a2c693b29b3$export$6e3807111c4874c4 = 3;
$5dcb1a2c693b29b3$export$c27134553091fb3a = null;
$5dcb1a2c693b29b3$export$33ee1acdc04fd2a2 = 2;
$5dcb1a2c693b29b3$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$5dcb1a2c693b29b3$export$8352ce38b91d0c62 = function() {
    $5dcb1a2c693b29b3$var$isHostCallbackScheduled || $5dcb1a2c693b29b3$var$isPerformingWork || ($5dcb1a2c693b29b3$var$isHostCallbackScheduled = !0, $5dcb1a2c693b29b3$var$requestHostCallback());
};
$5dcb1a2c693b29b3$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $5dcb1a2c693b29b3$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$5dcb1a2c693b29b3$export$d3dfb8e4810cb555 = function() {
    return $5dcb1a2c693b29b3$var$currentPriorityLevel;
};
$5dcb1a2c693b29b3$export$839f9183b0465a69 = function() {
    return $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$taskQueue);
};
$5dcb1a2c693b29b3$export$72fdf0e06517287b = function(eventHandler) {
    switch($5dcb1a2c693b29b3$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $5dcb1a2c693b29b3$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $5dcb1a2c693b29b3$var$currentPriorityLevel;
    $5dcb1a2c693b29b3$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5dcb1a2c693b29b3$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5dcb1a2c693b29b3$export$4b844e58a3e414b4 = function() {};
$5dcb1a2c693b29b3$export$816d2913ae6b83b1 = function() {};
$5dcb1a2c693b29b3$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $5dcb1a2c693b29b3$var$currentPriorityLevel;
    $5dcb1a2c693b29b3$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $5dcb1a2c693b29b3$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$5dcb1a2c693b29b3$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $5dcb1a2c693b29b3$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $5dcb1a2c693b29b3$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $5dcb1a2c693b29b3$var$push($5dcb1a2c693b29b3$var$timerQueue, priorityLevel), null === $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$taskQueue) && priorityLevel === $5dcb1a2c693b29b3$var$peek($5dcb1a2c693b29b3$var$timerQueue) && ($5dcb1a2c693b29b3$var$isHostTimeoutScheduled ? ($5dcb1a2c693b29b3$var$localClearTimeout($5dcb1a2c693b29b3$var$taskTimeoutID), $5dcb1a2c693b29b3$var$taskTimeoutID = -1) : $5dcb1a2c693b29b3$var$isHostTimeoutScheduled = !0, $5dcb1a2c693b29b3$var$requestHostTimeout($5dcb1a2c693b29b3$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $5dcb1a2c693b29b3$var$push($5dcb1a2c693b29b3$var$taskQueue, priorityLevel), $5dcb1a2c693b29b3$var$isHostCallbackScheduled || $5dcb1a2c693b29b3$var$isPerformingWork || ($5dcb1a2c693b29b3$var$isHostCallbackScheduled = !0, $5dcb1a2c693b29b3$var$requestHostCallback()));
    return priorityLevel;
};
$5dcb1a2c693b29b3$export$b5836b71941fa3ed = $5dcb1a2c693b29b3$var$shouldYieldToHost;
$5dcb1a2c693b29b3$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $5dcb1a2c693b29b3$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $5dcb1a2c693b29b3$var$currentPriorityLevel;
        $5dcb1a2c693b29b3$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $5dcb1a2c693b29b3$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("iBfRJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bsBsX"));

});

parcelRegister("4mG4E", function(module, exports) {
"use strict";
function $32d9da8bbfe60a91$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($32d9da8bbfe60a91$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$32d9da8bbfe60a91$var$checkDCE();

module.exports = (parcelRequire("evIF5"));

});
parcelRegister("evIF5", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $a9069ad58045f52c$export$69ce8ef3fe5cead0, (v) => $a9069ad58045f52c$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $a9069ad58045f52c$export$d39a5bbd09211389, (v) => $a9069ad58045f52c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $a9069ad58045f52c$export$cd75ccfd720a3cd4, (v) => $a9069ad58045f52c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $a9069ad58045f52c$export$a0816fa17a9e79be, (v) => $a9069ad58045f52c$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $a9069ad58045f52c$export$7292efcadded39f3, (v) => $a9069ad58045f52c$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $a9069ad58045f52c$export$da407abadb9b8f86, (v) => $a9069ad58045f52c$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $a9069ad58045f52c$export$314cfea32580671c, (v) => $a9069ad58045f52c$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $a9069ad58045f52c$export$513ccb98c53b8039, (v) => $a9069ad58045f52c$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $a9069ad58045f52c$export$dbca993bc2d264a, (v) => $a9069ad58045f52c$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $a9069ad58045f52c$export$4797a8006f0655d0, (v) => $a9069ad58045f52c$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $a9069ad58045f52c$export$c78a37762a8d58e1, (v) => $a9069ad58045f52c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $a9069ad58045f52c$export$606f11b2eb45ecc6, (v) => $a9069ad58045f52c$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $a9069ad58045f52c$export$f7e8a0bf92324b1e, (v) => $a9069ad58045f52c$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $a9069ad58045f52c$export$83d89fbfd8236492, (v) => $a9069ad58045f52c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a9069ad58045f52c$export$69ce8ef3fe5cead0;
var $a9069ad58045f52c$export$d39a5bbd09211389;
var $a9069ad58045f52c$export$cd75ccfd720a3cd4;
var $a9069ad58045f52c$export$a0816fa17a9e79be;
var $a9069ad58045f52c$export$7292efcadded39f3;
var $a9069ad58045f52c$export$da407abadb9b8f86;
var $a9069ad58045f52c$export$314cfea32580671c;
var $a9069ad58045f52c$export$513ccb98c53b8039;
var $a9069ad58045f52c$export$dbca993bc2d264a;
var $a9069ad58045f52c$export$4797a8006f0655d0;
var $a9069ad58045f52c$export$c78a37762a8d58e1;
var $a9069ad58045f52c$export$606f11b2eb45ecc6;
var $a9069ad58045f52c$export$f7e8a0bf92324b1e;
var $a9069ad58045f52c$export$83d89fbfd8236492;
"use strict";

var $iBfRJ = parcelRequire("iBfRJ");
function $a9069ad58045f52c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $a9069ad58045f52c$var$noop() {}
var $a9069ad58045f52c$var$Internals = {
    d: {
        f: $a9069ad58045f52c$var$noop,
        r: function() {
            throw Error($a9069ad58045f52c$var$formatProdErrorMessage(522));
        },
        D: $a9069ad58045f52c$var$noop,
        C: $a9069ad58045f52c$var$noop,
        L: $a9069ad58045f52c$var$noop,
        m: $a9069ad58045f52c$var$noop,
        X: $a9069ad58045f52c$var$noop,
        S: $a9069ad58045f52c$var$noop,
        M: $a9069ad58045f52c$var$noop
    },
    p: 0,
    findDOMNode: null
}, $a9069ad58045f52c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $a9069ad58045f52c$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a9069ad58045f52c$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $a9069ad58045f52c$var$ReactSharedInternals = $iBfRJ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $a9069ad58045f52c$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$a9069ad58045f52c$export$69ce8ef3fe5cead0 = $a9069ad58045f52c$var$Internals;
$a9069ad58045f52c$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($a9069ad58045f52c$var$formatProdErrorMessage(299));
    return $a9069ad58045f52c$var$createPortal$1(children, container, null, key);
};
$a9069ad58045f52c$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $a9069ad58045f52c$var$ReactSharedInternals.T, previousUpdatePriority = $a9069ad58045f52c$var$Internals.p;
    try {
        if ($a9069ad58045f52c$var$ReactSharedInternals.T = null, $a9069ad58045f52c$var$Internals.p = 2, fn) return fn();
    } finally{
        $a9069ad58045f52c$var$ReactSharedInternals.T = previousTransition, $a9069ad58045f52c$var$Internals.p = previousUpdatePriority, $a9069ad58045f52c$var$Internals.d.f();
    }
};
$a9069ad58045f52c$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $a9069ad58045f52c$var$Internals.d.C(href, options));
};
$a9069ad58045f52c$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $a9069ad58045f52c$var$Internals.d.D(href);
};
$a9069ad58045f52c$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $a9069ad58045f52c$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $a9069ad58045f52c$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $a9069ad58045f52c$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$a9069ad58045f52c$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $a9069ad58045f52c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $a9069ad58045f52c$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $a9069ad58045f52c$var$Internals.d.M(href);
    }
};
$a9069ad58045f52c$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $a9069ad58045f52c$var$getCrossOriginStringAs(as, options.crossOrigin);
        $a9069ad58045f52c$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$a9069ad58045f52c$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $a9069ad58045f52c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $a9069ad58045f52c$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $a9069ad58045f52c$var$Internals.d.m(href);
    }
};
$a9069ad58045f52c$export$4797a8006f0655d0 = function(form) {
    $a9069ad58045f52c$var$Internals.d.r(form);
};
$a9069ad58045f52c$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$a9069ad58045f52c$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $a9069ad58045f52c$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$a9069ad58045f52c$export$f7e8a0bf92324b1e = function() {
    return $a9069ad58045f52c$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$a9069ad58045f52c$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("3HWFn", function(module, exports) {
"use strict";
module.exports = "3.25.0";

});

parcelRegister("8JpIS", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $65b67ab7eaab9774$export$306c0aa65ff9ec16, (v) => $65b67ab7eaab9774$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $65b67ab7eaab9774$export$306c0aa65ff9ec16;
"use strict";

var $iBfRJ = parcelRequire("iBfRJ");
function $65b67ab7eaab9774$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $65b67ab7eaab9774$var$k = "function" === typeof Object.is ? Object.is : $65b67ab7eaab9774$var$h, $65b67ab7eaab9774$var$l = $iBfRJ.useState, $65b67ab7eaab9774$var$m = $iBfRJ.useEffect, $65b67ab7eaab9774$var$n = $iBfRJ.useLayoutEffect, $65b67ab7eaab9774$var$p = $iBfRJ.useDebugValue;
function $65b67ab7eaab9774$var$q(a, b) {
    var d = b(), f = $65b67ab7eaab9774$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $65b67ab7eaab9774$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $65b67ab7eaab9774$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $65b67ab7eaab9774$var$m(function() {
        $65b67ab7eaab9774$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $65b67ab7eaab9774$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $65b67ab7eaab9774$var$p(d);
    return d;
}
function $65b67ab7eaab9774$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$65b67ab7eaab9774$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $65b67ab7eaab9774$var$t(a, b) {
    return b();
}
var $65b67ab7eaab9774$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $65b67ab7eaab9774$var$t : $65b67ab7eaab9774$var$q;
$65b67ab7eaab9774$export$306c0aa65ff9ec16 = void 0 !== $iBfRJ.useSyncExternalStore ? $iBfRJ.useSyncExternalStore : $65b67ab7eaab9774$var$u;

});

var $c8241f0b21c62924$exports = {};
"use strict";

$c8241f0b21c62924$exports = (parcelRequire("l6ag6"));


parcelRequire("iBfRJ");
var $3187838040ceb3fc$exports = {};
"use strict";
function $3187838040ceb3fc$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3187838040ceb3fc$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3187838040ceb3fc$var$checkDCE();

$3187838040ceb3fc$exports = (parcelRequire("cacyt"));



var $bd7918188970d8f3$exports = {};
/*! algoliasearch/lite.umd.js | 5.1.1 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(e, t) {
    t($bd7918188970d8f3$exports);
}($bd7918188970d8f3$exports, function(e) {
    "use strict";
    function t(e) {
        let t;
        const r = `algolia-client-js-${e.key}`;
        function s() {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
        }
        function a() {
            return JSON.parse(s().getItem(r) || "{}");
        }
        function o(e) {
            s().setItem(r, JSON.stringify(e));
        }
        return {
            get: (t, r, s = {
                miss: ()=>Promise.resolve()
            })=>Promise.resolve().then(()=>((function() {
                        const t = e.timeToLive ? 1e3 * e.timeToLive : null, r = a(), s = Object.fromEntries(Object.entries(r).filter(([, e])=>void 0 !== e.timestamp));
                        if (o(s), !t) return;
                        o(Object.fromEntries(Object.entries(s).filter(([, e])=>{
                            const r = (new Date).getTime();
                            return !(e.timestamp + t < r);
                        })));
                    })(), a()[JSON.stringify(t)])).then((e)=>Promise.all([
                        e ? e.value : r(),
                        void 0 !== e
                    ])).then(([e, t])=>Promise.all([
                        e,
                        t || s.miss(e)
                    ])).then(([e])=>e),
            set: (e, t)=>Promise.resolve().then(()=>{
                    const o = a();
                    return o[JSON.stringify(e)] = {
                        timestamp: (new Date).getTime(),
                        value: t
                    }, s().setItem(r, JSON.stringify(o)), t;
                }),
            delete: (e)=>Promise.resolve().then(()=>{
                    const t = a();
                    delete t[JSON.stringify(e)], s().setItem(r, JSON.stringify(t));
                }),
            clear: ()=>Promise.resolve().then(()=>{
                    s().removeItem(r);
                })
        };
    }
    function r(e) {
        const t = [
            ...e.caches
        ], s = t.shift();
        return void 0 === s ? {
            get: (e, t, r = {
                miss: ()=>Promise.resolve()
            })=>t().then((e)=>Promise.all([
                        e,
                        r.miss(e)
                    ])).then(([e])=>e),
            set: (e, t)=>Promise.resolve(t),
            delete: (e)=>Promise.resolve(),
            clear: ()=>Promise.resolve()
        } : {
            get: (e, a, o = {
                miss: ()=>Promise.resolve()
            })=>s.get(e, a, o).catch(()=>r({
                        caches: t
                    }).get(e, a, o)),
            set: (e, a)=>s.set(e, a).catch(()=>r({
                        caches: t
                    }).set(e, a)),
            delete: (e)=>s.delete(e).catch(()=>r({
                        caches: t
                    }).delete(e)),
            clear: ()=>s.clear().catch(()=>r({
                        caches: t
                    }).clear())
        };
    }
    function s(e = {
        serializable: !0
    }) {
        let t = {};
        return {
            get (r, s, a = {
                miss: ()=>Promise.resolve()
            }) {
                const o = JSON.stringify(r);
                if (o in t) return Promise.resolve(e.serializable ? JSON.parse(t[o]) : t[o]);
                const n = s();
                return n.then((e)=>a.miss(e)).then(()=>n);
            },
            set: (r, s)=>(t[JSON.stringify(r)] = e.serializable ? JSON.stringify(s) : s, Promise.resolve(s)),
            delete: (e)=>(delete t[JSON.stringify(e)], Promise.resolve()),
            clear: ()=>(t = {}, Promise.resolve())
        };
    }
    const a = 12e4;
    function o(e, t = "up") {
        const r = Date.now();
        return {
            ...e,
            status: t,
            lastUpdate: r,
            isUp: function() {
                return "up" === t || Date.now() - r > a;
            },
            isTimedOut: function() {
                return "timed out" === t && Date.now() - r <= a;
            }
        };
    }
    function n(e, t, r) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || !e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var s = r.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : t + "";
        }(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    class i extends Error {
        constructor(e, t){
            super(e), n(this, "name", "AlgoliaError"), t && (this.name = t);
        }
    }
    class c extends i {
        constructor(e, t, r){
            super(e, r), n(this, "stackTrace", void 0), this.stackTrace = t;
        }
    }
    class u extends c {
        constructor(e){
            super("Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support.", e, "RetryError");
        }
    }
    class l extends c {
        constructor(e, t, r, s = "ApiError"){
            super(e, r, s), n(this, "status", void 0), this.status = t;
        }
    }
    class m extends i {
        constructor(e, t){
            super(e, "DeserializationError"), n(this, "response", void 0), this.response = t;
        }
    }
    class d extends l {
        constructor(e, t, r, s){
            super(e, t, s, "DetailedApiError"), n(this, "error", void 0), this.error = r;
        }
    }
    function h(e, t, r) {
        const s = (a = r, Object.keys(a).filter((e)=>void 0 !== a[e]).sort().map((e)=>`${e}=${encodeURIComponent("[object Array]" === Object.prototype.toString.call(a[e]) ? a[e].join(",") : a[e]).replaceAll("+", "%20")}`).join("&"));
        var a;
        let o = `${e.protocol}://${e.url}${e.port ? `:${e.port}` : ""}/${"/" === t.charAt(0) ? t.substring(1) : t}`;
        return s.length && (o += `?${s}`), o;
    }
    function p(e) {
        const t = e.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return {
            ...e,
            request: {
                ...e.request,
                headers: {
                    ...e.request.headers,
                    ...t
                }
            }
        };
    }
    function f({ hosts: e, hostsCache: t, baseHeaders: r, baseQueryParameters: s, algoliaAgent: a, timeouts: n, requester: i, requestsCache: c, responsesCache: f }) {
        async function g(c, f, g = !0) {
            const y = [], v = function(e, t) {
                if ("GET" === e.method || void 0 === e.data && void 0 === t.data) return;
                const r = Array.isArray(e.data) ? e.data : {
                    ...e.data,
                    ...t.data
                };
                return JSON.stringify(r);
            }(c, f), P = function(e, t, r) {
                const s = {
                    Accept: "application/json",
                    ...e,
                    ...t,
                    ...r
                }, a = {};
                return Object.keys(s).forEach((e)=>{
                    const t = s[e];
                    a[e.toLowerCase()] = t;
                }), a;
            }(r, c.headers, f.headers), w = "GET" === c.method ? {
                ...c.data,
                ...f.data
            } : {}, b = {
                ...s,
                ...c.queryParameters,
                ...w
            };
            if (a.value && (b["x-algolia-agent"] = a.value), f && f.queryParameters) for (const e of Object.keys(f.queryParameters))f.queryParameters[e] && "[object Object]" !== Object.prototype.toString.call(f.queryParameters[e]) ? b[e] = f.queryParameters[e].toString() : b[e] = f.queryParameters[e];
            let q = 0;
            const O = async (e, r)=>{
                const s = e.pop();
                if (void 0 === s) throw new u(function(e) {
                    return e.map((e)=>p(e));
                }(y));
                let a = g ? f.timeouts?.read || n.read : f.timeouts?.write || n.write;
                const w = {
                    data: v,
                    headers: P,
                    method: c.method,
                    url: h(s, c.path, b),
                    connectTimeout: r(q, f.timeouts?.connect || n.connect),
                    responseTimeout: r(q, a)
                }, T = (t)=>{
                    const r = {
                        request: w,
                        response: t,
                        host: s,
                        triesLeft: e.length
                    };
                    return y.push(r), r;
                }, S = await i.send(w);
                if (function({ isTimedOut: e, status: t }) {
                    return e || function({ isTimedOut: e, status: t }) {
                        return !e && !~~t;
                    }({
                        isTimedOut: e,
                        status: t
                    }) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
                }(S)) {
                    const a = T(S);
                    return S.isTimedOut && q++, console.log("Retryable failure", p(a)), await t.set(s, o(s, S.isTimedOut ? "timed out" : "down")), O(e, r);
                }
                if (function({ status: e }) {
                    return 2 == ~~(e / 100);
                }(S)) return function(e) {
                    try {
                        return JSON.parse(e.content);
                    } catch (t) {
                        throw new m(t.message, e);
                    }
                }(S);
                throw T(S), function({ content: e, status: t }, r) {
                    try {
                        const s = JSON.parse(e);
                        return "error" in s ? new d(s.message, t, s.error, r) : new l(s.message, t, r);
                    } catch (e) {}
                    return new l(e, t, r);
                }(S, y);
            }, T = e.filter((e)=>"readWrite" === e.accept || (g ? "read" === e.accept : "write" === e.accept)), S = await async function(e) {
                const r = await Promise.all(e.map((e)=>t.get(e, ()=>Promise.resolve(o(e))))), s = r.filter((e)=>e.isUp()), a = r.filter((e)=>e.isTimedOut()), n = [
                    ...s,
                    ...a
                ];
                return {
                    hosts: n.length > 0 ? n : e,
                    getTimeout: (e, t)=>(0 === a.length && 0 === e ? 1 : a.length + 3 + e) * t
                };
            }(T);
            return O([
                ...S.hosts
            ].reverse(), S.getTimeout);
        }
        return {
            hostsCache: t,
            requester: i,
            timeouts: n,
            algoliaAgent: a,
            baseHeaders: r,
            baseQueryParameters: s,
            hosts: e,
            request: function(e, t = {}) {
                const a = e.useReadTransporter || "GET" === e.method;
                if (!a) return g(e, t, a);
                const o = ()=>g(e, t);
                if (!0 !== (t.cacheable || e.cacheable)) return o();
                const n = {
                    request: e,
                    requestOptions: t,
                    transporter: {
                        queryParameters: s,
                        headers: r
                    }
                };
                return f.get(n, ()=>c.get(n, ()=>c.set(n, o()).then((e)=>Promise.all([
                                c.delete(n),
                                e
                            ]), (e)=>Promise.all([
                                c.delete(n),
                                Promise.reject(e)
                            ])).then(([e, t])=>t)), {
                    miss: (e)=>f.set(n, e)
                });
            },
            requestsCache: c,
            responsesCache: f
        };
    }
    function g({ algoliaAgents: e, client: t, version: r }) {
        const s = (function(e) {
            const t = {
                value: `Algolia for JavaScript (${e})`,
                add (e) {
                    const r = `; ${e.segment}${void 0 !== e.version ? ` (${e.version})` : ""}`;
                    return -1 === t.value.indexOf(r) && (t.value = `${t.value}${r}`), t;
                }
            };
            return t;
        })(r).add({
            segment: t,
            version: r
        });
        return e.forEach((e)=>s.add(e)), s;
    }
    const y = "5.1.1";
    function v(e) {
        return [
            {
                url: `${e}-dsn.algolia.net`,
                accept: "read",
                protocol: "https"
            },
            {
                url: `${e}.algolia.net`,
                accept: "write",
                protocol: "https"
            }
        ].concat(function(e) {
            const t = e;
            for(let r = e.length - 1; r > 0; r--){
                const s = Math.floor(Math.random() * (r + 1)), a = e[r];
                t[r] = e[s], t[s] = a;
            }
            return t;
        }([
            {
                url: `${e}-1.algolianet.com`,
                accept: "readWrite",
                protocol: "https"
            },
            {
                url: `${e}-2.algolianet.com`,
                accept: "readWrite",
                protocol: "https"
            },
            {
                url: `${e}-3.algolianet.com`,
                accept: "readWrite",
                protocol: "https"
            }
        ]));
    }
    e.apiClientVersion = y, e.liteClient = function(e, a, o) {
        if (!e || "string" != typeof e) throw new Error("`appId` is missing.");
        if (!a || "string" != typeof a) throw new Error("`apiKey` is missing.");
        return function({ appId: e, apiKey: t, authMode: r, algoliaAgents: s, ...a }) {
            const o = function(e, t, r = "WithinHeaders") {
                const s = {
                    "x-algolia-api-key": t,
                    "x-algolia-application-id": e
                };
                return {
                    headers: ()=>"WithinHeaders" === r ? s : {},
                    queryParameters: ()=>"WithinQueryParameters" === r ? s : {}
                };
            }(e, t, r), n = f({
                hosts: v(e),
                ...a,
                algoliaAgent: g({
                    algoliaAgents: s,
                    client: "Lite",
                    version: y
                }),
                baseHeaders: {
                    "content-type": "text/plain",
                    ...o.headers(),
                    ...a.baseHeaders
                },
                baseQueryParameters: {
                    ...o.queryParameters(),
                    ...a.baseQueryParameters
                }
            });
            return {
                transporter: n,
                appId: e,
                clearCache: ()=>Promise.all([
                        n.requestsCache.clear(),
                        n.responsesCache.clear()
                    ]).then(()=>{}),
                get _ua () {
                    return n.algoliaAgent.value;
                },
                addAlgoliaAgent (e, t) {
                    n.algoliaAgent.add({
                        segment: e,
                        version: t
                    });
                },
                searchForHits (e, t) {
                    return this.search(e, t);
                },
                searchForFacets (e, t) {
                    return this.search(e, t);
                },
                customPost ({ path: e, parameters: t, body: r }, s) {
                    if (!e) throw new Error("Parameter `path` is required when calling `customPost`.");
                    const a = {
                        method: "POST",
                        path: "/{path}".replace("{path}", e),
                        queryParameters: t || {},
                        headers: {},
                        data: r || {}
                    };
                    return n.request(a, s);
                },
                getRecommendations (e, t) {
                    if (e && Array.isArray(e) && (e = {
                        requests: e
                    }), !e) throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
                    if (!e.requests) throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
                    const r = {
                        method: "POST",
                        path: "/1/indexes/*/recommendations",
                        queryParameters: {},
                        headers: {},
                        data: e,
                        useReadTransporter: !0,
                        cacheable: !0
                    };
                    return n.request(r, t);
                },
                search (e, t) {
                    if (e && Array.isArray(e)) {
                        const t = {
                            requests: e.map(({ params: e, ...t })=>"facet" === t.type ? {
                                    ...t,
                                    ...e,
                                    type: "facet"
                                } : {
                                    ...t,
                                    ...e,
                                    facet: void 0,
                                    maxFacetHits: void 0,
                                    facetQuery: void 0
                                })
                        };
                        e = t;
                    }
                    if (!e) throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
                    if (!e.requests) throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
                    const r = {
                        method: "POST",
                        path: "/1/indexes/*/queries",
                        queryParameters: {},
                        headers: {},
                        data: e,
                        useReadTransporter: !0,
                        cacheable: !0
                    };
                    return n.request(r, t);
                }
            };
        }({
            appId: e,
            apiKey: a,
            timeouts: {
                connect: 1e3,
                read: 2e3,
                write: 3e4
            },
            requester: {
                send: function(e) {
                    return new Promise((t)=>{
                        const r = new XMLHttpRequest;
                        r.open(e.method, e.url, !0), Object.keys(e.headers).forEach((t)=>r.setRequestHeader(t, e.headers[t]));
                        const s = (e, s)=>setTimeout(()=>{
                                r.abort(), t({
                                    status: 0,
                                    content: s,
                                    isTimedOut: !0
                                });
                            }, e), a = s(e.connectTimeout, "Connection timeout");
                        let o;
                        r.onreadystatechange = ()=>{
                            r.readyState > r.OPENED && void 0 === o && (clearTimeout(a), o = s(e.responseTimeout, "Socket timeout"));
                        }, r.onerror = ()=>{
                            0 === r.status && (clearTimeout(a), clearTimeout(o), t({
                                content: r.responseText || "Network request failed",
                                status: r.status,
                                isTimedOut: !1
                            }));
                        }, r.onload = ()=>{
                            clearTimeout(a), clearTimeout(o), t({
                                content: r.responseText,
                                status: r.status,
                                isTimedOut: !1
                            });
                        }, r.send(e.data);
                    });
                }
            },
            algoliaAgents: [
                {
                    segment: "Browser"
                }
            ],
            authMode: "WithinQueryParameters",
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: r({
                caches: [
                    t({
                        key: `${y}-${e}`
                    }),
                    s()
                ]
            }),
            ...o
        });
    };
});



var $iBfRJ = parcelRequire("iBfRJ");
var $64524f464adf5cc8$exports = {};
"use strict";
var $5b530fa7fdc238bb$exports = {};
"use strict";
var $b40ee84aff520977$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $b40ee84aff520977$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$b40ee84aff520977$exports = $b40ee84aff520977$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$b40ee84aff520977$var$EventEmitter.prototype._events = undefined;
$b40ee84aff520977$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$b40ee84aff520977$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b40ee84aff520977$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$b40ee84aff520977$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $b40ee84aff520977$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($b40ee84aff520977$var$isUndefined(handler)) return false;
    if ($b40ee84aff520977$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($b40ee84aff520977$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$b40ee84aff520977$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$b40ee84aff520977$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $b40ee84aff520977$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($b40ee84aff520977$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($b40ee84aff520977$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$b40ee84aff520977$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $b40ee84aff520977$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.on = $b40ee84aff520977$var$EventEmitter.prototype.addListener;
$b40ee84aff520977$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$b40ee84aff520977$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$b40ee84aff520977$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$b40ee84aff520977$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $b40ee84aff520977$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($b40ee84aff520977$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($b40ee84aff520977$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$b40ee84aff520977$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($b40ee84aff520977$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$b40ee84aff520977$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($b40ee84aff520977$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$b40ee84aff520977$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $b40ee84aff520977$var$isFunction(arg) {
    return typeof arg === "function";
}
function $b40ee84aff520977$var$isNumber(arg) {
    return typeof arg === "number";
}
function $b40ee84aff520977$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $b40ee84aff520977$var$isUndefined(arg) {
    return arg === void 0;
}


var $472002d069bfe884$exports = {};
"use strict";

var $54d0247e2c798db6$exports = {};
"use strict";
function $54d0247e2c798db6$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$54d0247e2c798db6$exports = $54d0247e2c798db6$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $472002d069bfe884$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$54d0247e2c798db6$exports($472002d069bfe884$var$DerivedHelper, $b40ee84aff520977$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $472002d069bfe884$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$472002d069bfe884$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$472002d069bfe884$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
$472002d069bfe884$exports = $472002d069bfe884$var$DerivedHelper;


var $1411600a08a5462d$exports = {};
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $1411600a08a5462d$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $1411600a08a5462d$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
$1411600a08a5462d$exports = {
    escapeFacetValue: $1411600a08a5462d$var$escapeFacetValue,
    unescapeFacetValue: $1411600a08a5462d$var$unescapeFacetValue
};


var $5b530fa7fdc238bb$require$escapeFacetValue = $1411600a08a5462d$exports.escapeFacetValue;

var $5115b718ca6c9d06$exports = {};
"use strict";
function $5115b718ca6c9d06$var$clone(value) {
    if (typeof value === "object" && value !== null) return $5115b718ca6c9d06$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $5115b718ca6c9d06$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $5115b718ca6c9d06$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($5115b718ca6c9d06$var$isObjectOrArrayOrFunction(targetVal) && $5115b718ca6c9d06$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $5115b718ca6c9d06$var$_merge(targetVal, sourceVal);
        else target[key] = $5115b718ca6c9d06$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $5115b718ca6c9d06$var$merge(target) {
    if (!$5115b718ca6c9d06$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($5115b718ca6c9d06$var$isObjectOrArrayOrFunction(source)) $5115b718ca6c9d06$var$_merge(target, source);
    }
    return target;
}
$5115b718ca6c9d06$exports = $5115b718ca6c9d06$var$merge;


var $4f1c35265f5636f7$exports = {};
"use strict";
function $4f1c35265f5636f7$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$4f1c35265f5636f7$exports = $4f1c35265f5636f7$var$objectHasKeys;


var $cb93ce3ecd8ab730$exports = {};
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $cb93ce3ecd8ab730$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$cb93ce3ecd8ab730$exports = $cb93ce3ecd8ab730$var$_objectWithoutPropertiesLoose;


var $8d0fc9d8922b19fd$exports = {};
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $8d0fc9d8922b19fd$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$8d0fc9d8922b19fd$var$RecommendParameters.prototype = {
    constructor: $8d0fc9d8922b19fd$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $8d0fc9d8922b19fd$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $8d0fc9d8922b19fd$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
$8d0fc9d8922b19fd$exports = $8d0fc9d8922b19fd$var$RecommendParameters;


var $a5e40eb54c20b531$exports = {};
"use strict";
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $a5e40eb54c20b531$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$a5e40eb54c20b531$var$RecommendResults.prototype = {
    constructor: $a5e40eb54c20b531$var$RecommendResults
};
$a5e40eb54c20b531$exports = $a5e40eb54c20b531$var$RecommendResults;


var $fdd25981527dc69e$exports = {};
"use strict";

function $fdd25981527dc69e$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $fdd25981527dc69e$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $fdd25981527dc69e$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $fdd25981527dc69e$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $fdd25981527dc69e$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getCompositionQueries: function getQueries(state) {
        return [
            {
                compositionID: state.index,
                requestBody: {
                    params: $fdd25981527dc69e$var$requestBuilder._getCompositionHitsSearchParams(state)
                }
            }
        ];
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($fdd25981527dc69e$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $fdd25981527dc69e$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $fdd25981527dc69e$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $fdd25981527dc69e$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $fdd25981527dc69e$var$sortObject($5115b718ca6c9d06$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getCompositionHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets.map(function(value) {
            if (state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements[value] && state.disjunctiveFacetsRefinements[value].length > 0) // only tag a disjunctiveFacet as disjunctive if it has a value selected
            // this helps avoid hitting the limit of 20 disjunctive facets in the Composition API
            return "disjunctive(" + value + ")";
            return value;
        })).concat($fdd25981527dc69e$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $fdd25981527dc69e$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $fdd25981527dc69e$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $fdd25981527dc69e$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        var params = state.getQueryParams();
        delete params.highlightPreTag;
        delete params.highlightPostTag;
        // not a valid search parameter, it is handled in _getCompositionQueries
        delete params.index;
        return $fdd25981527dc69e$var$sortObject($5115b718ca6c9d06$exports({}, params, additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $fdd25981527dc69e$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $fdd25981527dc69e$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $fdd25981527dc69e$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $fdd25981527dc69e$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $fdd25981527dc69e$var$sortObject($5115b718ca6c9d06$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $fdd25981527dc69e$var$sortObject($5115b718ca6c9d06$exports({}, $fdd25981527dc69e$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$fdd25981527dc69e$exports = $fdd25981527dc69e$var$requestBuilder;


var $e8496bf2308fb608$exports = {};
"use strict";
var $43419f0fed4306cb$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$43419f0fed4306cb$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $afd15546671bc7d2$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
$afd15546671bc7d2$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $40457e37cbd5bf50$exports = {};
"use strict";
function $40457e37cbd5bf50$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$40457e37cbd5bf50$exports = $40457e37cbd5bf50$var$intersection;





var $94052833688a5c47$exports = {};
"use strict";
function $94052833688a5c47$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($94052833688a5c47$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
$94052833688a5c47$exports = $94052833688a5c47$var$valToNumber;


var $d25ece568874eac1$exports = {};
"use strict";
$d25ece568874eac1$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $364ea95aed57bd38$exports = {};
"use strict";



var $364ea95aed57bd38$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($364ea95aed57bd38$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $43419f0fed4306cb$exports(mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $364ea95aed57bd38$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $364ea95aed57bd38$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($364ea95aed57bd38$var$lib.isRefined(refinementList, attribute, value)) return $364ea95aed57bd38$var$lib.removeRefinement(refinementList, attribute, value);
        return $364ea95aed57bd38$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$4f1c35265f5636f7$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $cb93ce3ecd8ab730$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$364ea95aed57bd38$exports = $364ea95aed57bd38$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $e8496bf2308fb608$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $e8496bf2308fb608$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $e8496bf2308fb608$var$findArray(array, searchedValue) {
    return $afd15546671bc7d2$exports(array, function(currentValue) {
        return $e8496bf2308fb608$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $e8496bf2308fb608$var$SearchParameters(newParameters) {
    var params = newParameters ? $e8496bf2308fb608$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$d25ece568874eac1$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $e8496bf2308fb608$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $e8496bf2308fb608$var$SearchParameters.PARAMETERS = Object.keys(new $e8496bf2308fb608$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $e8496bf2308fb608$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $e8496bf2308fb608$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $5115b718ca6c9d06$exports(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $e8496bf2308fb608$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $e8496bf2308fb608$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $e8496bf2308fb608$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $4f1c35265f5636f7$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($4f1c35265f5636f7$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$e8496bf2308fb608$var$SearchParameters.prototype = {
    constructor: $e8496bf2308fb608$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $364ea95aed57bd38$exports.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $364ea95aed57bd38$exports.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $364ea95aed57bd38$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $364ea95aed57bd38$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $94052833688a5c47$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $5115b718ca6c9d06$exports({}, this.numericRefinements);
        mod[attribute] = $5115b718ca6c9d06$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $e8496bf2308fb608$var$isEqualNumericRefinement(value.val, $94052833688a5c47$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$4f1c35265f5636f7$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $cb93ce3ecd8ab730$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($364ea95aed57bd38$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $364ea95aed57bd38$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($364ea95aed57bd38$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $364ea95aed57bd38$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($364ea95aed57bd38$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $364ea95aed57bd38$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$364ea95aed57bd38$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $364ea95aed57bd38$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$364ea95aed57bd38$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $364ea95aed57bd38$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$364ea95aed57bd38$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $364ea95aed57bd38$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $364ea95aed57bd38$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $364ea95aed57bd38$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $364ea95aed57bd38$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $43419f0fed4306cb$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $43419f0fed4306cb$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $43419f0fed4306cb$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $364ea95aed57bd38$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $364ea95aed57bd38$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $364ea95aed57bd38$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $94052833688a5c47$exports(value);
        var isAttributeValueDefined = $e8496bf2308fb608$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $40457e37cbd5bf50$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $40457e37cbd5bf50$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $e8496bf2308fb608$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $e8496bf2308fb608$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $cb93ce3ecd8ab730$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $afd15546671bc7d2$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $e8496bf2308fb608$exports = $e8496bf2308fb608$var$SearchParameters;


var $91fb9305d08ad933$exports = {};
"use strict";
var $3eb0c6cb801dfb1e$exports = {};
"use strict";
$3eb0c6cb801dfb1e$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $b015f93ba93fd3e3$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
$b015f93ba93fd3e3$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $3cb9bdb2235f58a4$exports = {};
"use strict";

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $3cb9bdb2235f58a4$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $afd15546671bc7d2$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};


var $f42227bff0b130b6$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order and keep the highest numeric value
function $f42227bff0b130b6$var$mergeNumericMax() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            var accValue = typeof acc[key] === "number" ? acc[key] : 0;
            var sourceValue = source[key];
            if (sourceValue === undefined) return;
            if (sourceValue >= accValue) {
                if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
                delete acc[key];
                acc[key] = sourceValue;
            }
        });
        return acc;
    }, {});
}
$f42227bff0b130b6$exports = $f42227bff0b130b6$var$mergeNumericMax;


var $8377b0749c9deaf5$exports = {};
"use strict";
function $8377b0749c9deaf5$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $8377b0749c9deaf5$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $8377b0749c9deaf5$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$8377b0749c9deaf5$exports = $8377b0749c9deaf5$var$orderBy;


var $91fb9305d08ad933$var$escapeFacetValue = $1411600a08a5462d$exports.escapeFacetValue;
var $91fb9305d08ad933$var$unescapeFacetValue = $1411600a08a5462d$exports.unescapeFacetValue;
var $398626534afe27a7$exports = {};
"use strict";
$398626534afe27a7$exports = $398626534afe27a7$var$generateTrees;




var $398626534afe27a7$var$escapeFacetValue = $1411600a08a5462d$exports.escapeFacetValue;
var $398626534afe27a7$var$unescapeFacetValue = $1411600a08a5462d$exports.unescapeFacetValue;
function $398626534afe27a7$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $3cb9bdb2235f58a4$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $398626534afe27a7$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            // root level, no count
            isRefined: true,
            // root level, always refined
            path: null,
            // root level, no path
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $398626534afe27a7$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $afd15546671bc7d2$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $398626534afe27a7$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $8377b0749c9deaf5$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $398626534afe27a7$var$format(facetCount, facetValue, hierarchicalSeparator, $398626534afe27a7$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $398626534afe27a7$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $398626534afe27a7$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $398626534afe27a7$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $91fb9305d08ad933$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $91fb9305d08ad933$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $91fb9305d08ad933$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $afd15546671bc7d2$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $91fb9305d08ad933$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $43419f0fed4306cb$exports(options, {
        persistHierarchicalRootCount: false
    });
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $91fb9305d08ad933$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $91fb9305d08ad933$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $91fb9305d08ad933$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $b015f93ba93fd3e3$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $91fb9305d08ad933$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $91fb9305d08ad933$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $3eb0c6cb801dfb1e$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $b015f93ba93fd3e3$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $b015f93ba93fd3e3$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = self.persistHierarchicalRootCount ? $f42227bff0b130b6$exports(self.hierarchicalFacets[position][attributeIndex].data, facetResults) : $43419f0fed4306cb$exports(facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $f42227bff0b130b6$exports(dataFromMainRequest, facetResults),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $91fb9305d08ad933$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($91fb9305d08ad933$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $b015f93ba93fd3e3$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $b015f93ba93fd3e3$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $43419f0fed4306cb$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($398626534afe27a7$exports(state));
    /**
   * @type {Array}
   */ this.facets = $3eb0c6cb801dfb1e$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $3eb0c6cb801dfb1e$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $91fb9305d08ad933$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $afd15546671bc7d2$exports(this.facets, predicate) || $afd15546671bc7d2$exports(this.disjunctiveFacets, predicate) || $afd15546671bc7d2$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $91fb9305d08ad933$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $afd15546671bc7d2$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $91fb9305d08ad933$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $afd15546671bc7d2$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $91fb9305d08ad933$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $afd15546671bc7d2$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $91fb9305d08ad933$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $91fb9305d08ad933$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $91fb9305d08ad933$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $91fb9305d08ad933$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $91fb9305d08ad933$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $91fb9305d08ad933$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $43419f0fed4306cb$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$91fb9305d08ad933$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $91fb9305d08ad933$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $91fb9305d08ad933$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($8377b0749c9deaf5$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $91fb9305d08ad933$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $91fb9305d08ad933$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $91fb9305d08ad933$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $43419f0fed4306cb$exports(opts, {
        sortBy: $91fb9305d08ad933$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $91fb9305d08ad933$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $91fb9305d08ad933$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $91fb9305d08ad933$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $3cb9bdb2235f58a4$exports(options.sortBy, $91fb9305d08ad933$var$SearchResults.DEFAULT_SORT);
            return $8377b0749c9deaf5$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $91fb9305d08ad933$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $91fb9305d08ad933$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $91fb9305d08ad933$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $91fb9305d08ad933$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $91fb9305d08ad933$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $afd15546671bc7d2$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $91fb9305d08ad933$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($91fb9305d08ad933$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($91fb9305d08ad933$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($91fb9305d08ad933$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($91fb9305d08ad933$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $91fb9305d08ad933$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $afd15546671bc7d2$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $91fb9305d08ad933$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $afd15546671bc7d2$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $afd15546671bc7d2$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$91fb9305d08ad933$exports = $91fb9305d08ad933$var$SearchResults;


var $c68609db2ea82583$exports = {};
"use strict";

var $9c8310ef8798d403$exports = {};
// @MAJOR: remove this function and use Array.prototype.flat
$9c8310ef8798d403$exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};


function $c68609db2ea82583$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $c68609db2ea82583$var$sortAndMergeRecommendations(objectIDs, results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (objectIDs.includes(hit.objectID)) return;
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $c68609db2ea82583$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $afd15546671bc7d2$exports($9c8310ef8798d403$exports(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
$c68609db2ea82583$exports = $c68609db2ea82583$var$sortAndMergeRecommendations;



var $3HWFn = parcelRequire("3HWFn");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $5b530fa7fdc238bb$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $3HWFn + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $e8496bf2308fb608$exports.make(opts);
    this.recommendState = new $8d0fc9d8922b19fd$exports({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$54d0247e2c798db6$exports($5b530fa7fdc238bb$var$AlgoliaSearchHelper, $b40ee84aff520977$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.searchWithComposition = function() {
    this._runComposition({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $fdd25981527dc69e$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $fdd25981527dc69e$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $91fb9305d08ad933$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $91fb9305d08ad933$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $5115b718ca6c9d06$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $cb93ce3ecd8ab730$exports($fdd25981527dc69e$exports._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $fdd25981527dc69e$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $5b530fa7fdc238bb$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Search for facet values using the Composition API & based on a query and the name of a faceted attribute.
 * This triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.searchForCompositionFacetValues = function(facet, query, maxFacetHits, userState) {
    if (typeof this.client.searchForFacetValues !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    searchForFacetValuesPromise = this.client.searchForFacetValues({
        compositionID: state.index,
        facetName: facet,
        searchForFacetValuesRequest: {
            params: {
                query: query,
                maxFacetHits: maxFacetHits,
                searchQuery: $fdd25981527dc69e$exports._getCompositionHitsSearchParams(state)
            }
        }
    });
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = content.results[0];
        content.facetHits.forEach(function(f) {
            f.escapedValue = $5b530fa7fdc238bb$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $5b530fa7fdc238bb$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setCurrentPage = $5b530fa7fdc238bb$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setPage = $5b530fa7fdc238bb$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $e8496bf2308fb608$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $e8496bf2308fb608$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($4f1c35265f5636f7$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $5b530fa7fdc238bb$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getCurrentPage = $5b530fa7fdc238bb$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getPage = $5b530fa7fdc238bb$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $fdd25981527dc69e$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $fdd25981527dc69e$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
/**
 * Perform the underlying queries
 * @private
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._runComposition = function() {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = $fdd25981527dc69e$exports._getCompositionQueries(derivedState);
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    if (queries.length > 1) throw new Error("Only one query is allowed when using a composition.");
    var query = queries[0];
    try {
        this.client.search(query).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $8d0fc9d8922b19fd$exports());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    var rawContent = Object.keys(content).reduce(function(value, key) {
        if (key !== "results") value[key] = content[key];
        return value;
    }, {});
    if (Object.keys(rawContent).length <= 0) rawContent = undefined;
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $91fb9305d08ad933$exports(state, specificResults, self._searchResultsOptions);
        if (rawContent !== undefined) helper.lastResults._rawContent = rawContent;
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $c68609db2ea82583$exports(ids, indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $a5e40eb54c20b531$exports(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $3HWFn + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $472002d069bfe884$exports(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $5b530fa7fdc238bb$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $5b530fa7fdc238bb$exports = $5b530fa7fdc238bb$var$AlgoliaSearchHelper;






/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $64524f464adf5cc8$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $5b530fa7fdc238bb$exports(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $64524f464adf5cc8$var$algoliasearchHelper.version = (parcelRequire("3HWFn"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $64524f464adf5cc8$var$algoliasearchHelper.AlgoliaSearchHelper = $5b530fa7fdc238bb$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $64524f464adf5cc8$var$algoliasearchHelper.SearchParameters = $e8496bf2308fb608$exports;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $64524f464adf5cc8$var$algoliasearchHelper.RecommendParameters = $8d0fc9d8922b19fd$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $64524f464adf5cc8$var$algoliasearchHelper.SearchResults = $91fb9305d08ad933$exports;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $64524f464adf5cc8$var$algoliasearchHelper.RecommendResults = $a5e40eb54c20b531$exports;
$64524f464adf5cc8$exports = $64524f464adf5cc8$var$algoliasearchHelper;


function $91c6d247324321b1$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
}
function $91c6d247324321b1$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $91c6d247324321b1$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
}

function $3a165817c0906f06$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a165817c0906f06$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a165817c0906f06$var$_typeof(o);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $3a165817c0906f06$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $3a165817c0906f06$var$isObjectLike(value) {
    return $3a165817c0906f06$var$_typeof(value) === "object" && value !== null;
}
function $3a165817c0906f06$export$53b83ca8eaab0383(value) {
    if (!$3a165817c0906f06$var$isObjectLike(value) || $3a165817c0906f06$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $b6dad470b36376b5$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}


function $ce34b0eef3172c93$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}


function $d3e5eacd65539fdb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d3e5eacd65539fdb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d3e5eacd65539fdb$var$_typeof(o);
}
var $d3e5eacd65539fdb$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $d3e5eacd65539fdb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3e5eacd65539fdb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3e5eacd65539fdb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d3e5eacd65539fdb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3e5eacd65539fdb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3e5eacd65539fdb$var$_defineProperty(obj, key, value) {
    key = $d3e5eacd65539fdb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d3e5eacd65539fdb$var$_toPropertyKey(t) {
    var i = $d3e5eacd65539fdb$var$_toPrimitive(t, "string");
    return "symbol" == $d3e5eacd65539fdb$var$_typeof(i) ? i : String(i);
}
function $d3e5eacd65539fdb$var$_toPrimitive(t, r) {
    if ("object" != $d3e5eacd65539fdb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d3e5eacd65539fdb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d3e5eacd65539fdb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d3e5eacd65539fdb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d3e5eacd65539fdb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d3e5eacd65539fdb$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $d3e5eacd65539fdb$var$_objectWithoutProperties(right, $d3e5eacd65539fdb$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $d3e5eacd65539fdb$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $d3e5eacd65539fdb$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $d3e5eacd65539fdb$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $b6dad470b36376b5$export$de3a4d4a0d731119)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $d3e5eacd65539fdb$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $d3e5eacd65539fdb$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $d3e5eacd65539fdb$var$_objectSpread($d3e5eacd65539fdb$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $d3e5eacd65539fdb$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $d3e5eacd65539fdb$var$_objectSpread($d3e5eacd65539fdb$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $d3e5eacd65539fdb$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $d3e5eacd65539fdb$var$_objectSpread($d3e5eacd65539fdb$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $d3e5eacd65539fdb$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $d3e5eacd65539fdb$var$_objectSpread($d3e5eacd65539fdb$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $d3e5eacd65539fdb$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $d3e5eacd65539fdb$var$_objectSpread($d3e5eacd65539fdb$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $d3e5eacd65539fdb$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $ce34b0eef3172c93$export$f70730c3d1fc524e)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $d3e5eacd65539fdb$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $d3e5eacd65539fdb$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $d3e5eacd65539fdb$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $d3e5eacd65539fdb$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $d3e5eacd65539fdb$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $d3e5eacd65539fdb$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $d3e5eacd65539fdb$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $d3e5eacd65539fdb$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $d3e5eacd65539fdb$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $d3e5eacd65539fdb$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $d3e5eacd65539fdb$var$mergeFacets(ruleContextsMerged, right);
        return $d3e5eacd65539fdb$var$mergeWithRest(facetsMerged, right);
    });
};

function $381348598347b86b$export$8793edee2d425525() {}


function $699545635e3ab143$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $699545635e3ab143$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $699545635e3ab143$var$_typeof(o);
}
function $699545635e3ab143$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $699545635e3ab143$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $699545635e3ab143$var$ownKeys(Object(t), !0).forEach(function(r) {
            $699545635e3ab143$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $699545635e3ab143$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $699545635e3ab143$var$_defineProperty(obj, key, value) {
    key = $699545635e3ab143$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $699545635e3ab143$var$_toPropertyKey(t) {
    var i = $699545635e3ab143$var$_toPrimitive(t, "string");
    return "symbol" == $699545635e3ab143$var$_typeof(i) ? i : String(i);
}
function $699545635e3ab143$var$_toPrimitive(t, r) {
    if ("object" != $699545635e3ab143$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $699545635e3ab143$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Refine the given search parameters.
 */ var $699545635e3ab143$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "configure",
    connector: true
});
function $699545635e3ab143$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, acc), {}, $699545635e3ab143$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $699545635e3ab143$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $381348598347b86b$export$8793edee2d425525);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    return function(widgetParams) {
        if (!widgetParams || !(0, $3a165817c0906f06$export$53b83ca8eaab0383)(widgetParams.searchParameters)) throw new Error($699545635e3ab143$var$withUsage("The `searchParameters` option expects an object."));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $699545635e3ab143$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $d3e5eacd65539fdb$export$8049d91f25899769)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: "ais.configure",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $699545635e3ab143$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, renderState), {}, {
                    configure: $699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $d3e5eacd65539fdb$export$8049d91f25899769)(new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $d3e5eacd65539fdb$export$8049d91f25899769)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters($699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, uiState), {}, {
                    configure: $699545635e3ab143$var$_objectSpread($699545635e3ab143$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $699545635e3ab143$export$2e2bcd8739ae039 = $699545635e3ab143$var$connectConfigure;



var $iBfRJ = parcelRequire("iBfRJ");
function $21fa42d4983016b5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21fa42d4983016b5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21fa42d4983016b5$var$_typeof(o);
}
/* eslint-disable complexity */ /*
 * Code taken from dequal/lite v2.0.0
 * https://github.com/lukeed/dequal/blob/9aa73181ac7e081cd330cac67d313632ac04bb02/src/lite.js
 *
 * It adds a 3rd argument `compare(a, b)` that lets execute custom logic to
 * compare values.
 * We use it to skip comparing function references.
 */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $21fa42d4983016b5$var$has = Object.prototype.hasOwnProperty;
function $21fa42d4983016b5$export$de8294bb3be0322f(foo, bar, compare) {
    // start of custom implementation
    if (compare !== null && compare !== void 0 && compare(foo, bar)) return true;
    // end of custom implementation
    var ctor;
    var len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $21fa42d4983016b5$export$de8294bb3be0322f(foo[len], bar[len], compare));
            }
            return len === -1;
        }
        if (!ctor || $21fa42d4983016b5$var$_typeof(foo) === "object") {
            len = 0;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for(ctor in foo){
                if ($21fa42d4983016b5$var$has.call(foo, ctor) && ++len && !$21fa42d4983016b5$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$21fa42d4983016b5$export$de8294bb3be0322f(foo[ctor], bar[ctor], compare)) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    // eslint-disable-next-line no-self-compare
    return foo !== foo && bar !== bar;
}



function $a68a04f8bef2ee50$export$be9bb8d98a5619e9(state) {
    var _state$query, _state$page, _state$hitsPerPage;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchResults(state, [
        {
            query: (_state$query = state.query) !== null && _state$query !== void 0 ? _state$query : "",
            page: (_state$page = state.page) !== null && _state$page !== void 0 ? _state$page : 0,
            hitsPerPage: (_state$hitsPerPage = state.hitsPerPage) !== null && _state$hitsPerPage !== void 0 ? _state$hitsPerPage : 20,
            hits: [],
            nbHits: 0,
            nbPages: 0,
            params: "",
            exhaustiveNbHits: true,
            exhaustiveFacetsCount: true,
            processingTimeMS: 0,
            index: state.index
        }
    ], {
        /** used by connectors to prevent persisting these results */ __isArtificial: true
    });
}


function $b4c049c58339bf47$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b4c049c58339bf47$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b4c049c58339bf47$var$_typeof(o);
}
function $b4c049c58339bf47$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4c049c58339bf47$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4c049c58339bf47$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b4c049c58339bf47$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4c049c58339bf47$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4c049c58339bf47$var$_defineProperty(obj, key, value) {
    key = $b4c049c58339bf47$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b4c049c58339bf47$var$_toPropertyKey(t) {
    var i = $b4c049c58339bf47$var$_toPrimitive(t, "string");
    return "symbol" == $b4c049c58339bf47$var$_typeof(i) ? i : String(i);
}
function $b4c049c58339bf47$var$_toPrimitive(t, r) {
    if ("object" != $b4c049c58339bf47$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b4c049c58339bf47$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b4c049c58339bf47$export$cb51f617c98f90d3(indexWidget) {
    var helper = indexWidget.getHelper();
    var results = // On SSR, we get the results injected on the Index.
    indexWidget.getResults() || // On the browser, we create fallback results based on the helper state.
    (0, $a68a04f8bef2ee50$export$be9bb8d98a5619e9)(helper.state);
    var scopedResults = indexWidget.getScopedResults().map(function(scopedResult) {
        var fallbackResults = scopedResult.indexId === indexWidget.getIndexId() ? results : (0, $a68a04f8bef2ee50$export$be9bb8d98a5619e9)(scopedResult.helper.state);
        return $b4c049c58339bf47$var$_objectSpread($b4c049c58339bf47$var$_objectSpread({}, scopedResult), {}, {
            // We keep `results` from being `null`.
            results: scopedResult.results || fallbackResults
        });
    });
    return {
        results: results,
        scopedResults: scopedResults,
        recommendResults: helper.lastRecommendResults
    };
}



var $iBfRJ = parcelRequire("iBfRJ");

var $iBfRJ = parcelRequire("iBfRJ");
var $25013601be57fbac$export$899c7584ba03b94a = /*#__PURE__*/ (0, $iBfRJ.createContext)(null);


/**
 * Throws an error if the condition is not met.
 *
 * The error is exhaustive in development, and becomes generic in production.
 *
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $19d63615f3bbb4f3$export$f5708dca728d7177(condition, message) {
    if (condition) return;
    throw new Error("Invariant failed");
}


function $a823d82a9a3d8872$export$78be30f1ffebe6ed() {
    var context = (0, $iBfRJ.useContext)((0, $25013601be57fbac$export$899c7584ba03b94a));
    (0, $19d63615f3bbb4f3$export$f5708dca728d7177)(context !== null, "The <Index> component must be used within <InstantSearch>.");
    return context;
}



var $iBfRJ = parcelRequire("iBfRJ");

var $iBfRJ = parcelRequire("iBfRJ");
var $2d53e859a49a5d35$export$4b9ddb9c6903c13 = /*#__PURE__*/ (0, $iBfRJ.createContext)(null);



function $8cb92a462d64f7c5$export$607655cdd66d2a68() {
    var search = (0, $iBfRJ.useContext)((0, $2d53e859a49a5d35$export$4b9ddb9c6903c13));
    (0, $19d63615f3bbb4f3$export$f5708dca728d7177)(search !== null, "Hooks must be used inside the <InstantSearch> component.\n\nThey are not compatible with the `react-instantsearch-core@6.x` and `react-instantsearch-dom` packages, so make sure to use the <InstantSearch> component from `react-instantsearch-core@7.x`.");
    return search;
}



var $iBfRJ = parcelRequire("iBfRJ");

var $iBfRJ = parcelRequire("iBfRJ");
var $77fea52226219bb7$export$87f9401208449446 = /*#__PURE__*/ (0, $iBfRJ.createContext)(null);


function $3477c7c09ca23ad1$export$692e83606e644bf6() {
    return (0, $iBfRJ.useContext)((0, $77fea52226219bb7$export$87f9401208449446));
}



var $iBfRJ = parcelRequire("iBfRJ");

var $iBfRJ = parcelRequire("iBfRJ");
var $f45301a5a5f6ed95$export$92edcc5c9a39af56 = /*#__PURE__*/ (0, $iBfRJ.createContext)(null);


function $57cab9ff255a206a$export$b7b167d1ffee3ddc() {
    return (0, $iBfRJ.useContext)((0, $f45301a5a5f6ed95$export$92edcc5c9a39af56));
}



var $iBfRJ = parcelRequire("iBfRJ");

function $5876f8c8e2999a57$var$_slicedToArray(arr, i) {
    return $5876f8c8e2999a57$var$_arrayWithHoles(arr) || $5876f8c8e2999a57$var$_iterableToArrayLimit(arr, i) || $5876f8c8e2999a57$var$_unsupportedIterableToArray(arr, i) || $5876f8c8e2999a57$var$_nonIterableRest();
}
function $5876f8c8e2999a57$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5876f8c8e2999a57$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5876f8c8e2999a57$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5876f8c8e2999a57$var$_arrayLikeToArray(o, minLen);
}
function $5876f8c8e2999a57$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5876f8c8e2999a57$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5876f8c8e2999a57$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5876f8c8e2999a57$export$e15835fface14b28(value) {
    var _useState = (0, $iBfRJ.useState)(function() {
        return value;
    }), _useState2 = $5876f8c8e2999a57$var$_slicedToArray(_useState, 2), stableValue = _useState2[0], setStableValue = _useState2[1];
    if (!(0, $21fa42d4983016b5$export$de8294bb3be0322f)(stableValue, value)) setStableValue(value);
    return stableValue;
}



var $iBfRJ = parcelRequire("iBfRJ");


var $iBfRJ = parcelRequire("iBfRJ");
var $3427e4b9ebf1e261$var$useKey = "use";
var $3427e4b9ebf1e261$export$1f96ae73734a86cc = $iBfRJ[$3427e4b9ebf1e261$var$useKey];




var $iBfRJ = parcelRequire("iBfRJ");
var $18e6891184dde8a2$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $iBfRJ.useLayoutEffect) : (0, $iBfRJ.useEffect);



var $iBfRJ = parcelRequire("iBfRJ");

var $iBfRJ = parcelRequire("iBfRJ");
var $3072e182f3a5a958$export$f690384094665d60 = /*#__PURE__*/ (0, $iBfRJ.createContext)(null);


function $97fe9202ac4e6718$export$b0820d56d4bdeee6() {
    return (0, $iBfRJ.useContext)((0, $3072e182f3a5a958$export$f690384094665d60));
}


function $734be7865efbfefb$export$bed784987806c3d2(_ref) {
    var _waitingForResultsRef;
    var widget = _ref.widget, parentIndex = _ref.parentIndex, props = _ref.props, shouldSsr = _ref.shouldSsr;
    var waitingForResultsRef = (0, $97fe9202ac4e6718$export$b0820d56d4bdeee6)();
    var prevPropsRef = (0, $iBfRJ.useRef)(props);
    (0, $iBfRJ.useEffect)(function() {
        prevPropsRef.current = props;
    }, [
        props
    ]);
    var prevWidgetRef = (0, $iBfRJ.useRef)(widget);
    (0, $iBfRJ.useEffect)(function() {
        prevWidgetRef.current = widget;
    }, [
        widget
    ]);
    var cleanupTimerRef = (0, $iBfRJ.useRef)(null);
    var shouldAddWidgetEarly = shouldSsr && !parentIndex.getWidgets().includes(widget);
    var search = (0, $8cb92a462d64f7c5$export$607655cdd66d2a68)();
    // This effect is responsible for adding, removing, and updating the widget.
    // We need to support scenarios where the widget is remounted quickly, like in
    // Strict Mode, so that we don't lose its state, and therefore that we don't
    // break routing.
    (0, $18e6891184dde8a2$export$700979bc83e7db82)(function() {
        var previousWidget = prevWidgetRef.current;
        // Scenario 1: the widget is added for the first time.
        if (!cleanupTimerRef.current) {
            if (!shouldSsr) parentIndex.addWidgets([
                widget
            ]);
        } else {
            // We cancel the original effect cleanup because it may not be necessary if
            // props haven't changed. (We manually call it if it is below.)
            clearTimeout(cleanupTimerRef.current);
            // Warning: if an unstable function prop is provided, `dequal` is not able
            // to keep its reference and therefore will consider that props did change.
            // This could unsollicitely remove/add the widget, therefore forget its state,
            // and could be a source of confusion.
            // If users face this issue, we should advise them to provide stable function
            // references.
            var arePropsEqual = (0, $21fa42d4983016b5$export$de8294bb3be0322f)(props, prevPropsRef.current);
            // If props did change, then we execute the cleanup function instantly
            // and then add the widget back. This lets us add the widget without
            // waiting for the scheduled cleanup function to finish (that we canceled
            // above).
            if (!arePropsEqual) {
                parentIndex.removeWidgets([
                    previousWidget
                ]);
                parentIndex.addWidgets([
                    widget
                ]);
            }
        }
        return function() {
            // We don't remove the widget right away, but rather schedule it so that
            // we're able to cancel it in the next effect.
            cleanupTimerRef.current = setTimeout(function() {
                search._schedule(function() {
                    if (search._preventWidgetCleanup) return;
                    parentIndex.removeWidgets([
                        previousWidget
                    ]);
                });
            });
        };
    }, [
        parentIndex,
        widget,
        shouldSsr,
        search,
        props
    ]);
    if (shouldAddWidgetEarly || (waitingForResultsRef === null || waitingForResultsRef === void 0 ? void 0 : (_waitingForResultsRef = waitingForResultsRef.current) === null || _waitingForResultsRef === void 0 ? void 0 : _waitingForResultsRef.status) === "pending") parentIndex.addWidgets([
        widget
    ]);
    if (typeof window === "undefined" && waitingForResultsRef !== null && waitingForResultsRef !== void 0 && waitingForResultsRef.current && // We need the widgets contained in the index to be added before we trigger the search request.
    widget.$$type !== "ais.index") {
        var _search$helper;
        (0, $3427e4b9ebf1e261$export$1f96ae73734a86cc)(waitingForResultsRef.current);
        // If we made a second request because of DynamicWidgets, we need to wait for the second result,
        // except for DynamicWidgets itself which needs to render its children after the first result.
        if (widget.$$type !== "ais.dynamicWidgets" && (_search$helper = search.helper) !== null && _search$helper !== void 0 && _search$helper.lastResults) (0, $3427e4b9ebf1e261$export$1f96ae73734a86cc)(waitingForResultsRef.current);
    }
}


function $9e9269f1a011fc3b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9e9269f1a011fc3b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9e9269f1a011fc3b$var$_typeof(o);
}
var $9e9269f1a011fc3b$var$_excluded = [
    "instantSearchInstance",
    "widgetParams"
], $9e9269f1a011fc3b$var$_excluded2 = [
    "widgetParams"
];
function $9e9269f1a011fc3b$var$_slicedToArray(arr, i) {
    return $9e9269f1a011fc3b$var$_arrayWithHoles(arr) || $9e9269f1a011fc3b$var$_iterableToArrayLimit(arr, i) || $9e9269f1a011fc3b$var$_unsupportedIterableToArray(arr, i) || $9e9269f1a011fc3b$var$_nonIterableRest();
}
function $9e9269f1a011fc3b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e9269f1a011fc3b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e9269f1a011fc3b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e9269f1a011fc3b$var$_arrayLikeToArray(o, minLen);
}
function $9e9269f1a011fc3b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e9269f1a011fc3b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9e9269f1a011fc3b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9e9269f1a011fc3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e9269f1a011fc3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e9269f1a011fc3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9e9269f1a011fc3b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e9269f1a011fc3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9e9269f1a011fc3b$var$_defineProperty(obj, key, value) {
    key = $9e9269f1a011fc3b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9e9269f1a011fc3b$var$_toPropertyKey(t) {
    var i = $9e9269f1a011fc3b$var$_toPrimitive(t, "string");
    return "symbol" == $9e9269f1a011fc3b$var$_typeof(i) ? i : String(i);
}
function $9e9269f1a011fc3b$var$_toPrimitive(t, r) {
    if ("object" != $9e9269f1a011fc3b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9e9269f1a011fc3b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9e9269f1a011fc3b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9e9269f1a011fc3b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9e9269f1a011fc3b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9e9269f1a011fc3b$export$7b345619fa263f7e(connector) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var additionalWidgetProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var serverContext = (0, $3477c7c09ca23ad1$export$692e83606e644bf6)();
    var ssrContext = (0, $57cab9ff255a206a$export$b7b167d1ffee3ddc)();
    var search = (0, $8cb92a462d64f7c5$export$607655cdd66d2a68)();
    var parentIndex = (0, $a823d82a9a3d8872$export$78be30f1ffebe6ed)();
    var stableProps = (0, $5876f8c8e2999a57$export$e15835fface14b28)(props);
    var stableAdditionalWidgetProperties = (0, $5876f8c8e2999a57$export$e15835fface14b28)(additionalWidgetProperties);
    var shouldSetStateRef = (0, $iBfRJ.useRef)(true);
    var previousRenderStateRef = (0, $iBfRJ.useRef)(null);
    var previousStatusRef = (0, $iBfRJ.useRef)(search.status);
    var widget = (0, $iBfRJ.useMemo)(function() {
        var createWidget = connector(function(connectorState, isFirstRender) {
            // We skip the `init` widget render because:
            // - We rely on `getWidgetRenderState` to compute the initial state before
            //   the InstantSearch.js lifecycle starts.
            // - It prevents UI flashes when updating the widget props.
            if (isFirstRender) {
                shouldSetStateRef.current = true;
                return;
            }
            // There are situations where InstantSearch.js may render widgets slightly
            // after they're removed by React, and thus try to update the React state
            // on unmounted components. React 16 and 17 consider them as memory leaks
            // and display a warning.
            // This happens in <DynamicWidgets> when `attributesToRender` contains a
            // value without an attribute previously mounted. React will unmount the
            // component controlled by that attribute, but InstantSearch.js will stay
            // unaware of this change until the render pass finishes, and therefore
            // notifies of a state change.
            // This ref lets us track this situation and ignore these state updates.
            if (shouldSetStateRef.current) {
                var instantSearchInstance = connectorState.instantSearchInstance, widgetParams = connectorState.widgetParams, renderState = $9e9269f1a011fc3b$var$_objectWithoutProperties(connectorState, $9e9269f1a011fc3b$var$_excluded);
                // We only update the state when a widget render state param changes,
                // except for functions. We ignore function reference changes to avoid
                // infinite loops. It's safe to omit them because they get updated
                // every time another render param changes.
                if (!(0, $21fa42d4983016b5$export$de8294bb3be0322f)(renderState, previousRenderStateRef.current, function(a, b) {
                    return (a === null || a === void 0 ? void 0 : a.constructor) === Function && (b === null || b === void 0 ? void 0 : b.constructor) === Function;
                }) || instantSearchInstance.status !== previousStatusRef.current) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    setState(renderState);
                    previousRenderStateRef.current = renderState;
                    previousStatusRef.current = instantSearchInstance.status;
                }
            }
        }, function() {
            // We'll ignore the next state update until we know for sure that
            // InstantSearch.js re-inits the component.
            shouldSetStateRef.current = false;
        });
        return $9e9269f1a011fc3b$var$_objectSpread($9e9269f1a011fc3b$var$_objectSpread({}, createWidget(stableProps)), stableAdditionalWidgetProperties);
    }, [
        connector,
        stableProps,
        stableAdditionalWidgetProperties
    ]);
    var _useState = (0, $iBfRJ.useState)(function() {
        if (widget.getWidgetRenderState) {
            var _widget$getWidgetSear;
            // The helper exists because we've started InstantSearch.
            var helper = parentIndex.getHelper();
            var uiState = parentIndex.getWidgetUiState({})[parentIndex.getIndexId()];
            helper.state = ((_widget$getWidgetSear = widget.getWidgetSearchParameters) === null || _widget$getWidgetSear === void 0 ? void 0 : _widget$getWidgetSear.call(widget, helper.state, {
                uiState: uiState
            })) || helper.state;
            var _getIndexSearchResult = (0, $b4c049c58339bf47$export$cb51f617c98f90d3)(parentIndex), results = _getIndexSearchResult.results, scopedResults = _getIndexSearchResult.scopedResults, recommendResults = _getIndexSearchResult.recommendResults;
            // We get the widget render state by providing the same parameters as
            // InstantSearch provides to the widget's `render` method.
            // See https://github.com/algolia/instantsearch/blob/019cd18d0de6dd320284aa4890541b7fe2198c65/src/widgets/index/index.ts#L604-L617
            var _widget$getWidgetRend = widget.getWidgetRenderState({
                helper: helper,
                parent: parentIndex,
                instantSearchInstance: search,
                results: widget.dependsOn === "recommend" && recommendResults && ssrContext ? recommendResults[ssrContext.recommendIdx.current++] : results,
                scopedResults: scopedResults,
                state: helper.state,
                renderState: search.renderState,
                templatesConfig: search.templatesConfig,
                createURL: parentIndex.createURL,
                searchMetadata: {
                    isSearchStalled: search.status === "stalled"
                },
                status: search.status,
                error: search.error
            }), widgetParams = _widget$getWidgetRend.widgetParams, renderState = $9e9269f1a011fc3b$var$_objectWithoutProperties(_widget$getWidgetRend, $9e9269f1a011fc3b$var$_excluded2);
            return renderState;
        }
        return {};
    }), _useState2 = $9e9269f1a011fc3b$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    (0, $734be7865efbfefb$export$bed784987806c3d2)({
        widget: widget,
        parentIndex: parentIndex,
        props: stableProps,
        shouldSsr: Boolean(serverContext)
    });
    return state;
}


function $8fd40084a36046c8$export$9bc811ec545fbcb6(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $699545635e3ab143$export$2e2bcd8739ae039), {
        searchParameters: props
    }, additionalWidgetProperties);
}


function $44c73e737d5e8e48$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $44c73e737d5e8e48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $44c73e737d5e8e48$var$_typeof(o);
}
function $44c73e737d5e8e48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44c73e737d5e8e48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44c73e737d5e8e48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $44c73e737d5e8e48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44c73e737d5e8e48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $44c73e737d5e8e48$var$_defineProperty(obj, key, value) {
    key = $44c73e737d5e8e48$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $44c73e737d5e8e48$var$_toPropertyKey(t) {
    var i = $44c73e737d5e8e48$var$_toPrimitive(t, "string");
    return "symbol" == $44c73e737d5e8e48$var$_typeof(i) ? i : String(i);
}
function $44c73e737d5e8e48$var$_toPrimitive(t, r) {
    if ("object" != $44c73e737d5e8e48$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $44c73e737d5e8e48$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $44c73e737d5e8e48$export$de5f40ff1ff419d2(props) {
    (0, $8fd40084a36046c8$export$9bc811ec545fbcb6)($44c73e737d5e8e48$var$_objectSpread({}, props), {
        $$widgetType: "ais.configure"
    });
    return null;
}


var $iBfRJ = parcelRequire("iBfRJ");
function $73424021722c7eb3$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}


function $1ea6e647c07b346d$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $73424021722c7eb3$export$11cc42aebef2ef3a)(rendering), ").\n\n").concat(usage));
}

function $f73f2d4ab0f68a43$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}


function $bc60c9359d7bbc6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc60c9359d7bbc6d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc60c9359d7bbc6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bc60c9359d7bbc6d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc60c9359d7bbc6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bc60c9359d7bbc6d$var$_defineProperty(obj, key, value) {
    key = $bc60c9359d7bbc6d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bc60c9359d7bbc6d$var$_toPropertyKey(t) {
    var i = $bc60c9359d7bbc6d$var$_toPrimitive(t, "string");
    return "symbol" == $bc60c9359d7bbc6d$var$_typeof(i) ? i : String(i);
}
function $bc60c9359d7bbc6d$var$_toPrimitive(t, r) {
    if ("object" != $bc60c9359d7bbc6d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bc60c9359d7bbc6d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bc60c9359d7bbc6d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bc60c9359d7bbc6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bc60c9359d7bbc6d$var$_typeof(o);
}
function $bc60c9359d7bbc6d$var$_slicedToArray(arr, i) {
    return $bc60c9359d7bbc6d$var$_arrayWithHoles(arr) || $bc60c9359d7bbc6d$var$_iterableToArrayLimit(arr, i) || $bc60c9359d7bbc6d$var$_unsupportedIterableToArray(arr, i) || $bc60c9359d7bbc6d$var$_nonIterableRest();
}
function $bc60c9359d7bbc6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bc60c9359d7bbc6d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bc60c9359d7bbc6d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bc60c9359d7bbc6d$var$_arrayLikeToArray(o, minLen);
}
function $bc60c9359d7bbc6d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bc60c9359d7bbc6d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $bc60c9359d7bbc6d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $bc60c9359d7bbc6d$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $bc60c9359d7bbc6d$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === "string" ? attr : attr(facetValue);
        if (args.length === 1 && $bc60c9359d7bbc6d$var$_typeof(args[0]) === "object") instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === "click" && args.length >= 2 && args.length <= 4) {
            if (!(0, $f73f2d4ab0f68a43$export$12368a7050a31bdd)(helper, attribute, facetValue)) {
                var _helper$lastResults;
                // send event only when the facet is being checked "ON"
                instantSearchInstance.sendEventToInsights({
                    insightsMethod: "clickedFilters",
                    widgetType: widgetType,
                    eventType: eventType,
                    eventModifier: eventModifier,
                    payload: $bc60c9359d7bbc6d$var$_objectSpread({
                        eventName: eventName,
                        index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                        filters: [
                            "".concat(attribute, ":").concat(facetValue)
                        ]
                    }, additionalData),
                    attribute: attribute
                });
            }
        }
    };
    return sendEventForFacet;
}


function $5767f6a9a35b3ef9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5767f6a9a35b3ef9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5767f6a9a35b3ef9$var$_typeof(o);
}
var $5767f6a9a35b3ef9$var$_excluded = [
    "name",
    "escapedValue",
    "data",
    "path"
];
function $5767f6a9a35b3ef9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5767f6a9a35b3ef9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5767f6a9a35b3ef9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5767f6a9a35b3ef9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5767f6a9a35b3ef9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5767f6a9a35b3ef9$var$_defineProperty(obj, key, value) {
    key = $5767f6a9a35b3ef9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5767f6a9a35b3ef9$var$_toPropertyKey(t) {
    var i = $5767f6a9a35b3ef9$var$_toPrimitive(t, "string");
    return "symbol" == $5767f6a9a35b3ef9$var$_typeof(i) ? i : String(i);
}
function $5767f6a9a35b3ef9$var$_toPrimitive(t, r) {
    if ("object" != $5767f6a9a35b3ef9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5767f6a9a35b3ef9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $5767f6a9a35b3ef9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5767f6a9a35b3ef9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5767f6a9a35b3ef9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5767f6a9a35b3ef9$var$_slicedToArray(arr, i) {
    return $5767f6a9a35b3ef9$var$_arrayWithHoles(arr) || $5767f6a9a35b3ef9$var$_iterableToArrayLimit(arr, i) || $5767f6a9a35b3ef9$var$_unsupportedIterableToArray(arr, i) || $5767f6a9a35b3ef9$var$_nonIterableRest();
}
function $5767f6a9a35b3ef9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5767f6a9a35b3ef9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5767f6a9a35b3ef9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5767f6a9a35b3ef9$var$_arrayLikeToArray(o, minLen);
}
function $5767f6a9a35b3ef9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5767f6a9a35b3ef9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5767f6a9a35b3ef9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $5767f6a9a35b3ef9$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "hierarchical-menu",
    connector: true
});
var $5767f6a9a35b3ef9$var$DEFAULT_SORT = [
    "name:asc"
];
/**
 * **HierarchicalMenu** connector provides the logic to build a custom widget
 * that will give the user the ability to explore facets in a tree-like structure.
 *
 * This is commonly used for multi-level categorization of products on e-commerce
 * websites. From a UX point of view, we suggest not displaying more than two
 * levels deep.
 *
 * @type {Connector}
 * @param {function(HierarchicalMenuRenderingOptions, boolean)} renderFn Rendering function for the custom **HierarchicalMenu** widget.
 * @param {function} unmountFn Unmount function called when the widget is disposed.
 * @return {function(CustomHierarchicalMenuWidgetParams)} Re-usable widget factory for a custom **HierarchicalMenu** widget.
 */ var $5767f6a9a35b3ef9$var$connectHierarchicalMenu = function connectHierarchicalMenu(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $5767f6a9a35b3ef9$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attributes = _ref.attributes, _ref$separator = _ref.separator, separator = _ref$separator === void 0 ? " > " : _ref$separator, _ref$rootPath = _ref.rootPath, rootPath = _ref$rootPath === void 0 ? null : _ref$rootPath, _ref$showParentLevel = _ref.showParentLevel, showParentLevel = _ref$showParentLevel === void 0 ? true : _ref$showParentLevel, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $5767f6a9a35b3ef9$var$DEFAULT_SORT : _ref$sortBy, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attributes || !Array.isArray(attributes) || attributes.length === 0) throw new Error($5767f6a9a35b3ef9$var$withUsage("The `attributes` option expects an array of strings."));
        if (showMore === true && showMoreLimit <= limit) throw new Error($5767f6a9a35b3ef9$var$withUsage("The `showMoreLimit` option must be greater than `limit`."));
        // we need to provide a hierarchicalFacet name for the search state
        // so that we can always map $hierarchicalFacetName => real attributes
        // we use the first attribute name
        var _attributes = $5767f6a9a35b3ef9$var$_slicedToArray(attributes, 1), hierarchicalFacetName = _attributes[0];
        var sendEvent;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        var _refine;
        var isShowingMore = false;
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        function _prepareFacetValues(facetValues) {
            return facetValues.slice(0, getLimit()).map(function(_ref2) {
                var label = _ref2.name, value = _ref2.escapedValue, data = _ref2.data, path = _ref2.path, subValue = $5767f6a9a35b3ef9$var$_objectWithoutProperties(_ref2, $5767f6a9a35b3ef9$var$_excluded);
                var item = $5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, subValue), {}, {
                    value: value,
                    label: label,
                    data: null
                });
                if (Array.isArray(data)) item.data = _prepareFacetValues(data);
                return item;
            });
        }
        return {
            $$type: "ais.hierarchicalMenu",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                toggleShowMore = createToggleShowMore(renderOptions, this);
                renderFn($5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.removeHierarchicalFacet(hierarchicalFacetName).setQueryParameter("maxValuesPerFacet", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, renderState), {}, {
                    hierarchicalMenu: $5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, renderState.hierarchicalMenu), {}, $5767f6a9a35b3ef9$var$_defineProperty({}, hierarchicalFacetName, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref4) {
                var _this = this;
                var results = _ref4.results, state = _ref4.state, createURL = _ref4.createURL, instantSearchInstance = _ref4.instantSearchInstance, helper = _ref4.helper;
                var items = [];
                var canToggleShowMore = false;
                // Bind createURL to this specific attribute
                var _createURL = function _createURL(facetValue) {
                    return createURL(function(uiState) {
                        return _this.getWidgetUiState(uiState, {
                            searchParameters: state.resetPage().toggleFacetRefinement(hierarchicalFacetName, facetValue),
                            helper: helper
                        });
                    });
                };
                if (!sendEvent) sendEvent = (0, $bc60c9359d7bbc6d$export$75bfa3473d01f29f)({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    attribute: function attribute(facetValue) {
                        var index = facetValue.split(separator).length - 1;
                        return attributes[index];
                    },
                    widgetType: this.$$type
                });
                if (!_refine) _refine = function _refine(facetValue) {
                    sendEvent("click:internal", facetValue);
                    helper.toggleFacetRefinement(hierarchicalFacetName, facetValue).search();
                };
                if (results) {
                    var facetValues = results.getFacetValues(hierarchicalFacetName, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $5767f6a9a35b3ef9$var$DEFAULT_SORT
                    });
                    var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    var hasExhaustiveItems = (state.maxValuesPerFacet || 0) > getLimit() ? facetItems.length <= getLimit() : facetItems.length < getLimit();
                    canToggleShowMore = showMore && (isShowingMore || !hasExhaustiveItems);
                    items = transformItems(_prepareFacetValues(facetItems), {
                        results: results
                    });
                }
                return {
                    items: items,
                    refine: _refine,
                    canRefine: items.length > 0,
                    createURL: _createURL,
                    sendEvent: sendEvent,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    toggleShowMore: cachedToggleShowMore,
                    canToggleShowMore: canToggleShowMore
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var path = searchParameters.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);
                return $5767f6a9a35b3ef9$var$removeEmptyRefinementsFromUiState($5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, uiState), {}, {
                    hierarchicalMenu: $5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, uiState.hierarchicalMenu), {}, $5767f6a9a35b3ef9$var$_defineProperty({}, hierarchicalFacetName, path))
                }), hierarchicalFacetName);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var values = uiState.hierarchicalMenu && uiState.hierarchicalMenu[hierarchicalFacetName];
                if (searchParameters.isConjunctiveFacet(hierarchicalFacetName) || searchParameters.isDisjunctiveFacet(hierarchicalFacetName)) return searchParameters;
                if (searchParameters.isHierarchicalFacet(hierarchicalFacetName)) var facet = searchParameters.getHierarchicalFacetByName(hierarchicalFacetName);
                var withFacetConfiguration = searchParameters.removeHierarchicalFacet(hierarchicalFacetName).addHierarchicalFacet({
                    name: hierarchicalFacetName,
                    attributes: attributes,
                    separator: separator,
                    rootPath: rootPath,
                    showParentLevel: showParentLevel
                });
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!values) return withMaxValuesPerFacet.setQueryParameters({
                    hierarchicalFacetsRefinements: $5767f6a9a35b3ef9$var$_objectSpread($5767f6a9a35b3ef9$var$_objectSpread({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, $5767f6a9a35b3ef9$var$_defineProperty({}, hierarchicalFacetName, []))
                });
                return withMaxValuesPerFacet.addHierarchicalFacetRefinement(hierarchicalFacetName, values.join(separator));
            }
        };
    };
};
function $5767f6a9a35b3ef9$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.hierarchicalMenu) return indexUiState;
    if (!indexUiState.hierarchicalMenu[attribute] || indexUiState.hierarchicalMenu[attribute].length === 0) delete indexUiState.hierarchicalMenu[attribute];
    if (Object.keys(indexUiState.hierarchicalMenu).length === 0) delete indexUiState.hierarchicalMenu;
    return indexUiState;
}
var $5767f6a9a35b3ef9$export$2e2bcd8739ae039 = $5767f6a9a35b3ef9$var$connectHierarchicalMenu;



function $236071b09c56df04$export$9da6e234a1bdf658(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $5767f6a9a35b3ef9$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $cd33437cad6a0790$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(" ");
}



var $iBfRJ = parcelRequire("iBfRJ");
function $7b2f8b64da55a7c4$export$1131d30bb631f2ba(event) {
    var isMiddleClick = event.button === 1;
    return Boolean(isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}



var $iBfRJ = parcelRequire("iBfRJ");
var $f3e31dd936e9d1e1$var$_excluded = [
    "isShowingMore",
    "translations"
];
function $f3e31dd936e9d1e1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f3e31dd936e9d1e1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f3e31dd936e9d1e1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f3e31dd936e9d1e1$export$e41c325c8b11c297(_ref) {
    var isShowingMore = _ref.isShowingMore, translations = _ref.translations, props = $f3e31dd936e9d1e1$var$_objectWithoutProperties(_ref, $f3e31dd936e9d1e1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("button", props, translations.showMoreButtonText({
        isShowingMore: isShowingMore
    }));
}


var $39752885a803789f$var$_excluded = [
    "classNames",
    "items",
    "hasItems",
    "onNavigate",
    "createURL",
    "showMore",
    "canToggleShowMore",
    "onToggleShowMore",
    "isShowingMore",
    "translations"
];
function $39752885a803789f$var$_extends() {
    $39752885a803789f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39752885a803789f$var$_extends.apply(this, arguments);
}
function $39752885a803789f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $39752885a803789f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $39752885a803789f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $39752885a803789f$var$HierarchicalList(_ref) {
    var className = _ref.className, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, items = _ref.items, createURL = _ref.createURL, onNavigate = _ref.onNavigate;
    if (items.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("ul", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-list", classNames.list, className)
    }, items.map(function(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("li", {
            key: item.value,
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-item", classNames.item, item.isRefined && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-item--selected", classNames.selectedItem), item.data && item.data.length > 0 && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-item--parent", classNames.parentItem))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("a", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-link", classNames.link, item.isRefined && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-link--selected", classNames.selectedItemLink)),
            href: createURL(item.value),
            onClick: function onClick(event) {
                if ((0, $7b2f8b64da55a7c4$export$1131d30bb631f2ba)(event)) return;
                event.preventDefault();
                onNavigate(item.value);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-label", classNames.label)
        }, item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-count", classNames.count)
        }, item.count)), item.data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($39752885a803789f$var$HierarchicalList, {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-list--child", classNames.childList),
            classNames: classNames,
            items: item.data,
            onNavigate: onNavigate,
            createURL: createURL
        }));
    }));
}
function $39752885a803789f$export$cd053ad333284bbb(_ref2) {
    var _ref2$classNames = _ref2.classNames, classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames, items = _ref2.items, hasItems = _ref2.hasItems, onNavigate = _ref2.onNavigate, createURL = _ref2.createURL, showMore = _ref2.showMore, canToggleShowMore = _ref2.canToggleShowMore, onToggleShowMore = _ref2.onToggleShowMore, isShowingMore = _ref2.isShowingMore, translations = _ref2.translations, props = $39752885a803789f$var$_objectWithoutProperties(_ref2, $39752885a803789f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $39752885a803789f$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu", classNames.root, !hasItems && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu--noRefinement", classNames.noRefinementRoot), props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($39752885a803789f$var$HierarchicalList, {
        classNames: classNames,
        items: items,
        onNavigate: onNavigate,
        createURL: createURL
    }), showMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $f3e31dd936e9d1e1$export$e41c325c8b11c297), {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-showMore", classNames.showMore, !canToggleShowMore && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HierarchicalMenu-showMore--disabled", classNames.disabledShowMore)),
        disabled: !canToggleShowMore,
        onClick: onToggleShowMore,
        isShowingMore: isShowingMore,
        translations: translations
    }));
}


function $0b0a731837cb9484$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0b0a731837cb9484$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0b0a731837cb9484$var$_typeof(o);
}
var $0b0a731837cb9484$var$_excluded = [
    "attributes",
    "limit",
    "rootPath",
    "separator",
    "showMore",
    "showMoreLimit",
    "showParentLevel",
    "sortBy",
    "transformItems",
    "translations"
];
function $0b0a731837cb9484$var$_extends() {
    $0b0a731837cb9484$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b0a731837cb9484$var$_extends.apply(this, arguments);
}
function $0b0a731837cb9484$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b0a731837cb9484$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b0a731837cb9484$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0b0a731837cb9484$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b0a731837cb9484$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0b0a731837cb9484$var$_defineProperty(obj, key, value) {
    key = $0b0a731837cb9484$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0b0a731837cb9484$var$_toPropertyKey(t) {
    var i = $0b0a731837cb9484$var$_toPrimitive(t, "string");
    return "symbol" == $0b0a731837cb9484$var$_typeof(i) ? i : String(i);
}
function $0b0a731837cb9484$var$_toPrimitive(t, r) {
    if ("object" != $0b0a731837cb9484$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0b0a731837cb9484$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0b0a731837cb9484$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0b0a731837cb9484$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0b0a731837cb9484$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0b0a731837cb9484$export$cd053ad333284bbb(_ref) {
    var attributes = _ref.attributes, limit = _ref.limit, rootPath = _ref.rootPath, separator = _ref.separator, showMore = _ref.showMore, showMoreLimit = _ref.showMoreLimit, showParentLevel = _ref.showParentLevel, sortBy = _ref.sortBy, transformItems = _ref.transformItems, translations = _ref.translations, props = $0b0a731837cb9484$var$_objectWithoutProperties(_ref, $0b0a731837cb9484$var$_excluded);
    var _useHierarchicalMenu = (0, $236071b09c56df04$export$9da6e234a1bdf658)({
        attributes: attributes,
        limit: limit,
        rootPath: rootPath,
        separator: separator,
        showMore: showMore,
        showMoreLimit: showMoreLimit,
        showParentLevel: showParentLevel,
        sortBy: sortBy,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.hierarchicalMenu"
    }), items = _useHierarchicalMenu.items, canRefine = _useHierarchicalMenu.canRefine, canToggleShowMore = _useHierarchicalMenu.canToggleShowMore, createURL = _useHierarchicalMenu.createURL, isShowingMore = _useHierarchicalMenu.isShowingMore, refine = _useHierarchicalMenu.refine, toggleShowMore = _useHierarchicalMenu.toggleShowMore;
    var uiProps = {
        items: items,
        hasItems: canRefine,
        createURL: createURL,
        onNavigate: refine,
        canToggleShowMore: canToggleShowMore,
        onToggleShowMore: toggleShowMore,
        isShowingMore: isShowingMore,
        translations: $0b0a731837cb9484$var$_objectSpread({
            showMoreButtonText: function showMoreButtonText(options) {
                return options.isShowingMore ? "Show less" : "Show more";
            }
        }, translations)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $39752885a803789f$export$cd053ad333284bbb), $0b0a731837cb9484$var$_extends({}, props, uiProps, {
        showMore: showMore
    }));
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $e902f020b2c9d54e$var$htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
// Used to match HTML entities and HTML characters.
var $e902f020b2c9d54e$var$regexUnescapedHtml = /[&<>"']/g;
var $e902f020b2c9d54e$var$regexHasUnescapedHtml = RegExp($e902f020b2c9d54e$var$regexUnescapedHtml.source);
function $e902f020b2c9d54e$export$4e7f196112fea3c5(value) {
    return value && $e902f020b2c9d54e$var$regexHasUnescapedHtml.test(value) ? value.replace($e902f020b2c9d54e$var$regexUnescapedHtml, function(character) {
        return $e902f020b2c9d54e$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $e902f020b2c9d54e$var$htmlCharacters = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
// Used to match HTML entities and HTML characters.
var $e902f020b2c9d54e$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $e902f020b2c9d54e$var$regexHasEscapedHtml = RegExp($e902f020b2c9d54e$var$regexEscapedHtml.source);
function $e902f020b2c9d54e$export$e8bacd2802a88316(value) {
    return value && $e902f020b2c9d54e$var$regexHasEscapedHtml.test(value) ? value.replace($e902f020b2c9d54e$var$regexEscapedHtml, function(character) {
        return $e902f020b2c9d54e$var$htmlCharacters[character];
    }) : value;
}



function $6ae69c233bbe3267$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6ae69c233bbe3267$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6ae69c233bbe3267$var$_typeof(o);
}
function $6ae69c233bbe3267$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $6ae69c233bbe3267$var$_extends() {
    $6ae69c233bbe3267$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae69c233bbe3267$var$_extends.apply(this, arguments);
}
function $6ae69c233bbe3267$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ae69c233bbe3267$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ae69c233bbe3267$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6ae69c233bbe3267$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ae69c233bbe3267$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6ae69c233bbe3267$var$_defineProperty(obj, key, value) {
    key = $6ae69c233bbe3267$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ae69c233bbe3267$var$_toPropertyKey(t) {
    var i = $6ae69c233bbe3267$var$_toPrimitive(t, "string");
    return "symbol" == $6ae69c233bbe3267$var$_typeof(i) ? i : String(i);
}
function $6ae69c233bbe3267$var$_toPrimitive(t, r) {
    if ("object" != $6ae69c233bbe3267$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6ae69c233bbe3267$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6ae69c233bbe3267$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $6ae69c233bbe3267$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
// @MAJOR: in the future, this should only escape, not replace
function $6ae69c233bbe3267$var$replaceTagsAndEscape(value) {
    return (0, $e902f020b2c9d54e$export$4e7f196112fea3c5)(value).replace(new RegExp($6ae69c233bbe3267$export$1e7338a8952eaf35.highlightPreTag, "g"), $6ae69c233bbe3267$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($6ae69c233bbe3267$export$1e7338a8952eaf35.highlightPostTag, "g"), $6ae69c233bbe3267$export$62e796b7905e8e6b.highlightPostTag);
}
function $6ae69c233bbe3267$var$recursiveEscape(input) {
    if ((0, $3a165817c0906f06$export$53b83ca8eaab0383)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $6ae69c233bbe3267$var$_objectSpread($6ae69c233bbe3267$var$_objectSpread({}, acc), {}, $6ae69c233bbe3267$var$_defineProperty({}, key, $6ae69c233bbe3267$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($6ae69c233bbe3267$var$recursiveEscape);
    return $6ae69c233bbe3267$var$_objectSpread($6ae69c233bbe3267$var$_objectSpread({}, input), {}, {
        value: $6ae69c233bbe3267$var$replaceTagsAndEscape(input.value)
    });
}
function $6ae69c233bbe3267$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $6ae69c233bbe3267$var$_extends({}, ($6ae69c233bbe3267$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $6ae69c233bbe3267$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $6ae69c233bbe3267$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $6ae69c233bbe3267$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $6ae69c233bbe3267$var$_objectSpread($6ae69c233bbe3267$var$_objectSpread({}, h), {}, {
            highlighted: $6ae69c233bbe3267$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


function $d236013a390b8d22$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}

function $59eb1e95b9e5c884$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}



var $iBfRJ = parcelRequire("iBfRJ");


var $iBfRJ = parcelRequire("iBfRJ");
var $0732585907e1448f$exports = {};
function $0732585907e1448f$var$_extends() {
    $0732585907e1448f$exports = $0732585907e1448f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $0732585907e1448f$exports.__esModule = true, $0732585907e1448f$exports["default"] = $0732585907e1448f$exports;
    return $0732585907e1448f$var$_extends.apply(this, arguments);
}
$0732585907e1448f$exports = $0732585907e1448f$var$_extends, $0732585907e1448f$exports.__esModule = true, $0732585907e1448f$exports["default"] = $0732585907e1448f$exports;


var $b72c7cce3ebf3a6f$exports = {};
var $5ebf3e9c87085831$exports = {};
function $5ebf3e9c87085831$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$5ebf3e9c87085831$exports = $5ebf3e9c87085831$var$_objectWithoutPropertiesLoose, $5ebf3e9c87085831$exports.__esModule = true, $5ebf3e9c87085831$exports["default"] = $5ebf3e9c87085831$exports;


function $b72c7cce3ebf3a6f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5ebf3e9c87085831$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$b72c7cce3ebf3a6f$exports = $b72c7cce3ebf3a6f$var$_objectWithoutProperties, $b72c7cce3ebf3a6f$exports.__esModule = true, $b72c7cce3ebf3a6f$exports["default"] = $b72c7cce3ebf3a6f$exports;



var $53d1205cc3f53094$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $53d1205cc3f53094$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $53d1205cc3f53094$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $53d1205cc3f53094$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, (/*@__PURE__*/$parcel$interopDefault($b72c7cce3ebf3a6f$exports)))(userProps, $53d1205cc3f53094$var$_excluded);
        return createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($0732585907e1448f$exports)))({}, props, {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}



var $iBfRJ = parcelRequire("iBfRJ");
var $bf5a14b51a7a7e72$export$57a0c6fc80bec05c = (0, $53d1205cc3f53094$export$c8682df1c852a966)({
    createElement: (0, $iBfRJ.createElement),
    Fragment: (0, $iBfRJ.Fragment)
});


var $a9ca3b45604e2248$var$_excluded = [
    "classNames"
];
function $a9ca3b45604e2248$var$_extends() {
    $a9ca3b45604e2248$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9ca3b45604e2248$var$_extends.apply(this, arguments);
}
function $a9ca3b45604e2248$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a9ca3b45604e2248$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a9ca3b45604e2248$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a9ca3b45604e2248$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $a9ca3b45604e2248$var$_objectWithoutProperties(_ref, $a9ca3b45604e2248$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $bf5a14b51a7a7e72$export$57a0c6fc80bec05c), $a9ca3b45604e2248$var$_extends({
        classNames: {
            root: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Highlight", classNames.root),
            highlighted: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Highlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Highlight-separator", classNames.separator)
        }
    }, props));
}


var $c62ec36ff8cae40d$var$_excluded = [
    "hit",
    "attribute",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator"
];
function $c62ec36ff8cae40d$var$_extends() {
    $c62ec36ff8cae40d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c62ec36ff8cae40d$var$_extends.apply(this, arguments);
}
function $c62ec36ff8cae40d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c62ec36ff8cae40d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c62ec36ff8cae40d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c62ec36ff8cae40d$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, highlightedTagName = _ref.highlightedTagName, nonHighlightedTagName = _ref.nonHighlightedTagName, separator = _ref.separator, props = $c62ec36ff8cae40d$var$_objectWithoutProperties(_ref, $c62ec36ff8cae40d$var$_excluded);
    var property = (0, $59eb1e95b9e5c884$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = Array.isArray(property) ? property : [
        property
    ];
    var parts = properties.map(function(singleValue) {
        return (0, $d236013a390b8d22$export$e04d28e65b830ebf)((0, $e902f020b2c9d54e$export$e8bacd2802a88316)(singleValue.value || ""));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $a9ca3b45604e2248$export$39dbc3f558091353), $c62ec36ff8cae40d$var$_extends({}, props, {
        parts: parts,
        highlightedTagName: highlightedTagName,
        nonHighlightedTagName: nonHighlightedTagName,
        separator: separator
    }));
}




var $2c2368f78cc5463d$var$_excluded = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent",
    "banner",
    "bannerComponent"
];
// Should be imported from a shared package in the future
function $2c2368f78cc5463d$var$createDefaultBannerComponent(_ref) {
    var createElement = _ref.createElement;
    return function DefaultBanner(_ref2) {
        var classNames = _ref2.classNames, banner = _ref2.banner;
        if (!banner.image.urls[0].url) return null;
        return createElement("aside", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot)
        }, banner.link ? createElement("a", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-banner-link", classNames.bannerLink),
            href: banner.link.url,
            target: banner.link.target
        }, createElement("img", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        })) : createElement("img", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        }));
    };
}
function $2c2368f78cc5463d$export$abc871145e3e685(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var DefaultBannerComponent = $2c2368f78cc5463d$var$createDefaultBannerComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Hits(userProps) {
        var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, banner = userProps.banner, BannerComponent = userProps.bannerComponent, props = (0, (/*@__PURE__*/$parcel$interopDefault($b72c7cce3ebf3a6f$exports)))(userProps, $2c2368f78cc5463d$var$_excluded);
        return createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($0732585907e1448f$exports)))({}, props, {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits", classNames.root, hits.length === 0 && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits--empty", classNames.emptyRoot), props.className)
        }), banner && (BannerComponent ? createElement(BannerComponent, {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot),
            banner: banner
        }) : createElement(DefaultBannerComponent, {
            classNames: classNames,
            banner: banner
        })), hits.length === 0 && EmptyComponent ? createElement(EmptyComponent, null) : createElement("ol", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-list", classNames.list)
        }, hits.map(function(hit, index) {
            return createElement(ItemComponent, {
                key: hit.objectID,
                hit: hit,
                index: index,
                className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Hits-item", classNames.item),
                onClick: function onClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                },
                onAuxClick: function onAuxClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                }
            });
        })));
    };
}



var $iBfRJ = parcelRequire("iBfRJ");
function $cd9dc62f6f45fd49$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cd9dc62f6f45fd49$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cd9dc62f6f45fd49$var$_typeof(o);
}
function $cd9dc62f6f45fd49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd9dc62f6f45fd49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd9dc62f6f45fd49$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd9dc62f6f45fd49$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd9dc62f6f45fd49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd9dc62f6f45fd49$var$_defineProperty(obj, key, value) {
    key = $cd9dc62f6f45fd49$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd9dc62f6f45fd49$var$_toPropertyKey(t) {
    var i = $cd9dc62f6f45fd49$var$_toPrimitive(t, "string");
    return "symbol" == $cd9dc62f6f45fd49$var$_typeof(i) ? i : String(i);
}
function $cd9dc62f6f45fd49$var$_toPrimitive(t, r) {
    if ("object" != $cd9dc62f6f45fd49$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cd9dc62f6f45fd49$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd9dc62f6f45fd49$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $cd9dc62f6f45fd49$var$_objectSpread($cd9dc62f6f45fd49$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $a7f6ec7e5092702c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a7f6ec7e5092702c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a7f6ec7e5092702c$var$_typeof(o);
}
function $a7f6ec7e5092702c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a7f6ec7e5092702c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a7f6ec7e5092702c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a7f6ec7e5092702c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a7f6ec7e5092702c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a7f6ec7e5092702c$var$_defineProperty(obj, key, value) {
    key = $a7f6ec7e5092702c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a7f6ec7e5092702c$var$_toPropertyKey(t) {
    var i = $a7f6ec7e5092702c$var$_toPrimitive(t, "string");
    return "symbol" == $a7f6ec7e5092702c$var$_typeof(i) ? i : String(i);
}
function $a7f6ec7e5092702c$var$_toPrimitive(t, r) {
    if ("object" != $a7f6ec7e5092702c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a7f6ec7e5092702c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a7f6ec7e5092702c$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $a7f6ec7e5092702c$var$_objectSpread($a7f6ec7e5092702c$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}

function $449a71b1a234558d$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $449a71b1a234558d$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}


function $75284e74ffb34a31$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75284e74ffb34a31$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75284e74ffb34a31$var$ownKeys(Object(t), !0).forEach(function(r) {
            $75284e74ffb34a31$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75284e74ffb34a31$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $75284e74ffb34a31$var$_defineProperty(obj, key, value) {
    key = $75284e74ffb34a31$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75284e74ffb34a31$var$_toPropertyKey(t) {
    var i = $75284e74ffb34a31$var$_toPrimitive(t, "string");
    return "symbol" == $75284e74ffb34a31$var$_typeof(i) ? i : String(i);
}
function $75284e74ffb34a31$var$_toPrimitive(t, r) {
    if ("object" != $75284e74ffb34a31$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $75284e74ffb34a31$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $75284e74ffb34a31$var$_slicedToArray(arr, i) {
    return $75284e74ffb34a31$var$_arrayWithHoles(arr) || $75284e74ffb34a31$var$_iterableToArrayLimit(arr, i) || $75284e74ffb34a31$var$_unsupportedIterableToArray(arr, i) || $75284e74ffb34a31$var$_nonIterableRest();
}
function $75284e74ffb34a31$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $75284e74ffb34a31$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $75284e74ffb34a31$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $75284e74ffb34a31$var$_arrayLikeToArray(o, minLen);
}
function $75284e74ffb34a31$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $75284e74ffb34a31$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $75284e74ffb34a31$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $75284e74ffb34a31$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $75284e74ffb34a31$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $75284e74ffb34a31$var$_typeof(o);
}
function $75284e74ffb34a31$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $75284e74ffb34a31$export$2f82a8f6391c6db9(_ref) {
    var helper = _ref.helper, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $75284e74ffb34a31$var$_typeof(args[0]) === "object") return [
        args[0]
    ];
    var _args$0$split = args[0].split(":"), _args$0$split2 = $75284e74ffb34a31$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === "click" || eventType === "conversion") && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $75284e74ffb34a31$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === "view") {
        if (instantSearchInstance.status !== "idle") return [];
        return hitsChunks.map(function(batch, i) {
            var _helper$lastResults;
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: widgetType,
                eventType: eventType,
                payload: $75284e74ffb34a31$var$_objectSpread({
                    eventName: eventName || "Hits Viewed",
                    index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === "click") return hitsChunks.map(function(batch, i) {
        var _helper$lastResults2;
        return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $75284e74ffb34a31$var$_objectSpread({
                eventName: eventName || "Hit Clicked",
                index: ((_helper$lastResults2 = helper.lastResults) === null || _helper$lastResults2 === void 0 ? void 0 : _helper$lastResults2.index) || helper.state.index,
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === "conversion") return hitsChunks.map(function(batch, i) {
        var _helper$lastResults3;
        return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $75284e74ffb34a31$var$_objectSpread({
                eventName: eventName || "Hit Converted",
                index: ((_helper$lastResults3 = helper.lastResults) === null || _helper$lastResults3 === void 0 ? void 0 : _helper$lastResults3.index) || helper.state.index,
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $75284e74ffb34a31$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, helper = _ref2.helper, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $75284e74ffb34a31$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            helper: helper,
            methodName: "sendEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $75284e74ffb34a31$export$5a3d9973824d9b76(_ref3) {
    var helper = _ref3.helper, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $75284e74ffb34a31$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            helper: helper,
            methodName: "bindEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $449a71b1a234558d$export$44b4521aa38272f2)(payloads)) : "";
    };
    return bindEventForHits;
}


function $1f29b179c19b7544$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1f29b179c19b7544$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1f29b179c19b7544$var$_typeof(o);
}
function $1f29b179c19b7544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f29b179c19b7544$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f29b179c19b7544$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1f29b179c19b7544$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f29b179c19b7544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f29b179c19b7544$var$_defineProperty(obj, key, value) {
    key = $1f29b179c19b7544$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1f29b179c19b7544$var$_toPropertyKey(t) {
    var i = $1f29b179c19b7544$var$_toPrimitive(t, "string");
    return "symbol" == $1f29b179c19b7544$var$_typeof(i) ? i : String(i);
}
function $1f29b179c19b7544$var$_toPrimitive(t, r) {
    if ("object" != $1f29b179c19b7544$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1f29b179c19b7544$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1f29b179c19b7544$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "hits",
    connector: true
});
var $1f29b179c19b7544$export$2e2bcd8739ae039 = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $1f29b179c19b7544$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($1f29b179c19b7544$var$_objectSpread($1f29b179c19b7544$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($1f29b179c19b7544$var$_objectSpread($1f29b179c19b7544$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent("view:internal", renderState.items);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $1f29b179c19b7544$var$_objectSpread($1f29b179c19b7544$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $75284e74ffb34a31$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $75284e74ffb34a31$export$5a3d9973824d9b76)({
                    helper: helper,
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    items: [],
                    results: undefined,
                    banner: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $6ae69c233bbe3267$export$9adb036445aab889)(results.hits);
                var hitsWithAbsolutePosition = (0, $cd9dc62f6f45fd49$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $a7f6ec7e5092702c$export$b8f834386ea30952)(hitsWithAbsolutePosition, results.queryID);
                var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                return {
                    hits: items,
                    items: items,
                    results: results,
                    banner: banner,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $6ae69c233bbe3267$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $1f29b179c19b7544$var$_objectSpread($1f29b179c19b7544$var$_objectSpread({}, acc), {}, $1f29b179c19b7544$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $6ae69c233bbe3267$export$1e7338a8952eaf35));
            }
        };
    };
};



function $87328463ddad368e$export$1dc18a9d9332e2a7(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $1f29b179c19b7544$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


var $3e45d2db268da615$var$_excluded = [
    "escapeHTML",
    "transformItems",
    "hitComponent",
    "bannerComponent"
], $3e45d2db268da615$var$_excluded2 = [
    "hit",
    "index"
];
function $3e45d2db268da615$var$_extends() {
    $3e45d2db268da615$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e45d2db268da615$var$_extends.apply(this, arguments);
}
function $3e45d2db268da615$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3e45d2db268da615$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3e45d2db268da615$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// @MAJOR: Move default hit component back to the UI library
// once flavour specificities are erased
function $3e45d2db268da615$var$DefaultHitComponent(_ref) {
    var hit = _ref.hit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", {
        style: {
            wordBreak: "break-all"
        }
    }, JSON.stringify(hit).slice(0, 100), "\u2026");
}
var $3e45d2db268da615$var$HitsUiComponent = (0, $2c2368f78cc5463d$export$abc871145e3e685)({
    createElement: (0, $iBfRJ.createElement),
    Fragment: (0, $iBfRJ.Fragment)
});
function $3e45d2db268da615$export$9abb8533010f1d93(_ref2) {
    var escapeHTML = _ref2.escapeHTML, transformItems = _ref2.transformItems, _ref2$hitComponent = _ref2.hitComponent, HitComponent = _ref2$hitComponent === void 0 ? $3e45d2db268da615$var$DefaultHitComponent : _ref2$hitComponent, BannerComponent = _ref2.bannerComponent, props = $3e45d2db268da615$var$_objectWithoutProperties(_ref2, $3e45d2db268da615$var$_excluded);
    var _useHits = (0, $87328463ddad368e$export$1dc18a9d9332e2a7)({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.hits"
    }), hits = _useHits.hits, banner = _useHits.banner, sendEvent = _useHits.sendEvent;
    var itemComponent = (0, $iBfRJ.useMemo)(function() {
        return function(_ref3) {
            var hit = _ref3.hit, index = _ref3.index, itemProps = $3e45d2db268da615$var$_objectWithoutProperties(_ref3, $3e45d2db268da615$var$_excluded2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("li", $3e45d2db268da615$var$_extends({
                key: hit.objectID
            }, itemProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement(HitComponent, {
                hit: hit,
                sendEvent: sendEvent
            }));
        };
    }, [
        HitComponent,
        sendEvent
    ]);
    var bannerComponent = BannerComponent === false ? function() {
        return null;
    } : BannerComponent;
    var uiProps = {
        hits: hits,
        sendEvent: sendEvent,
        itemComponent: itemComponent,
        banner: banner,
        bannerComponent: bannerComponent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($3e45d2db268da615$var$HitsUiComponent, $3e45d2db268da615$var$_extends({}, props, uiProps));
}


var $iBfRJ = parcelRequire("iBfRJ");

function $500e65aa2968e49b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $500e65aa2968e49b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $500e65aa2968e49b$var$_typeof(o);
}
function $500e65aa2968e49b$var$_toConsumableArray(arr) {
    return $500e65aa2968e49b$var$_arrayWithoutHoles(arr) || $500e65aa2968e49b$var$_iterableToArray(arr) || $500e65aa2968e49b$var$_unsupportedIterableToArray(arr) || $500e65aa2968e49b$var$_nonIterableSpread();
}
function $500e65aa2968e49b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $500e65aa2968e49b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $500e65aa2968e49b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $500e65aa2968e49b$var$_arrayLikeToArray(o, minLen);
}
function $500e65aa2968e49b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $500e65aa2968e49b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $500e65aa2968e49b$var$_arrayLikeToArray(arr);
}
function $500e65aa2968e49b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $500e65aa2968e49b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $500e65aa2968e49b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $500e65aa2968e49b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $500e65aa2968e49b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $500e65aa2968e49b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $500e65aa2968e49b$var$_defineProperty(obj, key, value) {
    key = $500e65aa2968e49b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $500e65aa2968e49b$var$_toPropertyKey(t) {
    var i = $500e65aa2968e49b$var$_toPrimitive(t, "string");
    return "symbol" == $500e65aa2968e49b$var$_typeof(i) ? i : String(i);
}
function $500e65aa2968e49b$var$_toPrimitive(t, r) {
    if ("object" != $500e65aa2968e49b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $500e65aa2968e49b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $500e65aa2968e49b$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "hits-per-page",
    connector: true
});
var $500e65aa2968e49b$var$connectHitsPerPage = function connectHitsPerPage(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $500e65aa2968e49b$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, userItems = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!Array.isArray(userItems)) throw new Error($500e65aa2968e49b$var$withUsage("The `items` option expects an array of objects."));
        var items = userItems;
        var defaultItems = items.filter(function(item) {
            return item.default === true;
        });
        if (defaultItems.length === 0) throw new Error($500e65aa2968e49b$var$withUsage("A default value must be specified in `items`."));
        if (defaultItems.length > 1) throw new Error($500e65aa2968e49b$var$withUsage("More than one default value is specified in `items`."));
        var defaultItem = defaultItems[0];
        var normalizeItems = function normalizeItems(_ref2) {
            var hitsPerPage = _ref2.hitsPerPage;
            return items.map(function(item) {
                return $500e65aa2968e49b$var$_objectSpread($500e65aa2968e49b$var$_objectSpread({}, item), {}, {
                    isRefined: Number(item.value) === Number(hitsPerPage)
                });
            });
        };
        var connectorState = {
            getRefine: function getRefine(helper) {
                return function(value) {
                    return !value && value !== 0 ? helper.setQueryParameter("hitsPerPage", undefined).search() : helper.setQueryParameter("hitsPerPage", value).search();
                };
            },
            createURLFactory: function createURLFactory(_ref3) {
                var state = _ref3.state, createURL = _ref3.createURL, getWidgetUiState = _ref3.getWidgetUiState, helper = _ref3.helper;
                return function(value) {
                    return createURL(function(uiState) {
                        return getWidgetUiState(uiState, {
                            searchParameters: state.resetPage().setQueryParameter("hitsPerPage", !value && value !== 0 ? undefined : value),
                            helper: helper
                        });
                    });
                };
            }
        };
        return {
            $$type: "ais.hitsPerPage",
            init: function init(initOptions) {
                var state = initOptions.state, instantSearchInstance = initOptions.instantSearchInstance;
                var isCurrentInOptions = items.some(function(item) {
                    return Number(state.hitsPerPage) === Number(item.value);
                });
                if (!isCurrentInOptions) items = [
                    // The helper will convert the empty string to `undefined`.
                    {
                        value: "",
                        label: ""
                    }
                ].concat($500e65aa2968e49b$var$_toConsumableArray(items));
                renderFn($500e65aa2968e49b$var$_objectSpread($500e65aa2968e49b$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($500e65aa2968e49b$var$_objectSpread($500e65aa2968e49b$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                return state.setQueryParameter("hitsPerPage", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $500e65aa2968e49b$var$_objectSpread($500e65aa2968e49b$var$_objectSpread({}, renderState), {}, {
                    hitsPerPage: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref5) {
                var state = _ref5.state, results = _ref5.results, createURL = _ref5.createURL, helper = _ref5.helper;
                var canRefine = results ? results.nbHits > 0 : false;
                return {
                    items: transformItems(normalizeItems(state), {
                        results: results
                    }),
                    refine: connectorState.getRefine(helper),
                    createURL: connectorState.createURLFactory({
                        state: state,
                        createURL: createURL,
                        getWidgetUiState: this.getWidgetUiState,
                        helper: helper
                    }),
                    hasNoResults: !canRefine,
                    canRefine: canRefine,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref6) {
                var searchParameters = _ref6.searchParameters;
                var hitsPerPage = searchParameters.hitsPerPage;
                if (hitsPerPage === undefined || hitsPerPage === defaultItem.value) return uiState;
                return $500e65aa2968e49b$var$_objectSpread($500e65aa2968e49b$var$_objectSpread({}, uiState), {}, {
                    hitsPerPage: hitsPerPage
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
                var uiState = _ref7.uiState;
                return searchParameters.setQueryParameters({
                    hitsPerPage: uiState.hitsPerPage || defaultItem.value
                });
            }
        };
    };
};
var $500e65aa2968e49b$export$2e2bcd8739ae039 = $500e65aa2968e49b$var$connectHitsPerPage;



function $e44c52b222851184$export$98505b536e552530(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $500e65aa2968e49b$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}




var $iBfRJ = parcelRequire("iBfRJ");
var $8a63939dbbb5c1a3$var$_excluded = [
    "items",
    "onChange",
    "currentValue",
    "classNames"
];
function $8a63939dbbb5c1a3$var$_extends() {
    $8a63939dbbb5c1a3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8a63939dbbb5c1a3$var$_extends.apply(this, arguments);
}
function $8a63939dbbb5c1a3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8a63939dbbb5c1a3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8a63939dbbb5c1a3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8a63939dbbb5c1a3$export$1c363d4fc6896e21(_ref) {
    var items = _ref.items, _onChange = _ref.onChange, currentValue = _ref.currentValue, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $8a63939dbbb5c1a3$var$_objectWithoutProperties(_ref, $8a63939dbbb5c1a3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $8a63939dbbb5c1a3$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HitsPerPage", classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("select", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HitsPerPage-select", classNames.select),
        onChange: function onChange(event) {
            _onChange(Number(event.target.value));
        },
        value: String(currentValue)
    }, items.map(function(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("option", {
            key: item.value,
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-HitsPerPage-option", classNames.option),
            value: item.value
        }, item.label);
    })));
}


var $eaed8cda9706c844$var$_excluded = [
    "items",
    "transformItems"
];
function $eaed8cda9706c844$var$_extends() {
    $eaed8cda9706c844$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eaed8cda9706c844$var$_extends.apply(this, arguments);
}
function $eaed8cda9706c844$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eaed8cda9706c844$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eaed8cda9706c844$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $eaed8cda9706c844$export$1c363d4fc6896e21(_ref) {
    var userItems = _ref.items, transformItems = _ref.transformItems, props = $eaed8cda9706c844$var$_objectWithoutProperties(_ref, $eaed8cda9706c844$var$_excluded);
    var _useHitsPerPage = (0, $e44c52b222851184$export$98505b536e552530)({
        items: userItems,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.hitsPerPage"
    }), items = _useHitsPerPage.items, refine = _useHitsPerPage.refine;
    var _ref2 = items.find(function(_ref3) {
        var isRefined = _ref3.isRefined;
        return isRefined;
    }) || {}, currentValue = _ref2.value;
    var uiProps = {
        items: items,
        currentValue: currentValue,
        onChange: function onChange(value) {
            return refine(value);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $8a63939dbbb5c1a3$export$1c363d4fc6896e21), $eaed8cda9706c844$var$_extends({}, props, uiProps));
}


var $iBfRJ = parcelRequire("iBfRJ");





function $5d8ea489f68db0a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5d8ea489f68db0a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5d8ea489f68db0a0$var$_typeof(o);
}
var $5d8ea489f68db0a0$export$d900da7fa9a86f36 = "_ALGOLIA";
function $5d8ea489f68db0a0$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $5d8ea489f68db0a0$var$_typeof(document)) !== "object" || typeof document.cookie !== "string") return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $5d8ea489f68db0a0$export$61f1c6e9cd2ed687() {
    return $5d8ea489f68db0a0$var$getCookie($5d8ea489f68db0a0$export$d900da7fa9a86f36);
}
function $5d8ea489f68db0a0$export$2e2bcd8739ae039() {
    return $5d8ea489f68db0a0$export$61f1c6e9cd2ed687();
}


// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $6e63ebe2fed4edda$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}

// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $c147f4991eb21c4a$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.appId && searchClient.apiKey) // searchClient v5
    return [
        searchClient.appId,
        searchClient.apiKey
    ];
    else if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = "x-algolia-application-id";
        var API_KEY = "x-algolia-api-key";
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $8a56c836bfbfd946$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}


/**
 * Create UUID according to
 * https://www.ietf.org/rfc/rfc4122.txt.
 *
 * @returns Generated UUID.
 */ function $020be5a7c9e7a9e4$export$5dbf9a24b655dde4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        /* eslint-disable no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        /* eslint-enable */ return v.toString(16);
    });
}


function $3fbdae8c90dc5310$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3fbdae8c90dc5310$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3fbdae8c90dc5310$var$_typeof(o);
}
function $3fbdae8c90dc5310$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3fbdae8c90dc5310$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3fbdae8c90dc5310$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3fbdae8c90dc5310$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3fbdae8c90dc5310$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3fbdae8c90dc5310$var$_defineProperty(obj, key, value) {
    key = $3fbdae8c90dc5310$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3fbdae8c90dc5310$var$_toPropertyKey(t) {
    var i = $3fbdae8c90dc5310$var$_toPrimitive(t, "string");
    return "symbol" == $3fbdae8c90dc5310$var$_typeof(i) ? i : String(i);
}
function $3fbdae8c90dc5310$var$_toPrimitive(t, r) {
    if ("object" != $3fbdae8c90dc5310$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3fbdae8c90dc5310$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3fbdae8c90dc5310$var$_slicedToArray(arr, i) {
    return $3fbdae8c90dc5310$var$_arrayWithHoles(arr) || $3fbdae8c90dc5310$var$_iterableToArrayLimit(arr, i) || $3fbdae8c90dc5310$var$_unsupportedIterableToArray(arr, i) || $3fbdae8c90dc5310$var$_nonIterableRest();
}
function $3fbdae8c90dc5310$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3fbdae8c90dc5310$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3fbdae8c90dc5310$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3fbdae8c90dc5310$var$_toConsumableArray(arr) {
    return $3fbdae8c90dc5310$var$_arrayWithoutHoles(arr) || $3fbdae8c90dc5310$var$_iterableToArray(arr) || $3fbdae8c90dc5310$var$_unsupportedIterableToArray(arr) || $3fbdae8c90dc5310$var$_nonIterableSpread();
}
function $3fbdae8c90dc5310$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3fbdae8c90dc5310$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3fbdae8c90dc5310$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3fbdae8c90dc5310$var$_arrayLikeToArray(o, minLen);
}
function $3fbdae8c90dc5310$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3fbdae8c90dc5310$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3fbdae8c90dc5310$var$_arrayLikeToArray(arr);
}
function $3fbdae8c90dc5310$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3fbdae8c90dc5310$var$ALGOLIA_INSIGHTS_VERSION = "2.17.2";
var $3fbdae8c90dc5310$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($3fbdae8c90dc5310$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $3fbdae8c90dc5310$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $3fbdae8c90dc5310$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $381348598347b86b$export$8793edee2d425525);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === "ais.insights" && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $3fbdae8c90dc5310$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $c147f4991eb21c4a$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey2 = $3fbdae8c90dc5310$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedInitParams = undefined;
        var queuedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                "setUserToken",
                "init"
            ].map(function(key) {
                var _ref3 = (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $3fbdae8c90dc5310$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $3fbdae8c90dc5310$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $3fbdae8c90dc5310$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedInitParams = _map2[1];
        }
        // If user called `aa('setUserToken')` before creating the Insights middleware,
        // we temporarily store the token and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient("getUserToken", null, function(_error, userToken) {
            userTokenBeforeInit = $3fbdae8c90dc5310$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$3fbdae8c90dc5310$var$isModernInsightsClient(insightsClient)) insightsClient("init", $3fbdae8c90dc5310$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: "ais.insights",
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                try {
                    var script = document.createElement("script");
                    script.async = true;
                    script.src = $3fbdae8c90dc5310$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit("error", new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit("error", new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient("addAlgoliaAgent", "insights-middleware");
                helper = instantSearchInstance.mainHelper;
                var queueAtStart = insightsClient.queue;
                if (Array.isArray(queueAtStart)) {
                    var _map3 = [
                        "setUserToken",
                        "init"
                    ].map(function(key) {
                        var _ref7 = (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(queueAtStart.slice().reverse(), function(_ref9) {
                            var _ref10 = $3fbdae8c90dc5310$var$_slicedToArray(_ref9, 1), method = _ref10[0];
                            return method === key;
                        }) || [], _ref8 = $3fbdae8c90dc5310$var$_slicedToArray(_ref7, 2), value = _ref8[1];
                        return value;
                    });
                    var _map4 = $3fbdae8c90dc5310$var$_slicedToArray(_map3, 2);
                    queuedUserToken = _map4[0];
                    queuedInitParams = _map4[1];
                }
                initialParameters = $3fbdae8c90dc5310$var$getInitialParameters(instantSearchInstance);
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($3fbdae8c90dc5310$var$_objectSpread($3fbdae8c90dc5310$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $3fbdae8c90dc5310$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($3fbdae8c90dc5310$var$_objectSpread($3fbdae8c90dc5310$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                function setUserToken(token) {
                    setUserTokenToSearch(token, true);
                    insightsClient("setUserToken", token);
                }
                var anonymousUserToken = undefined;
                var anonymousTokenFromInsights = (0, $5d8ea489f68db0a0$export$61f1c6e9cd2ed687)();
                if (anonymousTokenFromInsights) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken on instantsearch and insights. If it's not set as an insights
                // userToken before a sendEvent, insights automatically generates a new anonymous token,
                // causing a state change and an unnecessary query on instantsearch.
                anonymousUserToken = anonymousTokenFromInsights;
                else {
                    var token = "anonymous-".concat((0, $020be5a7c9e7a9e4$export$5dbf9a24b655dde4)());
                    anonymousUserToken = token;
                }
                var userTokenFromInit;
                // With SSR, the token could be be set on the state. We make sure
                // that insights is in sync with that token since, there is no
                // insights lib on the server.
                var tokenFromSearchParameters = initialParameters.userToken;
                // When the first query is sent, the token is possibly not yet set by
                // the insights onChange callbacks (if insights isn't yet loaded).
                // It is explicitly being set here so that the first query has the
                // initial tokens set and ensure a second query isn't automatically
                // made when the onChange callback actually changes the state.
                if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.userToken) userTokenFromInit = insightsInitParams.userToken;
                if (userTokenFromInit) setUserToken(userTokenFromInit);
                else if (tokenFromSearchParameters) setUserToken(tokenFromSearchParameters);
                else if (userTokenBeforeInit) setUserToken(userTokenBeforeInit);
                else if (queuedUserToken) setUserToken(queuedUserToken);
                else if (anonymousUserToken) {
                    var _queuedInitParams;
                    setUserToken(anonymousUserToken);
                    if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.useCookie || (_queuedInitParams = queuedInitParams) !== null && _queuedInitParams !== void 0 && _queuedInitParams.useCookie) {
                        var _queuedInitParams2;
                        $3fbdae8c90dc5310$var$saveTokenAsCookie(anonymousUserToken, (insightsInitParams === null || insightsInitParams === void 0 ? void 0 : insightsInitParams.cookieDuration) || ((_queuedInitParams2 = queuedInitParams) === null || _queuedInitParams2 === void 0 ? void 0 : _queuedInitParams2.cookieDuration));
                    }
                }
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient("onUserTokenChange", function(token) {
                    return setUserTokenToSearch(token, true);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($3fbdae8c90dc5310$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var _getAppIdAndApiKey3 = (0, $c147f4991eb21c4a$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey4 = $3fbdae8c90dc5310$var$_slicedToArray(_getAppIdAndApiKey3, 2), latestAppId = _getAppIdAndApiKey4[0], latestApiKey = _getAppIdAndApiKey4[1];
                    var extraParams = {
                        headers: {
                            "X-Algolia-Application-Id": latestAppId,
                            "X-Algolia-API-Key": latestApiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                var viewedObjectIDs = new Set();
                var lastQueryId;
                instantSearchInstance.mainHelper.derivedHelpers[0].on("result", function(_ref11) {
                    var results = _ref11.results;
                    if (results && (!results.queryID || results.queryID !== lastQueryId)) {
                        lastQueryId = results.queryID;
                        viewedObjectIDs.clear();
                    }
                });
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        if (event.insightsMethod === "viewedObjectIDs") {
                            var _payload = event.payload;
                            var difference = _payload.objectIDs.filter(function(objectID) {
                                return !viewedObjectIDs.has(objectID);
                            });
                            if (difference.length === 0) return;
                            difference.forEach(function(objectID) {
                                return viewedObjectIDs.add(objectID);
                            });
                            _payload.objectIDs = difference;
                        }
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            "instantsearch"
                        ];
                        if ($$automatic) event.payload.algoliaSource.push("instantsearch-automatic");
                        if (event.eventModifier === "internal") event.payload.algoliaSource.push("instantsearch-internal");
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient("onUserTokenChange", undefined);
                instantSearchInstance.sendEventToInsights = (0, $381348598347b86b$export$8793edee2d425525);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($3fbdae8c90dc5310$var$_objectSpread($3fbdae8c90dc5310$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
function $3fbdae8c90dc5310$var$getInitialParameters(instantSearchInstance) {
    var _instantSearchInstanc, _instantSearchInstanc2;
    // in SSR, the initial state we use in this domain is set on the main index
    var stateFromInitialResults = ((_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : (_instantSearchInstanc2 = _instantSearchInstanc[instantSearchInstance.indexName]) === null || _instantSearchInstanc2 === void 0 ? void 0 : _instantSearchInstanc2.state) || {};
    var stateFromHelper = instantSearchInstance.mainHelper.state;
    return {
        userToken: stateFromInitialResults.userToken || stateFromHelper.userToken,
        clickAnalytics: stateFromInitialResults.clickAnalytics || stateFromHelper.clickAnalytics
    };
}
function $3fbdae8c90dc5310$var$saveTokenAsCookie(token, cookieDuration) {
    var MONTH = 2592000000;
    var d = new Date();
    d.setTime(d.getTime() + (cookieDuration || MONTH * 6));
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "_ALGOLIA=".concat(token, ";").concat(expires, ";path=/");
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $3fbdae8c90dc5310$var$isModernInsightsClient(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $3fbdae8c90dc5310$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $3fbdae8c90dc5310$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === "number" ? userToken.toString() : userToken;
}


function $1dc69ffbe28f5bcf$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $1dc69ffbe28f5bcf$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && "_state" in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}


function $f19a624d60d0f539$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $1dc69ffbe28f5bcf$export$dbf1227de6c1fbc6)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $f19a624d60d0f539$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $f19a624d60d0f539$export$4b4254890acf93e7() {
    return (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("Algolia Crawler")) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $f19a624d60d0f539$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            $$type: "ais.metadata",
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $f19a624d60d0f539$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


var $c8afc031a920371d$exports = {};
"use strict";
var $de771d5bc9c5ebe6$exports = {};
"use strict";
var $ba2ccb1fe231947e$exports = {};
"use strict";
var $d3f2d3c8dac61c06$exports = {};
"use strict";
var $d3f2d3c8dac61c06$var$replace = String.prototype.replace;
var $d3f2d3c8dac61c06$var$percentTwenties = /%20/g;
var $d3f2d3c8dac61c06$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$d3f2d3c8dac61c06$exports = {
    "default": $d3f2d3c8dac61c06$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d3f2d3c8dac61c06$var$replace.call(value, $d3f2d3c8dac61c06$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d3f2d3c8dac61c06$var$Format.RFC1738,
    RFC3986: $d3f2d3c8dac61c06$var$Format.RFC3986
};


var $ba2ccb1fe231947e$var$has = Object.prototype.hasOwnProperty;
var $ba2ccb1fe231947e$var$isArray = Array.isArray;
var $ba2ccb1fe231947e$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $ba2ccb1fe231947e$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($ba2ccb1fe231947e$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $ba2ccb1fe231947e$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $ba2ccb1fe231947e$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($ba2ccb1fe231947e$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$ba2ccb1fe231947e$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($ba2ccb1fe231947e$var$isArray(target) && !$ba2ccb1fe231947e$var$isArray(source)) mergeTarget = $ba2ccb1fe231947e$var$arrayToObject(target, options);
    if ($ba2ccb1fe231947e$var$isArray(target) && $ba2ccb1fe231947e$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($ba2ccb1fe231947e$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($ba2ccb1fe231947e$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $ba2ccb1fe231947e$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $ba2ccb1fe231947e$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $ba2ccb1fe231947e$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $d3f2d3c8dac61c06$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $ba2ccb1fe231947e$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($ba2ccb1fe231947e$var$hexTable[0xC0 | c >> 6] + $ba2ccb1fe231947e$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($ba2ccb1fe231947e$var$hexTable[0xE0 | c >> 12] + $ba2ccb1fe231947e$var$hexTable[0x80 | c >> 6 & 0x3F] + $ba2ccb1fe231947e$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $ba2ccb1fe231947e$var$hexTable[0xF0 | c >> 18] + $ba2ccb1fe231947e$var$hexTable[0x80 | c >> 12 & 0x3F] + $ba2ccb1fe231947e$var$hexTable[0x80 | c >> 6 & 0x3F] + $ba2ccb1fe231947e$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $ba2ccb1fe231947e$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $ba2ccb1fe231947e$var$compactQueue(queue);
    return value;
};
var $ba2ccb1fe231947e$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $ba2ccb1fe231947e$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $ba2ccb1fe231947e$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $ba2ccb1fe231947e$var$maybeMap = function maybeMap(val, fn) {
    if ($ba2ccb1fe231947e$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$ba2ccb1fe231947e$exports = {
    arrayToObject: $ba2ccb1fe231947e$var$arrayToObject,
    assign: $ba2ccb1fe231947e$var$assign,
    combine: $ba2ccb1fe231947e$var$combine,
    compact: $ba2ccb1fe231947e$var$compact,
    decode: $ba2ccb1fe231947e$var$decode,
    encode: $ba2ccb1fe231947e$var$encode,
    isBuffer: $ba2ccb1fe231947e$var$isBuffer,
    isRegExp: $ba2ccb1fe231947e$var$isRegExp,
    maybeMap: $ba2ccb1fe231947e$var$maybeMap,
    merge: $ba2ccb1fe231947e$var$merge
};



var $de771d5bc9c5ebe6$var$has = Object.prototype.hasOwnProperty;
var $de771d5bc9c5ebe6$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $de771d5bc9c5ebe6$var$isArray = Array.isArray;
var $de771d5bc9c5ebe6$var$split = String.prototype.split;
var $de771d5bc9c5ebe6$var$push = Array.prototype.push;
var $de771d5bc9c5ebe6$var$pushToArray = function(arr, valueOrArray) {
    $de771d5bc9c5ebe6$var$push.apply(arr, $de771d5bc9c5ebe6$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $de771d5bc9c5ebe6$var$toISO = Date.prototype.toISOString;
var $de771d5bc9c5ebe6$var$defaultFormat = $d3f2d3c8dac61c06$exports.default;
var $de771d5bc9c5ebe6$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $ba2ccb1fe231947e$exports.encode,
    encodeValuesOnly: false,
    format: $de771d5bc9c5ebe6$var$defaultFormat,
    formatter: $d3f2d3c8dac61c06$exports.formatters[$de771d5bc9c5ebe6$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $de771d5bc9c5ebe6$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $de771d5bc9c5ebe6$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $de771d5bc9c5ebe6$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $de771d5bc9c5ebe6$var$isArray(obj)) obj = $ba2ccb1fe231947e$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $de771d5bc9c5ebe6$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($de771d5bc9c5ebe6$var$isNonNullishPrimitive(obj) || $ba2ccb1fe231947e$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $de771d5bc9c5ebe6$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $de771d5bc9c5ebe6$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $de771d5bc9c5ebe6$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $de771d5bc9c5ebe6$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $de771d5bc9c5ebe6$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($de771d5bc9c5ebe6$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $de771d5bc9c5ebe6$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        $de771d5bc9c5ebe6$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $de771d5bc9c5ebe6$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $de771d5bc9c5ebe6$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $de771d5bc9c5ebe6$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $d3f2d3c8dac61c06$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$de771d5bc9c5ebe6$var$has.call($d3f2d3c8dac61c06$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $d3f2d3c8dac61c06$exports.formatters[format];
    var filter = $de771d5bc9c5ebe6$var$defaults.filter;
    if (typeof opts.filter === "function" || $de771d5bc9c5ebe6$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $de771d5bc9c5ebe6$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $de771d5bc9c5ebe6$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $de771d5bc9c5ebe6$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $de771d5bc9c5ebe6$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $de771d5bc9c5ebe6$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $de771d5bc9c5ebe6$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $de771d5bc9c5ebe6$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $de771d5bc9c5ebe6$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $de771d5bc9c5ebe6$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $de771d5bc9c5ebe6$var$defaults.strictNullHandling
    };
};
$de771d5bc9c5ebe6$exports = function(object, opts) {
    var obj = object;
    var options = $de771d5bc9c5ebe6$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($de771d5bc9c5ebe6$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $de771d5bc9c5ebe6$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $de771d5bc9c5ebe6$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $de771d5bc9c5ebe6$var$pushToArray(keys, $de771d5bc9c5ebe6$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $d4b655fd359a26e2$exports = {};
"use strict";

var $d4b655fd359a26e2$var$has = Object.prototype.hasOwnProperty;
var $d4b655fd359a26e2$var$isArray = Array.isArray;
var $d4b655fd359a26e2$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $ba2ccb1fe231947e$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $d4b655fd359a26e2$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $d4b655fd359a26e2$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $d4b655fd359a26e2$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $d4b655fd359a26e2$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $d4b655fd359a26e2$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $d4b655fd359a26e2$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $d4b655fd359a26e2$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $d4b655fd359a26e2$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $d4b655fd359a26e2$var$defaults.decoder, charset, "key");
            val = $ba2ccb1fe231947e$exports.maybeMap($d4b655fd359a26e2$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $d4b655fd359a26e2$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $d4b655fd359a26e2$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $d4b655fd359a26e2$var$isArray(val) ? [
            val
        ] : val;
        if ($d4b655fd359a26e2$var$has.call(obj, key)) obj[key] = $ba2ccb1fe231947e$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $d4b655fd359a26e2$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $d4b655fd359a26e2$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $d4b655fd359a26e2$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $d4b655fd359a26e2$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $d4b655fd359a26e2$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $d4b655fd359a26e2$var$parseObject(keys, val, options, valuesParsed);
};
var $d4b655fd359a26e2$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $d4b655fd359a26e2$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $d4b655fd359a26e2$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $d4b655fd359a26e2$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $d4b655fd359a26e2$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $d4b655fd359a26e2$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $d4b655fd359a26e2$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $d4b655fd359a26e2$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $d4b655fd359a26e2$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $ba2ccb1fe231947e$exports.isRegExp(opts.delimiter) ? opts.delimiter : $d4b655fd359a26e2$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $d4b655fd359a26e2$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $d4b655fd359a26e2$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $d4b655fd359a26e2$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $d4b655fd359a26e2$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $d4b655fd359a26e2$var$defaults.strictNullHandling
    };
};
$d4b655fd359a26e2$exports = function(str, opts) {
    var options = $d4b655fd359a26e2$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $d4b655fd359a26e2$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $d4b655fd359a26e2$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $ba2ccb1fe231947e$exports.merge(obj, newObj, options);
    }
    return $ba2ccb1fe231947e$exports.compact(obj);
};



$c8afc031a920371d$exports = {
    formats: $d3f2d3c8dac61c06$exports,
    parse: $d4b655fd359a26e2$exports,
    stringify: $de771d5bc9c5ebe6$exports
};



function $cf76e4f8f77d9181$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cf76e4f8f77d9181$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cf76e4f8f77d9181$var$_typeof(o);
}
function $cf76e4f8f77d9181$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cf76e4f8f77d9181$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cf76e4f8f77d9181$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cf76e4f8f77d9181$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cf76e4f8f77d9181$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cf76e4f8f77d9181$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cf76e4f8f77d9181$var$_defineProperty(obj, key, value) {
    key = $cf76e4f8f77d9181$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf76e4f8f77d9181$var$_toPropertyKey(t) {
    var i = $cf76e4f8f77d9181$var$_toPrimitive(t, "string");
    return "symbol" == $cf76e4f8f77d9181$var$_typeof(i) ? i : String(i);
}
function $cf76e4f8f77d9181$var$_toPrimitive(t, r) {
    if ("object" != $cf76e4f8f77d9181$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cf76e4f8f77d9181$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $cf76e4f8f77d9181$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $cf76e4f8f77d9181$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $cf76e4f8f77d9181$var$_classCallCheck(this, BrowserHistory);
        $cf76e4f8f77d9181$var$_defineProperty(this, "$$type", "ais.browser");
        /**
     * Transforms a UI state into a title for the page.
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "getLocation", void 0);
        $cf76e4f8f77d9181$var$_defineProperty(this, "writeTimer", void 0);
        $cf76e4f8f77d9181$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $cf76e4f8f77d9181$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $cf76e4f8f77d9181$var$_defineProperty(this, "_start", void 0);
        $cf76e4f8f77d9181$var$_defineProperty(this, "_dispose", void 0);
        $cf76e4f8f77d9181$var$_defineProperty(this, "_push", void 0);
        $cf76e4f8f77d9181$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === "undefined" ? true : cleanUrlOnDispose;
        (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $cf76e4f8f77d9181$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $cf76e4f8f77d9181$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($c8afc031a920371d$exports))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $cf76e4f8f77d9181$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || "", url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener("popstate", _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($c8afc031a920371d$exports))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener("popstate", _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $cf76e4f8f77d9181$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function() {
        return (0, $8a56c836bfbfd946$export$39f19eed34acd2f1)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $cf76e4f8f77d9181$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}


function $a3245de583927572$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a3245de583927572$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a3245de583927572$var$_typeof(o);
}
var $a3245de583927572$var$_excluded = [
    "configure"
];
function $a3245de583927572$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3245de583927572$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3245de583927572$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a3245de583927572$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3245de583927572$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a3245de583927572$var$_defineProperty(obj, key, value) {
    key = $a3245de583927572$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a3245de583927572$var$_toPropertyKey(t) {
    var i = $a3245de583927572$var$_toPrimitive(t, "string");
    return "symbol" == $a3245de583927572$var$_typeof(i) ? i : String(i);
}
function $a3245de583927572$var$_toPrimitive(t, r) {
    if ("object" != $a3245de583927572$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a3245de583927572$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a3245de583927572$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a3245de583927572$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a3245de583927572$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a3245de583927572$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $a3245de583927572$var$_objectWithoutProperties(uiState, $a3245de583927572$var$_excluded);
    return trackedUiState;
}
function $a3245de583927572$export$2e2bcd8739ae039() {
    return {
        $$type: "ais.simple",
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $a3245de583927572$var$_objectSpread($a3245de583927572$var$_objectSpread({}, state), {}, $a3245de583927572$var$_defineProperty({}, indexId, $a3245de583927572$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $a3245de583927572$var$_objectSpread($a3245de583927572$var$_objectSpread({}, state), {}, $a3245de583927572$var$_defineProperty({}, indexId, $a3245de583927572$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}


function $eb934b8ecdafa33f$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $eb934b8ecdafa33f$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($eb934b8ecdafa33f$var$isPrimitive(first) || $eb934b8ecdafa33f$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$eb934b8ecdafa33f$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}


function $60e82c6b2c6aef8a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $60e82c6b2c6aef8a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $60e82c6b2c6aef8a$var$_typeof(o);
}
function $60e82c6b2c6aef8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60e82c6b2c6aef8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60e82c6b2c6aef8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $60e82c6b2c6aef8a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60e82c6b2c6aef8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $60e82c6b2c6aef8a$var$_defineProperty(obj, key, value) {
    key = $60e82c6b2c6aef8a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $60e82c6b2c6aef8a$var$_toPropertyKey(t) {
    var i = $60e82c6b2c6aef8a$var$_toPrimitive(t, "string");
    return "symbol" == $60e82c6b2c6aef8a$var$_typeof(i) ? i : String(i);
}
function $60e82c6b2c6aef8a$var$_toPrimitive(t, r) {
    if ("object" != $60e82c6b2c6aef8a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $60e82c6b2c6aef8a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $60e82c6b2c6aef8a$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $cf76e4f8f77d9181$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $a3245de583927572$export$2e2bcd8739ae039)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $60e82c6b2c6aef8a$var$_objectSpread($60e82c6b2c6aef8a$var$_objectSpread({}, acc), {}, $60e82c6b2c6aef8a$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || "__unknown__", ", stateMapping:").concat(stateMapping.$$type || "__unknown__", "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $eb934b8ecdafa33f$export$248d38f6296296c5)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $60e82c6b2c6aef8a$var$_objectSpread($60e82c6b2c6aef8a$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};



function $c738370bbc5dbd5d$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}

function $9ffe6df8dd4528f4$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}


var $019e9c119d1b85f0$var$id = 0;
function $019e9c119d1b85f0$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== "recommend") return;
    widget.$$id = $019e9c119d1b85f0$var$id++;
}
function $019e9c119d1b85f0$export$13e2e3d76152aecf() {
    $019e9c119d1b85f0$var$id = 0;
}


function $634c6b61814361f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $634c6b61814361f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $634c6b61814361f8$var$_typeof(o);
}
var $634c6b61814361f8$var$_excluded = [
    "initialSearchParameters"
], $634c6b61814361f8$var$_excluded2 = [
    "initialRecommendParameters"
];
function $634c6b61814361f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $634c6b61814361f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $634c6b61814361f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $634c6b61814361f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $634c6b61814361f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $634c6b61814361f8$var$_defineProperty(obj, key, value) {
    key = $634c6b61814361f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $634c6b61814361f8$var$_toPropertyKey(t) {
    var i = $634c6b61814361f8$var$_toPrimitive(t, "string");
    return "symbol" == $634c6b61814361f8$var$_typeof(i) ? i : String(i);
}
function $634c6b61814361f8$var$_toPrimitive(t, r) {
    if ("object" != $634c6b61814361f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $634c6b61814361f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $634c6b61814361f8$var$_toConsumableArray(arr) {
    return $634c6b61814361f8$var$_arrayWithoutHoles(arr) || $634c6b61814361f8$var$_iterableToArray(arr) || $634c6b61814361f8$var$_unsupportedIterableToArray(arr) || $634c6b61814361f8$var$_nonIterableSpread();
}
function $634c6b61814361f8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $634c6b61814361f8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $634c6b61814361f8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $634c6b61814361f8$var$_arrayLikeToArray(o, minLen);
}
function $634c6b61814361f8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $634c6b61814361f8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $634c6b61814361f8$var$_arrayLikeToArray(arr);
}
function $634c6b61814361f8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $634c6b61814361f8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $634c6b61814361f8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $634c6b61814361f8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $634c6b61814361f8$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "index-widget"
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $634c6b61814361f8$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $634c6b61814361f8$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $634c6b61814361f8$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $634c6b61814361f8$var$_objectWithoutProperties(widgetSearchParametersOptions, $634c6b61814361f8$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)(widget)) return state;
        if (widget.dependsOn === "search" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $634c6b61814361f8$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $634c6b61814361f8$var$_objectWithoutProperties(widgetRecommendParametersOptions, $634c6b61814361f8$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)(widget) && widget.dependsOn === "recommend" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $634c6b61814361f8$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $634c6b61814361f8$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $634c6b61814361f8$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $634c6b61814361f8$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($634c6b61814361f8$var$_toConsumableArray($634c6b61814361f8$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $634c6b61814361f8$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($634c6b61814361f8$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== "recommend" || (0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $634c6b61814361f8$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === "function") return localInstantSearchInstance._createURL($634c6b61814361f8$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($634c6b61814361f8$var$_defineProperty({}, indexId, $634c6b61814361f8$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($634c6b61814361f8$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($634c6b61814361f8$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            widgets.forEach(function(widget) {
                if ((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $019e9c119d1b85f0$export$50b3ac0e47148c0b)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $634c6b61814361f8$var$privateHelperSetState(helper, {
                    state: $634c6b61814361f8$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $634c6b61814361f8$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $1dc69ffbe28f5bcf$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $634c6b61814361f8$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $1dc69ffbe28f5bcf$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($634c6b61814361f8$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($634c6b61814361f8$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $634c6b61814361f8$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $634c6b61814361f8$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $634c6b61814361f8$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $634c6b61814361f8$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $634c6b61814361f8$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $634c6b61814361f8$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $d3e5eacd65539fdb$export$8049d91f25899769).apply(void 0, [
                    mainHelper.state
                ].concat($634c6b61814361f8$var$_toConsumableArray((0, $9ffe6df8dd4528f4$export$1c33c9881dac6797)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $634c6b61814361f8$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on("recommend:result", function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $1dc69ffbe28f5bcf$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
                    $634c6b61814361f8$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $1dc69ffbe28f5bcf$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $634c6b61814361f8$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === "error" && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $1dc69ffbe28f5bcf$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
                    $634c6b61814361f8$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $1dc69ffbe28f5bcf$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $634c6b61814361f8$var$_objectSpread($634c6b61814361f8$var$_objectSpread({}, uiState), {}, $634c6b61814361f8$var$_defineProperty({}, indexId, $634c6b61814361f8$var$_objectSpread($634c6b61814361f8$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $634c6b61814361f8$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $634c6b61814361f8$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === "function" ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $634c6b61814361f8$var$_objectSpread($634c6b61814361f8$var$_objectSpread({}, state), {}, $634c6b61814361f8$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $634c6b61814361f8$export$2e2bcd8739ae039 = $634c6b61814361f8$var$index;
function $634c6b61814361f8$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $634c6b61814361f8$var$_objectSpread($634c6b61814361f8$var$_objectSpread({}, instantSearchInstance.renderState), {}, $634c6b61814361f8$var$_defineProperty({}, parentIndexName, $634c6b61814361f8$var$_objectSpread($634c6b61814361f8$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}


var $ff6feb4e1dc75546$var$NAMESPACE = "ais";
var $ff6feb4e1dc75546$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($ff6feb4e1dc75546$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};



var $934858880af1c168$var$suit = (0, $ff6feb4e1dc75546$export$d8556a2a8f973135)("Highlight");
function $934858880af1c168$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $59eb1e95b9e5c884$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $934858880af1c168$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}


function $ac46eb5c08e28312$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ac46eb5c08e28312$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ac46eb5c08e28312$var$_typeof(o);
}
function $ac46eb5c08e28312$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $449a71b1a234558d$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $ac46eb5c08e28312$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($ac46eb5c08e28312$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $449a71b1a234558d$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $ac46eb5c08e28312$export$2e2bcd8739ae039(method, payload) {
    return $ac46eb5c08e28312$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}



function $0e3c5ba7e5ce25b1$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}


var $88217ba18789650a$var$hasAlphanumeric = new RegExp(/\w/i);
function $88217ba18789650a$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$88217ba18789650a$var$hasAlphanumeric.test((0, $e902f020b2c9d54e$export$e8bacd2802a88316)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $0a1a82fd433b5608$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0a1a82fd433b5608$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a1a82fd433b5608$var$_typeof(o);
}
function $0a1a82fd433b5608$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a1a82fd433b5608$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a1a82fd433b5608$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0a1a82fd433b5608$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a1a82fd433b5608$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a1a82fd433b5608$var$_defineProperty(obj, key, value) {
    key = $0a1a82fd433b5608$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a1a82fd433b5608$var$_toPropertyKey(t) {
    var i = $0a1a82fd433b5608$var$_toPrimitive(t, "string");
    return "symbol" == $0a1a82fd433b5608$var$_typeof(i) ? i : String(i);
}
function $0a1a82fd433b5608$var$_toPrimitive(t, r) {
    if ("object" != $0a1a82fd433b5608$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0a1a82fd433b5608$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0a1a82fd433b5608$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $0a1a82fd433b5608$var$_objectSpread($0a1a82fd433b5608$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $0a1a82fd433b5608$var$_objectSpread($0a1a82fd433b5608$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $88217ba18789650a$export$60c97785b669d08a)(parts, i)
        });
    });
}


var $7e931853b0219b33$var$suit = (0, $ff6feb4e1dc75546$export$d8556a2a8f973135)("ReverseHighlight");
function $7e931853b0219b33$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $59eb1e95b9e5c884$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $7e931853b0219b33$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $0e3c5ba7e5ce25b1$export$a34fe2fceda1929e)((0, $0a1a82fd433b5608$export$8d1202a2cf66e93)((0, $d236013a390b8d22$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $dd2090a5b445c60c$var$suit = (0, $ff6feb4e1dc75546$export$d8556a2a8f973135)("ReverseSnippet");
function $dd2090a5b445c60c$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $59eb1e95b9e5c884$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $dd2090a5b445c60c$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $0e3c5ba7e5ce25b1$export$a34fe2fceda1929e)((0, $0a1a82fd433b5608$export$8d1202a2cf66e93)((0, $d236013a390b8d22$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $c5d1bdb86541cc9a$var$suit = (0, $ff6feb4e1dc75546$export$d8556a2a8f973135)("Snippet");
function $c5d1bdb86541cc9a$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $59eb1e95b9e5c884$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $c5d1bdb86541cc9a$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}


function $3d20caf59bd6c34f$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}


function $1ab2283875e7ead7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1ab2283875e7ead7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1ab2283875e7ead7$var$_typeof(o);
}
function $1ab2283875e7ead7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ab2283875e7ead7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ab2283875e7ead7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1ab2283875e7ead7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ab2283875e7ead7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1ab2283875e7ead7$var$_defineProperty(obj, key, value) {
    key = $1ab2283875e7ead7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ab2283875e7ead7$var$_toPropertyKey(t) {
    var i = $1ab2283875e7ead7$var$_toPrimitive(t, "string");
    return "symbol" == $1ab2283875e7ead7$var$_typeof(i) ? i : String(i);
}
function $1ab2283875e7ead7$var$_toPrimitive(t, r) {
    if ("object" != $1ab2283875e7ead7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1ab2283875e7ead7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1ab2283875e7ead7$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $3d20caf59bd6c34f$export$f5dd818bff069720)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $934858880af1c168$export$2e2bcd8739ae039)($1ab2283875e7ead7$var$_objectSpread($1ab2283875e7ead7$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $7e931853b0219b33$export$2e2bcd8739ae039)($1ab2283875e7ead7$var$_objectSpread($1ab2283875e7ead7$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $c5d1bdb86541cc9a$export$2e2bcd8739ae039)($1ab2283875e7ead7$var$_objectSpread($1ab2283875e7ead7$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $dd2090a5b445c60c$export$2e2bcd8739ae039)($1ab2283875e7ead7$var$_objectSpread($1ab2283875e7ead7$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $ac46eb5c08e28312$export$2e2bcd8739ae039)(method, $1ab2283875e7ead7$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}


var $8441a02033446b9b$var$nextMicroTask = Promise.resolve();
function $8441a02033446b9b$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $8441a02033446b9b$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

function $b3a459ae640e9098$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b3a459ae640e9098$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b3a459ae640e9098$var$_typeof(o);
}
function $b3a459ae640e9098$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3a459ae640e9098$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3a459ae640e9098$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b3a459ae640e9098$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3a459ae640e9098$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b3a459ae640e9098$var$_defineProperty(obj, key, value) {
    key = $b3a459ae640e9098$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b3a459ae640e9098$var$_toPropertyKey(t) {
    var i = $b3a459ae640e9098$var$_toPrimitive(t, "string");
    return "symbol" == $b3a459ae640e9098$var$_typeof(i) ? i : String(i);
}
function $b3a459ae640e9098$var$_toPrimitive(t, r) {
    if ("object" != $b3a459ae640e9098$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b3a459ae640e9098$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b3a459ae640e9098$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $b3a459ae640e9098$var$_objectSpread($b3a459ae640e9098$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}

function $b18bee0a0f1360ae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b18bee0a0f1360ae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b18bee0a0f1360ae$var$_typeof(o);
}
function $b18bee0a0f1360ae$var$_slicedToArray(arr, i) {
    return $b18bee0a0f1360ae$var$_arrayWithHoles(arr) || $b18bee0a0f1360ae$var$_iterableToArrayLimit(arr, i) || $b18bee0a0f1360ae$var$_unsupportedIterableToArray(arr, i) || $b18bee0a0f1360ae$var$_nonIterableRest();
}
function $b18bee0a0f1360ae$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b18bee0a0f1360ae$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b18bee0a0f1360ae$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b18bee0a0f1360ae$var$_arrayLikeToArray(o, minLen);
}
function $b18bee0a0f1360ae$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b18bee0a0f1360ae$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b18bee0a0f1360ae$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b18bee0a0f1360ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b18bee0a0f1360ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b18bee0a0f1360ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b18bee0a0f1360ae$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b18bee0a0f1360ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b18bee0a0f1360ae$var$_defineProperty(obj, key, value) {
    key = $b18bee0a0f1360ae$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b18bee0a0f1360ae$var$_toPropertyKey(t) {
    var i = $b18bee0a0f1360ae$var$_toPrimitive(t, "string");
    return "symbol" == $b18bee0a0f1360ae$var$_typeof(i) ? i : String(i);
}
function $b18bee0a0f1360ae$var$_toPrimitive(t, r) {
    if ("object" != $b18bee0a0f1360ae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b18bee0a0f1360ae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b18bee0a0f1360ae$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!("transporter" in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== "function")) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $b18bee0a0f1360ae$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $b18bee0a0f1360ae$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $b18bee0a0f1360ae$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ("transporter" in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = Array.isArray(requests) ? // search client
            requests.map(function(request) {
                return $b18bee0a0f1360ae$var$_objectSpread($b18bee0a0f1360ae$var$_objectSpread({}, request), {}, {
                    params: $b18bee0a0f1360ae$var$serializeQueryParameters(request.params)
                });
            }) : // composition client
            $b18bee0a0f1360ae$var$serializeQueryParameters(requests.requestBody.params);
            return client.transporter.responsesCache.get({
                method: "search",
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: "search",
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!("transporter" in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $b18bee0a0f1360ae$var$_objectSpread($b18bee0a0f1360ae$var$_objectSpread({}, client.cache), {}, $b18bee0a0f1360ae$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $b18bee0a0f1360ae$var$deserializeQueryParameters(parameters) {
    return parameters.split("&").reduce(function(acc, parameter) {
        var _parameter$split = parameter.split("="), _parameter$split2 = $b18bee0a0f1360ae$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $b18bee0a0f1360ae$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join("&");
}



function $50143f54b403b8c2$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d)).forEach(function(widget) {
        return $50143f54b403b8c2$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}


var $3dacce5bdee29897$export$2e2bcd8739ae039 = "4.78.3";


function $55922fd02a39142f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $55922fd02a39142f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $55922fd02a39142f$var$_typeof(o);
}
function $55922fd02a39142f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55922fd02a39142f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55922fd02a39142f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $55922fd02a39142f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55922fd02a39142f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $55922fd02a39142f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $55922fd02a39142f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $55922fd02a39142f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $55922fd02a39142f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $55922fd02a39142f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $55922fd02a39142f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $55922fd02a39142f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $55922fd02a39142f$var$_setPrototypeOf(subClass, superClass);
}
function $55922fd02a39142f$var$_setPrototypeOf(o, p) {
    $55922fd02a39142f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $55922fd02a39142f$var$_setPrototypeOf(o, p);
}
function $55922fd02a39142f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $55922fd02a39142f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $55922fd02a39142f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $55922fd02a39142f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $55922fd02a39142f$var$_possibleConstructorReturn(this, result);
    };
}
function $55922fd02a39142f$var$_possibleConstructorReturn(self, call) {
    if (call && ($55922fd02a39142f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $55922fd02a39142f$var$_assertThisInitialized(self);
}
function $55922fd02a39142f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $55922fd02a39142f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $55922fd02a39142f$var$_getPrototypeOf(o) {
    $55922fd02a39142f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $55922fd02a39142f$var$_getPrototypeOf(o);
}
function $55922fd02a39142f$var$_defineProperty(obj, key, value) {
    key = $55922fd02a39142f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $55922fd02a39142f$var$_toPropertyKey(t) {
    var i = $55922fd02a39142f$var$_toPrimitive(t, "string");
    return "symbol" == $55922fd02a39142f$var$_typeof(i) ? i : String(i);
}
function $55922fd02a39142f$var$_toPrimitive(t, r) {
    if ("object" != $55922fd02a39142f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $55922fd02a39142f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $55922fd02a39142f$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "instantsearch"
});
function $55922fd02a39142f$var$defaultCreateURL() {
    return "#";
}
var $55922fd02a39142f$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $55922fd02a39142f$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $55922fd02a39142f$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $55922fd02a39142f$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $55922fd02a39142f$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "client", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "indexName", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "compositionID", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "onStateChange", null);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "future", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "helper", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "started", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "renderState", {});
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_createURL", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "_insights", void 0);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "middleware", []);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "status", "idle");
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "error", undefined);
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "scheduleSearch", (0, $8441a02033446b9b$export$260e5c0943f31606)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "scheduleRender", (0, $8441a02033446b9b$export$260e5c0943f31606)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = "idle";
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $55922fd02a39142f$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $55922fd02a39142f$var$_defineProperty($55922fd02a39142f$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $8441a02033446b9b$export$260e5c0943f31606)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? "" : _options$indexName, compositionID = options.compositionID, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $55922fd02a39142f$var$_objectSpread($55922fd02a39142f$var$_objectSpread({}, $55922fd02a39142f$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($55922fd02a39142f$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $3dacce5bdee29897$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($55922fd02a39142f$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.compositionID = compositionID;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $634c6b61814361f8$export$2e2bcd8739ae039)({
            // we use an index widget to render compositions
            // this only works because there's only one composition index allow for now
            indexName: _this.compositionID || _this.indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $1ab2283875e7ead7$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $55922fd02a39142f$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $381348598347b86b$export$8793edee2d425525);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $60e82c6b2c6aef8a$export$1fe5128387816284)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === "boolean" ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $3fbdae8c90dc5310$export$91e0bf09562e2c44)(insightsOptions));
        }
        if ((0, $f19a624d60d0f539$export$4b4254890acf93e7)()) _this.use((0, $f19a624d60d0f539$export$8ee9d2447935ed96)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $55922fd02a39142f$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === "stalled";
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $55922fd02a39142f$var$_objectSpread({
                        $$type: "__unknown__",
                        $$internal: false,
                        subscribe: (0, $381348598347b86b$export$8793edee2d425525),
                        started: (0, $381348598347b86b$export$8793edee2d425525),
                        unsubscribe: (0, $381348598347b86b$export$8793edee2d425525),
                        onStateChange: (0, $381348598347b86b$export$8793edee2d425525)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($55922fd02a39142f$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($55922fd02a39142f$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                if (this.compositionID && widgets.some((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d))) throw new Error($55922fd02a39142f$var$withUsage("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($55922fd02a39142f$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($55922fd02a39142f$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($55922fd02a39142f$var$withUsage("The `start` method has already been called once."));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                if (this.compositionID) mainHelper.searchForFacetValues = mainHelper.searchForCompositionFacetValues.bind(mainHelper);
                mainHelper.search = function() {
                    _this3.status = "loading";
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) {
                        if (_this3.compositionID) mainHelper.searchWithComposition();
                        else mainHelper.searchOnlyWithDerivedHelpers();
                    }
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $381348598347b86b$export$8793edee2d425525));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($64524f464adf5cc8$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = "error";
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit("error", error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $b18bee0a0f1360ae$export$7edf4eca27ca3a19)(this.client, this._initialResults);
                    (0, $b3a459ae640e9098$export$53ef00b131a96aa6)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $8441a02033446b9b$export$260e5c0943f31606)((0, $381348598347b86b$export$8793edee2d425525));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $8441a02033446b9b$export$260e5c0943f31606)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === "undefined") mainHelper.derivedHelpers[0].once("result", function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $3fbdae8c90dc5310$export$91e0bf09562e2c44)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = "stalled";
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($55922fd02a39142f$var$withUsage("The `start` method needs to be called before `setUiState`."));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $50143f54b403b8c2$export$fd5e8f1329b3d5e0)(typeof finalUiState === "function" ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $50143f54b403b8c2$export$fd5e8f1329b3d5e0)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($55922fd02a39142f$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($55922fd02a39142f$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($b40ee84aff520977$exports))));
var $55922fd02a39142f$export$2e2bcd8739ae039 = $55922fd02a39142f$var$InstantSearch;



var $iBfRJ = parcelRequire("iBfRJ");
var $eee9c0aff58cc61c$exports = {};
"use strict";

$eee9c0aff58cc61c$exports = (parcelRequire("8JpIS"));


var $9ceca121f044ea3a$export$2e2bcd8739ae039 = "7.15.8";




var $iBfRJ = parcelRequire("iBfRJ");
function $1fecc9e6d5b78f3c$var$_slicedToArray(arr, i) {
    return $1fecc9e6d5b78f3c$var$_arrayWithHoles(arr) || $1fecc9e6d5b78f3c$var$_iterableToArrayLimit(arr, i) || $1fecc9e6d5b78f3c$var$_unsupportedIterableToArray(arr, i) || $1fecc9e6d5b78f3c$var$_nonIterableRest();
}
function $1fecc9e6d5b78f3c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1fecc9e6d5b78f3c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1fecc9e6d5b78f3c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1fecc9e6d5b78f3c$var$_arrayLikeToArray(o, minLen);
}
function $1fecc9e6d5b78f3c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1fecc9e6d5b78f3c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1fecc9e6d5b78f3c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $1fecc9e6d5b78f3c$export$91db9bc4f8ac944a() {
    var _useReducer = (0, $iBfRJ.useReducer)(function(x) {
        return x + 1;
    }, 0), _useReducer2 = $1fecc9e6d5b78f3c$var$_slicedToArray(_useReducer, 2), forceUpdate = _useReducer2[1];
    return forceUpdate;
}







var $7G10b = parcelRequire("7G10b");
function $626c2950e9455b89$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $626c2950e9455b89$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $626c2950e9455b89$var$_typeof(o);
}
function $626c2950e9455b89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $626c2950e9455b89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $626c2950e9455b89$var$ownKeys(Object(t), !0).forEach(function(r) {
            $626c2950e9455b89$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $626c2950e9455b89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $626c2950e9455b89$var$_defineProperty(obj, key, value) {
    key = $626c2950e9455b89$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $626c2950e9455b89$var$_toPropertyKey(t) {
    var i = $626c2950e9455b89$var$_toPrimitive(t, "string");
    return "symbol" == $626c2950e9455b89$var$_typeof(i) ? i : String(i);
}
function $626c2950e9455b89$var$_toPrimitive(t, r) {
    if ("object" != $626c2950e9455b89$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $626c2950e9455b89$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $626c2950e9455b89$var$defaultUserAgents = [
    "react (".concat((0, $iBfRJ.version), ")"),
    "react-instantsearch (".concat((0, $9ceca121f044ea3a$export$2e2bcd8739ae039), ")"),
    "react-instantsearch-core (".concat((0, $9ceca121f044ea3a$export$2e2bcd8739ae039), ")")
];
var $626c2950e9455b89$var$serverUserAgent = "react-instantsearch-server (".concat((0, $9ceca121f044ea3a$export$2e2bcd8739ae039), ")");
var $626c2950e9455b89$var$nextUserAgent = function nextUserAgent(nextVersion) {
    return nextVersion ? "next.js (".concat(nextVersion, ")") : null;
};
function $626c2950e9455b89$export$c42eabfabffc4866(props) {
    var forceUpdate = (0, $1fecc9e6d5b78f3c$export$91db9bc4f8ac944a)();
    var serverContext = (0, $3477c7c09ca23ad1$export$692e83606e644bf6)();
    var serverState = (0, $57cab9ff255a206a$export$b7b167d1ffee3ddc)();
    var waitingForResultsRef = (0, $97fe9202ac4e6718$export$b0820d56d4bdeee6)();
    var initialResults = serverState === null || serverState === void 0 ? void 0 : serverState.initialResults;
    var prevPropsRef = (0, $iBfRJ.useRef)(props);
    var shouldRenderAtOnce = serverContext || initialResults || waitingForResultsRef;
    var searchRef = (0, $iBfRJ.useRef)(null);
    // As we need to render on mount with SSR, using the local ref above in `StrictMode` will
    // create and start two instances of InstantSearch. To avoid this, we instead discard it and use
    // an upward ref from `InstantSearchSSRContext` as it has already been mounted a second time at this point.
    if (serverState) searchRef = serverState.ssrSearchRef;
    if (searchRef.current === null) {
        // We don't use the `instantsearch()` function because it comes with other
        // top-level APIs that we don't need.
        // See https://github.com/algolia/instantsearch/blob/5b529f43d8acc680f85837eaaa41f7fd03a3f833/src/index.es.ts#L63-L86
        var search = new (0, $55922fd02a39142f$export$2e2bcd8739ae039)(props);
        search._schedule = function _schedule(cb) {
            search._schedule.queue.push(cb);
            clearTimeout(search._schedule.timer);
            search._schedule.timer = setTimeout(function() {
                search._schedule.queue.forEach(function(callback) {
                    callback();
                });
                search._schedule.queue = [];
            }, 0);
        };
        search._schedule.queue = [];
        if (shouldRenderAtOnce) // InstantSearch.js has a private Initial Results API that lets us inject
        // results on the search instance.
        // On the server, we default the initial results to an empty object so that
        // InstantSearch.js doesn't schedule a search that isn't used, leading to
        // an additional network request. (This is equivalent to monkey-patching
        // `scheduleSearch` to a noop.)
        search._initialResults = initialResults || {};
        $626c2950e9455b89$var$addAlgoliaAgents(props.searchClient, [].concat($626c2950e9455b89$var$defaultUserAgents, [
            serverContext && $626c2950e9455b89$var$serverUserAgent,
            $626c2950e9455b89$var$nextUserAgent($626c2950e9455b89$var$getNextVersion())
        ]));
        // On the server, we start the search early to compute the search parameters.
        // On SSR, we start the search early to directly catch up with the lifecycle
        // and render.
        if (shouldRenderAtOnce) search.start();
        if (serverContext) // We notify `getServerState()` of the InstantSearch internals to retrieve
        // the server state and pass it to the render on SSR.
        serverContext.notifyServer({
            search: search
        });
        $626c2950e9455b89$var$warnNextRouter(props.routing);
        $626c2950e9455b89$var$warnNextAppDir(Boolean(waitingForResultsRef));
        searchRef.current = search;
    }
    var _search = searchRef.current;
    var prevProps = prevPropsRef.current;
    if (prevProps.indexName !== props.indexName) {
        _search.helper.setIndex(props.indexName || "").search();
        prevPropsRef.current = props;
    }
    if (prevProps.searchClient !== props.searchClient) {
        $626c2950e9455b89$var$addAlgoliaAgents(props.searchClient, [].concat($626c2950e9455b89$var$defaultUserAgents, [
            serverContext && $626c2950e9455b89$var$serverUserAgent
        ]));
        _search.mainHelper.setClient(props.searchClient).search();
        prevPropsRef.current = props;
    }
    if (prevProps.onStateChange !== props.onStateChange) {
        _search.onStateChange = props.onStateChange;
        prevPropsRef.current = props;
    }
    if (prevProps.searchFunction !== props.searchFunction) {
        // Updating the `searchFunction` to `undefined` is not supported by
        // InstantSearch.js, so it will throw an error.
        // This is a fair behavior until we add an update API in InstantSearch.js.
        _search._searchFunction = props.searchFunction;
        prevPropsRef.current = props;
    }
    if (prevProps.stalledSearchDelay !== props.stalledSearchDelay) {
        var _props$stalledSearchD;
        // The default `stalledSearchDelay` in InstantSearch.js is 200ms.
        // We need to reset it when it's undefined to get back to the original value.
        _search._stalledSearchDelay = (_props$stalledSearchD = props.stalledSearchDelay) !== null && _props$stalledSearchD !== void 0 ? _props$stalledSearchD : 200;
        prevPropsRef.current = props;
    }
    if (!(0, $21fa42d4983016b5$export$de8294bb3be0322f)(prevProps.future, props.future)) {
        _search.future = $626c2950e9455b89$var$_objectSpread($626c2950e9455b89$var$_objectSpread({}, (0, $55922fd02a39142f$export$8bd42a83af1ca676)), props.future);
        prevPropsRef.current = props;
    }
    var cleanupTimerRef = (0, $iBfRJ.useRef)(null);
    var store = (0, $eee9c0aff58cc61c$exports.useSyncExternalStore)((0, $iBfRJ.useCallback)(function() {
        var search = searchRef.current;
        // Scenario 1: the component mounts.
        if (cleanupTimerRef.current === null) // On SSR, the instance is already started so we don't start it again.
        {
            if (!search.started) {
                search.start();
                forceUpdate();
            }
        } else {
            // We cancel the previous cleanup function because we don't want to
            // dispose the search during an update.
            clearTimeout(cleanupTimerRef.current);
            search._preventWidgetCleanup = false;
        }
        return function() {
            function cleanup() {
                search.dispose();
            }
            clearTimeout(search._schedule.timer);
            // We clean up only when the component that uses this subscription unmounts,
            // but not when it updates, because it would dispose the instance, which
            // would remove all the widgets and break routing.
            // Executing the cleanup function in a `setTimeout()` lets us cancel it
            // in the next effect.
            // (There might be better ways to do this.)
            cleanupTimerRef.current = setTimeout(cleanup);
            // We need to prevent the `useWidget` cleanup function so that widgets
            // are not removed before the instance is disposed, triggering
            // an unwanted search request.
            search._preventWidgetCleanup = true;
        };
    }, [
        forceUpdate
    ]), function() {
        return searchRef.current;
    }, function() {
        return searchRef.current;
    });
    return store;
}
function $626c2950e9455b89$var$addAlgoliaAgents(searchClient, userAgents) {
    if (typeof searchClient.addAlgoliaAgent !== "function") return;
    userAgents.filter(Boolean).forEach(function(userAgent) {
        searchClient.addAlgoliaAgent(userAgent);
    });
}
function $626c2950e9455b89$var$warnNextRouter(routing) {
    var _routing$router, isUsingNextRouter;
}
function $626c2950e9455b89$var$warnNextAppDir(isRscContextDefined) {
    var _next;
    return;
}
/**
 * Gets the version of Next.js if it is available in the `window` object,
 * otherwise it returns the NEXT_RUNTIME environment variable (in SSR),
 * which is either `nodejs` or `edge`.
 */ function $626c2950e9455b89$var$getNextVersion() {
    var _next2, _process$env;
    return typeof window !== "undefined" && ((_next2 = window.next) === null || _next2 === void 0 ? void 0 : _next2.version) || (typeof $7G10b !== "undefined" ? (_process$env = {}, _process$env === void 0) ? void 0 : _process$env.NEXT_RUNTIME : undefined);
}


var $99e2f2cc5fe7460f$var$_excluded = [
    "children"
];
function $99e2f2cc5fe7460f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $99e2f2cc5fe7460f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $99e2f2cc5fe7460f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $99e2f2cc5fe7460f$export$ad8f235d2c2c71c0(_ref) {
    var children = _ref.children, props = $99e2f2cc5fe7460f$var$_objectWithoutProperties(_ref, $99e2f2cc5fe7460f$var$_excluded);
    var search = (0, $626c2950e9455b89$export$c42eabfabffc4866)(props);
    if (!search.started) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $2d53e859a49a5d35$export$4b9ddb9c6903c13).Provider, {
        value: search
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $25013601be57fbac$export$899c7584ba03b94a).Provider, {
        value: search.mainIndex
    }, children));
}


var $iBfRJ = parcelRequire("iBfRJ");

function $1f85b153f251662e$var$_toConsumableArray(arr) {
    return $1f85b153f251662e$var$_arrayWithoutHoles(arr) || $1f85b153f251662e$var$_iterableToArray(arr) || $1f85b153f251662e$var$_unsupportedIterableToArray(arr) || $1f85b153f251662e$var$_nonIterableSpread();
}
function $1f85b153f251662e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f85b153f251662e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1f85b153f251662e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1f85b153f251662e$var$_arrayLikeToArray(o, minLen);
}
function $1f85b153f251662e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1f85b153f251662e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1f85b153f251662e$var$_arrayLikeToArray(arr);
}
function $1f85b153f251662e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1f85b153f251662e$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $1f85b153f251662e$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return start + current * limitStep;
    });
}


function $6b88020fdb2a506d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6b88020fdb2a506d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6b88020fdb2a506d$var$_typeof(o);
}
function $6b88020fdb2a506d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6b88020fdb2a506d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6b88020fdb2a506d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6b88020fdb2a506d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6b88020fdb2a506d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6b88020fdb2a506d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6b88020fdb2a506d$var$_defineProperty(obj, key, value) {
    key = $6b88020fdb2a506d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6b88020fdb2a506d$var$_toPropertyKey(t) {
    var i = $6b88020fdb2a506d$var$_toPrimitive(t, "string");
    return "symbol" == $6b88020fdb2a506d$var$_typeof(i) ? i : String(i);
}
function $6b88020fdb2a506d$var$_toPrimitive(t, r) {
    if ("object" != $6b88020fdb2a506d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6b88020fdb2a506d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6b88020fdb2a506d$var$Paginator = /*#__PURE__*/ function() {
    function Paginator(params) {
        $6b88020fdb2a506d$var$_classCallCheck(this, Paginator);
        $6b88020fdb2a506d$var$_defineProperty(this, "currentPage", void 0);
        $6b88020fdb2a506d$var$_defineProperty(this, "total", void 0);
        $6b88020fdb2a506d$var$_defineProperty(this, "padding", void 0);
        this.currentPage = params.currentPage;
        this.total = params.total;
        this.padding = params.padding;
    }
    $6b88020fdb2a506d$var$_createClass(Paginator, [
        {
            key: "pages",
            value: function pages() {
                var total = this.total, currentPage = this.currentPage, padding = this.padding;
                if (total === 0) return [
                    0
                ];
                var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
                if (totalDisplayedPages === total) return (0, $1f85b153f251662e$export$d02631cccf789723)({
                    end: total
                });
                var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
                var paddingRight = totalDisplayedPages - paddingLeft;
                var first = currentPage - paddingLeft;
                var last = currentPage + paddingRight;
                return (0, $1f85b153f251662e$export$d02631cccf789723)({
                    start: first,
                    end: last
                });
            }
        },
        {
            key: "nbPagesDisplayed",
            value: function nbPagesDisplayed(padding, total) {
                return Math.min(2 * padding + 1, total);
            }
        },
        {
            key: "calculatePaddingLeft",
            value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
                if (current <= padding) return current;
                if (current >= total - padding) return totalDisplayedPages - (total - current);
                return padding;
            }
        },
        {
            key: "isLastPage",
            value: function isLastPage() {
                return this.currentPage >= this.total - 1;
            }
        },
        {
            key: "isFirstPage",
            value: function isFirstPage() {
                return this.currentPage <= 0;
            }
        }
    ]);
    return Paginator;
}();
var $6b88020fdb2a506d$export$2e2bcd8739ae039 = $6b88020fdb2a506d$var$Paginator;


function $61804c1de5f26a97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $61804c1de5f26a97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61804c1de5f26a97$var$_typeof(o);
}
function $61804c1de5f26a97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61804c1de5f26a97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61804c1de5f26a97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $61804c1de5f26a97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61804c1de5f26a97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $61804c1de5f26a97$var$_defineProperty(obj, key, value) {
    key = $61804c1de5f26a97$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $61804c1de5f26a97$var$_toPropertyKey(t) {
    var i = $61804c1de5f26a97$var$_toPrimitive(t, "string");
    return "symbol" == $61804c1de5f26a97$var$_typeof(i) ? i : String(i);
}
function $61804c1de5f26a97$var$_toPrimitive(t, r) {
    if ("object" != $61804c1de5f26a97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $61804c1de5f26a97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $61804c1de5f26a97$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "pagination",
    connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */ var $61804c1de5f26a97$var$connectPagination = function connectPagination(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $61804c1de5f26a97$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, totalPages = _ref.totalPages, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
        var pager = new (0, $6b88020fdb2a506d$export$2e2bcd8739ae039)({
            currentPage: 0,
            total: 0,
            padding: padding
        });
        var connectorState = {};
        function getMaxPage(_ref2) {
            var nbPages = _ref2.nbPages;
            return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
        }
        return {
            $$type: "ais.pagination",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($61804c1de5f26a97$var$_objectSpread($61804c1de5f26a97$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($61804c1de5f26a97$var$_objectSpread($61804c1de5f26a97$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.setQueryParameter("page", undefined);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) return uiState;
                return $61804c1de5f26a97$var$_objectSpread($61804c1de5f26a97$var$_objectSpread({}, uiState), {}, {
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var page = uiState.page ? uiState.page - 1 : 0;
                return searchParameters.setQueryParameter("page", page);
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var results = _ref6.results, helper = _ref6.helper, state = _ref6.state, createURL = _ref6.createURL;
                if (!connectorState.refine) connectorState.refine = function(page) {
                    helper.setPage(page);
                    helper.search();
                };
                if (!connectorState.createURL) connectorState.createURL = function(page) {
                    return createURL(function(uiState) {
                        return $61804c1de5f26a97$var$_objectSpread($61804c1de5f26a97$var$_objectSpread({}, uiState), {}, {
                            page: page + 1
                        });
                    });
                };
                var page = state.page || 0;
                var nbPages = getMaxPage(results || {
                    nbPages: 0
                });
                pager.currentPage = page;
                pager.total = nbPages;
                return {
                    createURL: connectorState.createURL,
                    refine: connectorState.refine,
                    canRefine: nbPages > 1,
                    currentRefinement: page,
                    nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
                    nbPages: nbPages,
                    pages: results ? pager.pages() : [],
                    isFirstPage: pager.isFirstPage(),
                    isLastPage: pager.isLastPage(),
                    widgetParams: widgetParams
                };
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $61804c1de5f26a97$var$_objectSpread($61804c1de5f26a97$var$_objectSpread({}, renderState), {}, {
                    pagination: this.getWidgetRenderState(renderOptions)
                });
            }
        };
    };
};
var $61804c1de5f26a97$export$2e2bcd8739ae039 = $61804c1de5f26a97$var$connectPagination;



function $d2b6e9f461b72f61$export$f80c710216eae131(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $61804c1de5f26a97$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}




var $iBfRJ = parcelRequire("iBfRJ");

var $7a6b3700dacc44a9$var$_excluded = [
    "pages",
    "currentPage",
    "nbPages",
    "isFirstPage",
    "isLastPage",
    "showFirst",
    "showPrevious",
    "showNext",
    "showLast",
    "createURL",
    "onNavigate",
    "translations",
    "classNames"
], $7a6b3700dacc44a9$var$_excluded2 = [
    "isDisabled",
    "className",
    "classNames",
    "href",
    "onClick"
];
function $7a6b3700dacc44a9$var$_extends() {
    $7a6b3700dacc44a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7a6b3700dacc44a9$var$_extends.apply(this, arguments);
}
function $7a6b3700dacc44a9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7a6b3700dacc44a9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7a6b3700dacc44a9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7a6b3700dacc44a9$export$68f5e1453c188a82(_ref) {
    var pages = _ref.pages, currentPage = _ref.currentPage, nbPages = _ref.nbPages, isFirstPage = _ref.isFirstPage, isLastPage = _ref.isLastPage, _ref$showFirst = _ref.showFirst, showFirst = _ref$showFirst === void 0 ? true : _ref$showFirst, _ref$showPrevious = _ref.showPrevious, showPrevious = _ref$showPrevious === void 0 ? true : _ref$showPrevious, _ref$showNext = _ref.showNext, showNext = _ref$showNext === void 0 ? true : _ref$showNext, _ref$showLast = _ref.showLast, showLast = _ref$showLast === void 0 ? true : _ref$showLast, createURL = _ref.createURL, onNavigate = _ref.onNavigate, translations = _ref.translations, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $7a6b3700dacc44a9$var$_objectWithoutProperties(_ref, $7a6b3700dacc44a9$var$_excluded);
    var firstPageIndex = 0;
    var previousPageIndex = currentPage - 1;
    var nextPageIndex = currentPage + 1;
    var lastPageIndex = nbPages - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $7a6b3700dacc44a9$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination", classNames.root, nbPages <= 1 && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination--noRefinement", classNames.noRefinementRoot), props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("ul", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-list", classNames.list)
    }, showFirst && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($7a6b3700dacc44a9$var$PaginationItem, {
        isDisabled: isFirstPage,
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item--firstPage", classNames.firstPageItem),
        classNames: classNames,
        "aria-label": translations.firstPageItemAriaLabel,
        href: createURL(firstPageIndex),
        onClick: function onClick() {
            return onNavigate(firstPageIndex);
        }
    }, translations.firstPageItemText), showPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($7a6b3700dacc44a9$var$PaginationItem, {
        isDisabled: isFirstPage,
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item--previousPage", classNames.previousPageItem),
        classNames: classNames,
        "aria-label": translations.previousPageItemAriaLabel,
        href: createURL(previousPageIndex),
        onClick: function onClick() {
            return onNavigate(previousPageIndex);
        }
    }, translations.previousPageItemText), pages.map(function(page) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($7a6b3700dacc44a9$var$PaginationItem, {
            key: page,
            isDisabled: false,
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item--page", classNames.pageItem, page === currentPage && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item--selected", classNames.selectedItem)),
            classNames: classNames,
            "aria-label": translations.pageItemAriaLabel({
                currentPage: page + 1,
                nbPages: nbPages
            }),
            href: createURL(page),
            onClick: function onClick() {
                return onNavigate(page);
            }
        }, translations.pageItemText({
            currentPage: page + 1,
            nbPages: nbPages
        }));
    }), showNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($7a6b3700dacc44a9$var$PaginationItem, {
        isDisabled: isLastPage,
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item--nextPage", classNames.nextPageItem),
        classNames: classNames,
        "aria-label": translations.nextPageItemAriaLabel,
        href: createURL(nextPageIndex),
        onClick: function onClick() {
            return onNavigate(nextPageIndex);
        }
    }, translations.nextPageItemText), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement($7a6b3700dacc44a9$var$PaginationItem, {
        isDisabled: isLastPage,
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item--lastPage", classNames.lastPageItem),
        classNames: classNames,
        "aria-label": translations.lastPageItemAriaLabel,
        href: createURL(lastPageIndex),
        onClick: function onClick() {
            return onNavigate(lastPageIndex);
        }
    }, translations.lastPageItemText)));
}
function $7a6b3700dacc44a9$var$PaginationItem(_ref2) {
    var isDisabled = _ref2.isDisabled, className = _ref2.className, classNames = _ref2.classNames, href = _ref2.href, _onClick = _ref2.onClick, props = $7a6b3700dacc44a9$var$_objectWithoutProperties(_ref2, $7a6b3700dacc44a9$var$_excluded2);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("li", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item", classNames.item, "ais-Pagination-item--disabled", classNames.disabledItem, className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", $7a6b3700dacc44a9$var$_extends({
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-link", classNames.link)
    }, props)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("li", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-item", classNames.item, className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("a", $7a6b3700dacc44a9$var$_extends({
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Pagination-link", classNames.link),
        href: href,
        onClick: function onClick(event) {
            if ((0, $7b2f8b64da55a7c4$export$1131d30bb631f2ba)(event)) return;
            event.preventDefault();
            _onClick(event);
        }
    }, props)));
}


function $8ad4f14d5f73b083$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8ad4f14d5f73b083$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8ad4f14d5f73b083$var$_typeof(o);
}
var $8ad4f14d5f73b083$var$_excluded = [
    "showFirst",
    "showPrevious",
    "showNext",
    "showLast",
    "padding",
    "totalPages",
    "translations"
];
function $8ad4f14d5f73b083$var$_extends() {
    $8ad4f14d5f73b083$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ad4f14d5f73b083$var$_extends.apply(this, arguments);
}
function $8ad4f14d5f73b083$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ad4f14d5f73b083$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ad4f14d5f73b083$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8ad4f14d5f73b083$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ad4f14d5f73b083$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ad4f14d5f73b083$var$_defineProperty(obj, key, value) {
    key = $8ad4f14d5f73b083$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ad4f14d5f73b083$var$_toPropertyKey(t) {
    var i = $8ad4f14d5f73b083$var$_toPrimitive(t, "string");
    return "symbol" == $8ad4f14d5f73b083$var$_typeof(i) ? i : String(i);
}
function $8ad4f14d5f73b083$var$_toPrimitive(t, r) {
    if ("object" != $8ad4f14d5f73b083$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8ad4f14d5f73b083$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8ad4f14d5f73b083$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8ad4f14d5f73b083$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8ad4f14d5f73b083$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8ad4f14d5f73b083$export$68f5e1453c188a82(_ref) {
    var showFirst = _ref.showFirst, showPrevious = _ref.showPrevious, showNext = _ref.showNext, showLast = _ref.showLast, padding = _ref.padding, totalPages = _ref.totalPages, translations = _ref.translations, props = $8ad4f14d5f73b083$var$_objectWithoutProperties(_ref, $8ad4f14d5f73b083$var$_excluded);
    var _usePagination = (0, $d2b6e9f461b72f61$export$f80c710216eae131)({
        padding: padding,
        totalPages: totalPages
    }, {
        $$widgetType: "ais.pagination"
    }), pages = _usePagination.pages, currentRefinement = _usePagination.currentRefinement, isFirstPage = _usePagination.isFirstPage, isLastPage = _usePagination.isLastPage, nbPages = _usePagination.nbPages, createURL = _usePagination.createURL, refine = _usePagination.refine;
    var uiProps = {
        pages: pages,
        currentPage: currentRefinement,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        nbPages: nbPages,
        createURL: createURL,
        onNavigate: refine,
        translations: $8ad4f14d5f73b083$var$_objectSpread({
            firstPageItemText: "\u2039\u2039",
            previousPageItemText: "\u2039",
            nextPageItemText: "\u203A",
            lastPageItemText: "\u203A\u203A",
            pageItemText: function pageItemText(_ref2) {
                var currentPage = _ref2.currentPage;
                return String(currentPage);
            },
            firstPageItemAriaLabel: "First Page",
            previousPageItemAriaLabel: "Previous Page",
            nextPageItemAriaLabel: "Next Page",
            lastPageItemAriaLabel: "Last Page, Page ".concat(nbPages),
            pageItemAriaLabel: function pageItemAriaLabel(_ref3) {
                var currentPage = _ref3.currentPage;
                return "Page ".concat(currentPage);
            }
        }, translations)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $7a6b3700dacc44a9$export$68f5e1453c188a82), $8ad4f14d5f73b083$var$_extends({}, props, uiProps, {
        showFirst: showFirst,
        showPrevious: showPrevious,
        showNext: showNext,
        showLast: showLast
    }));
}


var $iBfRJ = parcelRequire("iBfRJ");

function $b6cfcd99b7047430$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b6cfcd99b7047430$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b6cfcd99b7047430$var$_typeof(o);
}
var $b6cfcd99b7047430$var$_excluded = [
    "name",
    "escapedValue"
], $b6cfcd99b7047430$var$_excluded2 = [
    "escapedValue",
    "value"
];
function $b6cfcd99b7047430$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6cfcd99b7047430$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6cfcd99b7047430$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b6cfcd99b7047430$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6cfcd99b7047430$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b6cfcd99b7047430$var$_defineProperty(obj, key, value) {
    key = $b6cfcd99b7047430$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b6cfcd99b7047430$var$_toPropertyKey(t) {
    var i = $b6cfcd99b7047430$var$_toPrimitive(t, "string");
    return "symbol" == $b6cfcd99b7047430$var$_typeof(i) ? i : String(i);
}
function $b6cfcd99b7047430$var$_toPrimitive(t, r) {
    if ("object" != $b6cfcd99b7047430$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b6cfcd99b7047430$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b6cfcd99b7047430$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b6cfcd99b7047430$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b6cfcd99b7047430$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b6cfcd99b7047430$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "refinement-list",
    connector: true
});
var $b6cfcd99b7047430$var$DEFAULT_SORT = [
    "isRefined",
    "count:desc",
    "name:asc"
];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */ var $b6cfcd99b7047430$var$connectRefinementList = function connectRefinementList(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $b6cfcd99b7047430$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attribute = _ref.attribute, _ref$operator = _ref.operator, operator = _ref$operator === void 0 ? "or" : _ref$operator, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $b6cfcd99b7047430$var$DEFAULT_SORT : _ref$sortBy, _ref$escapeFacetValue = _ref.escapeFacetValues, escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attribute) throw new Error($b6cfcd99b7047430$var$withUsage("The `attribute` option is required."));
        if (!/^(and|or)$/.test(operator)) throw new Error($b6cfcd99b7047430$var$withUsage('The `operator` must one of: `"and"`, `"or"` (got "'.concat(operator, '").')));
        if (showMore === true && showMoreLimit <= limit) throw new Error($b6cfcd99b7047430$var$withUsage("`showMoreLimit` should be greater than `limit`."));
        var formatItems = function formatItems(_ref2) {
            var label = _ref2.name, value = _ref2.escapedValue, item = $b6cfcd99b7047430$var$_objectWithoutProperties(_ref2, $b6cfcd99b7047430$var$_excluded);
            return $b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, item), {}, {
                value: value,
                label: label,
                highlighted: label
            });
        };
        var lastResultsFromMainSearch;
        var lastItemsFromMainSearch = [];
        var hasExhaustiveItems = true;
        var triggerRefine;
        var sendEvent;
        var isShowingMore = false;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        var searchForFacetValues = function searchForFacetValues() {
            return function() {};
        };
        var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
            return function(renderOptions) {
                return function(query) {
                    var instantSearchInstance = renderOptions.instantSearchInstance, searchResults = renderOptions.results;
                    if (query === "" && lastItemsFromMainSearch) // render with previous data from the helper.
                    renderFn($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, widget.getWidgetRenderState($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, renderOptions), {}, {
                        results: lastResultsFromMainSearch
                    }))), {}, {
                        instantSearchInstance: instantSearchInstance
                    }), false);
                    else {
                        var tags = {
                            highlightPreTag: escapeFacetValues ? (0, $6ae69c233bbe3267$export$1e7338a8952eaf35).highlightPreTag : (0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPreTag,
                            highlightPostTag: escapeFacetValues ? (0, $6ae69c233bbe3267$export$1e7338a8952eaf35).highlightPostTag : (0, $6ae69c233bbe3267$export$62e796b7905e8e6b).highlightPostTag
                        };
                        helper.searchForFacetValues(attribute, query, // We cap the `maxFacetHits` value to 100 because the Algolia API
                        // doesn't support a greater number.
                        // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
                        Math.min(getLimit(), 100), tags).then(function(results) {
                            var facetValues = escapeFacetValues ? (0, $6ae69c233bbe3267$export$9ae2e822836b2e1a)(results.facetHits) : results.facetHits;
                            var normalizedFacetValues = transformItems(facetValues.map(function(_ref3) {
                                var escapedValue = _ref3.escapedValue, value = _ref3.value, item = $b6cfcd99b7047430$var$_objectWithoutProperties(_ref3, $b6cfcd99b7047430$var$_excluded2);
                                return $b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, item), {}, {
                                    value: escapedValue,
                                    label: value
                                });
                            }), {
                                results: searchResults
                            });
                            renderFn($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, widget.getWidgetRenderState($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, renderOptions), {}, {
                                results: lastResultsFromMainSearch
                            }))), {}, {
                                items: normalizedFacetValues,
                                canToggleShowMore: false,
                                canRefine: true,
                                isFromSearch: true,
                                instantSearchInstance: instantSearchInstance
                            }), false);
                        });
                    }
                };
            };
        };
        return {
            $$type: "ais.refinementList",
            init: function init(initOptions) {
                renderFn($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, renderState), {}, {
                    refinementList: $b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, renderState.refinementList), {}, $b6cfcd99b7047430$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(renderOptions) {
                var _this = this;
                var results = renderOptions.results, state = renderOptions.state, _createURL = renderOptions.createURL, instantSearchInstance = renderOptions.instantSearchInstance, helper = renderOptions.helper;
                var items = [];
                var facetValues = [];
                if (!sendEvent || !triggerRefine || !searchForFacetValues) {
                    sendEvent = (0, $bc60c9359d7bbc6d$export$75bfa3473d01f29f)({
                        instantSearchInstance: instantSearchInstance,
                        helper: helper,
                        attribute: attribute,
                        widgetType: this.$$type
                    });
                    triggerRefine = function triggerRefine(facetValue) {
                        sendEvent("click:internal", facetValue);
                        helper.toggleFacetRefinement(attribute, facetValue).search();
                    };
                    searchForFacetValues = createSearchForFacetValues(helper, this);
                }
                if (results) {
                    var values = results.getFacetValues(attribute, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $b6cfcd99b7047430$var$DEFAULT_SORT
                    });
                    facetValues = values && Array.isArray(values) ? values : [];
                    items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
                        results: results
                    });
                    var maxValuesPerFacetConfig = state.maxValuesPerFacet;
                    var currentLimit = getLimit();
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
                    lastResultsFromMainSearch = results;
                    lastItemsFromMainSearch = items;
                    if (renderOptions.results) toggleShowMore = createToggleShowMore(renderOptions, this);
                }
                // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
                // function
                var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
                var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
                var canShowMore = showMore && !hasExhaustiveItems;
                var canToggleShowMore = canShowLess || canShowMore;
                return {
                    createURL: function createURL(facetValue) {
                        return _createURL(function(uiState) {
                            return _this.getWidgetUiState(uiState, {
                                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                                helper: helper
                            });
                        });
                    },
                    items: items,
                    refine: triggerRefine,
                    searchForItems: searchFacetValues,
                    isFromSearch: false,
                    canRefine: items.length > 0,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    canToggleShowMore: canToggleShowMore,
                    toggleShowMore: cachedToggleShowMore,
                    sendEvent: sendEvent,
                    hasExhaustiveItems: hasExhaustiveItems
                };
            },
            dispose: function dispose(_ref4) {
                var state = _ref4.state;
                unmountFn();
                var withoutMaxValuesPerFacet = state.setQueryParameter("maxValuesPerFacet", undefined);
                if (operator === "and") return withoutMaxValuesPerFacet.removeFacet(attribute);
                return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var values = operator === "or" ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
                return $b6cfcd99b7047430$var$removeEmptyRefinementsFromUiState($b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, uiState), {}, {
                    refinementList: $b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, uiState.refinementList), {}, $b6cfcd99b7047430$var$_defineProperty({}, attribute, values))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var isDisjunctive = operator === "or";
                if (searchParameters.isHierarchicalFacet(attribute)) return searchParameters;
                if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) return searchParameters;
                var values = uiState.refinementList && uiState.refinementList[attribute];
                var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!values) {
                    var key = isDisjunctive ? "disjunctiveFacetsRefinements" : "facetsRefinements";
                    return withMaxValuesPerFacet.setQueryParameters($b6cfcd99b7047430$var$_defineProperty({}, key, $b6cfcd99b7047430$var$_objectSpread($b6cfcd99b7047430$var$_objectSpread({}, withMaxValuesPerFacet[key]), {}, $b6cfcd99b7047430$var$_defineProperty({}, attribute, []))));
                }
                return values.reduce(function(parameters, value) {
                    return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
                }, withMaxValuesPerFacet);
            }
        };
    };
};
function $b6cfcd99b7047430$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.refinementList) return indexUiState;
    if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) delete indexUiState.refinementList[attribute];
    if (Object.keys(indexUiState.refinementList).length === 0) delete indexUiState.refinementList;
    return indexUiState;
}
var $b6cfcd99b7047430$export$2e2bcd8739ae039 = $b6cfcd99b7047430$var$connectRefinementList;



function $80521d29983009f9$export$5da5a5848a7e380(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $b6cfcd99b7047430$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}





var $iBfRJ = parcelRequire("iBfRJ");


var $5cbfcd84b73f3239$var$_excluded = [
    "canRefine",
    "items",
    "onRefine",
    "query",
    "searchBox",
    "noResults",
    "showMore",
    "canToggleShowMore",
    "onToggleShowMore",
    "isShowingMore",
    "className",
    "classNames",
    "translations"
];
function $5cbfcd84b73f3239$var$_extends() {
    $5cbfcd84b73f3239$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cbfcd84b73f3239$var$_extends.apply(this, arguments);
}
function $5cbfcd84b73f3239$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5cbfcd84b73f3239$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5cbfcd84b73f3239$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5cbfcd84b73f3239$export$40832886fec19653(_ref) {
    var canRefine = _ref.canRefine, items = _ref.items, onRefine = _ref.onRefine, query = _ref.query, searchBox = _ref.searchBox, noResults = _ref.noResults, showMore = _ref.showMore, canToggleShowMore = _ref.canToggleShowMore, onToggleShowMore = _ref.onToggleShowMore, isShowingMore = _ref.isShowingMore, className = _ref.className, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, translations = _ref.translations, props = $5cbfcd84b73f3239$var$_objectWithoutProperties(_ref, $5cbfcd84b73f3239$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $5cbfcd84b73f3239$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList", classNames.root, items.length === 0 && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList--noRefinement", classNames.noRefinementRoot), className)
    }), searchBox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-searchBox", classNames.searchBox)
    }, searchBox), noResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-noResults", classNames.noResults)
    }, noResults) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("ul", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-list", classNames.list)
    }, items.map(function(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("li", {
            key: item.value,
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-item", classNames.item, item.isRefined && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-item--selected", classNames.selectedItem))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("label", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-label", classNames.label)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("input", {
            checked: item.isRefined,
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-checkbox", classNames.checkbox),
            type: "checkbox",
            value: item.value,
            onChange: function onChange() {
                onRefine(item);
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-labelText", classNames.labelText)
        }, query.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $a9ca3b45604e2248$export$39dbc3f558091353), {
            parts: [
                (0, $d236013a390b8d22$export$e04d28e65b830ebf)((0, $e902f020b2c9d54e$export$e8bacd2802a88316)(item.highlighted || ""))
            ]
        }) : item.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-count", classNames.count)
        }, item.count)));
    })), showMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $f3e31dd936e9d1e1$export$e41c325c8b11c297), {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-showMore", classNames.showMore, !canToggleShowMore && (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-RefinementList-showMore--disabled", classNames.disabledShowMore)),
        disabled: !canToggleShowMore,
        onClick: onToggleShowMore,
        isShowingMore: isShowingMore,
        translations: translations
    }));
}




var $iBfRJ = parcelRequire("iBfRJ");
var $cf7f7c609cd89896$var$_excluded = [
    "formRef",
    "inputRef",
    "isSearchStalled",
    "onChange",
    "onReset",
    "onSubmit",
    "placeholder",
    "value",
    "autoFocus",
    "resetIconComponent",
    "submitIconComponent",
    "loadingIconComponent",
    "classNames",
    "translations"
];
function $cf7f7c609cd89896$var$_extends() {
    $cf7f7c609cd89896$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf7f7c609cd89896$var$_extends.apply(this, arguments);
}
function $cf7f7c609cd89896$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf7f7c609cd89896$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf7f7c609cd89896$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cf7f7c609cd89896$var$_ref2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
function $cf7f7c609cd89896$var$DefaultSubmitIcon(_ref) {
    var classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("svg", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-submitIcon", classNames.submitIcon),
        width: "10",
        height: "10",
        viewBox: "0 0 40 40",
        "aria-hidden": "true"
    }, $cf7f7c609cd89896$var$_ref2);
}
var $cf7f7c609cd89896$var$_ref4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
function $cf7f7c609cd89896$var$DefaultResetIcon(_ref3) {
    var classNames = _ref3.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("svg", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-resetIcon", classNames.resetIcon),
        viewBox: "0 0 20 20",
        width: "10",
        height: "10",
        "aria-hidden": "true"
    }, $cf7f7c609cd89896$var$_ref4);
}
var $cf7f7c609cd89896$var$_ref6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("g", {
    fill: "none",
    fillRule: "evenodd"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("circle", {
    strokeOpacity: ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
function $cf7f7c609cd89896$var$DefaultLoadingIcon(_ref5) {
    var classNames = _ref5.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("svg", {
        "aria-label": "Results are loading",
        width: "16",
        height: "16",
        viewBox: "0 0 38 38",
        stroke: "#444",
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-loadingIcon", classNames.loadingIcon),
        "aria-hidden": "true"
    }, $cf7f7c609cd89896$var$_ref6);
}
function $cf7f7c609cd89896$export$5a58787633b0b5d8(_ref7) {
    var formRef = _ref7.formRef, inputRef = _ref7.inputRef, isSearchStalled = _ref7.isSearchStalled, onChange = _ref7.onChange, onReset = _ref7.onReset, onSubmit = _ref7.onSubmit, _ref7$placeholder = _ref7.placeholder, placeholder = _ref7$placeholder === void 0 ? "" : _ref7$placeholder, value = _ref7.value, autoFocus = _ref7.autoFocus, _ref7$resetIconCompon = _ref7.resetIconComponent, ResetIcon = _ref7$resetIconCompon === void 0 ? $cf7f7c609cd89896$var$DefaultResetIcon : _ref7$resetIconCompon, _ref7$submitIconCompo = _ref7.submitIconComponent, SubmitIcon = _ref7$submitIconCompo === void 0 ? $cf7f7c609cd89896$var$DefaultSubmitIcon : _ref7$submitIconCompo, _ref7$loadingIconComp = _ref7.loadingIconComponent, LoadingIcon = _ref7$loadingIconComp === void 0 ? $cf7f7c609cd89896$var$DefaultLoadingIcon : _ref7$loadingIconComp, _ref7$classNames = _ref7.classNames, classNames = _ref7$classNames === void 0 ? {} : _ref7$classNames, translations = _ref7.translations, props = $cf7f7c609cd89896$var$_objectWithoutProperties(_ref7, $cf7f7c609cd89896$var$_excluded);
    function handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (onSubmit) onSubmit(event);
        if (inputRef.current) inputRef.current.blur();
    }
    function handleReset(event) {
        event.preventDefault();
        event.stopPropagation();
        onReset(event);
        if (inputRef.current) inputRef.current.focus();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $cf7f7c609cd89896$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox", classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("form", {
        ref: formRef,
        action: "",
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-form", classNames.form),
        noValidate: true,
        onSubmit: handleSubmit,
        onReset: handleReset,
        role: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("input", {
        ref: inputRef,
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-input", classNames.input),
        "aria-label": "Search",
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        placeholder: placeholder,
        spellCheck: false,
        maxLength: 512,
        type: "search",
        value: value,
        onChange: onChange,
        onCompositionEnd: onChange,
        autoFocus: autoFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("button", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-submit", classNames.submit),
        type: "submit",
        title: translations.submitButtonTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement(SubmitIcon, {
        classNames: classNames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("button", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-reset", classNames.reset),
        type: "reset",
        title: translations.resetButtonTitle,
        hidden: value.length === 0 || isSearchStalled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement(ResetIcon, {
        classNames: classNames
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SearchBox-loadingIndicator", classNames.loadingIndicator),
        hidden: !isSearchStalled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement(LoadingIcon, {
        classNames: classNames
    }))));
}


function $db58d555791b27cb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $db58d555791b27cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $db58d555791b27cb$var$_typeof(o);
}
var $db58d555791b27cb$var$_excluded = [
    "searchable",
    "searchablePlaceholder",
    "attribute",
    "operator",
    "limit",
    "showMore",
    "showMoreLimit",
    "sortBy",
    "escapeFacetValues",
    "transformItems",
    "translations"
];
function $db58d555791b27cb$var$_extends() {
    $db58d555791b27cb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $db58d555791b27cb$var$_extends.apply(this, arguments);
}
function $db58d555791b27cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $db58d555791b27cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $db58d555791b27cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $db58d555791b27cb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $db58d555791b27cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $db58d555791b27cb$var$_defineProperty(obj, key, value) {
    key = $db58d555791b27cb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $db58d555791b27cb$var$_toPropertyKey(t) {
    var i = $db58d555791b27cb$var$_toPrimitive(t, "string");
    return "symbol" == $db58d555791b27cb$var$_typeof(i) ? i : String(i);
}
function $db58d555791b27cb$var$_toPrimitive(t, r) {
    if ("object" != $db58d555791b27cb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $db58d555791b27cb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $db58d555791b27cb$var$_slicedToArray(arr, i) {
    return $db58d555791b27cb$var$_arrayWithHoles(arr) || $db58d555791b27cb$var$_iterableToArrayLimit(arr, i) || $db58d555791b27cb$var$_unsupportedIterableToArray(arr, i) || $db58d555791b27cb$var$_nonIterableRest();
}
function $db58d555791b27cb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $db58d555791b27cb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $db58d555791b27cb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $db58d555791b27cb$var$_arrayLikeToArray(o, minLen);
}
function $db58d555791b27cb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $db58d555791b27cb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $db58d555791b27cb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $db58d555791b27cb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $db58d555791b27cb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $db58d555791b27cb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $db58d555791b27cb$export$40832886fec19653(_ref) {
    var searchable = _ref.searchable, searchablePlaceholder = _ref.searchablePlaceholder, attribute = _ref.attribute, operator = _ref.operator, limit = _ref.limit, showMore = _ref.showMore, showMoreLimit = _ref.showMoreLimit, sortBy = _ref.sortBy, escapeFacetValues = _ref.escapeFacetValues, transformItems = _ref.transformItems, translations = _ref.translations, props = $db58d555791b27cb$var$_objectWithoutProperties(_ref, $db58d555791b27cb$var$_excluded);
    var _useRefinementList = (0, $80521d29983009f9$export$5da5a5848a7e380)({
        attribute: attribute,
        operator: operator,
        limit: limit,
        showMore: showMore,
        showMoreLimit: showMoreLimit,
        sortBy: sortBy,
        escapeFacetValues: escapeFacetValues,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.refinementList"
    }), canRefine = _useRefinementList.canRefine, canToggleShowMore = _useRefinementList.canToggleShowMore, isFromSearch = _useRefinementList.isFromSearch, isShowingMore = _useRefinementList.isShowingMore, items = _useRefinementList.items, refine = _useRefinementList.refine, searchForItems = _useRefinementList.searchForItems, toggleShowMore = _useRefinementList.toggleShowMore;
    var _useState = (0, $iBfRJ.useState)(""), _useState2 = $db58d555791b27cb$var$_slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var inputRef = (0, $iBfRJ.useRef)(null);
    function setQuery(newQuery) {
        var compositionComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setInputValue(newQuery);
        if (compositionComplete) searchForItems(newQuery);
    }
    function onRefine(item) {
        refine(item.value);
        setQuery("");
    }
    function onChange(event) {
        var compositionComplete = event.type === "compositionend" || !event.nativeEvent.isComposing;
        setQuery(event.currentTarget.value, compositionComplete);
    }
    function onReset() {
        setQuery("");
    }
    function onSubmit() {
        if (items.length > 0) {
            refine(items[0].value);
            setQuery("");
        }
    }
    var mergedTranslations = $db58d555791b27cb$var$_objectSpread({
        resetButtonTitle: "Clear the search query",
        submitButtonTitle: "Submit the search query",
        noResultsText: "No results.",
        showMoreButtonText: function showMoreButtonText(options) {
            return options.isShowingMore ? "Show less" : "Show more";
        }
    }, translations);
    var uiProps = {
        items: items,
        canRefine: canRefine,
        onRefine: onRefine,
        query: inputValue,
        searchBox: searchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $cf7f7c609cd89896$export$5a58787633b0b5d8), {
            inputRef: inputRef,
            placeholder: searchablePlaceholder,
            isSearchStalled: false,
            value: inputValue,
            onChange: onChange,
            onReset: onReset,
            onSubmit: onSubmit,
            translations: {
                submitButtonTitle: mergedTranslations.submitButtonTitle,
                resetButtonTitle: mergedTranslations.resetButtonTitle
            }
        }),
        noResults: searchable && isFromSearch && items.length === 0 && mergedTranslations.noResultsText,
        canToggleShowMore: canToggleShowMore,
        onToggleShowMore: toggleShowMore,
        isShowingMore: isShowingMore,
        translations: {
            showMoreButtonText: mergedTranslations.showMoreButtonText
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $5cbfcd84b73f3239$export$40832886fec19653), $db58d555791b27cb$var$_extends({}, props, uiProps, {
        showMore: showMore
    }));
}


var $iBfRJ = parcelRequire("iBfRJ");

function $3a0903f7f75d285b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a0903f7f75d285b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a0903f7f75d285b$var$_typeof(o);
}
function $3a0903f7f75d285b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a0903f7f75d285b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a0903f7f75d285b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3a0903f7f75d285b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a0903f7f75d285b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a0903f7f75d285b$var$_defineProperty(obj, key, value) {
    key = $3a0903f7f75d285b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a0903f7f75d285b$var$_toPropertyKey(t) {
    var i = $3a0903f7f75d285b$var$_toPrimitive(t, "string");
    return "symbol" == $3a0903f7f75d285b$var$_typeof(i) ? i : String(i);
}
function $3a0903f7f75d285b$var$_toPrimitive(t, r) {
    if ("object" != $3a0903f7f75d285b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3a0903f7f75d285b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3a0903f7f75d285b$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "search-box",
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $3a0903f7f75d285b$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $3a0903f7f75d285b$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $3a0903f7f75d285b$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $3a0903f7f75d285b$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: "ais.searchBox",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($3a0903f7f75d285b$var$_objectSpread($3a0903f7f75d285b$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($3a0903f7f75d285b$var$_objectSpread($3a0903f7f75d285b$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter("query", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $3a0903f7f75d285b$var$_objectSpread($3a0903f7f75d285b$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery("").search();
                    };
                }
                return {
                    query: state.query || "",
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === "stalled"
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || "";
                if (query === "" || uiState && uiState.query === query) return uiState;
                return $3a0903f7f75d285b$var$_objectSpread($3a0903f7f75d285b$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("query", uiState.query || "");
            }
        };
    };
};
var $3a0903f7f75d285b$export$2e2bcd8739ae039 = $3a0903f7f75d285b$var$connectSearchBox;



function $f372e3b4c42a6d57$export$34d981d965dcc5b5(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $3a0903f7f75d285b$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}



function $3bb497c502460291$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3bb497c502460291$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3bb497c502460291$var$_typeof(o);
}
var $3bb497c502460291$var$_excluded = [
    "queryHook",
    "searchAsYouType",
    "ignoreCompositionEvents",
    "translations"
];
function $3bb497c502460291$var$_extends() {
    $3bb497c502460291$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3bb497c502460291$var$_extends.apply(this, arguments);
}
function $3bb497c502460291$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bb497c502460291$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bb497c502460291$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3bb497c502460291$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bb497c502460291$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3bb497c502460291$var$_defineProperty(obj, key, value) {
    key = $3bb497c502460291$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3bb497c502460291$var$_toPropertyKey(t) {
    var i = $3bb497c502460291$var$_toPrimitive(t, "string");
    return "symbol" == $3bb497c502460291$var$_typeof(i) ? i : String(i);
}
function $3bb497c502460291$var$_toPrimitive(t, r) {
    if ("object" != $3bb497c502460291$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3bb497c502460291$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3bb497c502460291$var$_slicedToArray(arr, i) {
    return $3bb497c502460291$var$_arrayWithHoles(arr) || $3bb497c502460291$var$_iterableToArrayLimit(arr, i) || $3bb497c502460291$var$_unsupportedIterableToArray(arr, i) || $3bb497c502460291$var$_nonIterableRest();
}
function $3bb497c502460291$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3bb497c502460291$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3bb497c502460291$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3bb497c502460291$var$_arrayLikeToArray(o, minLen);
}
function $3bb497c502460291$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3bb497c502460291$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3bb497c502460291$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3bb497c502460291$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3bb497c502460291$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3bb497c502460291$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3bb497c502460291$export$5a58787633b0b5d8(_ref) {
    var queryHook = _ref.queryHook, _ref$searchAsYouType = _ref.searchAsYouType, searchAsYouType = _ref$searchAsYouType === void 0 ? true : _ref$searchAsYouType, _ref$ignoreCompositio = _ref.ignoreCompositionEvents, ignoreCompositionEvents = _ref$ignoreCompositio === void 0 ? false : _ref$ignoreCompositio, translations = _ref.translations, props = $3bb497c502460291$var$_objectWithoutProperties(_ref, $3bb497c502460291$var$_excluded);
    var _useSearchBox = (0, $f372e3b4c42a6d57$export$34d981d965dcc5b5)({
        queryHook: queryHook
    }, {
        $$widgetType: "ais.searchBox"
    }), query = _useSearchBox.query, refine = _useSearchBox.refine, isSearchStalled = _useSearchBox.isSearchStalled;
    var _useState = (0, $iBfRJ.useState)(query), _useState2 = $3bb497c502460291$var$_slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var inputRef = (0, $iBfRJ.useRef)(null);
    function setQuery(newQuery) {
        var isComposing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setInputValue(newQuery);
        if (searchAsYouType && !(ignoreCompositionEvents && isComposing)) refine(newQuery);
    }
    function onReset() {
        setQuery("");
        if (!searchAsYouType) refine("");
    }
    function onChange(event) {
        setQuery(event.currentTarget.value, event.nativeEvent.isComposing);
    }
    function onSubmit(event) {
        if (!searchAsYouType) refine(inputValue);
        if (props.onSubmit) props.onSubmit(event);
    }
    // Track when the InstantSearch query changes to synchronize it with
    // the React state.
    // We bypass the state update if the input is focused to avoid concurrent
    // updates when typing.
    if (query !== inputValue && document.activeElement !== inputRef.current) setInputValue(query);
    var uiProps = {
        inputRef: inputRef,
        isSearchStalled: isSearchStalled,
        onChange: onChange,
        onReset: onReset,
        onSubmit: onSubmit,
        value: inputValue,
        translations: $3bb497c502460291$var$_objectSpread({
            submitButtonTitle: "Submit the search query",
            resetButtonTitle: "Clear the search query"
        }, translations)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $cf7f7c609cd89896$export$5a58787633b0b5d8), $3bb497c502460291$var$_extends({}, props, uiProps));
}



var $iBfRJ = parcelRequire("iBfRJ");


var $iBfRJ = parcelRequire("iBfRJ");

var $9acb909fce567ce5$var$_excluded = [
    "classNames"
];
function $9acb909fce567ce5$var$_extends() {
    $9acb909fce567ce5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9acb909fce567ce5$var$_extends.apply(this, arguments);
}
function $9acb909fce567ce5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9acb909fce567ce5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9acb909fce567ce5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9acb909fce567ce5$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $9acb909fce567ce5$var$_objectWithoutProperties(_ref, $9acb909fce567ce5$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $bf5a14b51a7a7e72$export$57a0c6fc80bec05c), $9acb909fce567ce5$var$_extends({
        classNames: {
            root: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Snippet", classNames.root),
            highlighted: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Snippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-Snippet-separator", classNames.separator)
        }
    }, props));
}


var $67c8738e88386d71$var$_excluded = [
    "hit",
    "attribute",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator"
];
function $67c8738e88386d71$var$_extends() {
    $67c8738e88386d71$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67c8738e88386d71$var$_extends.apply(this, arguments);
}
function $67c8738e88386d71$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $67c8738e88386d71$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $67c8738e88386d71$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $67c8738e88386d71$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, highlightedTagName = _ref.highlightedTagName, nonHighlightedTagName = _ref.nonHighlightedTagName, separator = _ref.separator, props = $67c8738e88386d71$var$_objectWithoutProperties(_ref, $67c8738e88386d71$var$_excluded);
    var property = (0, $59eb1e95b9e5c884$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = Array.isArray(property) ? property : [
        property
    ];
    var parts = properties.map(function(singleValue) {
        return (0, $d236013a390b8d22$export$e04d28e65b830ebf)((0, $e902f020b2c9d54e$export$e8bacd2802a88316)(singleValue.value || ""));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $9acb909fce567ce5$export$10c56fa12fda26f9), $67c8738e88386d71$var$_extends({}, props, {
        parts: parts,
        highlightedTagName: highlightedTagName,
        nonHighlightedTagName: nonHighlightedTagName,
        separator: separator
    }));
}


var $iBfRJ = parcelRequire("iBfRJ");

function $3b7e8078324714a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b7e8078324714a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b7e8078324714a0$var$_typeof(o);
}
function $3b7e8078324714a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b7e8078324714a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b7e8078324714a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3b7e8078324714a0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b7e8078324714a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3b7e8078324714a0$var$_defineProperty(obj, key, value) {
    key = $3b7e8078324714a0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b7e8078324714a0$var$_toPropertyKey(t) {
    var i = $3b7e8078324714a0$var$_toPrimitive(t, "string");
    return "symbol" == $3b7e8078324714a0$var$_typeof(i) ? i : String(i);
}
function $3b7e8078324714a0$var$_toPrimitive(t, r) {
    if ("object" != $3b7e8078324714a0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3b7e8078324714a0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3b7e8078324714a0$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "sort-by",
    connector: true
});
/**
 * The **SortBy** connector provides the logic to build a custom widget that will display a
 * list of indices. With Algolia, this is most commonly used for changing ranking strategy. This allows
 * a user to change how the hits are being sorted.
 */ var $3b7e8078324714a0$var$connectSortBy = function connectSortBy(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $3b7e8078324714a0$var$withUsage());
    var connectorState = {};
    return function(widgetParams) {
        var _ref = widgetParams || {}, items = _ref.items, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(x) {
            return x;
        } : _ref$transformItems;
        if (!Array.isArray(items)) throw new Error($3b7e8078324714a0$var$withUsage("The `items` option expects an array of objects."));
        return {
            $$type: "ais.sortBy",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                var widgetRenderState = this.getWidgetRenderState(initOptions);
                var currentIndex = widgetRenderState.currentRefinement;
                var isCurrentIndexInItems = (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(items, function(item) {
                    return item.value === currentIndex;
                });
                renderFn($3b7e8078324714a0$var$_objectSpread($3b7e8078324714a0$var$_objectSpread({}, widgetRenderState), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($3b7e8078324714a0$var$_objectSpread($3b7e8078324714a0$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return connectorState.initialIndex ? state.setIndex(connectorState.initialIndex) : state;
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $3b7e8078324714a0$var$_objectSpread($3b7e8078324714a0$var$_objectSpread({}, renderState), {}, {
                    sortBy: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var results = _ref3.results, helper = _ref3.helper, state = _ref3.state, parent = _ref3.parent;
                if (!connectorState.initialIndex && parent) connectorState.initialIndex = parent.getIndexName();
                if (!connectorState.setIndex) connectorState.setIndex = function(indexName) {
                    helper.setIndex(indexName).search();
                };
                var hasNoResults = results ? results.nbHits === 0 : true;
                return {
                    currentRefinement: state.index,
                    options: transformItems(items, {
                        results: results
                    }),
                    refine: connectorState.setIndex,
                    hasNoResults: hasNoResults,
                    canRefine: !hasNoResults && items.length > 0,
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var currentIndex = searchParameters.index;
                return $3b7e8078324714a0$var$_objectSpread($3b7e8078324714a0$var$_objectSpread({}, uiState), {}, {
                    sortBy: currentIndex !== connectorState.initialIndex ? currentIndex : undefined
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("index", uiState.sortBy || connectorState.initialIndex || searchParameters.index);
            }
        };
    };
};
var $3b7e8078324714a0$export$2e2bcd8739ae039 = $3b7e8078324714a0$var$connectSortBy;



function $883ec573b77b137b$export$769dcabd4dad14b5(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $3b7e8078324714a0$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}




var $iBfRJ = parcelRequire("iBfRJ");
var $efb0b9f53e092e9b$var$_excluded = [
    "items",
    "value",
    "onChange",
    "classNames"
];
function $efb0b9f53e092e9b$var$_extends() {
    $efb0b9f53e092e9b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efb0b9f53e092e9b$var$_extends.apply(this, arguments);
}
function $efb0b9f53e092e9b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $efb0b9f53e092e9b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $efb0b9f53e092e9b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $efb0b9f53e092e9b$export$eb2ca1350bb61eb0(_ref) {
    var items = _ref.items, value = _ref.value, _ref$onChange = _ref.onChange, _onChange = _ref$onChange === void 0 ? function() {} : _ref$onChange, _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $efb0b9f53e092e9b$var$_objectWithoutProperties(_ref, $efb0b9f53e092e9b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $efb0b9f53e092e9b$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SortBy", classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("select", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SortBy-select", classNames.select),
        onChange: function onChange(event) {
            return _onChange(event.target.value);
        },
        value: value,
        "aria-label": "Sort results by"
    }, items.map(function(item) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("option", {
            className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-SortBy-option", classNames.option),
            key: item.value,
            value: item.value
        }, item.label);
    })));
}


var $78276a1234af39b4$var$_excluded = [
    "items",
    "transformItems"
];
function $78276a1234af39b4$var$_extends() {
    $78276a1234af39b4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $78276a1234af39b4$var$_extends.apply(this, arguments);
}
function $78276a1234af39b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $78276a1234af39b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $78276a1234af39b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $78276a1234af39b4$export$eb2ca1350bb61eb0(_ref) {
    var items = _ref.items, transformItems = _ref.transformItems, props = $78276a1234af39b4$var$_objectWithoutProperties(_ref, $78276a1234af39b4$var$_excluded);
    var _useSortBy = (0, $883ec573b77b137b$export$769dcabd4dad14b5)({
        items: items,
        transformItems: transformItems
    }, {
        $$widgetType: "ais.sortBy"
    }), currentRefinement = _useSortBy.currentRefinement, options = _useSortBy.options, refine = _useSortBy.refine;
    var uiProps = {
        items: options,
        value: currentRefinement,
        onChange: refine
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $efb0b9f53e092e9b$export$eb2ca1350bb61eb0), $78276a1234af39b4$var$_extends({}, props, uiProps));
}


var $iBfRJ = parcelRequire("iBfRJ");
function $b8de26a8b26fca93$export$ad628980c7383a99(value) {
    if (typeof value === "string") return value.replace(/^\\-/, "-");
    return value;
}
function $b8de26a8b26fca93$export$40415fcf01f0c9e8(value) {
    if (typeof value === "number" && value < 0 || typeof value === "string") return String(value).replace(/^-/, "\\-");
    return value;
}

function $e0a7a9517979e1ff$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}


function $ff586c8bd12b706d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ff586c8bd12b706d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ff586c8bd12b706d$var$_typeof(o);
}
function $ff586c8bd12b706d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff586c8bd12b706d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff586c8bd12b706d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ff586c8bd12b706d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff586c8bd12b706d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ff586c8bd12b706d$var$_defineProperty(obj, key, value) {
    key = $ff586c8bd12b706d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ff586c8bd12b706d$var$_toPropertyKey(t) {
    var i = $ff586c8bd12b706d$var$_toPrimitive(t, "string");
    return "symbol" == $ff586c8bd12b706d$var$_typeof(i) ? i : String(i);
}
function $ff586c8bd12b706d$var$_toPrimitive(t, r) {
    if ("object" != $ff586c8bd12b706d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ff586c8bd12b706d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ff586c8bd12b706d$var$_slicedToArray(arr, i) {
    return $ff586c8bd12b706d$var$_arrayWithHoles(arr) || $ff586c8bd12b706d$var$_iterableToArrayLimit(arr, i) || $ff586c8bd12b706d$var$_unsupportedIterableToArray(arr, i) || $ff586c8bd12b706d$var$_nonIterableRest();
}
function $ff586c8bd12b706d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff586c8bd12b706d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ff586c8bd12b706d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ff586c8bd12b706d$var$_arrayLikeToArray(o, minLen);
}
function $ff586c8bd12b706d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ff586c8bd12b706d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ff586c8bd12b706d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ff586c8bd12b706d$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "toggle-refinement",
    connector: true
});
var $ff586c8bd12b706d$var$$$type = "ais.toggleRefinement";
var $ff586c8bd12b706d$var$createSendEvent = function createSendEvent(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attribute = _ref.attribute, on = _ref.on;
    var sendEventForToggle = function sendEventForToggle() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1) {
            instantSearchInstance.sendEventToInsights(args[0]);
            return;
        }
        var isRefined = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $ff586c8bd12b706d$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        if (eventType !== "click" || on === undefined) return;
        // only send an event when the refinement gets applied,
        // not when it gets removed
        if (!isRefined) {
            var _helper$lastResults;
            instantSearchInstance.sendEventToInsights({
                insightsMethod: "clickedFilters",
                widgetType: $ff586c8bd12b706d$var$$$type,
                eventType: eventType,
                eventModifier: eventModifier,
                payload: {
                    eventName: eventName,
                    index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                    filters: on.map(function(value) {
                        return "".concat(attribute, ":").concat(value);
                    })
                },
                attribute: attribute
            });
        }
    };
    return sendEventForToggle;
};
/**
 * **Toggle** connector provides the logic to build a custom widget that will provide
 * an on/off filtering feature based on an attribute value or values.
 *
 * Two modes are implemented in the custom widget:
 *  - with or without the value filtered
 *  - switch between two values.
 */ var $ff586c8bd12b706d$var$connectToggleRefinement = function connectToggleRefinement(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $ff586c8bd12b706d$var$withUsage());
    return function(widgetParams) {
        var _ref2 = widgetParams || {}, attribute = _ref2.attribute, _ref2$on = _ref2.on, userOn = _ref2$on === void 0 ? true : _ref2$on, userOff = _ref2.off;
        if (!attribute) throw new Error($ff586c8bd12b706d$var$withUsage("The `attribute` option is required."));
        var hasAnOffValue = userOff !== undefined;
        // even though facet values can be numbers and boolean,
        // the helper methods only accept string in the type
        var on = (0, $e0a7a9517979e1ff$export$45b10814cc054894)(userOn).map((0, $b8de26a8b26fca93$export$40415fcf01f0c9e8));
        var off = hasAnOffValue ? (0, $e0a7a9517979e1ff$export$45b10814cc054894)(userOff).map((0, $b8de26a8b26fca93$export$40415fcf01f0c9e8)) : undefined;
        var sendEvent;
        var toggleRefinementFactory = function toggleRefinementFactory(helper) {
            return function() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isRefined: false
                }, isRefined = _ref3.isRefined;
                if (!isRefined) {
                    sendEvent("click:internal", isRefined);
                    if (hasAnOffValue) off.forEach(function(v) {
                        return helper.removeDisjunctiveFacetRefinement(attribute, v);
                    });
                    on.forEach(function(v) {
                        return helper.addDisjunctiveFacetRefinement(attribute, v);
                    });
                } else {
                    on.forEach(function(v) {
                        return helper.removeDisjunctiveFacetRefinement(attribute, v);
                    });
                    if (hasAnOffValue) off.forEach(function(v) {
                        return helper.addDisjunctiveFacetRefinement(attribute, v);
                    });
                }
                helper.search();
            };
        };
        var connectorState = {
            createURLFactory: function createURLFactory(isRefined, _ref4) {
                var state = _ref4.state, createURL = _ref4.createURL, getWidgetUiState = _ref4.getWidgetUiState, helper = _ref4.helper;
                return function() {
                    state = state.resetPage();
                    var valuesToRemove = isRefined ? on : off;
                    if (valuesToRemove) valuesToRemove.forEach(function(v) {
                        state = state.removeDisjunctiveFacetRefinement(attribute, v);
                    });
                    var valuesToAdd = isRefined ? off : on;
                    if (valuesToAdd) valuesToAdd.forEach(function(v) {
                        state = state.addDisjunctiveFacetRefinement(attribute, v);
                    });
                    return createURL(function(uiState) {
                        return getWidgetUiState(uiState, {
                            searchParameters: state,
                            helper: helper
                        });
                    });
                };
            }
        };
        return {
            $$type: $ff586c8bd12b706d$var$$$type,
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref5) {
                var state = _ref5.state;
                unmountFn();
                return state.removeDisjunctiveFacet(attribute);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, renderState), {}, {
                    toggleRefinement: $ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, renderState.toggleRefinement), {}, $ff586c8bd12b706d$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var state = _ref6.state, helper = _ref6.helper, results = _ref6.results, createURL = _ref6.createURL, instantSearchInstance = _ref6.instantSearchInstance;
                var isRefined = results ? on.every(function(v) {
                    return state.isDisjunctiveFacetRefined(attribute, v);
                }) : on.every(function(v) {
                    return state.isDisjunctiveFacetRefined(attribute, v);
                });
                var onFacetValue = {
                    isRefined: isRefined,
                    count: 0
                };
                var offFacetValue = {
                    isRefined: hasAnOffValue && !isRefined,
                    count: 0
                };
                if (results) {
                    var offValue = (0, $e0a7a9517979e1ff$export$45b10814cc054894)(off || false);
                    var allFacetValues = results.getFacetValues(attribute, {}) || [];
                    var onData = on.map(function(v) {
                        return (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(allFacetValues, function(_ref7) {
                            var escapedValue = _ref7.escapedValue;
                            return escapedValue === (0, $b8de26a8b26fca93$export$40415fcf01f0c9e8)(String(v));
                        });
                    }).filter(function(v) {
                        return v !== undefined;
                    });
                    var offData = hasAnOffValue ? offValue.map(function(v) {
                        return (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(allFacetValues, function(_ref8) {
                            var escapedValue = _ref8.escapedValue;
                            return escapedValue === (0, $b8de26a8b26fca93$export$40415fcf01f0c9e8)(String(v));
                        });
                    }).filter(function(v) {
                        return v !== undefined;
                    }) : [];
                    onFacetValue = {
                        isRefined: onData.length ? onData.every(function(v) {
                            return v.isRefined;
                        }) : false,
                        count: onData.reduce(function(acc, v) {
                            return acc + v.count;
                        }, 0) || null
                    };
                    offFacetValue = {
                        isRefined: offData.length ? offData.every(function(v) {
                            return v.isRefined;
                        }) : false,
                        count: offData.reduce(function(acc, v) {
                            return acc + v.count;
                        }, 0) || allFacetValues.reduce(function(total, _ref9) {
                            var count = _ref9.count;
                            return total + count;
                        }, 0)
                    };
                }
                if (!sendEvent) sendEvent = $ff586c8bd12b706d$var$createSendEvent({
                    instantSearchInstance: instantSearchInstance,
                    attribute: attribute,
                    on: on,
                    helper: helper
                });
                var nextRefinement = isRefined ? offFacetValue : onFacetValue;
                return {
                    value: {
                        name: attribute,
                        isRefined: isRefined,
                        count: results ? nextRefinement.count : null,
                        onFacetValue: onFacetValue,
                        offFacetValue: offFacetValue
                    },
                    createURL: connectorState.createURLFactory(isRefined, {
                        state: state,
                        createURL: createURL,
                        helper: helper,
                        getWidgetUiState: this.getWidgetUiState
                    }),
                    sendEvent: sendEvent,
                    canRefine: Boolean(results ? nextRefinement.count : null),
                    refine: toggleRefinementFactory(helper),
                    widgetParams: widgetParams
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref10) {
                var searchParameters = _ref10.searchParameters;
                var isRefined = on && on.every(function(v) {
                    return searchParameters.isDisjunctiveFacetRefined(attribute, v);
                });
                if (!isRefined) {
                    var _uiState$toggle;
                    // This needs to be done in the case `uiState` comes from `createURL`
                    (_uiState$toggle = uiState.toggle) === null || _uiState$toggle === void 0 || delete _uiState$toggle[attribute];
                    return uiState;
                }
                return $ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, uiState), {}, {
                    toggle: $ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, uiState.toggle), {}, $ff586c8bd12b706d$var$_defineProperty({}, attribute, isRefined))
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref11) {
                var uiState = _ref11.uiState;
                if (searchParameters.isHierarchicalFacet(attribute) || searchParameters.isConjunctiveFacet(attribute)) return searchParameters;
                var withFacetConfiguration = searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute);
                var isRefined = Boolean(uiState.toggle && uiState.toggle[attribute]);
                if (isRefined) {
                    if (on) on.forEach(function(v) {
                        withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v);
                    });
                    return withFacetConfiguration;
                }
                // It's not refined with an `off` value
                if (hasAnOffValue) {
                    if (off) off.forEach(function(v) {
                        withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v);
                    });
                    return withFacetConfiguration;
                }
                // It's not refined without an `off` value
                return withFacetConfiguration.setQueryParameters({
                    disjunctiveFacetsRefinements: $ff586c8bd12b706d$var$_objectSpread($ff586c8bd12b706d$var$_objectSpread({}, searchParameters.disjunctiveFacetsRefinements), {}, $ff586c8bd12b706d$var$_defineProperty({}, attribute, []))
                });
            }
        };
    };
};
var $ff586c8bd12b706d$export$2e2bcd8739ae039 = $ff586c8bd12b706d$var$connectToggleRefinement;



function $44a26be558c487ea$export$6a20aba25df252a6(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $ff586c8bd12b706d$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}




var $iBfRJ = parcelRequire("iBfRJ");
var $eca2edfc6d45c3fd$var$_excluded = [
    "classNames",
    "checked",
    "onChange",
    "label"
];
function $eca2edfc6d45c3fd$var$_extends() {
    $eca2edfc6d45c3fd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eca2edfc6d45c3fd$var$_extends.apply(this, arguments);
}
function $eca2edfc6d45c3fd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eca2edfc6d45c3fd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eca2edfc6d45c3fd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $eca2edfc6d45c3fd$export$36fa238829513e45(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, checked = _ref.checked, _onChange = _ref.onChange, label = _ref.label, props = $eca2edfc6d45c3fd$var$_objectWithoutProperties(_ref, $eca2edfc6d45c3fd$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("div", $eca2edfc6d45c3fd$var$_extends({}, props, {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-ToggleRefinement", classNames.root, props.className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("label", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-ToggleRefinement-label", classNames.label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("input", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-ToggleRefinement-checkbox", classNames.checkbox),
        type: "checkbox",
        checked: checked,
        onChange: function onChange(event) {
            _onChange(event.target.checked);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement("span", {
        className: (0, $cd33437cad6a0790$export$a274e22fb40f762e)("ais-ToggleRefinement-labelText", classNames.labelText)
    }, label)));
}


var $d3b4275317650d25$var$_excluded = [
    "attribute",
    "on",
    "off"
];
function $d3b4275317650d25$var$_extends() {
    $d3b4275317650d25$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3b4275317650d25$var$_extends.apply(this, arguments);
}
function $d3b4275317650d25$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d3b4275317650d25$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d3b4275317650d25$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d3b4275317650d25$export$36fa238829513e45(_ref) {
    var attribute = _ref.attribute, on = _ref.on, off = _ref.off, props = $d3b4275317650d25$var$_objectWithoutProperties(_ref, $d3b4275317650d25$var$_excluded);
    var _useToggleRefinement = (0, $44a26be558c487ea$export$6a20aba25df252a6)({
        attribute: attribute,
        on: on,
        off: off
    }, {
        $$widgetType: "ais.toggleRefinement"
    }), refine = _useToggleRefinement.refine, value = _useToggleRefinement.value;
    var uiProps = {
        checked: value.isRefined,
        onChange: function onChange(isChecked) {
            return refine({
                isRefined: !isChecked
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, $eca2edfc6d45c3fd$export$36fa238829513e45), $d3b4275317650d25$var$_extends({
        label: value.name
    }, props, uiProps));
}



parcelRequire("iBfRJ");
function $327ba17fc2883207$export$195b9afc167669b() {
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("a", {
        href: "https://algolia.com",
        "aria-label": "Go to the Algolia website",
        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 512 117",
            children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                fill: "#FFF",
                d: "M249.5 64.2V1.4c0-.9-.7-1.5-1.6-1.4L236.2 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.6-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7ZM443.5 24.4h-11.8c-.8 0-1.4.6-1.4 1.4v62c0 .8.6 1.4 1.4 1.4h11.8c.8 0 1.4-.6 1.4-1.4v-62c0-.8-.6-1.4-1.4-1.4ZM431.7 16.6h11.8c.8 0 1.4-.6 1.4-1.3v-14c0-.8-.7-1.4-1.6-1.3L431.5 2a1.4 1.4 0 0 0-1.2 1.3v12c0 .8.6 1.4 1.4 1.4Zm-20.5 47.6V1.4c0-.9-.7-1.5-1.5-1.4L397.9 2a1.4 1.4 0 0 0-1.2 1.3V67c0 3 0 21.6 22.4 22.3a1.4 1.4 0 0 0 1.5-1.4v-9.5c0-.7-.5-1.3-1.2-1.4-8.2-.9-8.2-11-8.2-12.7Zm-30.7-31c-2.6-2.8-5.8-5-9.6-6.5a31.7 31.7 0 0 0-12-2.3c-4.5 0-8.5.7-12.2 2.3A27.9 27.9 0 0 0 331 43.5a39.6 39.6 0 0 0 0 26.3c1.5 4 3.6 7.5 6.2 10.3 2.6 2.9 5.8 5 9.5 6.7a38 38 0 0 0 12.2 2.4c2.8 0 8.6-.9 12.3-2.4a27 27 0 0 0 9.5-6.7 35.1 35.1 0 0 0 8.3-23c0-4.9-.8-9.6-2.4-13.6-1.5-4-3.5-7.4-6.1-10.2ZM370 71.5a13.1 13.1 0 0 1-11.2 5.6 13 13 0 0 1-11.2-5.6c-2.7-3.6-4-7.9-4-14.2 0-6.3 1.3-11.5 4-15.1a13 13 0 0 1 11.1-5.5 13 13 0 0 1 11.3 5.5c2.6 3.6 4 8.8 4 15 0 6.4-1.3 10.6-4 14.3Zm-161.6-47H197a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.9 45.9 18.8 18.8 0 0 0 11.2 3.1H191.2l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13Zm0 48.3a17.8 17.8 0 0 1-10.4 3.5h-.2a12.5 12.5 0 0 1-.7 0A18.4 18.4 0 0 1 180.4 51c2.7-6.8 9-11.6 16.6-11.6h11.5v33.3Zm289-48.3H486a32 32 0 0 0-27 15 33.8 33.8 0 0 0 8.8 45.9 18.8 18.8 0 0 0 11.3 3.1h1.1l.6-.2h.2a21 21 0 0 0 16.5-14.6V87c0 .8.6 1.4 1.4 1.4h11.7c.8 0 1.4-.6 1.4-1.4V25.8c0-.8-.6-1.4-1.4-1.4h-13.1Zm0 48.3a17.8 17.8 0 0 1-10.5 3.5h-.9A18.4 18.4 0 0 1 469.4 51c2.6-6.8 9-11.6 16.6-11.6h11.5v33.3ZM306.3 24.4h-11.5a32 32 0 0 0-27 15 33.7 33.7 0 0 0-5.1 14.6 34.6 34.6 0 0 0 0 7.6c1 8.9 5.4 16.7 11.8 22a19.5 19.5 0 0 0 2.2 1.7 18.8 18.8 0 0 0 21.6-.6c3.8-2.7 6.7-6.7 8-11.1V87.9c0 5-1.3 8.9-4 11.5-2.7 2.6-7.3 3.9-13.6 3.9-2.6 0-6.7-.2-10.9-.6a1.4 1.4 0 0 0-1.4 1l-3 10a1.4 1.4 0 0 0 1.1 1.8c5 .7 10 1 12.8 1 11.4 0 19.8-2.4 25.3-7.4 5-4.6 7.8-11.4 8.2-20.7V25.8c0-.8-.6-1.4-1.3-1.4h-13.2Zm0 15s.2 32.4 0 33.4a17.5 17.5 0 0 1-10 3.4h-.2a13.6 13.6 0 0 1-1.7 0A18.7 18.7 0 0 1 278.3 51c2.6-6.8 9-11.6 16.5-11.6h11.5ZM58.2 0A58.3 58.3 0 1 0 86 109.5c.9-.5 1-1.6.3-2.2l-5.5-4.9a3.8 3.8 0 0 0-4-.6A47 47 0 0 1 11 57.5 47.3 47.3 0 0 1 58.2 11h47.3v84L78.7 71.2a2 2 0 0 0-3 .3 22 22 0 1 1 4.4-15.2 4 4 0 0 0 1.3 2.6l7 6.2c.8.7 2 .3 2.3-.8a33 33 0 0 0-30.4-39 33 33 0 0 0-35 32 33.3 33.3 0 0 0 32.2 33.9 32.8 32.8 0 0 0 20-6.3l35.1 31c1.5 1.4 3.9.3 3.9-1.7V2.2a2.2 2.2 0 0 0-2.2-2.2h-56Z"
            })
        })
    });
}



parcelRequire("iBfRJ");
/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @returns search parameters with refinements cleared
 */ function $442d0cd5a2106e7c$export$c8b9db57471d846b(_ref) {
    var helper = _ref.helper, _ref$attributesToClea = _ref.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
    var finalState = helper.state.setPage(0);
    finalState = attributesToClear.reduce(function(state, attribute) {
        if (finalState.isNumericRefined(attribute)) return state.removeNumericRefinement(attribute);
        if (finalState.isHierarchicalFacet(attribute)) return state.removeHierarchicalFacetRefinement(attribute);
        if (finalState.isDisjunctiveFacet(attribute)) return state.removeDisjunctiveFacetRefinement(attribute);
        if (finalState.isConjunctiveFacet(attribute)) return state.removeFacetRefinement(attribute);
        return state;
    }, finalState);
    if (attributesToClear.indexOf("query") !== -1) finalState = finalState.setQuery("");
    return finalState;
}



function $4d2b2941484f07ec$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $b8de26a8b26fca93$export$40415fcf01f0c9e8)(name)
    };
    var facet = (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === "hierarchical") {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $4d2b2941484f07ec$export$d9f33760e70a0a(_results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var results = _results || {};
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($4d2b2941484f07ec$var$getRefinement(state, "facet", attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: "exclude",
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($4d2b2941484f07ec$var$getRefinement(state, "disjunctive", attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $b8de26a8b26fca93$export$ad628980c7383a99)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($4d2b2941484f07ec$var$getRefinement(state, "hierarchical", attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: "numeric",
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: "tag",
            attribute: "_tags",
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: "query",
        type: "query",
        name: state.query,
        query: state.query
    });
    return refinements;
}


function $f400cd35efefac41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f400cd35efefac41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f400cd35efefac41$var$_typeof(o);
}
function $f400cd35efefac41$var$_toConsumableArray(arr) {
    return $f400cd35efefac41$var$_arrayWithoutHoles(arr) || $f400cd35efefac41$var$_iterableToArray(arr) || $f400cd35efefac41$var$_unsupportedIterableToArray(arr) || $f400cd35efefac41$var$_nonIterableSpread();
}
function $f400cd35efefac41$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f400cd35efefac41$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f400cd35efefac41$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f400cd35efefac41$var$_arrayLikeToArray(o, minLen);
}
function $f400cd35efefac41$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f400cd35efefac41$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f400cd35efefac41$var$_arrayLikeToArray(arr);
}
function $f400cd35efefac41$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f400cd35efefac41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f400cd35efefac41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f400cd35efefac41$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f400cd35efefac41$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f400cd35efefac41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f400cd35efefac41$var$_defineProperty(obj, key, value) {
    key = $f400cd35efefac41$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f400cd35efefac41$var$_toPropertyKey(t) {
    var i = $f400cd35efefac41$var$_toPrimitive(t, "string");
    return "symbol" == $f400cd35efefac41$var$_typeof(i) ? i : String(i);
}
function $f400cd35efefac41$var$_toPrimitive(t, r) {
    if ("object" != $f400cd35efefac41$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f400cd35efefac41$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f400cd35efefac41$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "clear-refinements",
    connector: true
});
var $f400cd35efefac41$var$connectClearRefinements = function connectClearRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $f400cd35efefac41$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$includedAttribut = _ref.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            "query"
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) throw new Error($f400cd35efefac41$var$withUsage("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
        var connectorState = {
            refine: (0, $381348598347b86b$export$8793edee2d425525),
            createURL: function createURL() {
                return "";
            },
            attributesToClear: []
        };
        var cachedRefine = function cachedRefine() {
            return connectorState.refine();
        };
        var cachedCreateURL = function cachedCreateURL() {
            return connectorState.createURL();
        };
        return {
            $$type: "ais.clearRefinements",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($f400cd35efefac41$var$_objectSpread($f400cd35efefac41$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($f400cd35efefac41$var$_objectSpread($f400cd35efefac41$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $f400cd35efefac41$var$_objectSpread($f400cd35efefac41$var$_objectSpread({}, renderState), {}, {
                    clearRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var createURL = _ref2.createURL, scopedResults = _ref2.scopedResults, results = _ref2.results;
                connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
                    return attributesToClear.concat($f400cd35efefac41$var$getAttributesToClear({
                        scopedResult: scopedResult,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        transformItems: transformItems,
                        results: results
                    }));
                }, []);
                connectorState.refine = function() {
                    connectorState.attributesToClear.forEach(function(_ref3) {
                        var indexHelper = _ref3.helper, items = _ref3.items;
                        indexHelper.setState((0, $442d0cd5a2106e7c$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        })).search();
                    });
                };
                connectorState.createURL = function() {
                    return createURL((0, $d3e5eacd65539fdb$export$8049d91f25899769).apply(void 0, $f400cd35efefac41$var$_toConsumableArray(connectorState.attributesToClear.map(function(_ref4) {
                        var indexHelper = _ref4.helper, items = _ref4.items;
                        return (0, $442d0cd5a2106e7c$export$c8b9db57471d846b)({
                            helper: indexHelper,
                            attributesToClear: items
                        });
                    }))));
                };
                var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
                    return attributeToClear.items.length > 0;
                });
                return {
                    canRefine: canRefine,
                    hasRefinements: canRefine,
                    refine: cachedRefine,
                    createURL: cachedCreateURL,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $f400cd35efefac41$var$getAttributesToClear(_ref5) {
    var scopedResult = _ref5.scopedResult, includedAttributes = _ref5.includedAttributes, excludedAttributes = _ref5.excludedAttributes, transformItems = _ref5.transformItems, results = _ref5.results;
    var includesQuery = includedAttributes.indexOf("query") !== -1 || excludedAttributes.indexOf("query") === -1;
    return {
        helper: scopedResult.helper,
        items: transformItems((0, $ce34b0eef3172c93$export$f70730c3d1fc524e)((0, $4d2b2941484f07ec$export$d9f33760e70a0a)(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
            return refinement.attribute;
        }).filter(function(attribute) {
            return(// If the array is empty (default case), we keep all the attributes
            includedAttributes.length === 0 || // Otherwise, only add the specified attributes
            includedAttributes.indexOf(attribute) !== -1);
        }).filter(function(attribute) {
            return(// If the query is included, we ignore the default `excludedAttributes = ['query']`
            attribute === "query" && includesQuery || // Otherwise, ignore the excluded attributes
            excludedAttributes.indexOf(attribute) === -1);
        })), {
            results: results
        })
    };
}
var $f400cd35efefac41$export$2e2bcd8739ae039 = $f400cd35efefac41$var$connectClearRefinements;



function $f651970fb6db34a2$export$60a47f8af66e226a(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $f400cd35efefac41$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}


function $a9c95fb5f6cc4b1b$export$974caec19ec0f86c() {
    const { refine: refine, canRefine: canRefine } = (0, $f651970fb6db34a2$export$60a47f8af66e226a)();
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
        className: "ais-ClearRefinements",
        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("button", {
            className: `ais-ClearRefinements-button ${!canRefine ? "ais-ClearRefinements-button--disabled" : ""}`,
            disabled: !canRefine,
            type: "button",
            onClick: refine,
            children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
                className: "clear-filters",
                children: [
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "11",
                        height: "11",
                        viewBox: "0 0 11 11",
                        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("g", {
                            fill: "none",
                            fillRule: "evenodd",
                            children: [
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                    d: "M0 0h11v11H0z"
                                }),
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                    fill: "#000",
                                    fillRule: "nonzero",
                                    d: "M8.26 2.75a3.896 3.896 0 1 0 1.102 3.262l.007-.056a.49.49 0 0 1 .485-.456c.253 0 .451.206.437.457 0 0 .012-.109-.006.061a4.813 4.813 0 1 1-1.348-3.887v-.987a.458.458 0 1 1 .917.002v2.062a.459.459 0 0 1-.459.459H7.334a.458.458 0 1 1-.002-.917h.928z"
                                })
                            ]
                        })
                    }),
                    "Clear filters"
                ]
            })
        })
    });
}



parcelRequire("iBfRJ");

function $ea2a8dbccb57b811$export$9c81ee90e4f7ab4e({ containerRef: containerRef }) {
    const { refine: refine } = (0, $f651970fb6db34a2$export$60a47f8af66e226a)();
    function onClick() {
        refine();
        document.body.classList.remove("filtering");
        containerRef.current.scrollIntoView();
    }
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
        className: "ais-ClearRefinements",
        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("button", {
            className: "ais-ClearRefinements-button",
            onClick: onClick,
            children: "Reset filters"
        })
    });
}



parcelRequire("iBfRJ");

var $iBfRJ = parcelRequire("iBfRJ");




var $iBfRJ = parcelRequire("iBfRJ");



function $671811b99faf6981$var$_slicedToArray(arr, i) {
    return $671811b99faf6981$var$_arrayWithHoles(arr) || $671811b99faf6981$var$_iterableToArrayLimit(arr, i) || $671811b99faf6981$var$_unsupportedIterableToArray(arr, i) || $671811b99faf6981$var$_nonIterableRest();
}
function $671811b99faf6981$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $671811b99faf6981$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $671811b99faf6981$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $671811b99faf6981$var$_arrayLikeToArray(o, minLen);
}
function $671811b99faf6981$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $671811b99faf6981$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $671811b99faf6981$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $671811b99faf6981$export$deb5cc6ef1318024() {
    var search = (0, $8cb92a462d64f7c5$export$607655cdd66d2a68)();
    var searchIndex = (0, $a823d82a9a3d8872$export$78be30f1ffebe6ed)();
    var _useState = (0, $iBfRJ.useState)(function() {
        var indexSearchResults = (0, $b4c049c58339bf47$export$cb51f617c98f90d3)(searchIndex);
        // We do this not to leak `recommendResults` in the API.
        return {
            results: indexSearchResults.results,
            scopedResults: indexSearchResults.scopedResults
        };
    }), _useState2 = $671811b99faf6981$var$_slicedToArray(_useState, 2), searchResults = _useState2[0], setSearchResults = _useState2[1];
    (0, $iBfRJ.useEffect)(function() {
        function handleRender() {
            var results = searchIndex.getResults();
            // Results can be `null` when the first search is stalled.
            // In this case, we skip the update.
            // See: https://github.com/algolia/instantsearch/blob/20996c7a159988c58e00ff24d2d2dc98af8b980f/src/widgets/index/index.ts#L652-L657
            if (results !== null) setSearchResults({
                results: results,
                scopedResults: searchIndex.getScopedResults()
            });
            else if (search.mainIndex.getIndexName().length === 0) {
                // If the main index has no name, we get the scoped results from
                // the first child index instead.
                var childIndex = search.mainIndex.getWidgets().find((0, $c738370bbc5dbd5d$export$a9c9a0d43506297d));
                childIndex && setSearchResults({
                    results: (0, $b4c049c58339bf47$export$cb51f617c98f90d3)(searchIndex).results,
                    scopedResults: childIndex.getScopedResults()
                });
            }
        }
        search.addListener("render", handleRender);
        // Force setting results to mitigate potential race conditions where
        // render listener is added after search results have been returned.
        // This edge case is currently not covered by the tests.
        handleRender();
        return function() {
            search.removeListener("render", handleRender);
        };
    }, [
        search,
        searchIndex
    ]);
    return searchResults;
}



var $iBfRJ = parcelRequire("iBfRJ");


function $c661b655f9be81ec$var$_slicedToArray(arr, i) {
    return $c661b655f9be81ec$var$_arrayWithHoles(arr) || $c661b655f9be81ec$var$_iterableToArrayLimit(arr, i) || $c661b655f9be81ec$var$_unsupportedIterableToArray(arr, i) || $c661b655f9be81ec$var$_nonIterableRest();
}
function $c661b655f9be81ec$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c661b655f9be81ec$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c661b655f9be81ec$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c661b655f9be81ec$var$_arrayLikeToArray(o, minLen);
}
function $c661b655f9be81ec$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c661b655f9be81ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c661b655f9be81ec$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c661b655f9be81ec$export$5fd14fa624074d55() {
    var search = (0, $8cb92a462d64f7c5$export$607655cdd66d2a68)();
    var searchIndex = (0, $a823d82a9a3d8872$export$78be30f1ffebe6ed)();
    var indexId = searchIndex.getIndexId();
    var _useState = (0, $iBfRJ.useState)(function() {
        return search.getUiState();
    }), _useState2 = $c661b655f9be81ec$var$_slicedToArray(_useState, 2), uiState = _useState2[0], setLocalUiState = _useState2[1];
    var indexUiState = uiState[indexId];
    var _useState3 = (0, $iBfRJ.useState)(function() {
        return search.renderState;
    }), _useState4 = $c661b655f9be81ec$var$_slicedToArray(_useState3, 2), renderState = _useState4[0], setRenderState = _useState4[1];
    var indexRenderState = renderState[indexId] || {};
    var setUiState = (0, $iBfRJ.useCallback)(function(nextUiState) {
        search.setUiState(nextUiState);
    }, [
        search
    ]);
    var setIndexUiState = (0, $iBfRJ.useCallback)(function(nextIndexUiState) {
        searchIndex.setIndexUiState(nextIndexUiState);
    }, [
        searchIndex
    ]);
    (0, $iBfRJ.useEffect)(function() {
        function handleRender() {
            setLocalUiState(search.getUiState());
            setRenderState(search.renderState);
        }
        search.addListener("render", handleRender);
        // Force setting state to mitigate potential race conditions where
        // render listener is added after search results have been returned.
        // This edge case is currently not covered by the tests.
        handleRender();
        return function() {
            search.removeListener("render", handleRender);
        };
    }, [
        search
    ]);
    return {
        uiState: uiState,
        setUiState: setUiState,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        renderState: renderState,
        indexRenderState: indexRenderState
    };
}


function $d1f4ce777f0c30e4$export$c3584afb06ed387d() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, catchError = _ref.catchError;
    var search = (0, $8cb92a462d64f7c5$export$607655cdd66d2a68)();
    var _useSearchState = (0, $c661b655f9be81ec$export$5fd14fa624074d55)(), uiState = _useSearchState.uiState, setUiState = _useSearchState.setUiState, indexUiState = _useSearchState.indexUiState, setIndexUiState = _useSearchState.setIndexUiState, renderState = _useSearchState.renderState, indexRenderState = _useSearchState.indexRenderState;
    var _useSearchResults = (0, $671811b99faf6981$export$deb5cc6ef1318024)(), results = _useSearchResults.results, scopedResults = _useSearchResults.scopedResults;
    var addMiddlewares = (0, $iBfRJ.useCallback)(function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
        search.use.apply(search, middlewares);
        return function() {
            search.unuse.apply(search, middlewares);
        };
    }, [
        search
    ]);
    var refresh = (0, $iBfRJ.useCallback)(function() {
        search.refresh();
    }, [
        search
    ]);
    (0, $18e6891184dde8a2$export$700979bc83e7db82)(function() {
        if (catchError) {
            var onError = function onError() {};
            search.addListener("error", onError);
            return function() {
                return search.removeListener("error", onError);
            };
        }
        return function() {};
    }, [
        search,
        catchError
    ]);
    return {
        results: results,
        scopedResults: scopedResults,
        uiState: uiState,
        setUiState: setUiState,
        indexUiState: indexUiState,
        setIndexUiState: setIndexUiState,
        renderState: renderState,
        indexRenderState: indexRenderState,
        addMiddlewares: addMiddlewares,
        refresh: refresh,
        status: search.status,
        error: search.error
    };
}



function $62d8e645220997bc$export$ef6006467f04ee41() {
    const { results: results } = (0, $d1f4ce777f0c30e4$export$c3584afb06ed387d)();
    const hasRefinements = results.getRefinements().length > 0;
    const description = hasRefinements ? "Try to reset your applied filters." : "Please try another query.";
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
        className: "hits-empty-state",
        children: [
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                xmlnsXlink: "http://www.w3.org/1999/xlink",
                width: "138",
                height: "138",
                className: "hits-empty-state-image",
                children: [
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("linearGradient", {
                                id: "c",
                                x1: "50%",
                                x2: "50%",
                                y1: "100%",
                                y2: "0%",
                                children: [
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: "#F5F5FA"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: "#FFF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                id: "b",
                                d: "M68.71 114.25a45.54 45.54 0 1 1 0-91.08 45.54 45.54 0 0 1 0 91.08z"
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("filter", {
                                id: "a",
                                width: "140.6%",
                                height: "140.6%",
                                x: "-20.3%",
                                y: "-15.9%",
                                filterUnits: "objectBoundingBox",
                                children: [
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feOffset", {
                                        dy: "4",
                                        in: "SourceAlpha",
                                        result: "shadowOffsetOuter1"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feGaussianBlur", {
                                        in: "shadowOffsetOuter1",
                                        result: "shadowBlurOuter1",
                                        stdDeviation: "5.5"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feColorMatrix", {
                                        in: "shadowBlurOuter1",
                                        result: "shadowMatrixOuter1",
                                        values: "0 0 0 0 0.145098039 0 0 0 0 0.17254902 0 0 0 0 0.380392157 0 0 0 0.15 0"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feOffset", {
                                        dy: "2",
                                        in: "SourceAlpha",
                                        result: "shadowOffsetOuter2"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feGaussianBlur", {
                                        in: "shadowOffsetOuter2",
                                        result: "shadowBlurOuter2",
                                        stdDeviation: "1.5"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feColorMatrix", {
                                        in: "shadowBlurOuter2",
                                        result: "shadowMatrixOuter2",
                                        values: "0 0 0 0 0.364705882 0 0 0 0 0.392156863 0 0 0 0 0.580392157 0 0 0 0.2 0"
                                    }),
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("feMerge", {
                                        children: [
                                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feMergeNode", {
                                                in: "shadowMatrixOuter1"
                                            }),
                                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("feMergeNode", {
                                                in: "shadowMatrixOuter2"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("g", {
                        fill: "none",
                        fillRule: "evenodd",
                        children: [
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("circle", {
                                cx: "68.85",
                                cy: "68.85",
                                r: "68.85",
                                fill: "#5468FF",
                                opacity: ".07"
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("circle", {
                                cx: "68.85",
                                cy: "68.85",
                                r: "52.95",
                                fill: "#5468FF",
                                opacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("use", {
                                fill: "#000",
                                filter: "url(#a)",
                                xlinkHref: "#b"
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("use", {
                                fill: "url(#c)",
                                xlinkHref: "#b"
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                d: "M76.01 75.44c5-5 5.03-13.06.07-18.01a12.73 12.73 0 0 0-18 .07c-5 4.99-5.03 13.05-.07 18a12.73 12.73 0 0 0 18-.06zm2.5 2.5a16.28 16.28 0 0 1-23.02.09A16.29 16.29 0 0 1 55.57 55a16.28 16.28 0 0 1 23.03-.1 16.28 16.28 0 0 1-.08 23.04zm1.08-1.08l-2.15 2.16 8.6 8.6 2.16-2.15-8.6-8.6z",
                                fill: "#5369FF"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("p", {
                className: "hits-empty-state-title",
                children: "Sorry, we can't find any matches to your query!"
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("p", {
                className: "hits-empty-state-description",
                children: description
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $a9c95fb5f6cc4b1b$export$974caec19ec0f86c), {})
        ]
    });
}



parcelRequire("iBfRJ");

function $6a8dab31ffa172dc$export$2a19844878d7a6e0({ children: children, fallback: fallback }) {
    const { results: results } = (0, $d1f4ce777f0c30e4$export$c3584afb06ed387d)();
    // The `__isArtificial` flag makes sure to not display the No Results message
    // when no hits have been returned yet.
    if (!results.__isArtificial && results.nbHits === 0) return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)((0, $c8241f0b21c62924$exports.Fragment), {
        children: [
            fallback,
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                hidden: true,
                children: children
            })
        ]
    });
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $c8241f0b21c62924$exports.Fragment), {
        children: children
    });
}



parcelRequire("iBfRJ");
function $793ff4f3c101ca76$export$2ddb90ad54e5f587({ children: children, header: header, footer: footer }) {
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
        className: "ais-Panel",
        children: [
            header && /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                className: "ais-Panel-header",
                children: header
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                className: "ais-Panel-body",
                children: children
            }),
            footer && /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                className: "ais-Panel-footer",
                children: footer
            })
        ]
    });
}




var $iBfRJ = parcelRequire("iBfRJ");
var $5349ef9fd0cadec9$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $5349ef9fd0cadec9$var$__DEV__ = false;
var $5349ef9fd0cadec9$var$warning = function() {};
if ($5349ef9fd0cadec9$var$__DEV__) {
    var $5349ef9fd0cadec9$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $5349ef9fd0cadec9$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $5349ef9fd0cadec9$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$5349ef9fd0cadec9$exports = $5349ef9fd0cadec9$var$warning;



var $iBfRJ = parcelRequire("iBfRJ");
var $0bbfdc7f6e60285b$var$e10 = Math.sqrt(50), $0bbfdc7f6e60285b$var$e5 = Math.sqrt(10), $0bbfdc7f6e60285b$var$e2 = Math.sqrt(2);
function $0bbfdc7f6e60285b$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $0bbfdc7f6e60285b$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $0bbfdc7f6e60285b$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $0bbfdc7f6e60285b$var$e10 ? 10 : error >= $0bbfdc7f6e60285b$var$e5 ? 5 : error >= $0bbfdc7f6e60285b$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $0bbfdc7f6e60285b$var$e10 ? 10 : error >= $0bbfdc7f6e60285b$var$e5 ? 5 : error >= $0bbfdc7f6e60285b$var$e2 ? 2 : 1);
}
function $0bbfdc7f6e60285b$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $0bbfdc7f6e60285b$var$e10) step1 *= 10;
    else if (error >= $0bbfdc7f6e60285b$var$e5) step1 *= 5;
    else if (error >= $0bbfdc7f6e60285b$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $3c59e1098e5cd941$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3c59e1098e5cd941$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3c59e1098e5cd941$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3c59e1098e5cd941$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3c59e1098e5cd941$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3c59e1098e5cd941$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3c59e1098e5cd941$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3c59e1098e5cd941$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3c59e1098e5cd941$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3c59e1098e5cd941$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3c59e1098e5cd941$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c59e1098e5cd941$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3c59e1098e5cd941$var$_setPrototypeOf(subClass, superClass);
}
function $3c59e1098e5cd941$var$_getPrototypeOf(o) {
    $3c59e1098e5cd941$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3c59e1098e5cd941$var$_getPrototypeOf(o);
}
function $3c59e1098e5cd941$var$_setPrototypeOf(o, p) {
    $3c59e1098e5cd941$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c59e1098e5cd941$var$_setPrototypeOf(o, p);
}
function $3c59e1098e5cd941$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3c59e1098e5cd941$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3c59e1098e5cd941$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3c59e1098e5cd941$var$_assertThisInitialized(self);
}
function $3c59e1098e5cd941$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3c59e1098e5cd941$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3c59e1098e5cd941$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3c59e1098e5cd941$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3c59e1098e5cd941$var$_possibleConstructorReturn(this, result);
    };
}
function $3c59e1098e5cd941$var$_slicedToArray(arr, i) {
    return $3c59e1098e5cd941$var$_arrayWithHoles(arr) || $3c59e1098e5cd941$var$_iterableToArrayLimit(arr, i) || $3c59e1098e5cd941$var$_unsupportedIterableToArray(arr, i) || $3c59e1098e5cd941$var$_nonIterableRest();
}
function $3c59e1098e5cd941$var$_toConsumableArray(arr) {
    return $3c59e1098e5cd941$var$_arrayWithoutHoles(arr) || $3c59e1098e5cd941$var$_iterableToArray(arr) || $3c59e1098e5cd941$var$_unsupportedIterableToArray(arr) || $3c59e1098e5cd941$var$_nonIterableSpread();
}
function $3c59e1098e5cd941$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3c59e1098e5cd941$var$_arrayLikeToArray(arr);
}
function $3c59e1098e5cd941$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3c59e1098e5cd941$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3c59e1098e5cd941$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3c59e1098e5cd941$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3c59e1098e5cd941$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3c59e1098e5cd941$var$_arrayLikeToArray(o, minLen);
}
function $3c59e1098e5cd941$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3c59e1098e5cd941$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3c59e1098e5cd941$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $3c59e1098e5cd941$var$prfx = "react-compound-slider:";
function $3c59e1098e5cd941$var$getSortByVal() {
    var reversed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function sortByVal(a, b) {
        if (a.val > b.val) return reversed ? -1 : 1;
        if (b.val > a.val) return reversed ? 1 : -1;
        return 0;
    };
}
function $3c59e1098e5cd941$var$getUpdatedHandles(handles, updateKey, updateValue) {
    var reversed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var index = handles.findIndex(function(v) {
        return v.key === updateKey;
    });
    if (index !== -1) {
        var _handles$index = handles[index], key = _handles$index.key, val = _handles$index.val;
        if (val === updateValue) return handles;
        return [].concat($3c59e1098e5cd941$var$_toConsumableArray(handles.slice(0, index)), [
            {
                key: key,
                val: updateValue
            }
        ], $3c59e1098e5cd941$var$_toConsumableArray(handles.slice(index + 1))).sort($3c59e1098e5cd941$var$getSortByVal(reversed));
    }
    return handles;
}
function $3c59e1098e5cd941$var$getSliderDomain(slider, vertical) {
    if (!slider) return [
        0,
        0
    ];
    var s = slider.getBoundingClientRect();
    var d0 = vertical ? s.top : s.left;
    var d1 = vertical ? s.bottom : s.right;
    return [
        d0,
        d1
    ];
}
function $3c59e1098e5cd941$var$isNotValidTouch(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "" : _ref$type, touches = _ref.touches;
    return !touches || touches.length > 1 || type.toLowerCase() === "touchend" && touches.length > 0;
}
function $3c59e1098e5cd941$var$getTouchPosition(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $3c59e1098e5cd941$var$getHandles() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var reversed = arguments.length > 1 ? arguments[1] : undefined;
    var valueToStep = arguments.length > 2 ? arguments[2] : undefined;
    var warn = arguments.length > 3 ? arguments[3] : undefined;
    var changes = 0;
    var handles = values.map(function(x) {
        var val = valueToStep.getValue(x);
        if (x !== val) {
            changes += 1;
            (0, (/*@__PURE__*/$parcel$interopDefault($5349ef9fd0cadec9$exports)))(!warn, "".concat($3c59e1098e5cd941$var$prfx, " Invalid value encountered. Changing ").concat(x, " to ").concat(val, "."));
        }
        return val;
    }).map(function(val, i) {
        return {
            key: "$$-".concat(i),
            val: val
        };
    }).sort($3c59e1098e5cd941$var$getSortByVal(reversed));
    return {
        handles: handles,
        changes: changes
    };
}
// default mode
function $3c59e1098e5cd941$export$c5ea20539002ff76(_, next) {
    return next;
} // prevent duplicate values and crossing
function $3c59e1098e5cd941$export$83a6069c6ecf7b2d(curr, next) {
    for(var i = 0; i < curr.length; i++){
        if (curr[i].key !== next[i].key) return curr;
        if (next[i + 1] && next[i].val === next[i + 1].val) return curr;
    }
    return next;
} // pushable mode
function $3c59e1098e5cd941$export$6aa1b5580ef4932c(curr, next, step, reversed, getValue) {
    var indexForMovingHandle = -1;
    var handleMoveIsPositive = true;
    for(var i = 0; i < curr.length; i++){
        var c = curr[i];
        var n = next[i]; // make sure keys are in same order if not return curr
        if (!n || n.key !== c.key) return curr;
        else if (n.val !== c.val) {
            indexForMovingHandle = i;
            handleMoveIsPositive = n.val - c.val > 0;
        }
    } // nothing has changed (shouldn't happen but just in case).
    if (indexForMovingHandle === -1) return curr;
    else {
        var increment = handleMoveIsPositive ? step : -step;
        for(var _i = 0; _i < next.length; _i++){
            var n0 = next[_i];
            var n1 = next[_i + 1];
            if (n1 && n0.val === n1.val) {
                if (_i === indexForMovingHandle) {
                    var newStep = n1.val + increment;
                    if (getValue(newStep) === newStep) {
                        var clone = $3c59e1098e5cd941$var$getUpdatedHandles(next, n1.key, n1.val + increment, reversed);
                        var check = $3c59e1098e5cd941$export$6aa1b5580ef4932c(next, clone, step, reversed, getValue);
                        if (check === next) return curr;
                        else return check;
                    } else return curr;
                } else {
                    var _newStep = n0.val + increment;
                    if (getValue(_newStep) === _newStep) {
                        var _clone = $3c59e1098e5cd941$var$getUpdatedHandles(next, n0.key, n0.val + increment, reversed);
                        var _check = $3c59e1098e5cd941$export$6aa1b5580ef4932c(next, _clone, step, reversed, getValue);
                        if (_check === next) return curr;
                        else return _check;
                    } else return curr;
                }
            }
        }
    }
    return next;
}
function $3c59e1098e5cd941$var$callAll() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(e) {
        return fns.forEach(function(fn) {
            return fn && fn(e);
        });
    };
}
var $3c59e1098e5cd941$var$NOOP = function NOOP() {
    return {
        value: 0,
        percent: 0
    };
};
var $3c59e1098e5cd941$export$b57863d0ff6a6d2b = /*#__PURE__*/ function(_Component) {
    $3c59e1098e5cd941$var$_inherits(Rail, _Component);
    var _super = $3c59e1098e5cd941$var$_createSuper(Rail);
    function Rail() {
        var _this;
        $3c59e1098e5cd941$var$_classCallCheck(this, Rail);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.getRailProps = function() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props = _this.props, emitMouse = _this$props.emitMouse, emitTouch = _this$props.emitTouch;
            return $3c59e1098e5cd941$var$_objectSpread2($3c59e1098e5cd941$var$_objectSpread2({}, props), {}, {
                onMouseDown: $3c59e1098e5cd941$var$callAll(props && props.onMouseDown, emitMouse),
                onTouchStart: $3c59e1098e5cd941$var$callAll(props && props.onTouchStart, emitTouch)
            });
        };
        return _this;
    }
    $3c59e1098e5cd941$var$_createClass(Rail, [
        {
            key: "render",
            value: function render() {
                var getRailProps = this.getRailProps, _this$props2 = this.props, getEventData = _this$props2.getEventData, _this$props2$activeHa = _this$props2.activeHandleID, activeHandleID = _this$props2$activeHa === void 0 ? "" : _this$props2$activeHa, children = _this$props2.children;
                var renderedChildren = children({
                    getEventData: getEventData || $3c59e1098e5cd941$var$NOOP,
                    activeHandleID: activeHandleID,
                    getRailProps: getRailProps
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Children.only(renderedChildren);
            }
        }
    ]);
    return Rail;
}((0, $iBfRJ.Component));
var $3c59e1098e5cd941$export$e687473b8d6c8292 = /*#__PURE__*/ function(_Component) {
    $3c59e1098e5cd941$var$_inherits(Handles, _Component);
    var _super = $3c59e1098e5cd941$var$_createSuper(Handles);
    function Handles() {
        var _this;
        $3c59e1098e5cd941$var$_classCallCheck(this, Handles);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.autofocus = function(e) {
            if (e.target instanceof HTMLElement) e.target.focus();
        };
        _this.getHandleProps = function(id) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var _this$props = _this.props, emitKeyboard = _this$props.emitKeyboard, emitMouse = _this$props.emitMouse, emitTouch = _this$props.emitTouch;
            return $3c59e1098e5cd941$var$_objectSpread2($3c59e1098e5cd941$var$_objectSpread2({}, props), {}, {
                onKeyDown: $3c59e1098e5cd941$var$callAll(props && props.onKeyDown, function(e) {
                    return emitKeyboard && emitKeyboard(e, id);
                }),
                onMouseDown: $3c59e1098e5cd941$var$callAll(props && props.onMouseDown, _this.autofocus, function(e) {
                    return emitMouse && emitMouse(e, id);
                }),
                onTouchStart: $3c59e1098e5cd941$var$callAll(props && props.onTouchStart, function(e) {
                    return emitTouch && emitTouch(e, id);
                })
            });
        };
        return _this;
    }
    $3c59e1098e5cd941$var$_createClass(Handles, [
        {
            key: "render",
            value: function render() {
                var getHandleProps = this.getHandleProps, _this$props2 = this.props, _this$props2$activeHa = _this$props2.activeHandleID, activeHandleID = _this$props2$activeHa === void 0 ? "" : _this$props2$activeHa, children = _this$props2.children, _this$props2$handles = _this$props2.handles, handles = _this$props2$handles === void 0 ? [] : _this$props2$handles;
                var renderedChildren = children({
                    handles: handles,
                    activeHandleID: activeHandleID,
                    getHandleProps: getHandleProps
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Children.only(renderedChildren);
            }
        }
    ]);
    return Handles;
}((0, $iBfRJ.Component));
var $3c59e1098e5cd941$var$LinearScale = /*#__PURE__*/ function() {
    function LinearScale() {
        $3c59e1098e5cd941$var$_classCallCheck(this, LinearScale);
        this.interpolator = void 0;
        this.domain = [
            0,
            1
        ];
        this.range = [
            0,
            1
        ];
        this.domain = [
            0,
            1
        ];
        this.range = [
            0,
            1
        ];
        this.interpolator = null;
    }
    $3c59e1098e5cd941$var$_createClass(LinearScale, [
        {
            key: "createInterpolator",
            value: function createInterpolator(domain, range) {
                var _this = this;
                var d0 = domain[0];
                var d1 = domain[1];
                var r0 = range[0];
                var r1 = range[1];
                if (d1 < d0) return function(x) {
                    return _this.interpolateValue(r1, r0)(_this.deinterpolateValue(d1, d0)(x));
                };
                else return function(x) {
                    return _this.interpolateValue(r0, r1)(_this.deinterpolateValue(d0, d1)(x));
                };
            }
        },
        {
            key: "interpolateValue",
            value: function interpolateValue(a, b) {
                return a = +a, b -= a, function i(t) {
                    return a + b * t;
                };
            }
        },
        {
            key: "deinterpolateValue",
            value: function deinterpolateValue(a, b) {
                return (b -= a = +a) ? function(x) {
                    return (x - a) / b;
                } : function() {
                    return b;
                };
            }
        },
        {
            key: "rescale",
            value: function rescale() {
                this.interpolator = null;
                return this;
            }
        },
        {
            key: "getValue",
            value: function getValue(x) {
                var domain = this.domain, range = this.range;
                return (this.interpolator || (this.interpolator = this.createInterpolator(domain, range)))(+x);
            }
        },
        {
            key: "setDomain",
            value: function setDomain(val) {
                this.domain = [
                    val[0],
                    val[1]
                ];
                this.rescale();
                return this;
            }
        },
        {
            key: "getDomain",
            value: function getDomain() {
                return this.domain;
            }
        },
        {
            key: "setRange",
            value: function setRange(val) {
                this.range = [
                    val[0],
                    val[1]
                ];
                return this;
            }
        },
        {
            key: "getRange",
            value: function getRange() {
                return this.range;
            }
        },
        {
            key: "getTicks",
            value: function getTicks(count) {
                var d = this.domain;
                return (0, $0bbfdc7f6e60285b$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count ? count : 10);
            }
        }
    ]);
    return LinearScale;
}();
var $3c59e1098e5cd941$var$defaultGetEventData$1 = function defaultGetEventData() {
    return {
        value: 0,
        percent: 0
    };
};
var $3c59e1098e5cd941$export$27c7467594ef87bd = /*#__PURE__*/ function(_Component) {
    $3c59e1098e5cd941$var$_inherits(Ticks, _Component);
    var _super = $3c59e1098e5cd941$var$_createSuper(Ticks);
    function Ticks() {
        $3c59e1098e5cd941$var$_classCallCheck(this, Ticks);
        return _super.apply(this, arguments);
    }
    $3c59e1098e5cd941$var$_createClass(Ticks, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, values = _this$props.values, _this$props$scale = _this$props.scale, scale = _this$props$scale === void 0 ? new $3c59e1098e5cd941$var$LinearScale() : _this$props$scale, _this$props$count = _this$props.count, count = _this$props$count === void 0 ? 10 : _this$props$count, _this$props$getEventD = _this$props.getEventData, getEventData = _this$props$getEventD === void 0 ? $3c59e1098e5cd941$var$defaultGetEventData$1 : _this$props$getEventD, _this$props$activeHan = _this$props.activeHandleID, activeHandleID = _this$props$activeHan === void 0 ? "" : _this$props$activeHan;
                var ticks = (values ? values : scale.getTicks(count)).map(function(value) {
                    return {
                        id: "$$-".concat(value),
                        value: value,
                        percent: scale.getValue(value)
                    };
                });
                var renderedChildren = children({
                    getEventData: getEventData,
                    activeHandleID: activeHandleID,
                    ticks: ticks
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Children.only(renderedChildren);
            }
        }
    ]);
    return Ticks;
}((0, $iBfRJ.Component));
var $3c59e1098e5cd941$var$defaultGetEventData = function defaultGetEventData() {
    return {
        value: 0,
        percent: 0
    };
};
var $3c59e1098e5cd941$export$76e817a61dd78922 = /*#__PURE__*/ function(_Component) {
    $3c59e1098e5cd941$var$_inherits(Tracks, _Component);
    var _super = $3c59e1098e5cd941$var$_createSuper(Tracks);
    function Tracks() {
        var _this;
        $3c59e1098e5cd941$var$_classCallCheck(this, Tracks);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.getTrackProps = function(props) {
            var _this$props = _this.props, emitMouse = _this$props.emitMouse, emitTouch = _this$props.emitTouch;
            return $3c59e1098e5cd941$var$_objectSpread2($3c59e1098e5cd941$var$_objectSpread2({}, props || {}), {}, {
                onMouseDown: $3c59e1098e5cd941$var$callAll(props && props.onMouseDown, emitMouse),
                onTouchStart: $3c59e1098e5cd941$var$callAll(props && props.onTouchStart, emitTouch)
            });
        };
        return _this;
    }
    $3c59e1098e5cd941$var$_createClass(Tracks, [
        {
            key: "render",
            value: function render() {
                var getTrackProps = this.getTrackProps, _this$props2 = this.props, children = _this$props2.children, _this$props2$left = _this$props2.left, left = _this$props2$left === void 0 ? true : _this$props2$left, _this$props2$right = _this$props2.right, right = _this$props2$right === void 0 ? true : _this$props2$right, _this$props2$scale = _this$props2.scale, scale = _this$props2$scale === void 0 ? new $3c59e1098e5cd941$var$LinearScale() : _this$props2$scale, _this$props2$handles = _this$props2.handles, handles = _this$props2$handles === void 0 ? [] : _this$props2$handles, _this$props2$getEvent = _this$props2.getEventData, getEventData = _this$props2$getEvent === void 0 ? $3c59e1098e5cd941$var$defaultGetEventData : _this$props2$getEvent, _this$props2$activeHa = _this$props2.activeHandleID, activeHandleID = _this$props2$activeHa === void 0 ? "" : _this$props2$activeHa;
                var domain = scale.getDomain();
                var tracks = [];
                for(var i = 0; i < handles.length + 1; i++){
                    var source = handles[i - 1];
                    var target = handles[i];
                    if (i === 0 && left === true) source = {
                        id: "$",
                        value: domain[0],
                        percent: 0
                    };
                    else if (i === handles.length && right === true) target = {
                        id: "$",
                        value: domain[1],
                        percent: 100
                    };
                    if (source && target) tracks.push({
                        id: "".concat(source.id, "-").concat(target.id),
                        source: source,
                        target: target
                    });
                }
                var renderedChildren = children({
                    getEventData: getEventData,
                    activeHandleID: activeHandleID,
                    tracks: tracks,
                    getTrackProps: getTrackProps
                });
                return renderedChildren && (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Children.only(renderedChildren);
            }
        }
    ]);
    return Tracks;
}((0, $iBfRJ.Component));
function $3c59e1098e5cd941$var$clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
var $3c59e1098e5cd941$var$DiscreteScale = /*#__PURE__*/ $3c59e1098e5cd941$var$_createClass(function DiscreteScale() {
    var _this = this;
    $3c59e1098e5cd941$var$_classCallCheck(this, DiscreteScale);
    this.step = 1;
    this.domain = [
        0,
        1
    ];
    this.range = [
        0,
        1
    ];
    this.setDomain = function(val) {
        _this.domain = [
            val[0],
            val[1]
        ];
        return _this;
    };
    this.setRange = function(val) {
        _this.range = [
            val[0],
            val[1]
        ];
        return _this;
    };
    this.setStep = function(val) {
        _this.step = val;
        return _this;
    };
    this.getValue = function(x) {
        var _this$domain = $3c59e1098e5cd941$var$_slicedToArray(_this.domain, 2), d0 = _this$domain[0], d1 = _this$domain[1], _this$range = $3c59e1098e5cd941$var$_slicedToArray(_this.range, 2), r0 = _this$range[0], r1 = _this$range[1], step = _this.step;
        var p = ($3c59e1098e5cd941$var$clamp(x, d0, d1) - d0) / (d1 - d0);
        var b = step * Math.round(p * (r1 - r0) / step) + r0;
        return $3c59e1098e5cd941$var$clamp(b, r0 < r1 ? r0 : r1, r1 > r0 ? r1 : r0);
    };
});
var $3c59e1098e5cd941$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var $3c59e1098e5cd941$var$noop = function noop() {};
var $3c59e1098e5cd941$var$compare = function compare(b) {
    return function(m, d, i) {
        return m && b[i] === d;
    };
};
var $3c59e1098e5cd941$var$equal = function equal(a, b) {
    return a === b || a.length === b.length && a.reduce($3c59e1098e5cd941$var$compare(b), true);
};
var $3c59e1098e5cd941$var$isRCSComponent = function isRCSComponent(item) {
    if (!/*#__PURE__*/ (0, $iBfRJ.isValidElement)(item)) return false;
    var type = item.type;
    var name = type ? type.name : "";
    return name === $3c59e1098e5cd941$export$e687473b8d6c8292.name || name === $3c59e1098e5cd941$export$b57863d0ff6a6d2b.name || name === $3c59e1098e5cd941$export$27c7467594ef87bd.name || name === $3c59e1098e5cd941$export$76e817a61dd78922.name;
};
var $3c59e1098e5cd941$var$getNextValue = function getNextValue(curr, step, domain, reversed) {
    var newVal = reversed ? curr - step : curr + step;
    return reversed ? Math.max(domain[0], newVal) : Math.min(domain[1], newVal);
};
var $3c59e1098e5cd941$var$getPrevValue = function getPrevValue(curr, step, domain, reversed) {
    var newVal = reversed ? curr + step : curr - step;
    return reversed ? Math.min(domain[1], newVal) : Math.max(domain[0], newVal);
};
var $3c59e1098e5cd941$var$defaultDomain = [
    0,
    100
];
var $3c59e1098e5cd941$export$472062a354075cee = /*#__PURE__*/ function(_PureComponent) {
    $3c59e1098e5cd941$var$_inherits(Slider, _PureComponent);
    var _super = $3c59e1098e5cd941$var$_createSuper(Slider);
    function Slider() {
        var _this;
        $3c59e1098e5cd941$var$_classCallCheck(this, Slider);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            step: 0.1,
            values: [],
            domain: $3c59e1098e5cd941$var$defaultDomain,
            handles: [],
            reversed: false,
            activeHandleID: "",
            valueToPerc: null,
            valueToStep: null,
            pixelToStep: null
        };
        _this.slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createRef();
        _this.onKeyDown = function(e, handleID) {
            var validUpKeys = [
                "ArrowRight",
                "ArrowUp"
            ];
            var validDownKeys = [
                "ArrowDown",
                "ArrowLeft"
            ];
            var _assertThisInitialize = $3c59e1098e5cd941$var$_assertThisInitialized(_this), handles = _assertThisInitialize.state.handles, _assertThisInitialize2 = _assertThisInitialize.props, _assertThisInitialize3 = _assertThisInitialize2.step, step = _assertThisInitialize3 === void 0 ? 0.1 : _assertThisInitialize3, _assertThisInitialize4 = _assertThisInitialize2.reversed, reversed = _assertThisInitialize4 === void 0 ? false : _assertThisInitialize4, _assertThisInitialize5 = _assertThisInitialize2.vertical, vertical = _assertThisInitialize5 === void 0 ? false : _assertThisInitialize5, _assertThisInitialize6 = _assertThisInitialize2.domain, domain = _assertThisInitialize6 === void 0 ? [
                0,
                100
            ] : _assertThisInitialize6;
            var key = e.key || "".concat(e.keyCode);
            if (!validUpKeys.concat(validDownKeys).includes(key)) return;
            if (vertical) {
                var _ref = [
                    validDownKeys,
                    validUpKeys
                ];
                validUpKeys = _ref[0];
                validDownKeys = _ref[1];
            }
            e.stopPropagation && e.stopPropagation();
            e.preventDefault && e.preventDefault();
            var found = handles.find(function(value) {
                return value.key === handleID;
            });
            if (!found) return;
            var currVal = found.val;
            var newVal = currVal;
            if (validUpKeys.includes(key)) newVal = $3c59e1098e5cd941$var$getNextValue(currVal, step, domain, reversed);
            else if (validDownKeys.includes(key)) newVal = $3c59e1098e5cd941$var$getPrevValue(currVal, step, domain, reversed);
            var nextHandles = handles.map(function(v) {
                return v.key === handleID ? {
                    key: v.key,
                    val: newVal
                } : v;
            });
            _this.submitUpdate(nextHandles, true);
        };
        _this.onMouseDown = function(e, handleID) {
            _this.onStart(e, handleID, false);
        };
        _this.onTouchStart = function(e, handleID) {
            if ($3c59e1098e5cd941$var$isNotValidTouch(e)) return;
            _this.onStart(e, handleID, true);
        };
        _this.getEventData = function(e, isTouch) {
            var _assertThisInitialize7 = $3c59e1098e5cd941$var$_assertThisInitialized(_this), _assertThisInitialize8 = _assertThisInitialize7.state, pixelToStep = _assertThisInitialize8.pixelToStep, valueToPerc = _assertThisInitialize8.valueToPerc, vertical = _assertThisInitialize7.props.vertical; // double check the dimensions of the slider
            // @ts-ignore
            pixelToStep.setDomain($3c59e1098e5cd941$var$getSliderDomain(_this.slider.current, vertical));
            var value;
            if (isTouch && e instanceof TouchEvent) // @ts-ignore
            value = pixelToStep.getValue($3c59e1098e5cd941$var$getTouchPosition(vertical, e));
            else if (e instanceof MouseEvent) // @ts-ignore
            value = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
            return {
                value: value,
                // @ts-ignore
                percent: valueToPerc.getValue(value)
            };
        };
        _this.onMouseMove = function(e) {
            var _assertThisInitialize9 = $3c59e1098e5cd941$var$_assertThisInitialized(_this), _assertThisInitialize10 = _assertThisInitialize9.state, curr = _assertThisInitialize10.handles, pixelToStep = _assertThisInitialize10.pixelToStep, _assertThisInitialize11 = _assertThisInitialize10.activeHandleID, activeHandleID = _assertThisInitialize11 === void 0 ? "" : _assertThisInitialize11, _assertThisInitialize12 = _assertThisInitialize9.props, vertical = _assertThisInitialize12.vertical, _assertThisInitialize13 = _assertThisInitialize12.reversed, reversed = _assertThisInitialize13 === void 0 ? false : _assertThisInitialize13; // double check the dimensions of the slider
            // @ts-ignore
            pixelToStep.setDomain($3c59e1098e5cd941$var$getSliderDomain(_this.slider.current, vertical)); // find the closest value (aka step) to the event location
            // @ts-ignore
            var updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX); // generate a "candidate" set of values - a suggestion of what to do
            var nextHandles = $3c59e1098e5cd941$var$getUpdatedHandles(curr, activeHandleID, updateValue, reversed); // submit the candidate values
            _this.submitUpdate(nextHandles);
        };
        _this.onTouchMove = function(e) {
            var _assertThisInitialize14 = $3c59e1098e5cd941$var$_assertThisInitialized(_this), _assertThisInitialize15 = _assertThisInitialize14.state, curr = _assertThisInitialize15.handles, pixelToStep = _assertThisInitialize15.pixelToStep, activeHandleID = _assertThisInitialize15.activeHandleID, _assertThisInitialize16 = _assertThisInitialize14.props, vertical = _assertThisInitialize16.vertical, reversed = _assertThisInitialize16.reversed;
            if (pixelToStep === null || $3c59e1098e5cd941$var$isNotValidTouch(e)) return;
             // double check the dimensions of the slider
            // @ts-ignore
            pixelToStep.setDomain($3c59e1098e5cd941$var$getSliderDomain(_this.slider.current, vertical)); // find the closest value (aka step) to the event location
            // @ts-ignore
            var updateValue = pixelToStep.getValue($3c59e1098e5cd941$var$getTouchPosition(vertical, e)); // generate a "candidate" set of values - a suggestion of what to do
            var nextHandles = $3c59e1098e5cd941$var$getUpdatedHandles(curr, activeHandleID, updateValue, reversed); // submit the candidate values
            _this.submitUpdate(nextHandles);
        };
        _this.onMouseUp = function() {
            var _assertThisInitialize17 = $3c59e1098e5cd941$var$_assertThisInitialized(_this), _assertThisInitialize18 = _assertThisInitialize17.state, _assertThisInitialize19 = _assertThisInitialize18.handles, handles = _assertThisInitialize19 === void 0 ? [] : _assertThisInitialize19, activeHandleID = _assertThisInitialize18.activeHandleID, _assertThisInitialize20 = _assertThisInitialize17.props, _assertThisInitialize21 = _assertThisInitialize20.onChange, onChange = _assertThisInitialize21 === void 0 ? $3c59e1098e5cd941$var$noop : _assertThisInitialize21, _assertThisInitialize22 = _assertThisInitialize20.onSlideEnd, onSlideEnd = _assertThisInitialize22 === void 0 ? $3c59e1098e5cd941$var$noop : _assertThisInitialize22;
            onChange(handles.map(function(d) {
                return d.val;
            }));
            onSlideEnd(handles.map(function(d) {
                return d.val;
            }), {
                activeHandleID: activeHandleID
            });
            _this.setState({
                activeHandleID: ""
            });
            if ($3c59e1098e5cd941$var$isBrowser) {
                document.removeEventListener("mousemove", _this.onMouseMove);
                document.removeEventListener("mouseup", _this.onMouseUp);
            }
        };
        _this.onTouchEnd = function() {
            var _assertThisInitialize23 = $3c59e1098e5cd941$var$_assertThisInitialized(_this), _assertThisInitialize24 = _assertThisInitialize23.state, handles = _assertThisInitialize24.handles, activeHandleID = _assertThisInitialize24.activeHandleID, _assertThisInitialize25 = _assertThisInitialize23.props, _assertThisInitialize26 = _assertThisInitialize25.onChange, onChange = _assertThisInitialize26 === void 0 ? $3c59e1098e5cd941$var$noop : _assertThisInitialize26, _assertThisInitialize27 = _assertThisInitialize25.onSlideEnd, onSlideEnd = _assertThisInitialize27 === void 0 ? $3c59e1098e5cd941$var$noop : _assertThisInitialize27;
            onChange(handles.map(function(d) {
                return d.val;
            }));
            onSlideEnd(handles.map(function(d) {
                return d.val;
            }), {
                activeHandleID: activeHandleID
            });
            _this.setState({
                activeHandleID: ""
            });
            if ($3c59e1098e5cd941$var$isBrowser) {
                document.removeEventListener("touchmove", _this.onTouchMove);
                document.removeEventListener("touchend", _this.onTouchEnd);
            }
        };
        return _this;
    }
    $3c59e1098e5cd941$var$_createClass(Slider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pixelToStep = this.state.pixelToStep;
                var vertical = this.props.vertical; // @ts-ignore
                pixelToStep.setDomain($3c59e1098e5cd941$var$getSliderDomain(this.slider.current, vertical));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeListeners();
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners() {
                if ($3c59e1098e5cd941$var$isBrowser) {
                    document.removeEventListener("mousemove", this.onMouseMove);
                    document.removeEventListener("mouseup", this.onMouseUp);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "onStart",
            value: function onStart(e, handleID, isTouch) {
                var handles = this.state.handles, _this$props$onSlideSt = this.props.onSlideStart, onSlideStart = _this$props$onSlideSt === void 0 ? $3c59e1098e5cd941$var$noop : _this$props$onSlideSt;
                if (!isTouch) e.preventDefault && e.preventDefault();
                e.stopPropagation && e.stopPropagation();
                var found = handles.find(function(value) {
                    return value.key === handleID;
                });
                if (found) {
                    this.setState({
                        activeHandleID: handleID
                    });
                    onSlideStart(handles.map(function(d) {
                        return d.val;
                    }), {
                        activeHandleID: handleID
                    });
                    isTouch ? this.addTouchEvents() : this.addMouseEvents();
                } else {
                    this.setState({
                        activeHandleID: ""
                    });
                    this.handleRailAndTrackClicks(e, isTouch);
                }
            }
        },
        {
            key: "handleRailAndTrackClicks",
            value: function handleRailAndTrackClicks(e, isTouch) {
                var _this2 = this;
                var _this$state = this.state, curr = _this$state.handles, pixelToStep = _this$state.pixelToStep, _this$props = this.props, vertical = _this$props.vertical, _this$props$reversed = _this$props.reversed, reversed = _this$props$reversed === void 0 ? false : _this$props$reversed;
                var slider = this.slider; // double check the dimensions of the slider
                // @ts-ignore
                pixelToStep.setDomain($3c59e1098e5cd941$var$getSliderDomain(slider.current, vertical)); // find the closest value (aka step) to the event location
                var updateValue;
                if (isTouch) // @ts-ignore
                updateValue = pixelToStep.getValue($3c59e1098e5cd941$var$getTouchPosition(vertical, e));
                else // @ts-ignore
                updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
                 // find the closest handle key
                var updateKey = "";
                var minDiff = Infinity;
                for(var i = 0; i < curr.length; i++){
                    var _curr$i = curr[i], key = _curr$i.key, val = _curr$i.val;
                    var diff = Math.abs(val - updateValue);
                    if (diff < minDiff) {
                        updateKey = key;
                        minDiff = diff;
                    }
                } // generate a "candidate" set of values - a suggestion of what to do
                var nextHandles = $3c59e1098e5cd941$var$getUpdatedHandles(curr, updateKey, updateValue, reversed); // submit the candidate values
                this.setState({
                    activeHandleID: updateKey
                }, function() {
                    _this2.submitUpdate(nextHandles, true);
                    isTouch ? _this2.addTouchEvents() : _this2.addMouseEvents();
                });
            }
        },
        {
            key: "addMouseEvents",
            value: function addMouseEvents() {
                if ($3c59e1098e5cd941$var$isBrowser) {
                    document.addEventListener("mousemove", this.onMouseMove);
                    document.addEventListener("mouseup", this.onMouseUp);
                }
            }
        },
        {
            key: "addTouchEvents",
            value: function addTouchEvents() {
                if ($3c59e1098e5cd941$var$isBrowser) {
                    document.addEventListener("touchmove", this.onTouchMove);
                    document.addEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "submitUpdate",
            value: function submitUpdate(next) {
                var callOnChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var _this$props2 = this.props, _this$props2$mode = _this$props2.mode, mode = _this$props2$mode === void 0 ? 1 : _this$props2$mode, _this$props2$step = _this$props2.step, step = _this$props2$step === void 0 ? 0.1 : _this$props2$step, _this$props2$onUpdate = _this$props2.onUpdate, onUpdate = _this$props2$onUpdate === void 0 ? $3c59e1098e5cd941$var$noop : _this$props2$onUpdate, _this$props2$onChange = _this$props2.onChange, onChange = _this$props2$onChange === void 0 ? $3c59e1098e5cd941$var$noop : _this$props2$onChange, _this$props2$reversed = _this$props2.reversed, reversed = _this$props2$reversed === void 0 ? false : _this$props2$reversed; //@ts-ignore
                var getValue = this.state.valueToStep.getValue;
                this.setState(function(_ref2) {
                    var curr = _ref2.handles;
                    var handles = []; // given the current handles and a candidate set, decide what to do
                    if (typeof mode === "function") {
                        handles = mode(curr, next, step, reversed, getValue);
                        (0, (/*@__PURE__*/$parcel$interopDefault($5349ef9fd0cadec9$exports)))(Array.isArray(handles), "Custom mode function did not return an array.");
                    } else switch(mode){
                        case 1:
                            handles = $3c59e1098e5cd941$export$c5ea20539002ff76(curr, next);
                            break;
                        case 2:
                            handles = $3c59e1098e5cd941$export$83a6069c6ecf7b2d(curr, next);
                            break;
                        case 3:
                            handles = $3c59e1098e5cd941$export$6aa1b5580ef4932c(curr, next, step, reversed, getValue);
                            break;
                        default:
                            handles = next;
                            (0, (/*@__PURE__*/$parcel$interopDefault($5349ef9fd0cadec9$exports)))(false, "".concat($3c59e1098e5cd941$var$prfx, " Invalid mode value."));
                    }
                    onUpdate(handles.map(function(d) {
                        return d.val;
                    }));
                    if (callOnChange) onChange(handles.map(function(d) {
                        return d.val;
                    }));
                    return {
                        handles: handles
                    };
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$state2 = this.state, handles = _this$state2.handles, valueToPerc = _this$state2.valueToPerc, activeHandleID = _this$state2.activeHandleID, _this$props3 = this.props, className = _this$props3.className, _this$props3$rootStyl = _this$props3.rootStyle, rootStyle = _this$props3$rootStyl === void 0 ? {} : _this$props3$rootStyl, _this$props3$rootProp = _this$props3.rootProps, rootProps = _this$props3$rootProp === void 0 ? {} : _this$props3$rootProp, _this$props3$componen = _this$props3.component, Comp = _this$props3$componen === void 0 ? "div" : _this$props3$componen, _this$props3$disabled = _this$props3.disabled, disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled, _this$props3$flatten = _this$props3.flatten, flatten = _this$props3$flatten === void 0 ? false : _this$props3$flatten;
                var mappedHandles = handles.map(function(_ref3) {
                    var key = _ref3.key, val = _ref3.val;
                    // @ts-ignore
                    return {
                        id: key,
                        value: val,
                        percent: valueToPerc.getValue(val)
                    };
                });
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Children.map(this.props.children, function(child) {
                    if ($3c59e1098e5cd941$var$isRCSComponent(child) === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).cloneElement(child, {
                        scale: valueToPerc,
                        handles: mappedHandles,
                        activeHandleID: activeHandleID,
                        getEventData: _this3.getEventData,
                        emitKeyboard: disabled ? $3c59e1098e5cd941$var$noop : _this3.onKeyDown,
                        emitMouse: disabled ? $3c59e1098e5cd941$var$noop : _this3.onMouseDown,
                        emitTouch: disabled ? $3c59e1098e5cd941$var$noop : _this3.onTouchStart
                    });
                    else return child;
                });
                return flatten ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement(Comp, $3c59e1098e5cd941$var$_objectSpread2($3c59e1098e5cd941$var$_objectSpread2({}, rootProps), {}, {
                    style: rootStyle,
                    className: className,
                    ref: this.slider
                })), children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iBfRJ))).createElement(Comp, $3c59e1098e5cd941$var$_objectSpread2($3c59e1098e5cd941$var$_objectSpread2({}, rootProps), {}, {
                    style: rootStyle,
                    className: className,
                    ref: this.slider
                }), children));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var _nextProps$step = nextProps.step, step = _nextProps$step === void 0 ? 0.1 : _nextProps$step, values = nextProps.values, _nextProps$domain = nextProps.domain, domain = _nextProps$domain === void 0 ? $3c59e1098e5cd941$var$defaultDomain : _nextProps$domain, _nextProps$reversed = nextProps.reversed, reversed = _nextProps$reversed === void 0 ? false : _nextProps$reversed, _nextProps$onUpdate = nextProps.onUpdate, onUpdate = _nextProps$onUpdate === void 0 ? $3c59e1098e5cd941$var$noop : _nextProps$onUpdate, _nextProps$onChange = nextProps.onChange, onChange = _nextProps$onChange === void 0 ? $3c59e1098e5cd941$var$noop : _nextProps$onChange, _nextProps$warnOnChan = nextProps.warnOnChanges, warnOnChanges = _nextProps$warnOnChan === void 0 ? false : _nextProps$warnOnChan;
                var valueToPerc = prevState.valueToPerc;
                var valueToStep = prevState.valueToStep;
                var pixelToStep = prevState.pixelToStep;
                var nextState = {};
                if (!valueToPerc || !valueToStep || !pixelToStep) {
                    valueToPerc = new $3c59e1098e5cd941$var$LinearScale();
                    valueToStep = new $3c59e1098e5cd941$var$DiscreteScale();
                    pixelToStep = new $3c59e1098e5cd941$var$DiscreteScale();
                    nextState.valueToPerc = valueToPerc;
                    nextState.valueToStep = valueToStep;
                    nextState.pixelToStep = pixelToStep;
                }
                if (prevState.domain === $3c59e1098e5cd941$var$defaultDomain || prevState.step === null || prevState.domain === null || prevState.reversed === null || step !== prevState.step || domain[0] !== prevState.domain[0] || domain[1] !== prevState.domain[1] || reversed !== prevState.reversed) {
                    var _domain = $3c59e1098e5cd941$var$_slicedToArray(domain, 2), min = _domain[0], max = _domain[1];
                    valueToStep.setStep(step).setRange([
                        min,
                        max
                    ]).setDomain([
                        min,
                        max
                    ]);
                    if (reversed === true) {
                        valueToPerc.setDomain([
                            min,
                            max
                        ]).setRange([
                            100,
                            0
                        ]);
                        pixelToStep.setStep(step).setRange([
                            max,
                            min
                        ]);
                    } else {
                        valueToPerc.setDomain([
                            min,
                            max
                        ]).setRange([
                            0,
                            100
                        ]);
                        pixelToStep.setStep(step).setRange([
                            min,
                            max
                        ]);
                    }
                    (0, (/*@__PURE__*/$parcel$interopDefault($5349ef9fd0cadec9$exports)))(max > min, "".concat($3c59e1098e5cd941$var$prfx, " Max must be greater than min (even if reversed). Max is ").concat(max, ". Min is ").concat(min, "."));
                    var _getHandles = $3c59e1098e5cd941$var$getHandles(values || prevState.values, reversed, valueToStep, warnOnChanges), handles = _getHandles.handles, changes = _getHandles.changes;
                    if (changes || values === undefined || values === prevState.values) {
                        onUpdate(handles.map(function(d) {
                            return d.val;
                        }));
                        onChange(handles.map(function(d) {
                            return d.val;
                        }));
                    }
                    nextState.step = step;
                    nextState.values = values;
                    nextState.domain = domain === $3c59e1098e5cd941$var$defaultDomain ? $3c59e1098e5cd941$var$_toConsumableArray(domain) : domain;
                    nextState.handles = handles;
                    nextState.reversed = reversed;
                } else if (!$3c59e1098e5cd941$var$equal(values, prevState.values)) {
                    var _getHandles2 = $3c59e1098e5cd941$var$getHandles(values, reversed, valueToStep, warnOnChanges), _handles = _getHandles2.handles, _changes = _getHandles2.changes;
                    if (_changes) {
                        onUpdate(_handles.map(function(d) {
                            return d.val;
                        }));
                        onChange(_handles.map(function(d) {
                            return d.val;
                        }));
                    }
                    nextState.values = values;
                    nextState.handles = _handles;
                }
                if (Object.keys(nextState).length) return nextState;
                return null;
            }
        }
    ]);
    return Slider;
}((0, $iBfRJ.PureComponent));


// This is the `Number.isFinite()` polyfill recommended by MDN.
// We do not provide any tests for this function.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite#Polyfill
// @MAJOR Replace with the native `Number.isFinite` method
function $947adbb69e2c94cc$export$cf6c09818bd7035a(value) {
    return typeof value === "number" && isFinite(value);
}


function $3504c57495fb7262$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3504c57495fb7262$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3504c57495fb7262$var$_typeof(o);
}
function $3504c57495fb7262$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3504c57495fb7262$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3504c57495fb7262$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3504c57495fb7262$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3504c57495fb7262$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3504c57495fb7262$var$_defineProperty(obj, key, value) {
    key = $3504c57495fb7262$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3504c57495fb7262$var$_toPropertyKey(t) {
    var i = $3504c57495fb7262$var$_toPrimitive(t, "string");
    return "symbol" == $3504c57495fb7262$var$_typeof(i) ? i : String(i);
}
function $3504c57495fb7262$var$_toPrimitive(t, r) {
    if ("object" != $3504c57495fb7262$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3504c57495fb7262$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3504c57495fb7262$var$_slicedToArray(arr, i) {
    return $3504c57495fb7262$var$_arrayWithHoles(arr) || $3504c57495fb7262$var$_iterableToArrayLimit(arr, i) || $3504c57495fb7262$var$_unsupportedIterableToArray(arr, i) || $3504c57495fb7262$var$_nonIterableRest();
}
function $3504c57495fb7262$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3504c57495fb7262$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3504c57495fb7262$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3504c57495fb7262$var$_arrayLikeToArray(o, minLen);
}
function $3504c57495fb7262$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3504c57495fb7262$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3504c57495fb7262$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $3504c57495fb7262$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "range-input",
    connector: true
}, {
    name: "range-slider",
    connector: true
});
var $3504c57495fb7262$var$$$type = "ais.range";
// @MAJOR: potentially we should consolidate these types
function $3504c57495fb7262$var$toPrecision(_ref) {
    var min = _ref.min, max = _ref.max, precision = _ref.precision;
    var pow = Math.pow(10, precision);
    return {
        min: min ? Math.floor(min * pow) / pow : min,
        max: max ? Math.ceil(max * pow) / pow : max
    };
}
/**
 * **Range** connector provides the logic to create custom widget that will let
 * the user refine results using a numeric range.
 *
 * This connectors provides a `refine()` function that accepts bounds. It will also provide
 * information about the min and max bounds for the current result set.
 */ var $3504c57495fb7262$var$connectRange = function connectRange(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $3504c57495fb7262$var$withUsage());
    return function(widgetParams) {
        var _ref2 = widgetParams || {}, _ref2$attribute = _ref2.attribute, attribute = _ref2$attribute === void 0 ? "" : _ref2$attribute, minBound = _ref2.min, maxBound = _ref2.max, _ref2$precision = _ref2.precision, precision = _ref2$precision === void 0 ? 0 : _ref2$precision;
        if (!attribute) throw new Error($3504c57495fb7262$var$withUsage("The `attribute` option is required."));
        if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minBound) && (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxBound) && minBound > maxBound) throw new Error($3504c57495fb7262$var$withUsage("The `max` option can't be lower than `min`."));
        var formatToNumber = function formatToNumber(v) {
            return Number(Number(v).toFixed(precision));
        };
        var rangeFormatter = {
            from: function from(v) {
                return v.toLocaleString();
            },
            to: function to(v) {
                return formatToNumber(v).toLocaleString();
            }
        };
        // eslint-disable-next-line complexity
        var getRefinedState = function getRefinedState(helper, currentRange, nextMin, nextMax) {
            var resolvedState = helper.state;
            var currentRangeMin = currentRange.min, currentRangeMax = currentRange.max;
            var _ref3 = resolvedState.getNumericRefinement(attribute, ">=") || [], _ref4 = $3504c57495fb7262$var$_slicedToArray(_ref3, 1), min = _ref4[0];
            var _ref5 = resolvedState.getNumericRefinement(attribute, "<=") || [], _ref6 = $3504c57495fb7262$var$_slicedToArray(_ref5, 1), max = _ref6[0];
            var isResetMin = nextMin === undefined || nextMin === "";
            var isResetMax = nextMax === undefined || nextMax === "";
            var _toPrecision = $3504c57495fb7262$var$toPrecision({
                min: !isResetMin ? parseFloat(nextMin) : undefined,
                max: !isResetMax ? parseFloat(nextMax) : undefined,
                precision: precision
            }), nextMinAsNumber = _toPrecision.min, nextMaxAsNumber = _toPrecision.max;
            var newNextMin;
            if (!(0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minBound) && currentRangeMin === nextMinAsNumber) newNextMin = undefined;
            else if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minBound) && isResetMin) newNextMin = minBound;
            else newNextMin = nextMinAsNumber;
            var newNextMax;
            if (!(0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxBound) && currentRangeMax === nextMaxAsNumber) newNextMax = undefined;
            else if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxBound) && isResetMax) newNextMax = maxBound;
            else newNextMax = nextMaxAsNumber;
            var isResetNewNextMin = newNextMin === undefined;
            var isGreaterThanCurrentRange = (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(currentRangeMin) && currentRangeMin <= newNextMin;
            var isMinValid = isResetNewNextMin || (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(newNextMin) && (!(0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(currentRangeMin) || isGreaterThanCurrentRange);
            var isResetNewNextMax = newNextMax === undefined;
            var isLowerThanRange = (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(newNextMax) && currentRangeMax >= newNextMax;
            var isMaxValid = isResetNewNextMax || (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(newNextMax) && (!(0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(currentRangeMax) || isLowerThanRange);
            var hasMinChange = min !== newNextMin;
            var hasMaxChange = max !== newNextMax;
            if ((hasMinChange || hasMaxChange) && isMinValid && isMaxValid) {
                resolvedState = resolvedState.removeNumericRefinement(attribute);
                if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(newNextMin)) resolvedState = resolvedState.addNumericRefinement(attribute, ">=", newNextMin);
                if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(newNextMax)) resolvedState = resolvedState.addNumericRefinement(attribute, "<=", newNextMax);
                return resolvedState.resetPage();
            }
            return null;
        };
        var createSendEvent = function createSendEvent(instantSearchInstance) {
            return function() {
                if (arguments.length === 1) {
                    instantSearchInstance.sendEventToInsights(arguments.length <= 0 ? undefined : arguments[0]);
                    return;
                }
            };
        };
        function _getCurrentRange(stats) {
            var min;
            if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minBound)) min = minBound;
            else if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(stats.min)) min = stats.min;
            else min = 0;
            var max;
            if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxBound)) max = maxBound;
            else if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(stats.max)) max = stats.max;
            else max = 0;
            return $3504c57495fb7262$var$toPrecision({
                min: min,
                max: max,
                precision: precision
            });
        }
        function _getCurrentRefinement(helper) {
            var _ref7 = helper.getNumericRefinement(attribute, ">=") || [], _ref8 = $3504c57495fb7262$var$_slicedToArray(_ref7, 1), minValue = _ref8[0];
            var _ref9 = helper.getNumericRefinement(attribute, "<=") || [], _ref10 = $3504c57495fb7262$var$_slicedToArray(_ref9, 1), maxValue = _ref10[0];
            var min = (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minValue) ? minValue : -Infinity;
            var max = (0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxValue) ? maxValue : Infinity;
            return [
                min,
                max
            ];
        }
        function _refine(helper, currentRange) {
            return function() {
                var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                    undefined,
                    undefined
                ], _ref12 = $3504c57495fb7262$var$_slicedToArray(_ref11, 2), nextMin = _ref12[0], nextMax = _ref12[1];
                var refinedState = getRefinedState(helper, currentRange, nextMin, nextMax);
                if (refinedState) helper.setState(refinedState).search();
            };
        }
        return {
            $$type: $3504c57495fb7262$var$$$type,
            init: function init(initOptions) {
                renderFn($3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                renderFn($3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, renderState), {}, {
                    range: $3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, renderState.range), {}, $3504c57495fb7262$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref13) {
                var results = _ref13.results, helper = _ref13.helper, instantSearchInstance = _ref13.instantSearchInstance;
                var facetsFromResults = results && results.disjunctiveFacets || [];
                var facet = (0, $6e63ebe2fed4edda$export$71aa6c912b956294)(facetsFromResults, function(facetResult) {
                    return facetResult.name === attribute;
                });
                var stats = facet && facet.stats || {
                    min: undefined,
                    max: undefined
                };
                var currentRange = _getCurrentRange(stats);
                var start = _getCurrentRefinement(helper);
                var refine;
                if (!results) // On first render pass an empty range
                // to be able to bypass the validation
                // related to it
                refine = _refine(helper, {
                    min: undefined,
                    max: undefined
                });
                else refine = _refine(helper, currentRange);
                return {
                    refine: refine,
                    canRefine: currentRange.min !== currentRange.max,
                    format: rangeFormatter,
                    range: currentRange,
                    sendEvent: createSendEvent(instantSearchInstance),
                    widgetParams: $3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, widgetParams), {}, {
                        precision: precision
                    }),
                    start: start
                };
            },
            dispose: function dispose(_ref14) {
                var state = _ref14.state;
                unmountFn();
                return state.removeDisjunctiveFacet(attribute).removeNumericRefinement(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref15) {
                var searchParameters = _ref15.searchParameters;
                var _searchParameters$get = searchParameters.getNumericRefinements(attribute), _searchParameters$get2 = _searchParameters$get[">="], min = _searchParameters$get2 === void 0 ? [] : _searchParameters$get2, _searchParameters$get3 = _searchParameters$get["<="], max = _searchParameters$get3 === void 0 ? [] : _searchParameters$get3;
                if (min.length === 0 && max.length === 0) return uiState;
                return $3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, uiState), {}, {
                    range: $3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, uiState.range), {}, $3504c57495fb7262$var$_defineProperty({}, attribute, "".concat(min, ":").concat(max)))
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref16) {
                var uiState = _ref16.uiState;
                var widgetSearchParameters = searchParameters.addDisjunctiveFacet(attribute).setQueryParameters({
                    numericRefinements: $3504c57495fb7262$var$_objectSpread($3504c57495fb7262$var$_objectSpread({}, searchParameters.numericRefinements), {}, $3504c57495fb7262$var$_defineProperty({}, attribute, {}))
                });
                if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minBound)) widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", minBound);
                if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxBound)) widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", maxBound);
                var value = uiState.range && uiState.range[attribute];
                if (!value || value.indexOf(":") === -1) return widgetSearchParameters;
                var _value$split$map = value.split(":").map(parseFloat), _value$split$map2 = $3504c57495fb7262$var$_slicedToArray(_value$split$map, 2), lowerBound = _value$split$map2[0], upperBound = _value$split$map2[1];
                if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(lowerBound) && (!(0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(minBound) || minBound < lowerBound)) {
                    widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, ">=");
                    widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, ">=", lowerBound);
                }
                if ((0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(upperBound) && (!(0, $947adbb69e2c94cc$export$cf6c09818bd7035a)(maxBound) || upperBound < maxBound)) {
                    widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, "<=");
                    widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, "<=", upperBound);
                }
                return widgetSearchParameters;
            }
        };
    };
};
var $3504c57495fb7262$export$2e2bcd8739ae039 = $3504c57495fb7262$var$connectRange;



function $81742c3925f1b98d$export$7f6d8a9c788c158e(props, additionalWidgetProperties) {
    return (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $3504c57495fb7262$export$2e2bcd8739ae039), props, additionalWidgetProperties);
}



function $dd4137ce2dcabd02$export$f5dd818bff069720(number) {
    return Number(number).toLocaleString();
}
function $dd4137ce2dcabd02$export$a274e22fb40f762e(...classNames) {
    return classNames.filter(Boolean).join(" ");
}


function $5079470791376668$var$Handle({ domain: [min, max], handle: { id: id, value: value, percent: percent }, disabled: disabled, getHandleProps: getHandleProps }) {
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)((0, $c8241f0b21c62924$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                style: {
                    position: "absolute",
                    left: `${percent}%`,
                    width: 40,
                    height: 25,
                    transform: "translate(-50%, -100%)",
                    cursor: disabled ? "not-allowed" : "grab",
                    zIndex: 1
                },
                "aria-hidden": true,
                ...getHandleProps(id)
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                role: "slider",
                className: "slider-handle",
                "aria-valuemin": min,
                "aria-valuemax": max,
                "aria-valuenow": value,
                style: {
                    left: `${percent}%`,
                    cursor: disabled ? "not-allowed" : "grab"
                },
                ...getHandleProps(id)
            })
        ]
    });
}
function $5079470791376668$var$convertToTicks(start, range) {
    const domain = range.min === 0 && range.max === 0 ? {
        min: undefined,
        max: undefined
    } : range;
    return [
        start[0] === -Infinity ? domain.min : start[0],
        start[1] === Infinity ? domain.max : start[1]
    ];
}
function $5079470791376668$export$ab4cabba918d1baf({ attribute: attribute, min: min, max: max }) {
    const { range: range, start: start, refine: refine, canRefine: canRefine } = (0, $81742c3925f1b98d$export$7f6d8a9c788c158e)({
        attribute: attribute,
        min: min,
        max: max
    }, {
        $$widgetType: "e-commerce.rangeSlider"
    });
    const [ticksValues, setTicksValues] = (0, $iBfRJ.useState)($5079470791376668$var$convertToTicks(start, range));
    const [prevStart, setPrevStart] = (0, $iBfRJ.useState)(start);
    if (start !== prevStart) {
        setTicksValues($5079470791376668$var$convertToTicks(start, range));
        setPrevStart(start);
    }
    const onChange = (values)=>{
        refine(values);
    };
    const onUpdate = (values)=>{
        setTicksValues(values);
    };
    if (!canRefine || ticksValues[0] === undefined || ticksValues[1] === undefined) return null;
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)((0, $3c59e1098e5cd941$export$472062a354075cee), {
        mode: 2,
        step: 1,
        domain: [
            range.min,
            range.max
        ],
        values: start,
        disabled: !canRefine,
        onChange: onChange,
        onUpdate: onUpdate,
        rootStyle: {
            position: "relative",
            marginTop: "1.5rem"
        },
        className: "ais-RangeSlider",
        children: [
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $3c59e1098e5cd941$export$b57863d0ff6a6d2b), {
                children: ({ getRailProps: getRailProps })=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                        className: "slider-rail",
                        ...getRailProps()
                    })
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $3c59e1098e5cd941$export$76e817a61dd78922), {
                left: false,
                right: false,
                children: ({ tracks: tracks, getTrackProps: getTrackProps })=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                        children: tracks.map(({ id: id, source: source, target: target })=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                                className: "slider-track",
                                style: {
                                    left: `${source.percent}%`,
                                    width: `${target.percent - source.percent}%`
                                },
                                ...getTrackProps()
                            }, id))
                    })
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $3c59e1098e5cd941$export$e687473b8d6c8292), {
                children: ({ handles: handles, getHandleProps: getHandleProps })=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                        children: handles.map((handle)=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)($5079470791376668$var$Handle, {
                                handle: handle,
                                domain: [
                                    range.min,
                                    range.max
                                ],
                                getHandleProps: getHandleProps
                            }, handle.id))
                    })
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $3c59e1098e5cd941$export$27c7467594ef87bd), {
                values: ticksValues,
                children: ({ ticks: ticks })=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                        children: ticks.map(({ id: id, value: value, percent: percent })=>/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
                                className: "slider-tick",
                                style: {
                                    left: `${percent}%`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("span", {
                                        style: {
                                            color: "#e2a400",
                                            marginRight: 4
                                        },
                                        children: "$"
                                    }),
                                    (0, $dd4137ce2dcabd02$export$f5dd818bff069720)(value)
                                ]
                            }, id))
                    })
            })
        ]
    });
}




function $994fb75785776aaf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $994fb75785776aaf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $994fb75785776aaf$var$_typeof(o);
}
function $994fb75785776aaf$var$_toConsumableArray(arr) {
    return $994fb75785776aaf$var$_arrayWithoutHoles(arr) || $994fb75785776aaf$var$_iterableToArray(arr) || $994fb75785776aaf$var$_unsupportedIterableToArray(arr) || $994fb75785776aaf$var$_nonIterableSpread();
}
function $994fb75785776aaf$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $994fb75785776aaf$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $994fb75785776aaf$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $994fb75785776aaf$var$_arrayLikeToArray(arr);
}
function $994fb75785776aaf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $994fb75785776aaf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $994fb75785776aaf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $994fb75785776aaf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $994fb75785776aaf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $994fb75785776aaf$var$_defineProperty(obj, key, value) {
    key = $994fb75785776aaf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $994fb75785776aaf$var$_toPropertyKey(t) {
    var i = $994fb75785776aaf$var$_toPrimitive(t, "string");
    return "symbol" == $994fb75785776aaf$var$_typeof(i) ? i : String(i);
}
function $994fb75785776aaf$var$_toPrimitive(t, r) {
    if ("object" != $994fb75785776aaf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $994fb75785776aaf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $994fb75785776aaf$var$_slicedToArray(arr, i) {
    return $994fb75785776aaf$var$_arrayWithHoles(arr) || $994fb75785776aaf$var$_iterableToArrayLimit(arr, i) || $994fb75785776aaf$var$_unsupportedIterableToArray(arr, i) || $994fb75785776aaf$var$_nonIterableRest();
}
function $994fb75785776aaf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $994fb75785776aaf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $994fb75785776aaf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $994fb75785776aaf$var$_arrayLikeToArray(o, minLen);
}
function $994fb75785776aaf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $994fb75785776aaf$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $994fb75785776aaf$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $994fb75785776aaf$var$withUsage = (0, $91c6d247324321b1$export$2fde5bffc340821e)({
    name: "rating-menu",
    connector: true
});
var $994fb75785776aaf$var$$$type = "ais.ratingMenu";
var $994fb75785776aaf$var$MAX_VALUES_PER_FACET_API_LIMIT = 1000;
var $994fb75785776aaf$var$STEP = 1;
var $994fb75785776aaf$var$createSendEvent = function createSendEvent(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, getRefinedStar = _ref.getRefinedStar, attribute = _ref.attribute;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1) {
            instantSearchInstance.sendEventToInsights(args[0]);
            return;
        }
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $994fb75785776aaf$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        if (eventType !== "click") return;
        var isRefined = getRefinedStar() === Number(facetValue);
        if (!isRefined) {
            var _helper$lastResults;
            instantSearchInstance.sendEventToInsights({
                insightsMethod: "clickedFilters",
                widgetType: $994fb75785776aaf$var$$$type,
                eventType: eventType,
                eventModifier: eventModifier,
                payload: {
                    eventName: eventName,
                    index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
                    filters: [
                        "".concat(attribute, ">=").concat(facetValue)
                    ]
                },
                attribute: attribute
            });
        }
    };
};
/**
 * **StarRating** connector provides the logic to build a custom widget that will let
 * the user refine search results based on ratings.
 *
 * The connector provides to the rendering: `refine()` to select a value and
 * `items` that are the values that can be selected. `refine` should be used
 * with `items.value`.
 */ var $994fb75785776aaf$var$connectRatingMenu = function connectRatingMenu(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $381348598347b86b$export$8793edee2d425525);
    (0, $1ea6e647c07b346d$export$adc2a8e09aa583ee)(renderFn, $994fb75785776aaf$var$withUsage());
    return function(widgetParams) {
        var _ref2 = widgetParams || {}, attribute = _ref2.attribute, _ref2$max = _ref2.max, max = _ref2$max === void 0 ? 5 : _ref2$max;
        var sendEvent;
        if (!attribute) throw new Error($994fb75785776aaf$var$withUsage("The `attribute` option is required."));
        var _getRefinedStar = function getRefinedStar(state) {
            var _values$;
            var values = state.getNumericRefinements(attribute);
            if (!((_values$ = values[">="]) !== null && _values$ !== void 0 && _values$.length)) return undefined;
            return values[">="][0];
        };
        var getFacetsMaxDecimalPlaces = function getFacetsMaxDecimalPlaces(facetResults) {
            var maxDecimalPlaces = 0;
            facetResults.forEach(function(facetResult) {
                var _facetResult$name$spl = facetResult.name.split("."), _facetResult$name$spl2 = $994fb75785776aaf$var$_slicedToArray(_facetResult$name$spl, 2), _facetResult$name$spl3 = _facetResult$name$spl2[1], decimal = _facetResult$name$spl3 === void 0 ? "" : _facetResult$name$spl3;
                maxDecimalPlaces = Math.max(maxDecimalPlaces, decimal.length);
            });
            return maxDecimalPlaces;
        };
        var getFacetValuesWarningMessage = function getFacetValuesWarningMessage(_ref3) {
            var maxDecimalPlaces = _ref3.maxDecimalPlaces, maxFacets = _ref3.maxFacets, maxValuesPerFacet = _ref3.maxValuesPerFacet;
            var maxDecimalPlacesInRange = Math.max(0, Math.floor(Math.log10($994fb75785776aaf$var$MAX_VALUES_PER_FACET_API_LIMIT / max)));
            var maxFacetsInRange = Math.min($994fb75785776aaf$var$MAX_VALUES_PER_FACET_API_LIMIT, Math.pow(10, maxDecimalPlacesInRange) * max);
            var solutions = [];
            if (maxFacets > $994fb75785776aaf$var$MAX_VALUES_PER_FACET_API_LIMIT) solutions.push('- Update your records to lower the precision of the values in the "'.concat(attribute, '" attribute (for example: ').concat(5.123456789.toPrecision(maxDecimalPlaces + 1), " to ").concat(5.123456789.toPrecision(maxDecimalPlacesInRange + 1), ")"));
            if (maxValuesPerFacet < maxFacetsInRange) solutions.push("- Increase the maximum number of facet values to ".concat(maxFacetsInRange, ' using the "configure" widget ').concat((0, $91c6d247324321b1$export$110679b26359d23d)({
                name: "configure"
            }), ' and the "maxValuesPerFacet" parameter https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/'));
            return "The ".concat(attribute, " attribute can have ").concat(maxFacets, " different values (0 to ").concat(max, " with a maximum of ").concat(maxDecimalPlaces, " decimals = ").concat(maxFacets, ") but you retrieved only ").concat(maxValuesPerFacet, " facet values. Therefore the number of results that match the refinements can be incorrect.\n    ").concat(solutions.length ? "To resolve this problem you can:\n".concat(solutions.join("\n")) : "");
        };
        function getRefinedState(state, facetValue) {
            var isRefined = _getRefinedStar(state) === Number(facetValue);
            var emptyState = state.resetPage().removeNumericRefinement(attribute);
            if (!isRefined) return emptyState.addNumericRefinement(attribute, "<=", max).addNumericRefinement(attribute, ">=", Number(facetValue));
            return emptyState;
        }
        var toggleRefinement = function toggleRefinement(helper, facetValue) {
            sendEvent("click:internal", facetValue);
            helper.setState(getRefinedState(helper.state, facetValue)).search();
        };
        var connectorState = {
            toggleRefinementFactory: function toggleRefinementFactory(helper) {
                return toggleRefinement.bind(null, helper);
            },
            createURLFactory: function createURLFactory(_ref4) {
                var state = _ref4.state, createURL = _ref4.createURL, getWidgetUiState = _ref4.getWidgetUiState, helper = _ref4.helper;
                return function(value) {
                    return createURL(function(uiState) {
                        return getWidgetUiState(uiState, {
                            searchParameters: getRefinedState(state, value),
                            helper: helper
                        });
                    });
                };
            }
        };
        return {
            $$type: $994fb75785776aaf$var$$$type,
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, renderState), {}, {
                    ratingMenu: $994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, renderState.ratingMenu), {}, $994fb75785776aaf$var$_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref5) {
                var helper = _ref5.helper, results = _ref5.results, state = _ref5.state, instantSearchInstance = _ref5.instantSearchInstance, createURL = _ref5.createURL;
                var facetValues = [];
                if (!sendEvent) sendEvent = $994fb75785776aaf$var$createSendEvent({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    getRefinedStar: function getRefinedStar() {
                        return _getRefinedStar(helper.state);
                    },
                    attribute: attribute
                });
                var refinementIsApplied = false;
                var totalCount = 0;
                var facetResults = results === null || results === void 0 ? void 0 : results.getFacetValues(attribute, {});
                if (results && facetResults) {
                    var maxValuesPerFacet = facetResults.length;
                    var maxDecimalPlaces = getFacetsMaxDecimalPlaces(facetResults);
                    var maxFacets = Math.pow(10, maxDecimalPlaces) * max;
                    var refinedStar = _getRefinedStar(state);
                    var _loop = function _loop(star) {
                        var isRefined = refinedStar === star;
                        refinementIsApplied = refinementIsApplied || isRefined;
                        var count = facetResults.filter(function(f) {
                            return Number(f.name) >= star && Number(f.name) <= max;
                        }).map(function(f) {
                            return f.count;
                        }).reduce(function(sum, current) {
                            return sum + current;
                        }, 0);
                        totalCount += count;
                        if (refinedStar && !isRefined && count === 0) // skip count==0 when at least 1 refinement is enabled
                        // eslint-disable-next-line no-continue
                        return "continue";
                        var stars = $994fb75785776aaf$var$_toConsumableArray(new Array(Math.floor(max / $994fb75785776aaf$var$STEP))).map(function(_v, i) {
                            return i * $994fb75785776aaf$var$STEP < star;
                        });
                        facetValues.push({
                            stars: stars,
                            name: String(star),
                            label: String(star),
                            value: String(star),
                            count: count,
                            isRefined: isRefined
                        });
                    };
                    for(var star = $994fb75785776aaf$var$STEP; star < max; star += $994fb75785776aaf$var$STEP){
                        var _ret = _loop(star);
                        if (_ret === "continue") continue;
                    }
                }
                facetValues = facetValues.reverse();
                var hasNoResults = results ? results.nbHits === 0 : true;
                return {
                    items: facetValues,
                    hasNoResults: hasNoResults,
                    canRefine: (!hasNoResults || refinementIsApplied) && totalCount > 0,
                    refine: connectorState.toggleRefinementFactory(helper),
                    sendEvent: sendEvent,
                    createURL: connectorState.createURLFactory({
                        state: state,
                        createURL: createURL,
                        helper: helper,
                        getWidgetUiState: this.getWidgetUiState
                    }),
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref6) {
                var state = _ref6.state;
                unmountFn();
                return state.removeNumericRefinement(attribute);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref7) {
                var searchParameters = _ref7.searchParameters;
                var value = _getRefinedStar(searchParameters);
                return $994fb75785776aaf$var$removeEmptyRefinementsFromUiState($994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, uiState), {}, {
                    ratingMenu: $994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, uiState.ratingMenu), {}, $994fb75785776aaf$var$_defineProperty({}, attribute, typeof value === "number" ? value : undefined))
                }), attribute);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref8) {
                var uiState = _ref8.uiState;
                var value = uiState.ratingMenu && uiState.ratingMenu[attribute];
                var withDisjunctiveFacet = searchParameters.addDisjunctiveFacet(attribute).removeNumericRefinement(attribute).removeDisjunctiveFacetRefinement(attribute);
                if (!value) return withDisjunctiveFacet.setQueryParameters({
                    numericRefinements: $994fb75785776aaf$var$_objectSpread($994fb75785776aaf$var$_objectSpread({}, withDisjunctiveFacet.numericRefinements), {}, $994fb75785776aaf$var$_defineProperty({}, attribute, {}))
                });
                return withDisjunctiveFacet.addNumericRefinement(attribute, "<=", max).addNumericRefinement(attribute, ">=", value);
            }
        };
    };
};
function $994fb75785776aaf$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.ratingMenu) return indexUiState;
    if (typeof indexUiState.ratingMenu[attribute] !== "number") delete indexUiState.ratingMenu[attribute];
    if (Object.keys(indexUiState.ratingMenu).length === 0) delete indexUiState.ratingMenu;
    return indexUiState;
}
var $994fb75785776aaf$export$2e2bcd8739ae039 = $994fb75785776aaf$var$connectRatingMenu;


parcelRequire("iBfRJ");


function $e146c3ff0d941dbb$export$63624e0823f82b87({ attribute: attribute }) {
    const { refine: refine, items: items, createURL: createURL } = (0, $9e9269f1a011fc3b$export$7b345619fa263f7e)((0, $994fb75785776aaf$export$2e2bcd8739ae039), {
        attribute: attribute
    }, {
        $$widgetType: "e-commerce.ratingMenu"
    });
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
        className: "ais-RatingMenu",
        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("ul", {
            className: "ais-RatingMenu-list",
            children: items.map((rating)=>{
                return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("li", {
                    className: (0, $dd4137ce2dcabd02$export$a274e22fb40f762e)("ais-RatingMenu-item", rating.isRefined && "ais-RatingMenu-item--selected", rating.count === 0 && "ais-RatingMenu-item--disabled"),
                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("a", {
                        className: "ais-RatingMenu-link",
                        "aria-label": `${rating.value} & up`,
                        href: createURL(rating.value),
                        onClick: (event)=>{
                            event.preventDefault();
                            refine(rating.value);
                        },
                        children: [
                            rating.stars.map((isStarFull, starIndex)=>{
                                return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("svg", {
                                    className: (0, $dd4137ce2dcabd02$export$a274e22fb40f762e)("ais-RatingMenu-starIcon", isStarFull ? "ais-RatingMenu-starIcon--full" : "ais-RatingMenu-starIcon--empty"),
                                    "aria-hidden": "true",
                                    viewBox: "0 0 16 16",
                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M10.472 5.008L16 5.816l-4 3.896.944 5.504L8 12.616l-4.944 2.6L4 9.712 0 5.816l5.528-.808L8 0z"
                                    })
                                }, starIndex);
                            }),
                            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("span", {
                                className: "ais-RatingMenu-count",
                                children: rating.count
                            })
                        ]
                    })
                }, rating.value);
            })
        })
    });
}



parcelRequire("iBfRJ");


function $a87109314872be39$export$ee2d71e3fbd004ff() {
    const { results: { nbHits: nbHits } } = (0, $d1f4ce777f0c30e4$export$c3584afb06ed387d)();
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("strong", {
                children: (0, $dd4137ce2dcabd02$export$f5dd818bff069720)(nbHits)
            }),
            " results"
        ]
    });
}



parcelRequire("iBfRJ");


function $e07aab3b32e4f04d$export$b5314781ab50943a({ onClick: onClick }) {
    const { results: { nbHits: nbHits } } = (0, $d1f4ce777f0c30e4$export$c3584afb06ed387d)();
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("button", {
        className: "button button-primary",
        onClick: onClick,
        children: [
            "See ",
            (0, $dd4137ce2dcabd02$export$f5dd818bff069720)(nbHits),
            " results"
        ]
    });
}






var $iBfRJ = parcelRequire("iBfRJ");

function $caef9ce472a1b869$export$30318940d8eafabd({ children: children }) {
    const { addMiddlewares: addMiddlewares } = (0, $d1f4ce777f0c30e4$export$c3584afb06ed387d)();
    const containerRef = (0, $iBfRJ.useRef)(null);
    (0, $iBfRJ.useEffect)(()=>{
        const middleware = ()=>{
            return {
                onStateChange () {
                    const isFiltering = document.body.classList.contains("filtering");
                    const isTyping = document.activeElement?.tagName === "INPUT" && document.activeElement?.getAttribute("type") === "search";
                    if (isFiltering || isTyping) return;
                    containerRef.current.scrollIntoView();
                }
            };
        };
        return addMiddlewares(middleware);
    }, [
        addMiddlewares
    ]);
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
        ref: containerRef,
        className: "ais-ScrollTo",
        children: children
    });
}


/* eslint complexity: off */ 
const $7d68d7779ce46476$var$routeStateDefaultValues = {
    query: "",
    page: "1",
    brands: undefined,
    category: "",
    rating: "",
    price: "",
    free_shipping: "false",
    sortBy: "instant_search",
    hitsPerPage: "20"
};
const $7d68d7779ce46476$var$encodedCategories = {
    Cameras: "Cameras & Camcorders",
    Cars: "Car Electronics & GPS",
    Phones: "Cell Phones",
    TV: "TV & Home Theater"
};
const $7d68d7779ce46476$var$decodedCategories = Object.keys($7d68d7779ce46476$var$encodedCategories).reduce((acc, key)=>{
    const newKey = $7d68d7779ce46476$var$encodedCategories[key];
    const newValue = key;
    return {
        ...acc,
        [newKey]: newValue
    };
}, {});
// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function $7d68d7779ce46476$var$getCategorySlug(name) {
    const encodedName = $7d68d7779ce46476$var$decodedCategories[name] || name;
    return encodedName.split(" ").map(encodeURIComponent).join("+");
}
// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function $7d68d7779ce46476$var$getCategoryName(slug) {
    const decodedSlug = $7d68d7779ce46476$var$encodedCategories[slug] || slug;
    return decodeURIComponent(decodedSlug.replace(/\+/g, " "));
}
const $7d68d7779ce46476$var$originalWindowTitle = document.title;
const $7d68d7779ce46476$var$router = (0, $cf76e4f8f77d9181$export$2e2bcd8739ae039)({
    cleanUrlOnDispose: false,
    windowTitle ({ category: category, query: query }) {
        const queryTitle = query ? `Results for "${query}"` : "";
        return [
            queryTitle,
            category,
            $7d68d7779ce46476$var$originalWindowTitle
        ].filter(Boolean).join(" | ");
    },
    createURL ({ qsModule: qsModule, routeState: routeState, location: location }) {
        const { protocol: protocol, hostname: hostname, port: port = "", pathname: pathname, hash: hash } = location;
        const portWithPrefix = port === "" ? "" : `:${port}`;
        const urlParts = location.href.match(/^(.*?)\/search/);
        const baseUrl = urlParts && urlParts[0] || `${protocol}//${hostname}${portWithPrefix}${pathname}search`;
        const categoryPath = routeState.category ? `${$7d68d7779ce46476$var$getCategorySlug(routeState.category)}/` : "";
        const queryParameters = {};
        if (routeState.query && routeState.query !== $7d68d7779ce46476$var$routeStateDefaultValues.query) queryParameters.query = encodeURIComponent(routeState.query);
        if (routeState.page && routeState.page !== $7d68d7779ce46476$var$routeStateDefaultValues.page) queryParameters.page = routeState.page;
        if (routeState.brands && routeState.brands !== $7d68d7779ce46476$var$routeStateDefaultValues.brands) queryParameters.brands = routeState.brands.map(encodeURIComponent);
        if (routeState.rating && routeState.rating !== $7d68d7779ce46476$var$routeStateDefaultValues.rating) queryParameters.rating = routeState.rating;
        if (routeState.price && routeState.price !== $7d68d7779ce46476$var$routeStateDefaultValues.price) queryParameters.price = routeState.price;
        if (routeState.free_shipping && routeState.free_shipping !== $7d68d7779ce46476$var$routeStateDefaultValues.free_shipping) queryParameters.free_shipping = routeState.free_shipping;
        if (routeState.sortBy && routeState.sortBy !== $7d68d7779ce46476$var$routeStateDefaultValues.sortBy) queryParameters.sortBy = routeState.sortBy;
        if (routeState.hitsPerPage && routeState.hitsPerPage !== $7d68d7779ce46476$var$routeStateDefaultValues.hitsPerPage) queryParameters.hitsPerPage = routeState.hitsPerPage;
        const queryString = qsModule.stringify(queryParameters, {
            addQueryPrefix: true,
            arrayFormat: "repeat"
        });
        return `${baseUrl}/${categoryPath}${queryString}${hash}`;
    },
    parseURL ({ qsModule: qsModule, location: location }) {
        const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/);
        const category = $7d68d7779ce46476$var$getCategoryName(pathnameMatches && pathnameMatches[1] || "");
        const queryParameters = qsModule.parse(location.search.slice(1));
        const { query: query = "", page: page = 1, brands: brands = [], price: price, free_shipping: free_shipping, hitsPerPage: hitsPerPage, sortBy: sortBy, rating: rating } = queryParameters;
        // `qs` does not return an array when there's a single value.
        const allBrands = Array.isArray(brands) ? brands : [
            brands
        ].filter(Boolean);
        return {
            category: category,
            query: decodeURIComponent(query),
            page: page,
            brands: allBrands.map(decodeURIComponent),
            rating: rating,
            price: price,
            free_shipping: free_shipping,
            sortBy: sortBy,
            hitsPerPage: hitsPerPage
        };
    }
});
const $7d68d7779ce46476$var$getStateMapping = ({ indexName: indexName })=>({
        stateToRoute (uiState) {
            const indexUiState = uiState[indexName];
            return {
                query: indexUiState.query,
                page: indexUiState.page && String(indexUiState.page) || undefined,
                brands: indexUiState.refinementList && indexUiState.refinementList.brand,
                category: indexUiState.hierarchicalMenu && indexUiState.hierarchicalMenu["hierarchicalCategories.lvl0"] && indexUiState.hierarchicalMenu["hierarchicalCategories.lvl0"].join("/"),
                rating: indexUiState.ratingMenu && indexUiState.ratingMenu.rating && String(indexUiState.ratingMenu.rating) || undefined,
                price: indexUiState.range && indexUiState.range.price,
                free_shipping: indexUiState.toggle && String(indexUiState.toggle.free_shipping) || undefined,
                sortBy: indexUiState.sortBy,
                hitsPerPage: indexUiState.hitsPerPage && String(indexUiState.hitsPerPage) || undefined
            };
        },
        routeToState (routeState) {
            const hierarchicalMenu = {};
            if (routeState.category) hierarchicalMenu["hierarchicalCategories.lvl0"] = routeState.category.split("/");
            const refinementList = {};
            if (routeState.brands) refinementList.brand = routeState.brands;
            const range = {};
            if (routeState.price) range.price = routeState.price;
            return {
                [indexName]: {
                    query: routeState.query,
                    page: Number(routeState.page),
                    hierarchicalMenu: hierarchicalMenu,
                    refinementList: refinementList,
                    ratingMenu: {
                        rating: Number(routeState.rating)
                    },
                    range: range,
                    toggle: {
                        free_shipping: Boolean(routeState.free_shipping)
                    },
                    sortBy: routeState.sortBy,
                    hitsPerPage: Number(routeState.hitsPerPage)
                }
            };
        }
    });
const $7d68d7779ce46476$var$getRouting = (indexName)=>({
        router: $7d68d7779ce46476$var$router,
        stateMapping: $7d68d7779ce46476$var$getStateMapping({
            indexName: indexName
        })
    });
var $7d68d7779ce46476$export$2e2bcd8739ae039 = $7d68d7779ce46476$var$getRouting;








const $6dd0f260ff7435ce$var$searchClient = (0, $bd7918188970d8f3$exports.liteClient)("latency", "6be0576ff61c053d5f9a3225e2a90f76");
const $6dd0f260ff7435ce$var$indexName = "instant_search";
const $6dd0f260ff7435ce$var$routing = (0, $7d68d7779ce46476$export$2e2bcd8739ae039)($6dd0f260ff7435ce$var$indexName);
function $6dd0f260ff7435ce$export$86fbec116b87613f() {
    const containerRef = (0, $iBfRJ.useRef)(null);
    const headerRef = (0, $iBfRJ.useRef)(null);
    function openFilters() {
        document.body.classList.add("filtering");
        window.scrollTo(0, 0);
        window.addEventListener("keyup", onKeyUp);
        window.addEventListener("click", onClick);
    }
    function closeFilters() {
        document.body.classList.remove("filtering");
        containerRef.current.scrollIntoView();
        window.removeEventListener("keyup", onKeyUp);
        window.removeEventListener("click", onClick);
    }
    function onKeyUp(event) {
        if (event.key !== "Escape") return;
        closeFilters();
    }
    function onClick(event) {
        if (event.target !== headerRef.current) return;
        closeFilters();
    }
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)((0, $99e2f2cc5fe7460f$export$ad8f235d2c2c71c0), {
        searchClient: $6dd0f260ff7435ce$var$searchClient,
        indexName: $6dd0f260ff7435ce$var$indexName,
        routing: $6dd0f260ff7435ce$var$routing,
        insights: true,
        children: [
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("header", {
                className: "header",
                ref: headerRef,
                children: [
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("p", {
                        className: "header-logo",
                        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $327ba17fc2883207$export$195b9afc167669b), {})
                    }),
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("p", {
                        className: "header-title",
                        children: "Stop looking for an item \u2014 find it."
                    }),
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $3bb497c502460291$export$5a58787633b0b5d8), {
                        placeholder: "Product, brand, color, \u2026",
                        submitIconComponent: $6dd0f260ff7435ce$var$SubmitIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $44c73e737d5e8e48$export$de5f40ff1ff419d2), {
                attributesToSnippet: [
                    "description:10"
                ],
                snippetEllipsisText: "\u2026",
                removeWordsIfNoResults: "allOptional"
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $caef9ce472a1b869$export$30318940d8eafabd), {
                children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("main", {
                    className: "container",
                    ref: containerRef,
                    children: [
                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
                            className: "container-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("section", {
                                    className: "container-filters",
                                    onKeyUp: onKeyUp,
                                    children: [
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
                                            className: "container-header",
                                            children: [
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("h2", {
                                                    children: "Filters"
                                                }),
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                                                    className: "clear-filters",
                                                    "data-layout": "desktop",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $a9c95fb5f6cc4b1b$export$974caec19ec0f86c), {})
                                                }),
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                                                    className: "clear-filters",
                                                    "data-layout": "mobile",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $a87109314872be39$export$ee2d71e3fbd004ff), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
                                            className: "container-body",
                                            children: [
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $793ff4f3c101ca76$export$2ddb90ad54e5f587), {
                                                    header: "Category",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $0b0a731837cb9484$export$cd053ad333284bbb), {
                                                        attributes: [
                                                            "hierarchicalCategories.lvl0",
                                                            "hierarchicalCategories.lvl1"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $793ff4f3c101ca76$export$2ddb90ad54e5f587), {
                                                    header: "Brands",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $db58d555791b27cb$export$40832886fec19653), {
                                                        attribute: "brand",
                                                        searchable: true,
                                                        searchablePlaceholder: "Search for brands\u2026"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $793ff4f3c101ca76$export$2ddb90ad54e5f587), {
                                                    header: "Price",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $5079470791376668$export$ab4cabba918d1baf), {
                                                        attribute: "price"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $793ff4f3c101ca76$export$2ddb90ad54e5f587), {
                                                    header: "Free shipping",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $d3b4275317650d25$export$36fa238829513e45), {
                                                        attribute: "free_shipping",
                                                        label: "Display only items with free shipping",
                                                        on: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $793ff4f3c101ca76$export$2ddb90ad54e5f587), {
                                                    header: "Ratings",
                                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $e146c3ff0d941dbb$export$63624e0823f82b87), {
                                                        attribute: "rating"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("footer", {
                                    className: "container-filters-footer",
                                    "data-layout": "mobile",
                                    children: [
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                                            className: "container-filters-footer-button-wrapper",
                                            children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $ea2a8dbccb57b811$export$9c81ee90e4f7ab4e), {
                                                containerRef: containerRef
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("div", {
                                            className: "container-filters-footer-button-wrapper",
                                            children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $e07aab3b32e4f04d$export$b5314781ab50943a), {
                                                onClick: closeFilters
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("section", {
                            className: "container-results",
                            children: [
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("header", {
                                    className: "container-header container-options",
                                    children: [
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $78276a1234af39b4$export$eb2ca1350bb61eb0), {
                                            className: "container-option",
                                            items: [
                                                {
                                                    label: "Sort by featured",
                                                    value: "instant_search"
                                                },
                                                {
                                                    label: "Price ascending",
                                                    value: "instant_search_price_asc"
                                                },
                                                {
                                                    label: "Price descending",
                                                    value: "instant_search_price_desc"
                                                }
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $eaed8cda9706c844$export$1c363d4fc6896e21), {
                                            className: "container-option",
                                            items: [
                                                {
                                                    label: "16 hits per page",
                                                    value: 16,
                                                    default: true
                                                },
                                                {
                                                    label: "32 hits per page",
                                                    value: 32
                                                },
                                                {
                                                    label: "64 hits per page",
                                                    value: 64
                                                }
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $6a8dab31ffa172dc$export$2a19844878d7a6e0), {
                                    fallback: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $62d8e645220997bc$export$ef6006467f04ee41), {}),
                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $3e45d2db268da615$export$9abb8533010f1d93), {
                                        hitComponent: $6dd0f260ff7435ce$var$Hit
                                    })
                                }),
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("footer", {
                                    className: "container-footer",
                                    children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $8ad4f14d5f73b083$export$68f5e1453c188a82), {
                                        padding: 2,
                                        showFirst: false,
                                        showLast: false
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("aside", {
                "data-layout": "mobile",
                children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("button", {
                    className: "filters-button",
                    "data-action": "open-overlay",
                    onClick: openFilters,
                    children: [
                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 16 14",
                            children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                d: "M15 1H1l5.6 6.3v4.37L9.4 13V7.3z",
                                stroke: "#fff",
                                strokeWidth: "1.29",
                                fill: "none",
                                fillRule: "evenodd",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        }),
                        "Filters"
                    ]
                })
            })
        ]
    });
}
function $6dd0f260ff7435ce$var$SubmitIcon() {
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 18 18",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.67",
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("circle", {
                    cx: "7.11",
                    cy: "7.11",
                    r: "7.11"
                }),
                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                    d: "M16 16l-3.87-3.87"
                })
            ]
        })
    });
}
function $6dd0f260ff7435ce$var$Hit({ hit: hit }) {
    return /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("article", {
        className: "hit",
        children: [
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("header", {
                className: "hit-image-container",
                children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("img", {
                    src: hit.image,
                    alt: hit.name,
                    className: "hit-image"
                })
            }),
            /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("div", {
                className: "hit-info-container",
                children: [
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("p", {
                        className: "hit-category",
                        children: hit.categories[0]
                    }),
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("h1", {
                        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $c62ec36ff8cae40d$export$39dbc3f558091353), {
                            attribute: "name",
                            highlightedTagName: "mark",
                            hit: hit
                        })
                    }),
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("p", {
                        className: "hit-description",
                        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $67c8738e88386d71$export$10c56fa12fda26f9), {
                            attribute: "description",
                            highlightedTagName: "mark",
                            hit: hit
                        })
                    }),
                    /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("footer", {
                        children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("span", {
                                    className: "hit-em",
                                    children: "$"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("strong", {
                                    children: (0, $dd4137ce2dcabd02$export$f5dd818bff069720)(hit.price)
                                }),
                                " ",
                                /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsxs)("span", {
                                    className: "hit-em hit-rating",
                                    children: [
                                        /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "8",
                                            height: "8",
                                            viewBox: "0 0 16 16",
                                            children: /*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)("path", {
                                                fill: "#e2a400",
                                                fillRule: "evenodd",
                                                d: "M10.472 5.008L16 5.816l-4 3.896.944 5.504L8 12.616l-4.944 2.6L4 9.712 0 5.816l5.528-.808L8 0z"
                                            })
                                        }),
                                        " ",
                                        hit.rating
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


(0, $3187838040ceb3fc$exports.createRoot)(document.getElementById("root")).render(/*#__PURE__*/ (0, $c8241f0b21c62924$exports.jsx)((0, $6dd0f260ff7435ce$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.d39d9ca3.js.map
